export const PROFESSIONS = {
  basic: [
    "Artisan",
    "Brawler",
    "Entertainer",
    "Gladiator",
    "Marksman",
    "Medic",
    "Scout",
    "Politician",
  ],
  elite: [
    "Architect",
    "Armorsmith",
    "Bio-Engineer",
    "Bounty Hunter",
    "Combat Medic",
    "Carbineer",
    "Chef",
    "Creature Handler",
    "Commando",
    "Dancer",
    "Doctor",
    "Droid Engineer",
    "Fencer",
    "Image Designer",
    "Merchant",
    "Musician",
    "Pikeman",
    "Pistoleer",
    "Ranger",
    "Rifleman",
    "Smuggler",
    "Squad Leader",
    "Swordsman",
    "Tailor",
    "Teras Kasi Artist",
    "Weaponsmith",
  ],
  forceSensitive: [
    "Combat Prowess",
    "Enhanced Reflexes",
    "Crafting Mastery",
    "Heightened Senses",
  ],
  jedi: ["Lightsaber", "Powers", "Healing", "Enchancements", "Defender"],
};

export const SKILL_TITLE = {
  ballistic_munitions_components: "Ballistic munitions components",
  bio_engineer: "Bio-Engineer",
  chef: "Chef",
  combat: "Combat",
  combat_1hsword: "Fencer",
  combat_1hsword_ability_01: "Intermediate Fencing Technique",
  combat_1hsword_ability_02: "Advanced Fencing Technique",
  combat_1hsword_ability_03: "Expert Fencing Technique",
  combat_1hsword_ability_04: "Master Fencing Technique",
  combat_1hsword_accuracy_01: "Intermediate Fencing Stances and Grips",
  combat_1hsword_accuracy_02: "Advanced Fencing Stances and Grips",
  combat_1hsword_accuracy_03: "Expert Fencing Stances and Grips",
  combat_1hsword_accuracy_04: "Master Fencing Stances and Grips",
  combat_1hsword_master: "Master Fencer",
  combat_1hsword_novice: "Novice Fencer",
  combat_1hsword_speed_01: "Intermediate Footwork",
  combat_1hsword_speed_02: "Advanced Footwork",
  combat_1hsword_speed_03: "Expert Footwork",
  combat_1hsword_speed_04: "Master Footwork",
  combat_1hsword_support_01: "Intermediate Fencing Finesse",
  combat_1hsword_support_02: "Advanced Fencing Finesse",
  combat_1hsword_support_03: "Expert Fencing Finesse",
  combat_1hsword_support_04: "Master Fencing Finesse",
  combat_2hsword: "Swordsman",
  combat_2hsword_ability_01: "Intermediate Sword Defense",
  combat_2hsword_ability_02: "Advanced Sword Defense",
  combat_2hsword_ability_03: "Expert Sword Defense",
  combat_2hsword_ability_04: "Master Sword Defense",
  combat_2hsword_accuracy_01: "Intermediate Sword Offense",
  combat_2hsword_accuracy_02: "Advanced Sword Offense",
  combat_2hsword_accuracy_03: "Expert Sword Offense",
  combat_2hsword_accuracy_04: "Master Sword Offense",
  combat_2hsword_master: "Master Swordsman",
  combat_2hsword_novice: "Novice Swordsman",
  combat_2hsword_speed_01: "Intermediate Sword Techniques",
  combat_2hsword_speed_02: "Advanced Sword Techniques",
  combat_2hsword_speed_03: "Expert Sword Techniques",
  combat_2hsword_speed_04: "Master Sword Techniques",
  combat_2hsword_support_01: "Intermediate Sword Finesse",
  combat_2hsword_support_02: "Advanced Sword Finesse",
  combat_2hsword_support_03: "Expert Sword Finesse",
  combat_2hsword_support_04: "Master Sword Finesse",
  combat_bountyhunter: "Bounty Hunter",
  combat_bountyhunter_droidcontrol_01: "Bounty Carbine Specialization I",
  combat_bountyhunter_droidcontrol_02: "Bounty Carbine Specialization II",
  combat_bountyhunter_droidcontrol_03: "Bounty Carbine Specialization III",
  combat_bountyhunter_droidcontrol_04: "Bounty Carbine Specialization IV",
  combat_bountyhunter_droidresponse_01: "Bounty Pistol Specialization I",
  combat_bountyhunter_droidresponse_02: "Bounty Pistol Specialization II",
  combat_bountyhunter_droidresponse_03: "Bounty Pistol Specialization III",
  combat_bountyhunter_droidresponse_04: "Bounty Pistol Specialization IV",
  combat_bountyhunter_investigation_01: "Investigation I",
  combat_bountyhunter_investigation_02: "Investigation II",
  combat_bountyhunter_investigation_03: "Investigation III",
  combat_bountyhunter_investigation_04: "Investigation IV",
  combat_bountyhunter_master: "Master Bounty Hunter",
  combat_bountyhunter_novice: "Novice Bounty Hunter",
  combat_bountyhunter_support_01: "Light Lightning Cannon Specialization I",
  combat_bountyhunter_support_02: "Light Lightning Cannon Specialization II",
  combat_bountyhunter_support_03: "Light Lightning Cannon Specialization III",
  combat_bountyhunter_support_04: "Light Lightning Cannon Specialization IV",
  combat_brawler: "Brawler",
  combat_brawler_1handmelee_01: "One-Handed I: Sword Technique",
  combat_brawler_1handmelee_02: "One-Handed II: Lethal Strikes",
  combat_brawler_1handmelee_03: "One-Handed III: Blunt Edge Strikes",
  combat_brawler_1handmelee_04: "One-Handed IV: Dance of Blades",
  combat_brawler_2handmelee_01: "Two-Handed I: Weighted Stances",
  combat_brawler_2handmelee_02: "Two-Handed II: Strength & Precision",
  combat_brawler_2handmelee_03: "Two-Handed III: Sweeps",
  combat_brawler_2handmelee_04: "Two-Handed IV: Fatal Finesse",
  combat_brawler_master: "Master Brawler",
  combat_brawler_novice: "Novice Brawler",
  combat_brawler_polearm_01: "Polearms I: Long Hafted Weaponry",
  combat_brawler_polearm_02: "Polearms II: Form & Balance",
  combat_brawler_polearm_03: "Polearms III: Power Strikes",
  combat_brawler_polearm_04: "Polearms IV: Overwhelming Assault",
  combat_brawler_unarmed_01: "Unarmed I: Street Fighting",
  combat_brawler_unarmed_02: "Unarmed II: Stunning Attack",
  combat_brawler_unarmed_03: "Unarmed III: Blinding Attack",
  combat_brawler_unarmed_04: "Unarmed IV: Teras Kasi Fundamentals",
  combat_carbine: "Carbineer",
  combat_carbine_ability_01: "Intermediate Carbine Counterinsurgency Tactics",
  combat_carbine_ability_02: "Advanced Carbine Counterinsurgency Tactics",
  combat_carbine_ability_03: "Expert Carbine Counterinsurgency Tactics",
  combat_carbine_ability_04: "Master Carbine Counterinsurgency Tactics",
  combat_carbine_accuracy_01: "Intermediate Carbine Assault Tactics",
  combat_carbine_accuracy_02: "Advanced Carbine Assault Tactics",
  combat_carbine_accuracy_03: "Expert Carbine Assault Tactics",
  combat_carbine_accuracy_04: "Master Carbine Assault Tactics",
  combat_carbine_master: "Master Carbineer",
  combat_carbine_novice: "Novice Carbineer",
  combat_carbine_speed_01: "Intermediate Carbine Marksmanship",
  combat_carbine_speed_02: "Advanced Carbine Marksmanship",
  combat_carbine_speed_03: "Expert Carbine Marksmanship",
  combat_carbine_speed_04: "Master Carbine Marksmanship",
  combat_carbine_support_01: "Intermediate Carbine Special Abilities",
  combat_carbine_support_02: "Advanced Carbine Special Abilities",
  combat_carbine_support_03: "Expert Carbine Special Abilities",
  combat_carbine_support_04: "Master Carbine Special Abilities",
  combat_command_support_02: "Advanced Specialized Weapon Crafting",
  combat_command_support_04: "Master Specialized Weapon Crafting",
  combat_commando: "Commando",
  combat_commando_heavyweapon_accuracy_01: "Field Tactics I",
  combat_commando_heavyweapon_accuracy_02: "Field Tactics II",
  combat_commando_heavyweapon_accuracy_03: "Field Tactics III",
  combat_commando_heavyweapon_accuracy_04: "Field Tactics IV",
  combat_commando_heavyweapon_speed_01: "Heavy Support Weapons I",
  combat_commando_heavyweapon_speed_02: "Heavy Support Weapons II",
  combat_commando_heavyweapon_speed_03: "Heavy Support Weapons III",
  combat_commando_heavyweapon_speed_04: "Heavy Support Weapons IV",
  combat_commando_master: "Master Commando",
  combat_commando_novice: "Novice Commando",
  combat_commando_support_01: "Acid Rifle Specialization I",
  combat_commando_support_02: "Acid Rifle Specialization II",
  combat_commando_support_03: "Acid Rifle Specialization III",
  combat_commando_support_04: "Acid Rifle Specialization IV",
  combat_commando_thrownweapon_01: "Flamethrower Specialization I",
  combat_commando_thrownweapon_02: "Flamethrower Specialization II",
  combat_commando_thrownweapon_03: "Flamethrower Specialization III",
  combat_commando_thrownweapon_04: "Flamethrower Specialization IV",
  combat_engineer: "Combat Engineer",
  combat_marksman: "Marksman",
  combat_marksman_carbine_01: "Carbines I: Medium Range Combat",
  combat_marksman_carbine_02: "Carbines II: Full Auto Firing",
  combat_marksman_carbine_03: "Carbines III: Improved Control",
  combat_marksman_carbine_04: "Carbines IV: Called Shots",
  combat_marksman_master: "Master Marksman",
  combat_marksman_novice: "Novice Marksman",
  combat_marksman_pistol_01: "Pistols I: Short Range Combat",
  combat_marksman_pistol_02: "Pistols II: Light Sidearms",
  combat_marksman_pistol_03: "Pistols III: Medium Sidearms",
  combat_marksman_pistol_04: "Pistols IV: Heavy Sidearms",
  combat_marksman_rifle_01: "Rifles I: Long Range Combat",
  combat_marksman_rifle_02: "Rifles II: Concealed Firing",
  combat_marksman_rifle_03: "Rifles III: Improved Aim",
  combat_marksman_rifle_04: "Rifles IV: Sniping",
  combat_marksman_support_01: "Ranged Support I: Aim & Threaten",
  combat_marksman_support_02: "Ranged Support II: Maneuvers",
  combat_marksman_support_03: "Ranged Support III: Warning Shot",
  combat_marksman_support_04: "Ranged Support IV: Suppression",
  combat_medic: "Combat Medic",
  combat_melee_basic: "Melee combat: basic knowledge",
  combat_melee_teras_kasi_basic: "Teras Kasi: basic knowledge",
  combat_melee_teras_kasi_power_advanced: "Teras Kasi: advanced power",
  combat_melee_teras_kasi_power_basic: "Teras Kasi: basic power",
  combat_melee_teras_kasi_power_expert: "Teras Kasi: expert power",
  combat_melee_teras_kasi_power_intermediate: "Teras Kasi: intermediate power",
  combat_melee_teras_kasi_speed_advanced: "Teras Kasi: advanced speed",
  combat_melee_teras_kasi_speed_basic: "Teras Kasi: basic speed",
  combat_melee_teras_kasi_speed_expert: "Teras Kasi: expert speed",
  combat_melee_teras_kasi_speed_intermediate: "Teras Kasi: intermediate speed",
  combat_melee_teras_kasi_technique_advanced: "Teras Kasi: advanced technique",
  combat_melee_teras_kasi_technique_basic: "Teras Kasi: basic technique",
  combat_melee_teras_kasi_technique_expert: "Teras Kasi: expert technique",
  combat_melee_teras_kasi_technique_intermediate:
    "Teras Kasi: intermediate technique",
  combat_meleespecialize_onehand_advanced:
    "Melee Specialist: advanced one-handed combat",
  combat_meleespecialize_onehand_basic:
    "Melee Specialist: basic one-handed combat",
  combat_meleespecialize_onehand_expert:
    "Melee Specialist: expert one-handed combat",
  combat_meleespecialize_onehand_intermediate:
    "Melee Specialist: intermediate one-handed combat",
  combat_meleespecialize_onehand_specialist:
    "Melee Specialist: one-hand specialization",
  combat_meleespecialize_polearm_advanced:
    "Melee Specialist: advanced pole-arm techniques",
  combat_meleespecialize_polearm_basic:
    "Melee Specialist: basic polearm abilities",
  combat_meleespecialize_polearm_expert:
    "Melee Specialist: expert polearm combat techniques",
  combat_meleespecialize_polearm_intermediate:
    "Melee Specialist: intermediate polearm",
  combat_meleespecialize_polearm_specialist:
    "Melee Specialist: polearm specialization",
  combat_meleespecialize_teras_kasi_specialist: "Teras Kasi: Specialist",
  combat_meleespecialize_twohand_advanced:
    "Melee Specialist: advanced two-hand combat techniques",
  combat_meleespecialize_twohand_basic:
    "Melee Specialist: basic two-hand combat ability",
  combat_meleespecialize_twohand_expert:
    "Melee Specialist: expert two-hand combat ability",
  combat_meleespecialize_twohand_intermediate:
    "Melee Specialist: intermediate two-handed combat",
  combat_meleespecialize_twohand_specialist:
    "Melee Specialist: two-hand specialization",
  combat_pistol: "Pistoleer",
  combat_pistol_ability_01: "Pistol Techniques I: Disarming Shot",
  combat_pistol_ability_02: "Pistol Techniques II: Double Tap",
  combat_pistol_ability_03: "Pistol Techniques III: Stopping Shot",
  combat_pistol_ability_04: "Pistol Techniques IV: Fan Shot",
  combat_pistol_accuracy_01: "Pistol Grips I: Point Blank Hold",
  combat_pistol_accuracy_02: "Pistol Grips II: Dodge Hold",
  combat_pistol_accuracy_03: "Pistol Grips III: Two-Handed Aim & Fire",
  combat_pistol_accuracy_04: "Pistol Grips IV: Rapid Trigger Work",
  combat_pistol_master: "Master Pistoleer",
  combat_pistol_novice: "Novice Pistoleer",
  combat_pistol_speed_01: "Pistol Marksmanship I: Wrist Stability",
  combat_pistol_speed_02: "Pistol Marksmanship II: Firing on the Move",
  combat_pistol_speed_03: "Pistol Marksmanship III: Fast Target Acquisition",
  combat_pistol_speed_04: "Pistol Marksmanship IV: Dead-Eye Aim",
  combat_pistol_support_01: "Pistol Stances I: Close Range Stability",
  combat_pistol_support_02: "Pistol Stances II: Quick-Draw Posture",
  combat_pistol_support_03: "Pistol Stances III: Firing from the Hip",
  combat_pistol_support_04: "Pistol Stances IV: Advanced Coordination",
  combat_polearm: "Pikeman",
  combat_polearm_ability_01: "Intermediate Polearm Defensive Techniques",
  combat_polearm_ability_02: "Advanced Polearm Defensive Techniques",
  combat_polearm_ability_03: "Expert Polearm Defensive Techniques",
  combat_polearm_ability_04: "Master Polearm Defensive Techniques",
  combat_polearm_accuracy_01: "Intermediate Polearm Stances",
  combat_polearm_accuracy_02: "Advanced Polearm Stances",
  combat_polearm_accuracy_03: "Expert Polearm Stances",
  combat_polearm_accuracy_04: "Master Polearm Stances",
  combat_polearm_master: "Master Pikeman",
  combat_polearm_novice: "Novice Pikeman",
  combat_polearm_speed_01: "Intermediate Polearm Offensive Techniques",
  combat_polearm_speed_02: "Advanced Polearm Offensive Techniques",
  combat_polearm_speed_03: "Expert Polearm Offensive Techniques",
  combat_polearm_speed_04: "Master Polearm Offensive Techniques",
  combat_polearm_support_01: "Intermediate Polearm Support Abilities",
  combat_polearm_support_02: "Advanced Polearm Support Abilities",
  combat_polearm_support_03: "Expert Polearm Support Abilities",
  combat_polearm_support_04: "Master Polearm Support Abilities",
  combat_ranged_accuracy_advanced: "Ranged combat: advanced accuracy",
  combat_ranged_accuracy_basic: "Ranged combat: basic accuracy",
  combat_ranged_accuracy_expert: "Ranged combat: expert accuracy",
  combat_ranged_accuracy_intermediate: "Ranged combat: intermediate accuracy",
  combat_ranged_speed_advanced: "Ranged combat: advanced speed",
  combat_ranged_speed_basic: "Ranged combat: basic speed",
  combat_ranged_speed_expert: "Ranged combat: expert speed",
  combat_ranged_speed_intermediate: "Ranged combat: intermediate speed",
  combat_ranged_weapons_basic: "Ranged combat: basic ranged weapon ability",
  combat_rangedspecialize_carbine_advanced:
    "Ranged specialization: advanced carbine",
  combat_rangedspecialize_carbine_basic: "Ranged specialization: basic carbine",
  combat_rangedspecialize_carbine_intermediate:
    "Ranged specialization: intermediate carbine",
  combat_rangedspecialize_carbine_specialist:
    "Ranged Specialization: Carbine Specialist",
  combat_rangedspecialize_pistol_advanced:
    "Ranged Specialization: Advanced Pistol",
  combat_rangedspecialize_pistol_basic: "Ranged Specialization: Basic Pistols",
  combat_rangedspecialize_pistol_intermediate:
    "Ranged Specialization: Intermediate Pistol Technique",
  combat_rangedspecialize_pistol_specialist:
    "Ranged Specialization: Pistol Specialist",
  combat_rangedspecialize_rifle_advanced:
    "Ranged Specialization: Advanced Rifle",
  combat_rangedspecialize_rifle_basic: "Ranged Specialization: Basic Rifle",
  combat_rangedspecialize_rifle_intermediate:
    "Ranged Specialization: Intermediate Rifle",
  combat_rangedspecialize_rifle_specialist:
    "Ranged Specialization: Rifle Specialist",
  combat_rifleman: "Rifleman",
  combat_rifleman_ability_01: "Counter-Sniping I: Flushing Shot",
  combat_rifleman_ability_02: "Counter-Sniping II: Startling Shot",
  combat_rifleman_ability_03: "Counter-Sniping III: Advanced Flushing Shot",
  combat_rifleman_ability_04: "Counter-Sniping IV: Advanced Startling Shot",
  combat_rifleman_accuracy_01: "Sniping I: Mind Shot 2",
  combat_rifleman_accuracy_02: "Sniping II: Head Shot 3",
  combat_rifleman_accuracy_03: "Sniping III: Surprise Shot",
  combat_rifleman_accuracy_04: "Sniping IV: Sniper Shot",
  combat_rifleman_master: "Master Rifleman",
  combat_rifleman_novice: "Novice Rifleman",
  combat_rifleman_speed_01: "Concealment I: Conceal Shot",
  combat_rifleman_speed_02: "Concealment II: Cover Fighting",
  combat_rifleman_speed_03: "Concealment III: Sneak and Shoot",
  combat_rifleman_speed_04: "Concealment IV: Silent Assassin",
  combat_rifleman_support_01: "Rifle Abilities I: Flurry Shot",
  combat_rifleman_support_02: "Rifle Abilities II: Defensive Firing",
  combat_rifleman_support_03: "Rifle Abilities III: Flurry Shot 2",
  combat_rifleman_support_04: "Rifle Abilities IV: Fast Sniping",
  combat_smuggler: "Smuggler",
  combat_smuggler_combat_01: "Dirty Fighting I: Feign Death",
  combat_smuggler_combat_02: "Dirty Fighting II: Shooting Wild",
  combat_smuggler_combat_03: "Dirty Fighting III: Low Blow",
  combat_smuggler_combat_04: "Dirty Fighting IV: Last Ditch Assault",
  combat_smuggler_master: "Master Smuggler",
  combat_smuggler_novice: "Novice Smuggler",
  combat_smuggler_slicing_01: "Slicing I: Terminals",
  combat_smuggler_slicing_02: "Slicing II: Weapon Basic",
  combat_smuggler_slicing_03: "Slicing III: Armor",
  combat_smuggler_slicing_04: "Slicing IV: Weapon Advanced",
  combat_smuggler_spice_01: "Spices I: Naturals",
  combat_smuggler_spice_02: "Spices II: Meds",
  combat_smuggler_spice_03: "Spices III: Stims",
  combat_smuggler_spice_04: "Spices IV: Chems",
  combat_smuggler_underworld_01: "Underworld I: Negotiator",
  combat_smuggler_underworld_02: "Underworld II: Fast Talker",
  combat_smuggler_underworld_03: "Underworld III: Sell Out",
  combat_smuggler_underworld_04: "Underworld IV: Connections",
  combat_tactic_block_advanced: "Combat Tactics: Advanced Blocking",
  combat_tactic_block_basic: "Combat Tactics: Basic Blocking",
  combat_tactic_block_expert: "Combat Tactics: Expert Blocking",
  combat_tactic_block_intermediate: "Combat Tactics: Intermediate Blocking",
  combat_tactic_counter_advanced: "Combat Tactics: Advanced Counter-attack",
  combat_tactic_counter_basic: "Combat Tactics: Basic Counter-attack",
  combat_tactic_counter_expert: "Combat Tactics: Expert Counter-attack",
  combat_tactic_evade_advanced: "Combat Tactics: Advanced Evasion Techniques",
  combat_tactic_evade_basic: "Combat Tactics: Basic Evasion",
  combat_tactic_evade_expert: "Combat Tactics: Evasion Expert",
  combat_tactic_general_basic: "Combat Tactics: General Combat Technique",
  combat_tactic_ranged_weapon_ability_advanced:
    "Combat Tactics: Advanced Ranged Weapon Ability",
  combat_tactic_ranged_weapon_ability_basic:
    "Combat Tactics: Basic Ranged Weapon Ability",
  combat_tactic_ranged_weapon_ability_expert:
    "Combat Tactics: Expert Ranged Weapon Ability",
  combat_tactic_stealth_advanced: "Combat Tactics: Advanced Stealth Techniques",
  combat_tactic_stealth_basic: "Combat Tactics: Basic Stealth",
  combat_tactic_stealth_expert: "Combat Tactics: Stealth Expert",
  combat_tactic_strategy_advanced: "Combat Tactics: Advanced Strategy",
  combat_tactic_strategy_basic: "Combat Tactics: Basic Strategy",
  combat_tactic_strategy_expert: "Combat Tactics: Expert Strategy",
  combat_tactic_strategy_intermediate: "Combat Tactics: Intermediate Strategy",
  combat_unarmed: "Teras Kasi Artist",
  combat_unarmed_ability_01: "Intermediate Power Techniques",
  combat_unarmed_ability_02: "Advanced Power Techniques",
  combat_unarmed_ability_03: "Expert Power Techniques",
  combat_unarmed_ability_04: "Master Power Techniques",
  combat_unarmed_accuracy_01: "Intermediate Meditative Techniques",
  combat_unarmed_accuracy_02: "Advanced Meditative Techniques",
  combat_unarmed_accuracy_03: "Expert Meditative Techniques",
  combat_unarmed_accuracy_04: "Master Meditative Techniques",
  combat_unarmed_master: "Teras Kasi Master",
  combat_unarmed_novice: "Teras Kasi Novice",
  combat_unarmed_speed_01: "Intermediate Balance Conditioning",
  combat_unarmed_speed_02: "Advanced Balance Conditioning",
  combat_unarmed_speed_03: "Expert Balance Conditioning",
  combat_unarmed_speed_04: "Master Balance Conditioning",
  combat_unarmed_support_01: "Intermediate Precision Striking",
  combat_unarmed_support_02: "Advanced Precision Striking",
  combat_unarmed_support_03: "Expert Precision Striking",
  combat_unarmed_support_04: "Master Precision Striking",
  commando: "Commando",
  commerce: "Commerce",
  common_knowledge: "Common Knowledge",
  craft_armor_advanced_armor_designer: "Armorsmith: Advanced Armor Designer",
  craft_armor_advanced_segment_construction:
    "Armorsmith: Advanced Segment Construction",
  craft_armor_armor_layers: "Armorsmith: Armor Layer Construction Techniques",
  craft_armor_composite_armor_segments: "Armorsmith: Composite Armor Segments",
  craft_armor_deflector_shield_components:
    "Armorsmith: Deflector Shield Components",
  craft_armor_deflector_shield_fundamentals:
    "Armorsmith: Deflector Shield Fundamentals",
  craft_armor_expert_armor_designer: "Armorsmith: Expert Armor Designer",
  craft_armor_heavy_armor_modules:
    "Armorsmith: Heavy Armor Modules Construction Techniques",
  craft_armor_light_armor_modules:
    "Armorsmith: Light Armor Modules Construction Techniques",
  craft_armor_natural_armor_segments: "Armorsmith: Natural Armor Segments",
  craft_armor_novice_armor_designer: "Armorsmith: Novice Armor Designer",
  craft_cook_culinaryskill_advanced: "Cooking: Advanced Culinary Skill",
  craft_cook_culinaryskill_basic: "Cooking: Basic Culinary Skill",
  craft_cook_culinaryskill_expert: "Cooking: Expert Culinary Skill",
  craft_cook_culinaryskill_intermediate: "Cooking: Intermediate Culinary Skill",
  craft_cook_general_advanced: "Cooking: Advanced General Knowledge",
  craft_cook_general_expert: "Cooking: Expert General Knowledge",
  craft_cook_general_intermediate: "Cooking: Intermediate General Knowledge",
  craft_cook_general_novice: "Cooking: Novice",
  craft_cook_technique_advanced: "Cooking: Advanced Technique",
  craft_cook_technique_basic: "Cooking: Basic Technique",
  craft_cook_technique_expert: "Cooking: Expert Technique",
  craft_cook_technique_intermediate: "Cooking: Intermediate Technique",
  craft_factory_efficiency_advanced: "Factories: Advanced Efficiency",
  craft_factory_efficiency_basic: "Factories: Basic Efficiency",
  craft_factory_efficiency_expert: "Factories: Efficiency Expert",
  craft_factory_efficiency_intermediate: "Factories: Intermediate Efficiency",
  craft_factory_efficiency_specialist: "Factories: Efficiency Specialist",
  craft_factory_maintenance_advanced: "Factories: Advanced Maintenance",
  craft_factory_maintenance_basic: "Factories: Basic Maintenance",
  craft_factory_maintenance_expert: "Factories: Expert Maintenance",
  craft_factory_maintenance_intermediate: "Factories: Intermediate Maintenance",
  craft_factory_management_advanced: "Factories: Advanced Maintenance",
  craft_factory_management_basic: "Factories: Basic Management",
  craft_factory_management_expert: "Factories: Expert Management",
  craft_factory_management_intermediate: "Factories: Intermediate Management",
  craft_factory_speed_advanced: "Factories: Advanced Speed",
  craft_factory_speed_basic: "Factories: Basic Speed",
  craft_factory_speed_expert: "Factories: Expert Speed",
  craft_factory_speed_intermediate: "Factories: Intermediate Speed",
  craft_farm_management_advanced: "Farming: Advanced Management",
  craft_farm_management_basic: "Farming: Basic Management",
  craft_farm_management_expert: "Farming: Expert Management",
  craft_farm_management_intermediate: "Farming: Intermediate Management",
  craft_farm_management_specialist: "Farming: Management Specialist",
  craft_farm_producecrop_advanced: "Farming: Advanced Crop Production",
  craft_farm_producecrop_basic: "Farming: Basic Crop Production",
  craft_farm_producecrop_expert: "Farming: Expert Crop Production",
  craft_farm_producecrop_intermediate: "Farming: Intermediate Crop Production",
  craft_farm_producecrop_specialist: "Farming: Crop Production Specialist",
  craft_farm_producelivestock_advanced:
    "Ranching: Advanced Livestock Production",
  craft_farm_producelivestock_basic: "Ranching: Basic Livestock Production",
  craft_farm_producelivestock_expert: "Ranching: Livestock Production Expert",
  craft_farm_producelivestock_intermediate:
    "Ranching: Intermediate Livestock Production",
  craft_farm_producelivestock_specialist:
    "Ranching: Livestock Production Specialist",
  craft_general_engineering_advanced: "Crafting: Advanced General Engineering",
  craft_general_engineering_basic: "Crafting: Basic General Engineering",
  craft_general_engineering_expert: "Crafting: Expert Engineering",
  craft_general_engineering_intermediate: "Crafting: Intermediate Engineering",
  craft_general_engineering_specialist: "Crafting: Engineering Specialist",
  craft_general_experimentation_advanced: "Crafting: Advanced Experimentation",
  craft_general_experimentation_basic: "Crafting: Basic Experimentation",
  craft_general_experimentation_expert: "Crafting: Expert Experimentation",
  craft_general_experimentation_specialist:
    "Crafting: Experimentation Specialist",
  craft_general_itemdesign_advanced: "Crafting: Advanced Item Design",
  craft_general_itemdesign_basic: "Crafting: Basic Item Design",
  craft_general_itemdesign_expert: "Crafting: Expert Item Design",
  craft_general_itemdesign_specialist: "Crafting: Item Design Specialist",
  craft_general_repair_advanced: "Crafting: Advanced General Repair",
  craft_general_repair_basic: "Crafting: Basic Repair",
  craft_general_repair_expert: "Crafting: Expert General Repair",
  craft_general_repairsalvage_specialist: "Repair / Salvage Specialist",
  craft_general_salvage_advanced: "Crafting: Advanced Salvage",
  craft_general_salvage_basic: "Crafting: Basic Salvage",
  craft_general_salvage_expert: "Crafting: Salvage Expert",
  craft_resource_mineliquid_advanced: "Liquid Mining: Advanced",
  craft_resource_mineliquid_basic: "Liquid Mining: Basic",
  craft_resource_mineliquid_expert: "Liquid Mining: Expert",
  craft_resource_mineliquid_specialist: "Liquid Mining: Specialist",
  craft_resource_minemineral_advanced: "Mineral Mining: Advanced",
  craft_resource_minemineral_basic: "Mineral Mining: Basic",
  craft_resource_minemineral_expert: "Mineral Mining: Expert",
  craft_resource_minemineral_specialist: "Mineral Mining: Specialist",
  craft_resource_minerenewable_advanced: "Renewable Resource Mining: Advanced",
  craft_resource_minerenewable_basic: "Renewable Resource Mining: Basic",
  craft_resource_minerenewable_expert: "Renewable Resource Mining: Expert",
  craft_resource_minerenewable_specialist:
    "Renewable Resource Mining: Specialist",
  craft_resource_survey_advanced: "Surveying: Advanced",
  craft_resource_survey_basic: "Surveying: Basic",
  craft_resource_survey_expert: "Surveying: Expert",
  craft_resource_survey_specialist: "Surveying: Specialist",
  craft_tailor_accessory_advanced: "Tailoring: Advanced Accessories",
  craft_tailor_accessory_basic: "Tailoring: Basic Accessories",
  craft_tailor_accessory_expert: "Tailoring: Expert Accessories",
  craft_tailor_accessory_intermediate: "Tailoring: Intermediate Accessories",
  craft_tailor_dye_advanced: "Tailoring: Advanced Dyes",
  craft_tailor_dye_basic: "Tailoring: Basic Dyes",
  craft_tailor_dye_expert: "Tailoring: Expert Dyes",
  craft_tailor_dye_intermediate: "Tailoring: Intermediate Dyes",
  craft_tailor_general_advanced: "Tailoring: Advanced General",
  craft_tailor_general_expert: "Tailoring: Expert General",
  craft_tailor_general_intermediate: "Tailoring: Intermediate General",
  craft_tailor_general_novice: "Tailoring: Novice General",
  craft_tailor_material_advanced: "Tailoring: Advanced Materials",
  craft_tailor_material_basic: "Tailoring: Basic Materials",
  craft_tailor_material_expert: "Tailoring: Expert Materials",
  craft_tailor_material_intermediate: "Tailoring: Intermediate Materials",
  craft_vend_accounting_advanced: "Vending: Advanced Accounting",
  craft_vend_accounting_basic: "Vending: Basic Accounting",
  craft_vend_accounting_expert: "Vending: Expert Accounting",
  craft_vend_accounting_intermediate: "Vending: Intermediate Accounting",
  craft_vend_customization_advanced: "Vending: Advanced Customization",
  craft_vend_customization_basic: "Vending: Basic Customization",
  craft_vend_customization_expert: "Vending: Customization Expert",
  craft_vend_customization_intermediate: "Vending: Intermediate Customization",
  craft_vend_management_advanced: "Vending: Advanced Management",
  craft_vend_management_basic: "Vending: Basic Management",
  craft_vend_management_expert: "Vending: Expert Management",
  craft_vend_management_intermediate: "Vending: Intermediate Management",
  craft_vend_salespecialist_advanced: "Vending: Advanced Sales Specialist",
  craft_vend_salespecialist_basic: "Vending: Basic Sales Specialization",
  craft_vend_salespecialist_expert: "Vending: Expert Sales Specialist",
  craft_vend_salespecialist_intermediate:
    "Vending: Intermediate Sales Specialist",
  craft_weapon_melee_blade_crafting: "Melee Weapon Crafting: Basic Blades",
  craft_weapon_melee_blunt_implements:
    "Melee Weapon Crafting: Blunt Implements",
  craft_weapon_melee_grips_and_handles:
    "Melee Weapon Crafting: Grips and Handles",
  craft_weapon_melee_two_handed_weapon_design:
    "Melee Weapon Crafting: Two-handed Weapons Design",
  craft_weapon_melee_vibro_weapon_construction:
    "Melee Weapon Crafting: Vibro-weapon Construction Techniques",
  craft_weapon_melee_weapon_construction_techniques:
    "Melee Weapon Crafting: Construction Techniques",
  craft_weapon_melee_weapontech_advanced: "Crafting: Advanced Melee Weapontech",
  craft_weapon_melee_weapontech_expert: "Crafting: Expert Melee Weapontech",
  craft_weapon_melee_weapontech_novice: "Crafting: Novice Melee Weapontech",
  craft_weapon_munition_ballistics_advanced:
    "Munitions Crafting: Advanced Ballistics",
  craft_weapon_munition_ballistics_basic:
    "Munitions Crafting: Basic Ballistics",
  craft_weapon_munition_ballistics_expert:
    "Munitions Crafting: Expert Ballistics",
  craft_weapon_munition_explosives_advanced:
    "Munitions Crafting: Advanced Explosives",
  craft_weapon_munition_explosives_basic:
    "Munitions Crafting: Basic Explosives",
  craft_weapon_munition_explosives_expert:
    "Munitions Crafting: Expert Explosives",
  craft_weapon_munition_explosivetech_advanced:
    "Munitions Crafting: Advanced Explosives-tech",
  craft_weapon_munition_explosivetech_expert:
    "Munitions Crafting: Expert Explosives-tech",
  craft_weapon_munition_explosivetech_novice:
    "Munitions Crafting: Novice Explosives-tech",
  craft_weapon_ranged_advanced_ranged_weapons_technician:
    "Gunsmith: Advanced Ranged Weapons Technician",
  craft_weapon_ranged_chassis_components:
    "Gunsmith: Chassis Component Construction",
  craft_weapon_ranged_expert_ranged_weapons_technician:
    "Gunsmith: Expert Ranged Weapons Technician",
  craft_weapon_ranged_firing_mechanisms: "Gunsmith: Firing Mechanisms Crafting",
  craft_weapon_ranged_heavy_ballistic_weapon_design:
    "Gunsmith: Heavy Ballistic Weapons Design",
  craft_weapon_ranged_heavy_energy_weapon_design:
    "Gunsmith: Heavy Energy Weapons Design",
  craft_weapon_ranged_heavy_weapon_construction:
    "Gunsmith: Heavy Weapons Construction Techniques",
  craft_weapon_ranged_light_ballistic_weapon_design:
    "Gunsmith: Light Ballistic Weapons Design",
  craft_weapon_ranged_light_energy_weapon_design:
    "Gunsmith: Light Energy Weapons Design",
  craft_weapon_ranged_light_weapon_construction:
    "Gunsmith: Light Weapons Construction Techniques",
  craft_weapon_ranged_novice_ranged_weapons_technician:
    "Gunsmith: Novice Ranged Weapons Technician",
  craft_weapon_ranged_weapon_accessories:
    "Gunsmith: Ranged Weapon Accessories Crafting Ability",
  crafting_architect: "Architect",
  crafting_architect_blueprints_01: "Buildings I: Small Houses",
  crafting_architect_blueprints_02: "Buildings II: Medium Houses",
  crafting_architect_blueprints_03: "Buildings III: Large Houses",
  crafting_architect_blueprints_04: "Buildings IV: Large Houses",
  crafting_architect_harvest_04: "Master Harvester Construction",
  crafting_architect_harvesting_01: "Installations I: Factories",
  crafting_architect_harvesting_02: "Installations II: Medium Harvesters",
  crafting_architect_harvesting_03: "Installations III: Medium Harvesters",
  crafting_architect_harvesting_04: "Installations IV: Heavy Harvesters",
  crafting_architect_master: "Master Architect",
  crafting_architect_novice: "Novice Architect",
  crafting_architect_production_01: "Furniture I: Modest",
  crafting_architect_production_02: "Furniture II: Stylish",
  crafting_architect_production_03: "Furniture III: Advanced",
  crafting_architect_production_04: "Furniture IV: Tech",
  crafting_architect_techniques_01: "Construction I: Intermediate",
  crafting_architect_techniques_02: "Construction II: Advanced",
  crafting_architect_techniques_03: "Construction III: Expert",
  crafting_architect_techniques_04: "Construction IV: Master",
  crafting_armorsmith: "Armorsmith",
  crafting_armorsmith_complexity_01: "Technique I: Protection Fundamentals",
  crafting_armorsmith_complexity_02: "Technique II: Advanced Outfitting",
  crafting_armorsmith_complexity_03: "Technique III: Expert Outfitting",
  crafting_armorsmith_complexity_04: "Technique IV: Armor Crafting Mastery",
  crafting_armorsmith_deflectors_01: "Deflectors I: Deflector Components",
  crafting_armorsmith_deflectors_02: "Deflectors II: Mk 1 Technology",
  crafting_armorsmith_deflectors_03: "Deflectors III: Mk 2 Technology",
  crafting_armorsmith_deflectors_04: "Deflectors IV: Mk 3 Technology",
  crafting_armorsmith_heavy_01: "Layers I: Basic Enhancements",
  crafting_armorsmith_heavy_02: "Layers II: Blast & Heat",
  crafting_armorsmith_heavy_03: "Layers III: Cold & Shock",
  crafting_armorsmith_heavy_04: "Layers IV: Exotic Protection",
  crafting_armorsmith_master: "Master Armorsmith",
  crafting_armorsmith_novice: "Novice Armorsmith",
  crafting_armorsmith_personal_01: "Personal Armor I: Chitin",
  crafting_armorsmith_personal_02: "Personal Armor II: Tantel",
  crafting_armorsmith_personal_03: "Personal Armor III: Ubese",
  crafting_armorsmith_personal_04: "Personal Armor IV: Padded",
  crafting_artisan: "Artisan",
  crafting_artisan_business_01: "Business I: Access Fees",
  crafting_artisan_business_02: "Business II: Advanced Sales",
  crafting_artisan_business_03: "Business III: Business Ownership",
  crafting_artisan_business_04: "Business IV: Business Diversity",
  crafting_artisan_domestic_01: "Domestic Arts I: Simple Cooking",
  crafting_artisan_domestic_02: "Domestic Arts II: Simple Tailoring",
  crafting_artisan_domestic_03: "Domestic Arts III: Basic Desserts",
  crafting_artisan_domestic_04: "Domestic Arts IV: Clothing Repair",
  crafting_artisan_engineering_01: "Engineering I: Tinkering",
  crafting_artisan_engineering_02: "Engineering II: Hardware Design",
  crafting_artisan_engineering_03: "Engineering III: Advanced Concepts",
  crafting_artisan_engineering_04: "Engineering IV: Complex Systems",
  crafting_artisan_master: "Master Artisan",
  crafting_artisan_novice: "Novice Artisan",
  crafting_artisan_survey_01: "Surveying I: Improved Results",
  crafting_artisan_survey_02: "Surveying II: Increased Range",
  crafting_artisan_survey_03: "Surveying III: Exceptional Results",
  crafting_artisan_survey_04: "Surveying IV: Regional Surveying",
  crafting_chef: "Chef",
  crafting_chef_dessert_01: "Desserts I: Pastries",
  crafting_chef_dessert_02: "Desserts II: Cakes",
  crafting_chef_dessert_03: "Desserts III: Complex Desserts",
  crafting_chef_dessert_04: "Desserts IV: Delicious Creations",
  crafting_chef_dish_01: "Entrees I: Basic Meals",
  crafting_chef_dish_02: "Entrees II: Advanced Cooking",
  crafting_chef_dish_03: "Entrees III: Complex Dishes",
  crafting_chef_dish_04: "Entrees IV: Creative Dishes",
  crafting_chef_drink_01: "Mixology I: Cantina Favorites",
  crafting_chef_drink_02: "Mixology II: Fruity Drinks",
  crafting_chef_drink_03: "Mixology III: Hard Drinks",
  crafting_chef_drink_04: "Mixology IV: Regional Favorites",
  crafting_chef_master: "Master Chef",
  crafting_chef_novice: "Novice Chef",
  crafting_chef_techniques_01: "Cooking I: Experimentation",
  crafting_chef_techniques_02: "Cooking II: Nutrition",
  crafting_chef_techniques_03: "Cooking III: Creative Flavoring",
  crafting_chef_techniques_04: "Cooking IV: Culinary Mastery",
  crafting_droidengineer: "Droid Engineer",
  crafting_droidengineer_blueprints_01: "Intermediate Droid Blueprints",
  crafting_droidengineer_blueprints_02: "Advanced Droid Blueprints",
  crafting_droidengineer_blueprints_03: "Expert Droid Blueprints",
  crafting_droidengineer_blueprints_04: "Master Droid Blueprints",
  crafting_droidengineer_master: "Master Droid Engineer",
  crafting_droidengineer_novice: "Novice Droid Engineer",
  crafting_droidengineer_production_01: "Intermediate Droid Production",
  crafting_droidengineer_production_02: "Advanced Droid Production",
  crafting_droidengineer_production_03: "Expert Droid Production",
  crafting_droidengineer_production_04: "Master Droid Production",
  crafting_droidengineer_refinement_01: "Intermediate Droid Refinement",
  crafting_droidengineer_refinement_02: "Advanced Droid Refinement",
  crafting_droidengineer_refinement_03: "Expert Droid Refinement",
  crafting_droidengineer_refinement_04: "Master Droid Refinement",
  crafting_droidengineer_techniques_01:
    "Intermediate Droid Construction Techniques",
  crafting_droidengineer_techniques_02:
    "Advanced Droid Construction Techniques",
  crafting_droidengineer_techniques_03: "Expert Droid Construction Techniques",
  crafting_droidengineer_techniques_04: "Master Droid Construction Techniques",
  crafting_merchant: "Merchant",
  crafting_merchant_advertising_01: "Advertising I: Vocalization Training",
  crafting_merchant_advertising_02: "Advertising II: Advanced Vocalization",
  crafting_merchant_advertising_03: "Advertising III: Planetary Ad Campaign",
  crafting_merchant_advertising_04: "Advertising IV: Advertising Efficiency",
  crafting_merchant_hiring_01: "Hiring I: Selective Hiring",
  crafting_merchant_hiring_02: "Hiring II: Expanded Hiring",
  crafting_merchant_hiring_03: "Hiring III: Complete Hiring",
  crafting_merchant_hiring_04: "Hiring IV: Uniforms",
  crafting_merchant_management_01: "Management I: Additional Vendor",
  crafting_merchant_management_02: "Management II: Additional Vendor",
  crafting_merchant_management_03: "Management III: Additional Vendor",
  crafting_merchant_management_04: "Management IV: Additional Vendor",
  crafting_merchant_master: "Master Merchant",
  crafting_merchant_novice: "Novice Merchant",
  crafting_merchant_sales_01: "Efficiency I: Market",
  crafting_merchant_sales_02: "Efficiency II: Vendor",
  crafting_merchant_sales_03: "Efficiency III: Increased Market",
  crafting_merchant_sales_04: "Efficiency IV: Structures",
  crafting_shipwright: "Shipwright",
  crafting_shipwright_defense_01: "Defense Systems I:  Light Armaments",
  crafting_shipwright_defense_02: "Defense Systems II: Standard Ordnance",
  crafting_shipwright_defense_03: "Defense Systems III: Heavy Weapons",
  crafting_shipwright_defense_04: "Defense Systems IV: Advanced Ship Defense",
  crafting_shipwright_engineering_01: "Spaceframe Engineering I: Small Chassis",
  crafting_shipwright_engineering_02:
    "Spaceframe Engineering II: Standard Assault Ships",
  crafting_shipwright_engineering_03:
    "Spaceframe Engineering III: Heavy Fighters",
  crafting_shipwright_engineering_04:
    "Spaceframe Engineering IV: Advanced Ship Design",
  crafting_shipwright_master: "Master Shipwright",
  crafting_shipwright_novice: "Novice Shipwright",
  crafting_shipwright_propulsion_01:
    "Propulsion Technology I: Simple Ion Drives",
  crafting_shipwright_propulsion_02:
    "Propulsion Technology II: Thrust Dynamics",
  crafting_shipwright_propulsion_03:
    "Propulsion Technology III: Advanced Hyperdrive Engineering",
  crafting_shipwright_propulsion_04:
    "Propulsion Technology IV: Advanced Drive Theory",
  crafting_shipwright_systems_01: "Core Systems I: Basic Systems",
  crafting_shipwright_systems_02: "Core Systems II: Intermediate Ship Devices",
  crafting_shipwright_systems_03: "Core Systems III: Heavy Internal Systems",
  crafting_shipwright_systems_04: "Core Systems IV: Advanced Assembly",
  crafting_starfighter_engineer: "Starfighter Engineer",
  crafting_starfighter_engineer_defense_01:
    "Defensive Systems I: Shield Projectors",
  crafting_starfighter_engineer_defense_02:
    "Defensive Systems II: Advanced Durasteel Weaves",
  crafting_starfighter_engineer_defense_03:
    "Defensive Systems III: Anti-Missile Defense",
  crafting_starfighter_engineer_defense_04:
    "Defensive Systems IV: Advanced Shield Technology",
  crafting_starfighter_engineer_infrastructure_01:
    "Advanced Infrastructure I: Large-Block Power Plants",
  crafting_starfighter_engineer_infrastructure_02:
    "Advanced Infrastructure II: Military-Grade Engines",
  crafting_starfighter_engineer_infrastructure_03:
    "Advanced Infrastructure III: Advanced Reactor Design",
  crafting_starfighter_engineer_infrastructure_04:
    "Advanced Infrastructure IV: Experimental Drives",
  crafting_starfighter_engineer_master: "Master Starfighter Engineer",
  crafting_starfighter_engineer_novice: "Novice Starfighter Engineer",
  crafting_starfighter_engineer_systems_01:
    "Advanced Core Systems I: High Performance Boosters",
  crafting_starfighter_engineer_systems_02:
    "Advanced Core Systems II: Advanced Aftermarket Design",
  crafting_starfighter_engineer_systems_03:
    "Advanced Core Systems III: Droid Interfaces",
  crafting_starfighter_engineer_systems_04:
    "Advanced Core Systems IV: Elite Modification",
  crafting_starfighter_engineer_weapons_01:
    "Combat Systems I: Cannon and Blaster Tech",
  crafting_starfighter_engineer_weapons_02:
    "Combat Systems II: Disruptor Technology",
  crafting_starfighter_engineer_weapons_03:
    "Combat Systems III: Missile Systems",
  crafting_starfighter_engineer_weapons_04:
    "Combat Systems IV: Advanced Weapon Technology",
  crafting_tailor: "Tailor",
  crafting_tailor_casual_01: "Casual Wear I: Basics",
  crafting_tailor_casual_02: "Casual Wear II: Synthetics",
  crafting_tailor_casual_03: "Casual Wear III: Weather Wear",
  crafting_tailor_casual_04: "Casual Wear IV: Complex Clothing",
  crafting_tailor_field_01: "Field Wear I: Basic Gear",
  crafting_tailor_field_02: "Field Wear II: Reinforced Fibers",
  crafting_tailor_field_03: "Field Wear III: Martial Gear",
  crafting_tailor_field_04: "Field Wear IV: Paramilitary Gear",
  crafting_tailor_formal_01: "Formal Wear I: Fashion Basics",
  crafting_tailor_formal_02: "Formal Wear II: Jewelry",
  crafting_tailor_formal_03: "Formal Wear III: Gowns",
  crafting_tailor_formal_04: "Formal Wear IV: High Fashion",
  crafting_tailor_master: "Master Tailor",
  crafting_tailor_novice: "Novice Tailor",
  crafting_tailor_production_01: "Tailoring I: Experimentation",
  crafting_tailor_production_02: "Tailoring II: Repair",
  crafting_tailor_production_03: "Tailoring III: Advanced Techniques",
  crafting_tailor_production_04: "Tailoring IV: Technical Mastery",
  crafting_weaponsmith: "Weaponsmith",
  crafting_weaponsmith_firearms_01: "Intermediate Firearms Crafting",
  crafting_weaponsmith_firearms_02: "Advanced Firearms Crafting",
  crafting_weaponsmith_firearms_03: "Expert Firearms Crafting",
  crafting_weaponsmith_firearms_04: "Master Firearms Crafting",
  crafting_weaponsmith_master: "Master Weaponsmith",
  crafting_weaponsmith_melee_01: "Intermediate Melee Weapons Crafting",
  crafting_weaponsmith_melee_02: "Advanced Melee Weapons Crafting",
  crafting_weaponsmith_melee_03: "Expert Melee Weapons Crafting",
  crafting_weaponsmith_melee_04: "Master Melee Weapons Crafting",
  crafting_weaponsmith_munitions_01: "Intermediate Munitions Crafting",
  crafting_weaponsmith_munitions_02: "Advanced Munitions Crafting",
  crafting_weaponsmith_munitions_03: "Expert Munitions Crafting",
  crafting_weaponsmith_munitions_04: "Master Munitions Crafting",
  crafting_weaponsmith_novice: "Novice Weaponsmith",
  crafting_weaponsmith_techniques_01: "Intermediate Weapon Crafting Techniques",
  crafting_weaponsmith_techniques_02: "Advanced Weapon Crafting Techniques",
  crafting_weaponsmith_techniques_03: "Expert Weapon Crafting Techniques",
  crafting_weaponsmith_techniques_04: "Master Weapon Crafting Techniques",
  creature_handler: "Creature Handler",
  demo_combat: "Demo Combat",
  doctor: "Doctor",
  droid_engineer: "Droid Engineer",
  entertainer: "Entertainer",
  explorer: "Explorer",
  force_discipline_defender: "Force Defense",
  force_discipline_defender_force_defense_01: "Force Defense I",
  force_discipline_defender_force_defense_02: "Force Defense II",
  force_discipline_defender_force_defense_03: "Force Defense III",
  force_discipline_defender_force_defense_04: "Force Defense IV",
  force_discipline_defender_master: "Master Force Defender",
  force_discipline_defender_melee_defense_01: "Force Melee Defense I",
  force_discipline_defender_melee_defense_02: "Force Melee Defense II",
  force_discipline_defender_melee_defense_03: "Force Melee Defense III",
  force_discipline_defender_melee_defense_04: "Force Melee Defense IV",
  force_discipline_defender_novice: "Novice Force Defender",
  force_discipline_defender_preternatural_defense_01: "Preternatural Defense I",
  force_discipline_defender_preternatural_defense_02:
    "Preternatural Defense II",
  force_discipline_defender_preternatural_defense_03:
    "Preternatural Defense III",
  force_discipline_defender_preternatural_defense_04:
    "Preternatural Defense IV",
  force_discipline_defender_ranged_defense_01: "Force Ranged Defense I",
  force_discipline_defender_ranged_defense_02: "Force Ranged Defense II",
  force_discipline_defender_ranged_defense_03: "Force Ranged Defense III",
  force_discipline_defender_ranged_defense_04: "Force Ranged Defense IV",
  force_discipline_enhancements: "Force Enhancement",
  force_discipline_enhancements_master: "Master Force Enhancer",
  force_discipline_enhancements_movement_01: "Force Celerity I",
  force_discipline_enhancements_movement_02: "Force Celerity II",
  force_discipline_enhancements_movement_03: "Force Celerity III",
  force_discipline_enhancements_movement_04: "Force Celerity IV",
  force_discipline_enhancements_novice: "Novice Force Enhancer",
  force_discipline_enhancements_protection_01: "Force Protection I",
  force_discipline_enhancements_protection_02: "Force Protection II",
  force_discipline_enhancements_protection_03: "Force Protection III",
  force_discipline_enhancements_protection_04: "Force Protection IV",
  force_discipline_enhancements_resistance_01: "Force Resistance I",
  force_discipline_enhancements_resistance_02: "Force Resistance II",
  force_discipline_enhancements_resistance_03: "Force Resistance III",
  force_discipline_enhancements_resistance_04: "Force Resistance IV",
  force_discipline_enhancements_synergy_01: "Force Synergy I",
  force_discipline_enhancements_synergy_02: "Force Synergy II",
  force_discipline_enhancements_synergy_03: "Force Synergy III",
  force_discipline_enhancements_synergy_04: "Force Synergy IV",
  force_discipline_healing: "Force Healing",
  force_discipline_healing_damage_01: "Force Rejuvenation I",
  force_discipline_healing_damage_02: "Force Rejuvenation II",
  force_discipline_healing_damage_03: "Force Rejuvenation III",
  force_discipline_healing_damage_04: "Force Rejuvenation IV",
  force_discipline_healing_master: "Master Force Healing",
  force_discipline_healing_novice: "Novice Force Healing",
  force_discipline_healing_other_01: "Force Assist I",
  force_discipline_healing_other_02: "Force Assist II",
  force_discipline_healing_other_03: "Force Assist III",
  force_discipline_healing_other_04: "Force Assist IV",
  force_discipline_healing_states_01: "Force Purification I",
  force_discipline_healing_states_02: "Force Purification II",
  force_discipline_healing_states_03: "Force Purification III",
  force_discipline_healing_states_04: "Force Purification IV",
  force_discipline_healing_wound_01: "Force Restoration I",
  force_discipline_healing_wound_02: "Force Restoration II",
  force_discipline_healing_wound_03: "Force Restoration III",
  force_discipline_healing_wound_04: "Force Restoration IV",
  force_discipline_light_saber: "Lightsaber",
  force_discipline_light_saber_master: "Lightsaber Master",
  force_discipline_light_saber_novice: "Lightsaber Novice",
  force_discipline_light_saber_one_hand_01: "One-Handed Lightsaber I",
  force_discipline_light_saber_one_hand_02: "One-Handed Lightsaber II",
  force_discipline_light_saber_one_hand_03: "One-Handed Lightsaber III",
  force_discipline_light_saber_one_hand_04: "One-Handed Lightsaber IV",
  force_discipline_light_saber_polearm_01: "Double-Bladed Lightsaber I",
  force_discipline_light_saber_polearm_02: "Double-Bladed Lightsaber II",
  force_discipline_light_saber_polearm_03: "Double-Bladed Lightsaber III",
  force_discipline_light_saber_polearm_04: "Double-Bladed Lightsaber IV",
  force_discipline_light_saber_technique_01: "Lightsaber Technique I",
  force_discipline_light_saber_technique_02: "Lightsaber Technique II",
  force_discipline_light_saber_technique_03: "Lightsaber Technique III",
  force_discipline_light_saber_technique_04: "Lightsaber Technique IV",
  force_discipline_light_saber_two_hand_01: "Two-Handed Lightsaber I",
  force_discipline_light_saber_two_hand_02: "Two-Handed Lightsaber II",
  force_discipline_light_saber_two_hand_03: "Two-Handed Lightsaber III",
  force_discipline_light_saber_two_hand_04: "Two-Handed Lightsaber IV",
  force_discipline_powers: "Force Powers",
  force_discipline_powers_debuff_01: "Force Diminish I",
  force_discipline_powers_debuff_02: "Force Diminish II",
  force_discipline_powers_debuff_03: "Force Diminish III",
  force_discipline_powers_debuff_04: "Force Diminish IV",
  force_discipline_powers_lightning_01: "Force Lightning I",
  force_discipline_powers_lightning_02: "Force Lightning II",
  force_discipline_powers_lightning_03: "Force Lightning III",
  force_discipline_powers_lightning_04: "Force Lightning IV",
  force_discipline_powers_master: "Master Force Wielder",
  force_discipline_powers_mental_01: "Force Subjugate I",
  force_discipline_powers_mental_02: "Force Subjugate II",
  force_discipline_powers_mental_03: "Force Subjugate III",
  force_discipline_powers_mental_04: "Force Subjugate IV",
  force_discipline_powers_novice: "Novice Force Wielder",
  force_discipline_powers_push_01: "Psychokineses I",
  force_discipline_powers_push_02: "Psychokineses II",
  force_discipline_powers_push_03: "Psychokineses III",
  force_discipline_powers_push_04: "Psychokineses IV",
  force_rank_dark: "Dark Force Rankings",
  force_rank_dark_master: "Council Leader",
  force_rank_dark_novice: "Rank Member",
  force_rank_dark_rank_01: "Enforcer I: 1st Rank",
  force_rank_dark_rank_02: "Enforcer II: 2nd Rank",
  force_rank_dark_rank_03: "Enforcer III: 3rd Rank",
  force_rank_dark_rank_04: "Enforcer IV: 4th Rank",
  force_rank_dark_rank_05: "Templar I: 5th Rank",
  force_rank_dark_rank_06: "Templar II: 6th Rank",
  force_rank_dark_rank_07: "Templar III: 7th Rank",
  force_rank_dark_rank_08: "Oppressor I: 8th Rank",
  force_rank_dark_rank_09: "Oppressor II: 9th Rank",
  force_rank_dark_rank_10: "The Council",
  force_rank_light: "Light Force Rankings",
  force_rank_light_master: "Council Leader",
  force_rank_light_novice: "Rank Member",
  force_rank_light_rank_01: "Sentinel I: 1st Rank",
  force_rank_light_rank_02: "Sentinel II: 2nd Rank",
  force_rank_light_rank_03: "Sentinel III: 3rd Rank",
  force_rank_light_rank_04: "Sentinel IV: 4th Rank",
  force_rank_light_rank_05: "Consular I: 5th Rank",
  force_rank_light_rank_06: "Consular II: 6th Rank",
  force_rank_light_rank_07: "Consular III: 7th Rank",
  force_rank_light_rank_08: "Arbiter I: 8th Rank",
  force_rank_light_rank_09: "Arbiter II: 9th Rank",
  force_rank_light_rank_10: "The Council",
  force_sensitive_combat_prowess: "Combat Prowess",
  force_sensitive_combat_prowess_master: "Combat Prowess Master",
  force_sensitive_combat_prowess_melee_accuracy:
    "Combat Prowess : Melee Accuracy",
  force_sensitive_combat_prowess_melee_accuracy_01:
    "Melee Accuracy I: Weapon Finesse",
  force_sensitive_combat_prowess_melee_accuracy_02:
    "Melee Accuracy II: Extension",
  force_sensitive_combat_prowess_melee_accuracy_03:
    "Melee Accuracy III: Weapon Control",
  force_sensitive_combat_prowess_melee_accuracy_04:
    "Melee Accuracy IV: Muscle Control",
  force_sensitive_combat_prowess_melee_speed:
    "Combat Prowess : Melee Weapon Speed",
  force_sensitive_combat_prowess_melee_speed_01: "Melee Speed I: Weapon Study",
  force_sensitive_combat_prowess_melee_speed_02: "Melee Speed II: Wielding",
  force_sensitive_combat_prowess_melee_speed_03:
    "Melee Speed III: Honed Abilities",
  force_sensitive_combat_prowess_melee_speed_04: "Melee Speed IV: Quick Attack",
  force_sensitive_combat_prowess_novice: "Combat Prowess Novice",
  force_sensitive_combat_prowess_ranged_accuracy:
    "Combat Prowess : Ranged Accuracy",
  force_sensitive_combat_prowess_ranged_accuracy_01:
    "Ranged Accuracy I: Sense Movement",
  force_sensitive_combat_prowess_ranged_accuracy_02:
    "Ranged Accuracy II: Sense Speed",
  force_sensitive_combat_prowess_ranged_accuracy_03:
    "Ranged Accuracy III: Vital Damage",
  force_sensitive_combat_prowess_ranged_accuracy_04:
    "Ranged Accuracy IV: Kill Shot",
  force_sensitive_combat_prowess_ranged_speed:
    "Combat Prowess : Ranged Weapon Speed",
  force_sensitive_combat_prowess_ranged_speed_01:
    "Ranged Speed I: Anticipation",
  force_sensitive_combat_prowess_ranged_speed_02:
    "Ranged Speed II: Honed Senses",
  force_sensitive_combat_prowess_ranged_speed_03:
    "Ranged Speed III: Trigger Finger",
  force_sensitive_combat_prowess_ranged_speed_04:
    "Ranged Speed IV: Will of the Weapon",
  force_sensitive_crafting_mastery: "Crafting Mastery",
  force_sensitive_crafting_mastery_assembly: "Crafting Mastery : Assembly",
  force_sensitive_crafting_mastery_assembly_01: "Assembly I: Dextrous Touch",
  force_sensitive_crafting_mastery_assembly_02:
    "Assembly II: Quality Assurance",
  force_sensitive_crafting_mastery_assembly_03:
    "Assembly III: Advanced Preparation",
  force_sensitive_crafting_mastery_assembly_04:
    "Assembly IV: Astute Construction",
  force_sensitive_crafting_mastery_experimentation:
    "Crafting Mastery : Experimentation",
  force_sensitive_crafting_mastery_experimentation_01:
    "Experimentation I: Crafting Studies",
  force_sensitive_crafting_mastery_experimentation_02:
    "Experimentation II: Progressive Tinkering",
  force_sensitive_crafting_mastery_experimentation_03:
    "Experimentation III: Improved Procedure",
  force_sensitive_crafting_mastery_experimentation_04:
    "Experimentation IV: Advanced Analysis",
  force_sensitive_crafting_mastery_master: "Crafting Mastery",
  force_sensitive_crafting_mastery_novice: "Crafting Mastery Novice",
  force_sensitive_crafting_mastery_repair: "Crafting Mastery : Repair",
  force_sensitive_crafting_mastery_repair_01: "Repair I: Restoration",
  force_sensitive_crafting_mastery_repair_02: "Repair II: Renovation",
  force_sensitive_crafting_mastery_repair_03: "Repair III: Refurbishing",
  force_sensitive_crafting_mastery_repair_04: "Repair IV: Rejuvenate",
  force_sensitive_crafting_mastery_technique: "Crafting Mastery : Technique",
  force_sensitive_crafting_mastery_technique_01:
    "Technique I: Fortunate Crafting",
  force_sensitive_crafting_mastery_technique_02:
    "Technique II: Auspicious Crafting",
  force_sensitive_crafting_mastery_technique_03:
    "Technique III: Substantial Crafting",
  force_sensitive_crafting_mastery_technique_04:
    "Technique IV: Prosperous Crafting",
  force_sensitive_enhanced_reflexes: "Enhanced Reflexes",
  force_sensitive_enhanced_reflexes_master: "Enhanced Reflexes Master",
  force_sensitive_enhanced_reflexes_melee_defense:
    "Enhanced Reflexes : Melee Defenses",
  force_sensitive_enhanced_reflexes_melee_defense_01:
    "Melee Defense I: Attack Avoidance",
  force_sensitive_enhanced_reflexes_melee_defense_02:
    "Melee Defense II: Increased Dexterity",
  force_sensitive_enhanced_reflexes_melee_defense_03:
    "Melee Defense III: Heightened Agility",
  force_sensitive_enhanced_reflexes_melee_defense_04:
    "Melee Defense IV: Close Combat Avoidance",
  force_sensitive_enhanced_reflexes_novice: "Enhanced Reflexes Novice",
  force_sensitive_enhanced_reflexes_ranged_defense:
    "Enhanced Reflexes : Ranged Defenses",
  force_sensitive_enhanced_reflexes_ranged_defense_01:
    "Ranged Defense I: Heightened Reflexes",
  force_sensitive_enhanced_reflexes_ranged_defense_02:
    "Ranged Defense II: Reaction Speed",
  force_sensitive_enhanced_reflexes_ranged_defense_03:
    "Ranged Defense III: Precognitive Senses",
  force_sensitive_enhanced_reflexes_ranged_defense_04:
    "Ranged Defense IV: Danger Sense",
  force_sensitive_enhanced_reflexes_survival: "Enhanced Reflexes : Survival",
  force_sensitive_enhanced_reflexes_survival_01:
    "Survival I: Wilderness Survival",
  force_sensitive_enhanced_reflexes_survival_02: "Survival II: Nature Sense",
  force_sensitive_enhanced_reflexes_survival_03:
    "Survival III: Uncanny Movement",
  force_sensitive_enhanced_reflexes_survival_04:
    "Survival IV: Harmonious Nature",
  force_sensitive_enhanced_reflexes_vehicle_control:
    "Enhanced Reflexes : Vehicle Control",
  force_sensitive_enhanced_reflexes_vehicle_control_01:
    "Vehicle Control I: Ground Sense",
  force_sensitive_enhanced_reflexes_vehicle_control_02:
    "Vehicle Control II: Superior Handling",
  force_sensitive_enhanced_reflexes_vehicle_control_03:
    "Vehicle Control III: Vehicle Harmony",
  force_sensitive_enhanced_reflexes_vehicle_control_04:
    "Vehicle Control IV: Reflexive Driving",
  force_sensitive_heightened_senses: "Heightened Senses",
  force_sensitive_heightened_senses_healing: "Heightened Senses : Healing",
  force_sensitive_heightened_senses_healing_01:
    "Healing I: Sophisticated Diagnosis",
  force_sensitive_heightened_senses_healing_02:
    "Healing II: Empathic Treatment",
  force_sensitive_heightened_senses_healing_03: "Healing III: Superior Remedy",
  force_sensitive_heightened_senses_healing_04:
    "Healing IV: Prominent Alleviation",
  force_sensitive_heightened_senses_luck: "Heightened Senses : Luck",
  force_sensitive_heightened_senses_luck_01: "Luck I: Unforeseen Events",
  force_sensitive_heightened_senses_luck_02: "Luck II: Fortune",
  force_sensitive_heightened_senses_luck_03: "Luck III: Serendipity",
  force_sensitive_heightened_senses_luck_04: "Luck IV: Kismet",
  force_sensitive_heightened_senses_master: "Heightened Senses Master",
  force_sensitive_heightened_senses_novice: "Heightened Senses Novice",
  force_sensitive_heightened_senses_persuasion:
    "Heightened Senses : Persuasion",
  force_sensitive_heightened_senses_persuasion_01: "Persuasion I: Alignment",
  force_sensitive_heightened_senses_persuasion_02:
    "Persuasion II: Blandishment",
  force_sensitive_heightened_senses_persuasion_03: "Persuasion III: Cajolery",
  force_sensitive_heightened_senses_persuasion_04: "Persuasion IV: Enticement",
  force_sensitive_heightened_senses_surveying: "Heightened Senses : Surveying",
  force_sensitive_heightened_senses_surveying_01:
    "Surveying I: Improved Mining",
  force_sensitive_heightened_senses_surveying_02: "Surveying II: Select Yields",
  force_sensitive_heightened_senses_surveying_03:
    "Surveying III: Preferred Results",
  force_sensitive_heightened_senses_surveying_04:
    "Surveying IV: Sharpened Assaying",
  force_title_jedi: "Force Progression",
  force_title_jedi_master: "Jedi Master",
  force_title_jedi_novice: "Force Sensitive",
  force_title_jedi_rank_01: "Jedi Initiate",
  force_title_jedi_rank_02: "Jedi Padawan",
  force_title_jedi_rank_03: "Jedi Knight",
  force_title_jedi_rank_04: "Jedi Guardian",
  gunsmith: "Gunsmith",
  image_designer: "Image Designer",
  intermediate_engineering: "Intermediate Engineering",
  intermediate_polylinguistics: "Intermediate Polylinguistics",
  intermediate_xenolinguistics: "Intermediate Xenolinguistics",
  jedi: "Jedi",
  jedi_dark_side_journeyman: "Dark Jedi Knight",
  jedi_dark_side_journeyman_force_manipulation_01:
    "Advanced Manipulation I: Lightning Arc",
  jedi_dark_side_journeyman_force_manipulation_02:
    "Advanced Manipulation II: Opponent Imbalance",
  jedi_dark_side_journeyman_force_manipulation_03:
    "Advanced Manipulation III: Greater Kinesis",
  jedi_dark_side_journeyman_force_manipulation_04:
    "Advanced Manipulation IV: Lightning Bolt",
  jedi_dark_side_journeyman_force_power_01: "Advanced Force Power I",
  jedi_dark_side_journeyman_force_power_02: "Advanced Force Power II",
  jedi_dark_side_journeyman_force_power_03: "Advanced Force Power III",
  jedi_dark_side_journeyman_force_power_04: "Advanced Force Power IV",
  jedi_dark_side_journeyman_healing_01:
    "Skilled Healing I: Projection of Strength",
  jedi_dark_side_journeyman_healing_02:
    "Skilled Healing II: Projection of Vitality",
  jedi_dark_side_journeyman_healing_03:
    "Skilled Healing III: Projection of Will",
  jedi_dark_side_journeyman_healing_04:
    "Skilled Healing IV: Projection of Remedy",
  jedi_dark_side_journeyman_master: "Dark Jedi Knight",
  jedi_dark_side_journeyman_novice: "Dark Jedi Apprentice",
  jedi_dark_side_journeyman_saber_01: "Heavy Lightsaber I: Called Strikes",
  jedi_dark_side_journeyman_saber_02: "Heavy Lightsaber II: Stances",
  jedi_dark_side_journeyman_saber_03: "Heavy Lightsaber III: Sturdy Strikes",
  jedi_dark_side_journeyman_saber_04: "Heavy Lightsaber IV: Vigorous Attack",
  jedi_dark_side_master: "Dark Jedi Master",
  jedi_dark_side_master_force_manipulation_01:
    "Superior Manipulation I: Lightning Fork",
  jedi_dark_side_master_force_manipulation_02:
    "Superior Manipulation II: Project Coercion",
  jedi_dark_side_master_force_manipulation_03:
    "Superior Manipulation III: Lightning Strike",
  jedi_dark_side_master_force_manipulation_04:
    "Superior Manipulation IV: Drain Essence",
  jedi_dark_side_master_force_power_01:
    "Superior Force Power I: Animal Anxiety",
  jedi_dark_side_master_force_power_02:
    "Superior Force Power II: Animal Conciliation",
  jedi_dark_side_master_force_power_03:
    "Superior Force Power III: Animal Bewilderment",
  jedi_dark_side_master_force_power_04: "Superior Force Power IV: Mind Control",
  jedi_dark_side_master_healing_01: "Expert Healing I: Restoration",
  jedi_dark_side_master_healing_02: "Expert Healing II: Stimulation",
  jedi_dark_side_master_healing_03: "Expert Healing III: Steadfastness",
  jedi_dark_side_master_healing_04: "Expert Healing IV: Expurgation",
  jedi_dark_side_master_master: "Dark Jedi Master",
  jedi_dark_side_master_novice: "Dark Jedi Guardian",
  jedi_dark_side_master_saber_01: "Dual-edge Saber I: Called Strikes",
  jedi_dark_side_master_saber_02: "Dual-edge Saber II: Mighty Strikes",
  jedi_dark_side_master_saber_03: "Dual-edge Saber III: Accurate Strikes",
  jedi_dark_side_master_saber_04: "Dual-edge Saber IV: Devastating Moves",
  jedi_light_side_journeyman: "Jedi Knight",
  jedi_light_side_journeyman_force_manipulation_01:
    "Improved Manipulation I: Lightning Arc",
  jedi_light_side_journeyman_force_manipulation_02:
    "Improved Manipulation II: Opponent Imbalance",
  jedi_light_side_journeyman_force_manipulation_03:
    "Improved Manipulation III: Greater Kinesis",
  jedi_light_side_journeyman_force_manipulation_04:
    "Improved Manipulation IV: Lightning Bolt",
  jedi_light_side_journeyman_force_power_01:
    "Improved Force Power I: Animal Trepidation",
  jedi_light_side_journeyman_force_power_02:
    "Improved Force Power II: Animal Tranquility",
  jedi_light_side_journeyman_force_power_03:
    "Improved Force Power III: Animal Persuasion",
  jedi_light_side_journeyman_force_power_04:
    "Improved Force Power IV: Confusion",
  jedi_light_side_journeyman_healing_01:
    "Advanced Healing I: Aura of Regeneration",
  jedi_light_side_journeyman_healing_02:
    "Advanced Healing II: Aura of Revitalization",
  jedi_light_side_journeyman_healing_03:
    "Advanced Healing III: Aura of Fortitude",
  jedi_light_side_journeyman_healing_04: "Advanced Healing IV: Aura of Purity",
  jedi_light_side_journeyman_master: "Jedi Knight",
  jedi_light_side_journeyman_novice: "Jedi Apprentice",
  jedi_light_side_journeyman_saber_01: "Two-hand Lightsaber I: Precision",
  jedi_light_side_journeyman_saber_02: "Two-hand Lightsaber II: Stability",
  jedi_light_side_journeyman_saber_03:
    "Two-hand Lightsaber III: Skilled Strikes",
  jedi_light_side_journeyman_saber_04: "Two-hand Lightsaber IV: Wild Swing",
  jedi_light_side_master: "Jedi Master",
  jedi_light_side_master_force_manipulation_01:
    "Greater Manipulation I: Lightning Fork",
  jedi_light_side_master_force_manipulation_02:
    "Greater Manipulation II: Instill Apprehension",
  jedi_light_side_master_force_manipulation_03:
    "Greater Manipulation III: Lightning Strike",
  jedi_light_side_master_force_manipulation_04:
    "Greater Manipulation IV: Drain Essence",
  jedi_light_side_master_force_power_01: "Greater Force Power I",
  jedi_light_side_master_force_power_02: "Greater Force Power II",
  jedi_light_side_master_force_power_03: "Greater Force Power III",
  jedi_light_side_master_force_power_04: "Greater Force Power IV",
  jedi_light_side_master_healing_01: "Superior Healing I: Restoration",
  jedi_light_side_master_healing_02: "Superior Healing II: Invigoration",
  jedi_light_side_master_healing_03: "Superior Healing III: Resolution",
  jedi_light_side_master_healing_04: "Superior Healing IV: Cleansing",
  jedi_light_side_master_master: "Jedi Master",
  jedi_light_side_master_novice: "Jedi Guardian",
  jedi_light_side_master_saber_01: "Polearm Saber I: Precision",
  jedi_light_side_master_saber_02: "Polearm Saber II: Expert Strikes",
  jedi_light_side_master_saber_03: "Polearm Saber III: Improved Precision",
  jedi_light_side_master_saber_04: "Polearm Saber IV: Power Strikes",
  jedi_novice: "Jedi Novice",
  jedi_padawan: "Jedi Padawan",
  jedi_padawan_force_manipulation_01: "Force Manipulation I: Increased Speed",
  jedi_padawan_force_manipulation_02:
    "Force Manipulation II: Opponent Disorientation",
  jedi_padawan_force_manipulation_03:
    "Force Manipulation III: Mental Intrusion",
  jedi_padawan_force_manipulation_04: "Force Manipulation IV: Lesser Kinesis",
  jedi_padawan_force_power_01: "Force Power I",
  jedi_padawan_force_power_02: "Force Power II",
  jedi_padawan_force_power_03: "Force Power III",
  jedi_padawan_force_power_04: "Force Power IV",
  jedi_padawan_healing_01: "Basic Healing I: Personal Regeneration",
  jedi_padawan_healing_02: "Basic Healing II: Personal Revitalization",
  jedi_padawan_healing_03: "Basic Healing III: Personal Fortitude",
  jedi_padawan_healing_04: "Basic Healing IV: Personal Rejuvenation",
  jedi_padawan_master: "Jedi Padawan",
  jedi_padawan_novice: "Jedi Initiate",
  jedi_padawan_saber_01: "Lightsaber I: Laser Weapon Basics",
  jedi_padawan_saber_02: "Lightsaber II: Celerity",
  jedi_padawan_saber_03: "Lightsaber III: Precision",
  jedi_padawan_saber_04: "Lightsaber IV: Advanced Strikes",
  journalist: "Journalist",
  marksman: "Marksman",
  melee_weaponsmith: "Melee Weaponsmith",
  merchant: "Merchant",
  miner: "Miner",
  novice_architect: "Novice Architect",
  novice_armor_designer: "Novice Armor Designer",
  novice_armorer: "Novice Armorer",
  novice_bio_engineer: "Novice Bio-Engineer",
  novice_chef: "Novice Chef",
  novice_combat_engineer: "Novice Combat Engineer",
  novice_combat_medic: "Novice Combat Medic",
  novice_commando: "Novice Commando",
  novice_cook: "Novice Cook",
  novice_creature_handler: "Novice Creature Handler",
  novice_doctor: "Novice Doctor",
  novice_droid_engineer: "Novice Droid Engineer",
  novice_droid_technician: "Novice Droid Technician",
  novice_entertainer: "Novice Entertainer",
  novice_explorer: "Novice Explorer",
  novice_gunsmith: "Novice Gunsmith",
  novice_jedi: "Novice Jedi",
  novice_marksman: "Novice Marksman",
  novice_melee_weapons_technician: "Novice Melee Weapons Technician",
  novice_merchant: "Novice Merchant",
  novice_miner: "Novice Miner",
  novice_politician: "Novice Politician",
  novice_ranged_weapons_technician: "Novice Ranged Weapons Technician",
  novice_ranger: "Novice Ranger",
  novice_smuggler: "Novice Smuggler",
  novice_teras_kasi_artist: "Novice Teras Kasi Artist",
  novice_vehicle_engineer: "Novice Vehicle Engineer",
  novice_vehicle_technician: "Novice Vehicle Technician",
  novice_weaponsmith: "Novice Weaponsmith",
  novice_xenobiologist: "Novice Xenobiologist",
  outdoors_bio_engineer: "Bio-Engineer",
  outdoors_bio_engineer_creature_01: "Clone Engineering I",
  outdoors_bio_engineer_creature_02: "Clone Engineering II",
  outdoors_bio_engineer_creature_03: "Clone Engineering III",
  outdoors_bio_engineer_creature_04: "Clone Engineering IV",
  outdoors_bio_engineer_dna_harvesting_01: "DNA Sampling I",
  outdoors_bio_engineer_dna_harvesting_02: "DNA Sampling II",
  outdoors_bio_engineer_dna_harvesting_03: "DNA Sampling III",
  outdoors_bio_engineer_dna_harvesting_04: "DNA Sampling IV",
  outdoors_bio_engineer_master: "Master Bio-Engineer",
  outdoors_bio_engineer_novice: "Novice Bio-Engineer",
  outdoors_bio_engineer_production_01: "Engineering Techniques I",
  outdoors_bio_engineer_production_02: "Engineering Techniques II",
  outdoors_bio_engineer_production_03: "Engineering Techniques III",
  outdoors_bio_engineer_production_04: "Engineering Techniques IV",
  outdoors_bio_engineer_tissue_01: "Tissue Engineering I",
  outdoors_bio_engineer_tissue_02: "Tissue Engineering II",
  outdoors_bio_engineer_tissue_03: "Tissue Engineering III",
  outdoors_bio_engineer_tissue_04: "Tissue Engineering IV",
  outdoors_creaturehandler: "Creature Handler",
  outdoors_creaturehandler_healing_01:
    "Creature Empathy I: Animal Comprehension",
  outdoors_creaturehandler_healing_02: "Creature Empathy II: Animal Compassion",
  outdoors_creaturehandler_healing_03:
    "Creature Empathy III: Biological Affinity",
  outdoors_creaturehandler_healing_04:
    "Creature Empathy IV: Consonance of Will",
  outdoors_creaturehandler_master: "Master Creature Handler",
  outdoors_creaturehandler_novice: "Novice Creature Handler",
  outdoors_creaturehandler_support_01:
    "Creature Management I: Group Organization",
  outdoors_creaturehandler_support_02:
    "Creature Management II: Advanced Organization",
  outdoors_creaturehandler_support_03:
    "Creature Management III: Pack Management",
  outdoors_creaturehandler_support_04: "Creature Management IV: Absolute Trust",
  outdoors_creaturehandler_taming_01: "Creature Taming I: Basic Domestication",
  outdoors_creaturehandler_taming_02:
    "Creature Taming II: Pacification Techniques",
  outdoors_creaturehandler_taming_03: "Creature Taming III: Behavioral Science",
  outdoors_creaturehandler_taming_04: "Creature Taming IV: Animal Language",
  outdoors_creaturehandler_training_01: "Creature Training I: Animal Rapport",
  outdoors_creaturehandler_training_02:
    "Creature Training II: Obedience Education",
  outdoors_creaturehandler_training_03:
    "Creature Training III: Martial Obedience Education",
  outdoors_creaturehandler_training_04:
    "Creature Training IV: Tactical Animal Psychology",
  outdoors_miner: "Miner",
  outdoors_miner_liquid_01: "Intermediate Liquid Mining",
  outdoors_miner_liquid_02: "Advanced Liquid Mining",
  outdoors_miner_liquid_03: "Expert Liquid Mining",
  outdoors_miner_liquid_04: "Master Liquid Mining",
  outdoors_miner_master: "Master Miner",
  outdoors_miner_mineral_01: "Intermediate Mineral Mining",
  outdoors_miner_mineral_02: "Advanced Mineral Mining",
  outdoors_miner_mineral_03: "Expert Mineral Miner",
  outdoors_miner_mineral_04: "Master Mineral Mining",
  outdoors_miner_novice: "Novice Miner",
  outdoors_miner_production_01: "Intermediate Installation Production",
  outdoors_miner_production_02: "Advanced Installation Production",
  outdoors_miner_production_03: "Expert Installation Production",
  outdoors_miner_production_04: "Master Installation Production",
  outdoors_miner_renewable_01: "Intermediate Energy Mining",
  outdoors_miner_renewable_02: "Advanced Energy Mining",
  outdoors_miner_renewable_03: "Expert Energy Mining",
  outdoors_miner_renewable_04: "Master Energy Mining",
  outdoors_ranger: "Ranger",
  outdoors_ranger_harvest_01: "Tracking I: Direction Sense",
  outdoors_ranger_harvest_02: "Tracking II: Path Reading",
  outdoors_ranger_harvest_03: "Tracking III: Improved Direction Sense",
  outdoors_ranger_harvest_04: "Tracking IV: Man Hunting",
  outdoors_ranger_master: "Master Ranger",
  outdoors_ranger_movement_01: "Wayfaring I: Basic Concealment",
  outdoors_ranger_movement_02: "Wayfaring II: Rough Terrain Mastery",
  outdoors_ranger_movement_03: "Wayfaring III: Stealth Techniques",
  outdoors_ranger_movement_04: "Wayfaring IV: Exploration Mastery",
  outdoors_ranger_novice: "Novice Ranger",
  outdoors_ranger_support_01: "Advanced Trapping I: Danger Recognition",
  outdoors_ranger_support_02: "Advanced Trapping II: Imaginative Design",
  outdoors_ranger_support_03: "Advanced Trapping III: Ingenious Design",
  outdoors_ranger_support_04: "Advanced Trapping IV: Trapping Mastery",
  outdoors_ranger_tracking_01: "Frontiering I: Advanced Foraging Techniques",
  outdoors_ranger_tracking_02: "Frontiering II: Advanced Camp Engineering",
  outdoors_ranger_tracking_03: "Frontiering III: Wilderness Survival Mastery",
  outdoors_ranger_tracking_04: "Frontiering IV: Habitat Engineering",
  outdoors_scout: "Scout",
  outdoors_scout_camp_01: "Survival I: Rudimentary Techniques",
  outdoors_scout_camp_02: "Survival II: Advanced Techniques",
  outdoors_scout_camp_03: "Survival III: Harsh Environment Techniques",
  outdoors_scout_camp_04: "Survival IV: Special Techniques",
  outdoors_scout_harvest_01: "Hunting I: Civilian Methodology",
  outdoors_scout_harvest_02: "Hunting II: Military Methodology",
  outdoors_scout_harvest_03: "Hunting III: Trandoshan Methodology",
  outdoors_scout_harvest_04: "Hunting IV: Unconventional Methodology",
  outdoors_scout_master: "Master Scout",
  outdoors_scout_movement_01: "Exploration I: Fundamentals",
  outdoors_scout_movement_02: "Exploration II: Advanced Principles",
  outdoors_scout_movement_03: "Exploration III: Harsh Environment Training",
  outdoors_scout_movement_04: "Exploration IV: Alien Environment Training",
  outdoors_scout_novice: "Novice Scout",
  outdoors_scout_tools_01: "Trapping I: Makeshift Design",
  outdoors_scout_tools_02: "Trapping II: Refined Design",
  outdoors_scout_tools_03: "Trapping III: Martial Design",
  outdoors_scout_tools_04: "Trapping IV: Elite Martial Design",
  outdoors_scout_tracking_01: "Intermediate Creature Tracking",
  outdoors_scout_tracking_02: "Advanced Creature Tracking",
  outdoors_scout_tracking_03: "Expert Creature Tracking",
  outdoors_scout_tracking_04: "Tracking Specialist",
  outdoors_squadleader: "Squad Leader",
  outdoors_squadleader_defense_01: "Leadership I: Enforced Discipline",
  outdoors_squadleader_defense_02: "Leadership II: Command Directives",
  outdoors_squadleader_defense_03: "Leadership III: Exemplary Behavior",
  outdoors_squadleader_defense_04: "Leadership IV: Battlefield Authority",
  outdoors_squadleader_master: "Master Squad Leader",
  outdoors_squadleader_movement_01: "Mobility I: Terrain Guidance",
  outdoors_squadleader_movement_02: "Mobility II: Flexibility",
  outdoors_squadleader_movement_03: "Mobility III: Advanced Guidance",
  outdoors_squadleader_movement_04: "Mobility IV: Advanced Flexibility",
  outdoors_squadleader_novice: "Novice Squad Leader",
  outdoors_squadleader_offense_01: "Strategy I: Planned Action",
  outdoors_squadleader_offense_02: "Strategy II: Decisive Action",
  outdoors_squadleader_offense_03: "Strategy III: Unified Strike",
  outdoors_squadleader_offense_04: "Strategy IV: Improved Unified Strike",
  outdoors_squadleader_support_01: "Tactics I: Battlefield Support",
  outdoors_squadleader_support_02: "Tactics II: Ranged Defense",
  outdoors_squadleader_support_03: "Tactics III: Retreat",
  outdoors_squadleader_support_04: "Tactics IV: Defensive Form",
  pilot: "Star Pilot",
  pilot_imperial_navy: "Imperial Navy Pilot",
  pilot_imperial_navy_droid_01:
    "Astromech Management I: Droid Interface Basics",
  pilot_imperial_navy_droid_02:
    "Astromech Management II: Engineering Algorithms",
  pilot_imperial_navy_droid_03:
    "Astromech Management III: System Balance Programming",
  pilot_imperial_navy_droid_04:
    "Astromech Management IV: Droid Intelligence Theory",
  pilot_imperial_navy_master: "Imperial Pilot Ace",
  pilot_imperial_navy_novice: "Imperial Pilot Initiate",
  pilot_imperial_navy_procedures_01: "Imperial Training I: Basic Training",
  pilot_imperial_navy_procedures_02: "Imperial Training II: Imperial Regular",
  pilot_imperial_navy_procedures_03: "Imperial Training III: Special Forces",
  pilot_imperial_navy_procedures_04: "Imperial Training IV: Elite TIE Guard",
  pilot_imperial_navy_starships_01:
    "Imperial Technology I: Intermediate TIE Combat Craft Operations",
  pilot_imperial_navy_starships_02:
    "Imperial Technology II: Advanced TIE Combat Craft Operations",
  pilot_imperial_navy_starships_03:
    "Imperial Technology III: Advanced Capability TIE Vessels",
  pilot_imperial_navy_starships_04:
    "Imperial Technology IV: TIE Experimental Vessels",
  pilot_imperial_navy_weapons_01:
    "Equipment I: Basic Imperial Starship Component Use",
  pilot_imperial_navy_weapons_02:
    "Equipment II: Intermediate Imperial Starship Component Use",
  pilot_imperial_navy_weapons_03:
    "Equipment III: Advanced Imperial Starship Component Use",
  pilot_imperial_navy_weapons_04:
    "Equipment IV: Heavy Imperial Starship Component Use",
  pilot_neutral: "Freelance Pilot",
  pilot_neutral_droid_01: "Droid Interface Basics",
  pilot_neutral_droid_02: "Engineering Algorithms",
  pilot_neutral_droid_03: "System Balance Programming",
  pilot_neutral_droid_04: "Droid Intelligence Theory",
  pilot_neutral_master: "Flight Artistry",
  pilot_neutral_novice: "Basic Pilot",
  pilot_neutral_procedures_01: "Basic Training",
  pilot_neutral_procedures_02: "Starship Defense",
  pilot_neutral_procedures_03: "Advanced Technique",
  pilot_neutral_procedures_04: "Expert Technique",
  pilot_neutral_starships_01: "Basic Fighters",
  pilot_neutral_starships_02: "Advanced Fighters",
  pilot_neutral_starships_03: "Special Warships",
  pilot_neutral_starships_04: "Exotic Vessels",
  pilot_neutral_weapons_01: "Basic Starship Component Use",
  pilot_neutral_weapons_02: "Intermediate Starship Component Use",
  pilot_neutral_weapons_03: "Advanced Starship Component Use",
  pilot_neutral_weapons_04: "Heavy Starship Component Use",
  pilot_rebel_navy: "Alliance Starfighter Pilot",
  pilot_rebel_navy_droid_01: "Droid Interface Basics",
  pilot_rebel_navy_droid_02: "Engineering Algorithms",
  pilot_rebel_navy_droid_03: "System Balance Programming",
  pilot_rebel_navy_droid_04: "Droid Intelligence Theory",
  pilot_rebel_navy_master: "Rebel Alliance Master Pilot",
  pilot_rebel_navy_novice: "Alliance Starfighter Trainee",
  pilot_rebel_navy_procedures_01: "Starfighter Survival Tactics",
  pilot_rebel_navy_procedures_02: "Space Combat Techniques",
  pilot_rebel_navy_procedures_03: "Advanced Space Combat",
  pilot_rebel_navy_procedures_04: "Special Weapons and Tactics",
  pilot_rebel_navy_starships_01: "Basic Starfighter Continuation Training",
  pilot_rebel_navy_starships_02: "Multi-role Craft",
  pilot_rebel_navy_starships_03: "Space Superiority Fighters",
  pilot_rebel_navy_starships_04: "Hyper-Maneuverable Starfighters",
  pilot_rebel_navy_weapons_01:
    "Equipment A: Basic Alliance Starship Component Use",
  pilot_rebel_navy_weapons_02:
    "Equipment B: Intermediate Alliance Starship Component Use",
  pilot_rebel_navy_weapons_03:
    "Equipment C: Advanced Alliance Starship Component Use",
  pilot_rebel_navy_weapons_04:
    "Equipment D: Heavy Alliance Starship Component Use",
  politician: "Politician",
  profession_architect: "Architect",
  profession_architect_novice: "Novice Architect",
  profession_armorsmith: "Armorsmith",
  profession_armorsmith_novice: "Novice Armorsmith",
  profession_bountyhunter: "Bounty Hunter",
  profession_bountyhunter_novice: "Novice Bounty Hunter",
  profession_chef: "Chef",
  profession_chef_novice: "Novice Chef",
  profession_combat_brawler_master: "Master Brawler",
  profession_combat_brawler_novice: "Novice Brawler",
  profession_combat_marksman_master: "Master Marksman",
  profession_combat_marksman_novice: "Novice Marksman",
  profession_combatengineer: "Combat Engineer",
  profession_combatengineer_novice: "Novice Combat Engineer",
  profession_combatmedic: "Combat Medic",
  profession_combatmedic_novice: "Novice Combat Medic",
  profession_commando: "Commando",
  profession_commando_novice: "Novice Commando",
  profession_crafting_artisan_master: "Master Artisan",
  profession_crafting_artisan_novice: "Novice Artisan",
  profession_doctor: "Doctor",
  profession_doctor_novice: "Novice Doctor",
  profession_entertainer: "Entertainer",
  profession_entertainer_novice: "Novice Entertainer",
  profession_explorer: "Explorer",
  profession_explorer_novice: "Novice Explorer",
  profession_gunsmith: "Gunsmith",
  profession_gunsmith_novice: "Novice Gunsmith",
  profession_imagedesigner: "Image Designer",
  profession_imagedesigner_novice: "Novice Image Designer",
  profession_marksman: "Marksman",
  profession_marksman_novice: "Novice Marksman",
  profession_merchant: "Merchant",
  profession_merchant_novice: "Novice Merchant",
  profession_miner: "Miner",
  profession_miner_novice: "Novice Miner",
  profession_outdoors_scout_master: "Master Scout",
  profession_outdoors_scout_novice: "Novice Scout",
  profession_rancher: "Rancher",
  profession_rancher_novice: "Novice Rancher",
  profession_ranger: "Ranger",
  profession_ranger_novice: "Novice Ranger",
  profession_science_medic_master: "Master Medic",
  profession_science_medic_novice: "Novice Medic",
  profession_smuggler: "Smuggler",
  profession_smuggler_novice: "Novice Smuggler",
  profession_social_entertainer_master: "Master Entertainer",
  profession_social_entertainer_novice: "Novice Entertainer",
  profession_squadleader: "Squad Leader",
  profession_squadleader_novice: "Novice Squad Leader",
  profession_teraskasi: "Teras Kasi Artist",
  profession_teraskasi_novice: "Novice Teras Kasi Artist",
  profession_weaponsmith: "Melee Weaponsmith",
  profession_weaponsmith_novice: "Novice Melee Weaponsmith",
  ranger: "Ranger",
  rifle_concealment_chance: "Sniper Support Chance",
  science: "Science",
  science_combatmedic: "Combat Medic",
  science_combatmedic_healing_range_01: "Intermediate Ranged Healing Distance",
  science_combatmedic_healing_range_02: "Advanced Ranged Healing Distance",
  science_combatmedic_healing_range_03: "Expert Ranged Healing Distance",
  science_combatmedic_healing_range_04: "Master Ranged Healing Distance",
  science_combatmedic_healing_range_speed_01:
    "Intermediate Ranged Healing Speed",
  science_combatmedic_healing_range_speed_02: "Advanced Ranged Healing Speed",
  science_combatmedic_healing_range_speed_03: "Expert Ranged Healing Speed",
  science_combatmedic_healing_range_speed_04: "Master Ranged Healing Speed",
  science_combatmedic_master: "Master Combat Medic",
  science_combatmedic_medicine_01: "Intermediate Combat Medicine Crafting",
  science_combatmedic_medicine_02: "Advanced Combat Medicine Crafting",
  science_combatmedic_medicine_03: "Expert Combat Medicine Crafting",
  science_combatmedic_medicine_04: "Master Combat Medicine Crafting",
  science_combatmedic_novice: "Novice Combat Medic",
  science_combatmedic_support_01: "Intermediate Combat Medic Support",
  science_combatmedic_support_02: "Advanced Combat Medic Support",
  science_combatmedic_support_03: "Expert Combat Medic Support",
  science_combatmedic_support_04: "Master Combat Medic Support",
  science_doctor: "Doctor",
  science_doctor_ability_01: "Intermediate Doctor's Medicine Knowledge",
  science_doctor_ability_02: "Advanced Doctor's Medicine Knowledge",
  science_doctor_ability_03: "Expert Doctor's Medicine Knowledge",
  science_doctor_ability_04: "Master Doctor's Medicine Knowledge",
  science_doctor_master: "Master Doctor",
  science_doctor_novice: "Novice Doctor",
  science_doctor_support_01: "Intermediate Doctor's Medicine Crafting",
  science_doctor_support_02: "Advanced Doctor's Medicine Crafting",
  science_doctor_support_03: "Expert Doctor's Medicine Crafting",
  science_doctor_support_04: "Master Doctor's Medicine Crafting",
  science_doctor_wound_01: "Intermediate Wound Treatment",
  science_doctor_wound_02: "Advanced Wound Treatment",
  science_doctor_wound_03: "Expert Wound Treatment",
  science_doctor_wound_04: "Master Wound Treatment",
  science_doctor_wound_speed_01: "Intermediate Wound Treatment Speed",
  science_doctor_wound_speed_02: "Advanced Wound Treatment Speed",
  science_doctor_wound_speed_03: "Expert Wound Treatment Speed",
  science_doctor_wound_speed_04: "Master Wound Treatment Speed",
  science_medic: "Medic",
  science_medic_ability_01: "Pharmacology I: Applications of Medicine",
  science_medic_ability_02: "Pharmacology II: Practical Medicine",
  science_medic_ability_03: "Pharmacology III: Combat Medicine",
  science_medic_ability_04: "Pharmacology IV: Xeno Pharmacology",
  science_medic_crafting_01: "Organic Chemistry I: Basic Wound Treatment",
  science_medic_crafting_02: "Organic Chemistry II: Enhanced Stimpacks",
  science_medic_crafting_03: "Organic Chemistry III: Complex Wound Treatment",
  science_medic_crafting_04: "Organic Chemistry IV: Experimental Chemistry",
  science_medic_injury_01: "First Aid I: Simple Bandaging",
  science_medic_injury_02: "First Aid II: Treat Bleeding",
  science_medic_injury_03: "First Aid III: Field Dressing",
  science_medic_injury_04: "First Aid IV: Quick Heal",
  science_medic_injury_speed_01: "Diagnostics I: Rapid Diagnosis",
  science_medic_injury_speed_02: "Diagnostics II: Transport Patient",
  science_medic_injury_speed_03: "Diagnostics III: Accelerated Healing",
  science_medic_injury_speed_04: "Diagnostics IV: Technical Diagnosis",
  science_medic_master: "Master Medic",
  science_medic_novice: "Novice Medic",
  skill_system_root: "Skill System Root",
  smuggler: "Smuggler",
  social: "Social",
  social_acrobat: "Acrobat",
  social_acrobat_evasion_01: "Acrobatics I: Enhanced Dexterity",
  social_acrobat_evasion_02: "Acrobatics II: Physical Evasion",
  social_acrobat_evasion_03: "Acrobatics III: Combat Alacrity",
  social_acrobat_evasion_04: "Acrobatics IV: Tactical Contortion",
  social_acrobat_juggling_01: "Juggling I: Pins",
  social_acrobat_juggling_02: "Juggling II: Rings",
  social_acrobat_juggling_03: "Juggling III: Sharp Objects",
  social_acrobat_juggling_04: "Juggling IV: Flaming Objects",
  social_acrobat_master: "Master Acrobat",
  social_acrobat_novice: "Novice Acrobat",
  social_acrobat_shock_01: "Juggling Effectiveness I: Balancer",
  social_acrobat_shock_02: "Juggling Effectiveness II: Athlete",
  social_acrobat_shock_03: "Juggling Effectiveness III: Acrobat",
  social_acrobat_shock_04: "Juggling Effectiveness IV: Aerialist",
  social_acrobat_thrown_01: "Throwing Weapons I: Daggers",
  social_acrobat_thrown_02: "Throwing Weapons II: Boomerang",
  social_acrobat_thrown_03: "Throwing Weapons III: Throwing Stars",
  social_acrobat_thrown_04: "Throwing Weapons IV: Plasma Sphere",
  social_dance_knowledge_advanced: "Dancing: Advanced Knowledge",
  social_dance_knowledge_basic: "Dancing: Basic Knowledge",
  social_dance_knowledge_expert: "Dancing: Expert Knowledge",
  social_dance_knowledge_intermediate: "Dancing: Intermediate Knowledge",
  social_dance_knowledge_specialist: "Dancing: Knowledge Specialist",
  social_dancer: "Dancer",
  social_dancer_ability_01: "Dancing Techniques I",
  social_dancer_ability_02: "Dancing Techniques II",
  social_dancer_ability_03: "Dancing Techniques III",
  social_dancer_ability_04: "Technique Specialist IV",
  social_dancer_knowledge_01: "Dancing Knowledge I",
  social_dancer_knowledge_02: "Dancing Knowledge II",
  social_dancer_knowledge_03: "Dancing Knowledge III",
  social_dancer_knowledge_04: "Dancing Knowledge IV",
  social_dancer_master: "Master Dancer",
  social_dancer_novice: "Novice Dancer",
  social_dancer_shock_01: "Dancer's Fatigue Healing I",
  social_dancer_shock_02: "Dancer's Fatigue Healing II",
  social_dancer_shock_03: "Dancer's Fatigue Healing III",
  social_dancer_shock_04: "Dancer's Fatigue Healing IV",
  social_dancer_wound_01: "Dancer's Wound Healing I",
  social_dancer_wound_02: "Dancer's Wound Healing II",
  social_dancer_wound_03: "Dancer's Wound Healing III",
  social_dancer_wound_04: "Dancer's Wound Healing IV",
  social_entertainer: "Entertainer",
  social_entertainer_dance_01: "Dancing I: Basic",
  social_entertainer_dance_02: "Dancing II: Rhythmic",
  social_entertainer_dance_03: "Dancing III: Footloose",
  social_entertainer_dance_04: "Dancing IV: Formal",
  social_entertainer_hairstyle_01: "Image Design I: Facial Hair & Trim",
  social_entertainer_hairstyle_02: "Image Design II: Basic Hair Styling",
  social_entertainer_hairstyle_03: "Image Design III: Improved Hair Styling",
  social_entertainer_hairstyle_04: "Image Design IV: Complex Hair Styling",
  social_entertainer_healing_01: "Entertainment Healing I: Amateur Act",
  social_entertainer_healing_02: "Entertainment Healing II: Professional Act",
  social_entertainer_healing_03: "Entertainment Healing III: Center Stage",
  social_entertainer_healing_04: "Entertainment Healing IV: Headliner",
  social_entertainer_master: "Master Entertainer",
  social_entertainer_music_01: "Musicianship I: Rock",
  social_entertainer_music_02: "Musicianship II: Easy",
  social_entertainer_music_03: "Musicianship III: Folk",
  social_entertainer_music_04: "Musicianship IV: Jazz",
  social_entertainer_novice: "Novice Entertainer",
  social_imagedesigner: "Image Designer",
  social_imagedesigner_bodyform_01: "Bodyform I: Personal Training",
  social_imagedesigner_bodyform_02: "Bodyform II: Body Glamour",
  social_imagedesigner_bodyform_03: "Bodyform III: Alien Bioforms",
  social_imagedesigner_bodyform_04: "Bodyform IV: Body Mastery",
  social_imagedesigner_exotic_01: "Face I: Facial Customization",
  social_imagedesigner_exotic_02: "Face II: Stage Make Up & Design",
  social_imagedesigner_exotic_03: "Face III: Alien Faceforms",
  social_imagedesigner_exotic_04: "Face IV: Face Mastery",
  social_imagedesigner_hairstyle_01: "Hairstyling I: Barber",
  social_imagedesigner_hairstyle_02: "Hairstyling II: Hair Dresser",
  social_imagedesigner_hairstyle_03: "Hairstyling III: Hair Stylist",
  social_imagedesigner_hairstyle_04: "Hairstyling IV: Beautician",
  social_imagedesigner_markings_01: "Markings I: Tattoos",
  social_imagedesigner_markings_02: "Markings II: Patterns",
  social_imagedesigner_markings_03: "Markings III: Advanced Detail",
  social_imagedesigner_markings_04: "Markings IV: Detail Mastery",
  social_imagedesigner_master: "Master Image Designer",
  social_imagedesigner_novice: "Novice Image Designer",
  social_langage_sullustan_speak: "Sullustese Speech (Sullustan Language)",
  social_language: "Languages",
  social_language_basic: "Basic Language (Human Language)",
  social_language_basic_comprehend: "Basic Comprehension (Human Language)",
  social_language_basic_speak: "Basic Speech (Human Language)",
  social_language_bothan: "Bothese",
  social_language_bothan_comprehend: "Bothese Comprehension (Bothan Language)",
  social_language_bothan_speak: "Bothese Speech (Bothan Language)",
  social_language_human: "Basic",
  social_language_ithorian: "Ithorese",
  social_language_ithorian_comprehend:
    "Ithorese Comprehension (Ithorian Language)",
  social_language_ithorian_speak: "Ithorese Speech (Ithorian Language)",
  social_language_lekku: "Lekku",
  social_language_lekku_comprehend:
    "Lekku Comprehension (Twi'lek Silent Language)",
  social_language_lekku_speak: "Lekku Silent Speech (Twi'lek Silent Language)",
  social_language_moncalamari: "Mon Calamarian",
  social_language_moncalamari_comprehend:
    "Mon Calamarian Comprehension (Mon Calamarian Language)",
  social_language_moncalamari_speak:
    "Mon Calamarian Speech (Mon Calamarian Language)",
  social_language_rodian: "Rodese",
  social_language_rodian_comprehend: "Rodese Comprehension (Rodian Language)",
  social_language_rodian_speak: "Rodese Speech (Rodian Language)",
  social_language_sullustan: "Sullustese",
  social_language_sullustan_comprehend:
    "Sullustese Comprehension (Sullustan Language)",
  social_language_sullustan_speak: "Sullustese Speech (Sullustan Language)",
  social_language_trandoshan: "Dosh",
  social_language_trandoshan_comprehend:
    "Dosh Comprehension (Trandoshan Language)",
  social_language_trandoshan_speak: "Dosh Speech (Trandoshan Language)",
  social_language_twilek: "Ryl",
  social_language_twilek_comprehend:
    "Ryl Comprehension (Twi'lek Spoken Language)",
  social_language_twilek_speak: "Ryl Speech (Twi'lek Spoken Language)",
  social_language_wookiee: "Shyriiwook",
  social_language_wookiee_comprehend:
    "Shyriiwook Comprehension (Wookiee Language)",
  social_language_wookiee_speak: "Shyriiwook Speech (Wookiee Language)",
  social_language_zabrak: "Zabrak",
  social_language_zabrak_comprehend: "Zabrak Comprehension (Zabrak Language)",
  social_language_zabrak_speak: "Zabrak Speech (Zabrak Language)",
  social_musician: "Musician",
  social_musician_ability_01: "Musical Techniques I",
  social_musician_ability_02: "Musical Techniques II",
  social_musician_ability_03: "Musical Techniques III",
  social_musician_ability_04: "Technique Specialist IV",
  social_musician_knowledge_01: "Musical Knowledge I",
  social_musician_knowledge_02: "Musical Knowledge II",
  social_musician_knowledge_03: "Musical Knowledge III",
  social_musician_knowledge_04: "Musical Knowledge IV",
  social_musician_master: "Master Musician",
  social_musician_novice: "Novice Musician",
  social_musician_shock_01: "Musician's Fatigue Healing I",
  social_musician_shock_02: "Musician's Fatigue Healing II",
  social_musician_shock_03: "Musician's Fatigue Healing III",
  social_musician_shock_04: "Musician's Fatigue Healing IV",
  social_musician_wound_01: "Musician's Wound Healing I",
  social_musician_wound_02: "Musician's Wound Healing II",
  social_musician_wound_03: "Musician's Wound Healing III",
  social_musician_wound_04: "Musician's Wound Healing IV",
  social_politician: "Politician",
  social_politician_civic_01: "Civic Policy I: Jobs",
  social_politician_civic_02: "Civic Policy II: Education",
  social_politician_civic_03: "Civic Policy III: Medical Policies",
  social_politician_civic_04: "Civic Policy IV: Job Policies",
  social_politician_fiscal_01: "Fiscal Policy I: Tourism",
  social_politician_fiscal_02: "Fiscal Policy II: Banking & Travel",
  social_politician_fiscal_03: "Fiscal Policy III: Industry",
  social_politician_fiscal_04: "Fiscal Policy IV: Research",
  social_politician_martial_01: "Martial Policy I: Militia",
  social_politician_martial_02: "Martial Policy II: Cloning",
  social_politician_martial_03: "Martial Policy III: Stronghold",
  social_politician_martial_04: "Martial Policy IV: Faction",
  social_politician_master: "Master Politician",
  social_politician_novice: "Novice Politician",
  social_politician_urban_01: "City Customization I: Lamps & Statues",
  social_politician_urban_02: "City Customization II: Fountains",
  social_politician_urban_03: "City Customization III: Gardens",
  social_politician_urban_04: "City Customization IV: Advanced Decoration",
  species_bothan: "Bothan Species Features",
  species_human: "Human Species Features",
  species_ithorian: "Ithorian Species Features",
  species_moncal: "Mon Calamari Species Features",
  species_rodian: "Rodian Species Features",
  species_sullustan: "Sullustan Species Features",
  species_trandoshan: "Trandoshan Species Features",
  species_twilek: "Twi'lek Species Features",
  species_wookiee: "Wookiee Species Features",
  species_zabrak: "Zabrak Species Features",
  teras_kasi_artist: "Teras Kasi Artist",
  vehicle_engineer: "Vehicle Engineer",
  xenobiologist: "Xenobiologist",
  combat_gladiator_novice: "Gladiator",
  combat_gladiator_master: "Titan of the Arena",
  combat_gladiator_thraex_01: "Thraex 01: Shield Hook Laceration",
  combat_gladiator_thraex_02: "Thraex 02: Serpent's Advance",
  combat_gladiator_thraex_03: "Thraex 03: Greave Breaker",
  combat_gladiator_thraex_04: "Thraex 04: Blood-Drunk Fury",
  combat_gladiator_murmillo_01: "Murmillo 01: Scutum Lock",
  combat_gladiator_murmillo_02: "Murmillo 02: Shield Crush",
  combat_gladiator_murmillo_03: "Murmillo 03: Gladius Riposte",
  combat_gladiator_murmillo_04: "Murmillo 04: March of the Colossus",
  combat_gladiator_dimachaerus_01: "Dimachaerus 01: Crosscut Rush",
  combat_gladiator_dimachaerus_02: "Dimachaerus 02: Whirling Evasion",
  combat_gladiator_dimachaerus_03: "Dimachaerus 03: Twin Fang Assault",
  combat_gladiator_dimachaerus_04: "Dimachaerus 04: Sudden Reversal",
  combat_gladiator_secutor_01: "Secutor 01: Lockstep Advance",
  combat_gladiator_secutor_02: "Secutor 02: Helm-Down Guard",
  combat_gladiator_secutor_03: "Secutor 03: Endurance of Iron",
  combat_gladiator_secutor_04: "Secutor 04: Arena Closure",
};

export const ALL_PROFESSIONS = {
  social_entertainer: {
    master_links: [],
    master: "social_entertainer_master",
    branch_1: {
      links: ["social_imagedesigner"],
      skills: [
        "social_entertainer_hairstyle_01",
        "social_entertainer_hairstyle_02",
        "social_entertainer_hairstyle_03",
        "social_entertainer_hairstyle_04",
      ],
    },
    branch_2: {
      links: ["social_musician"],
      skills: [
        "social_entertainer_music_01",
        "social_entertainer_music_02",
        "social_entertainer_music_03",
        "social_entertainer_music_04",
      ],
    },
    branch_3: {
      links: ["social_dancer"],
      skills: [
        "social_entertainer_dance_01",
        "social_entertainer_dance_02",
        "social_entertainer_dance_03",
        "social_entertainer_dance_04",
      ],
    },
    branch_4: {
      links: ["social_musician", "social_dancer"],
      skills: [
        "social_entertainer_healing_01",
        "social_entertainer_healing_02",
        "social_entertainer_healing_03",
        "social_entertainer_healing_04",
      ],
    },
    novice: "social_entertainer_novice",
    novice_links: [""],
  },
  outdoors_scout: {
    master_links: ["outdoors_ranger"],
    master: "outdoors_scout_master",
    branch_1: {
      links: [
        "outdoors_creaturehandler",
        "combat_bountyhunter",
        "outdoors_squadleader",
      ],
      skills: [
        "outdoors_scout_movement_01",
        "outdoors_scout_movement_02",
        "outdoors_scout_movement_03",
        "outdoors_scout_movement_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "outdoors_scout_tools_01",
        "outdoors_scout_tools_02",
        "outdoors_scout_tools_03",
        "outdoors_scout_tools_04",
      ],
    },
    branch_3: {
      links: ["outdoors_creaturehandler", "outdoors_bio_engineer"],
      skills: [
        "outdoors_scout_harvest_01",
        "outdoors_scout_harvest_02",
        "outdoors_scout_harvest_03",
        "outdoors_scout_harvest_04",
      ],
    },
    branch_4: {
      links: ["outdoors_squadleader"],
      skills: [
        "outdoors_scout_camp_01",
        "outdoors_scout_camp_02",
        "outdoors_scout_camp_03",
        "outdoors_scout_camp_04",
      ],
    },
    novice: "outdoors_scout_novice",
    novice_links: [""],
  },
  science_medic: {
    master_links: ["science_doctor", "science_combatmedic"],
    master: "science_medic_master",
    branch_1: {
      links: [],
      skills: [
        "science_medic_injury_01",
        "science_medic_injury_02",
        "science_medic_injury_03",
        "science_medic_injury_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "science_medic_injury_speed_01",
        "science_medic_injury_speed_02",
        "science_medic_injury_speed_03",
        "science_medic_injury_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "science_medic_ability_01",
        "science_medic_ability_02",
        "science_medic_ability_03",
        "science_medic_ability_04",
      ],
    },
    branch_4: {
      links: ["outdoors_bio_engineer"],
      skills: [
        "science_medic_crafting_01",
        "science_medic_crafting_02",
        "science_medic_crafting_03",
        "science_medic_crafting_04",
      ],
    },
    novice: "science_medic_novice",
    novice_links: [""],
  },
  crafting_artisan: {
    master_links: [],
    master: "crafting_artisan_master",
    branch_1: {
      links: [
        "crafting_armorsmith",
        "crafting_weaponsmith",
        "crafting_architect",
        "crafting_droidengineer",
      ],
      skills: [
        "crafting_artisan_engineering_01",
        "crafting_artisan_engineering_02",
        "crafting_artisan_engineering_03",
        "crafting_artisan_engineering_04",
      ],
    },
    branch_2: {
      links: ["crafting_chef", "crafting_tailor"],
      skills: [
        "crafting_artisan_domestic_01",
        "crafting_artisan_domestic_02",
        "crafting_artisan_domestic_03",
        "crafting_artisan_domestic_04",
      ],
    },
    branch_3: {
      links: ["crafting_merchant"],
      skills: [
        "crafting_artisan_business_01",
        "crafting_artisan_business_02",
        "crafting_artisan_business_03",
        "crafting_artisan_business_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_artisan_survey_01",
        "crafting_artisan_survey_02",
        "crafting_artisan_survey_03",
        "crafting_artisan_survey_04",
      ],
    },
    novice: "crafting_artisan_novice",
    novice_links: [""],
  },
  combat_brawler: {
    master_links: [],
    master: "combat_brawler_master",
    branch_1: {
      links: ["combat_unarmed", "combat_smuggler", "combat_commando"],
      skills: [
        "combat_brawler_unarmed_01",
        "combat_brawler_unarmed_02",
        "combat_brawler_unarmed_03",
        "combat_brawler_unarmed_04",
      ],
    },
    branch_2: {
      links: ["combat_1hsword"],
      skills: [
        "combat_brawler_1handmelee_01",
        "combat_brawler_1handmelee_02",
        "combat_brawler_1handmelee_03",
        "combat_brawler_1handmelee_04",
      ],
    },
    branch_3: {
      links: ["combat_2hsword"],
      skills: [
        "combat_brawler_2handmelee_01",
        "combat_brawler_2handmelee_02",
        "combat_brawler_2handmelee_03",
        "combat_brawler_2handmelee_04",
      ],
    },
    branch_4: {
      links: ["combat_polearm"],
      skills: [
        "combat_brawler_polearm_01",
        "combat_brawler_polearm_02",
        "combat_brawler_polearm_03",
        "combat_brawler_polearm_04",
      ],
    },
    novice: "combat_brawler_novice",
    novice_links: [""],
  },
  combat_marksman: {
    master_links: ["combat_bountyhunter", "combat_commando"],
    master: "combat_marksman_master",
    branch_1: {
      links: ["combat_rifleman"],
      skills: [
        "combat_marksman_rifle_01",
        "combat_marksman_rifle_02",
        "combat_marksman_rifle_03",
        "combat_marksman_rifle_04",
      ],
    },
    branch_2: {
      links: ["combat_pistol", "combat_smuggler"],
      skills: [
        "combat_marksman_pistol_01",
        "combat_marksman_pistol_02",
        "combat_marksman_pistol_03",
        "combat_marksman_pistol_04",
      ],
    },
    branch_3: {
      links: ["combat_carbine"],
      skills: [
        "combat_marksman_carbine_01",
        "combat_marksman_carbine_02",
        "combat_marksman_carbine_03",
        "combat_marksman_carbine_04",
      ],
    },
    branch_4: {
      links: ["science_combatmedic", "outdoors_squadleader"],
      skills: [
        "combat_marksman_support_01",
        "combat_marksman_support_02",
        "combat_marksman_support_03",
        "combat_marksman_support_04",
      ],
    },
    novice: "combat_marksman_novice",
    novice_links: [""],
  },
  combat_rifleman: {
    master_links: [],
    master: "combat_rifleman_master",
    branch_1: {
      links: [],
      skills: [
        "combat_rifleman_accuracy_01",
        "combat_rifleman_accuracy_02",
        "combat_rifleman_accuracy_03",
        "combat_rifleman_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_rifleman_speed_01",
        "combat_rifleman_speed_02",
        "combat_rifleman_speed_03",
        "combat_rifleman_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_rifleman_ability_01",
        "combat_rifleman_ability_02",
        "combat_rifleman_ability_03",
        "combat_rifleman_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_rifleman_support_01",
        "combat_rifleman_support_02",
        "combat_rifleman_support_03",
        "combat_rifleman_support_04",
      ],
    },
    novice: "combat_rifleman_novice",
    novice_links: ["combat_marksman"],
  },
  combat_pistol: {
    master_links: [],
    master: "combat_pistol_master",
    branch_1: {
      links: [],
      skills: [
        "combat_pistol_accuracy_01",
        "combat_pistol_accuracy_02",
        "combat_pistol_accuracy_03",
        "combat_pistol_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_pistol_speed_01",
        "combat_pistol_speed_02",
        "combat_pistol_speed_03",
        "combat_pistol_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_pistol_ability_01",
        "combat_pistol_ability_02",
        "combat_pistol_ability_03",
        "combat_pistol_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_pistol_support_01",
        "combat_pistol_support_02",
        "combat_pistol_support_03",
        "combat_pistol_support_04",
      ],
    },
    novice: "combat_pistol_novice",
    novice_links: ["combat_marksman"],
  },
  combat_carbine: {
    master_links: [],
    master: "combat_carbine_master",
    branch_1: {
      links: [],
      skills: [
        "combat_carbine_accuracy_01",
        "combat_carbine_accuracy_02",
        "combat_carbine_accuracy_03",
        "combat_carbine_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_carbine_speed_01",
        "combat_carbine_speed_02",
        "combat_carbine_speed_03",
        "combat_carbine_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_carbine_ability_01",
        "combat_carbine_ability_02",
        "combat_carbine_ability_03",
        "combat_carbine_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_carbine_support_01",
        "combat_carbine_support_02",
        "combat_carbine_support_03",
        "combat_carbine_support_04",
      ],
    },
    novice: "combat_carbine_novice",
    novice_links: ["combat_marksman"],
  },
  combat_unarmed: {
    master_links: [],
    master: "combat_unarmed_master",
    branch_1: {
      links: [],
      skills: [
        "combat_unarmed_accuracy_01",
        "combat_unarmed_accuracy_02",
        "combat_unarmed_accuracy_03",
        "combat_unarmed_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_unarmed_speed_01",
        "combat_unarmed_speed_02",
        "combat_unarmed_speed_03",
        "combat_unarmed_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_unarmed_ability_01",
        "combat_unarmed_ability_02",
        "combat_unarmed_ability_03",
        "combat_unarmed_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_unarmed_support_01",
        "combat_unarmed_support_02",
        "combat_unarmed_support_03",
        "combat_unarmed_support_04",
      ],
    },
    novice: "combat_unarmed_novice",
    novice_links: ["combat_brawler"],
  },
  combat_1hsword: {
    master_links: [],
    master: "combat_1hsword_master",
    branch_1: {
      links: [],
      skills: [
        "combat_1hsword_accuracy_01",
        "combat_1hsword_accuracy_02",
        "combat_1hsword_accuracy_03",
        "combat_1hsword_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_1hsword_speed_01",
        "combat_1hsword_speed_02",
        "combat_1hsword_speed_03",
        "combat_1hsword_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_1hsword_ability_01",
        "combat_1hsword_ability_02",
        "combat_1hsword_ability_03",
        "combat_1hsword_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_1hsword_support_01",
        "combat_1hsword_support_02",
        "combat_1hsword_support_03",
        "combat_1hsword_support_04",
      ],
    },
    novice: "combat_1hsword_novice",
    novice_links: ["combat_brawler"],
  },
  combat_2hsword: {
    master_links: [],
    master: "combat_2hsword_master",
    branch_1: {
      links: [],
      skills: [
        "combat_2hsword_accuracy_01",
        "combat_2hsword_accuracy_02",
        "combat_2hsword_accuracy_03",
        "combat_2hsword_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_2hsword_speed_01",
        "combat_2hsword_speed_02",
        "combat_2hsword_speed_03",
        "combat_2hsword_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_2hsword_ability_01",
        "combat_2hsword_ability_02",
        "combat_2hsword_ability_03",
        "combat_2hsword_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_2hsword_support_01",
        "combat_2hsword_support_02",
        "combat_2hsword_support_03",
        "combat_2hsword_support_04",
      ],
    },
    novice: "combat_2hsword_novice",
    novice_links: ["combat_brawler"],
  },
  combat_polearm: {
    master_links: [],
    master: "combat_polearm_master",
    branch_1: {
      links: [],
      skills: [
        "combat_polearm_accuracy_01",
        "combat_polearm_accuracy_02",
        "combat_polearm_accuracy_03",
        "combat_polearm_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_polearm_speed_01",
        "combat_polearm_speed_02",
        "combat_polearm_speed_03",
        "combat_polearm_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_polearm_ability_01",
        "combat_polearm_ability_02",
        "combat_polearm_ability_03",
        "combat_polearm_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_polearm_support_01",
        "combat_polearm_support_02",
        "combat_polearm_support_03",
        "combat_polearm_support_04",
      ],
    },
    novice: "combat_polearm_novice",
    novice_links: ["combat_brawler"],
  },
  social_dancer: {
    master_links: [],
    master: "social_dancer_master",
    branch_1: {
      links: [],
      skills: [
        "social_dancer_ability_01",
        "social_dancer_ability_02",
        "social_dancer_ability_03",
        "social_dancer_ability_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "social_dancer_wound_01",
        "social_dancer_wound_02",
        "social_dancer_wound_03",
        "social_dancer_wound_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "social_dancer_knowledge_01",
        "social_dancer_knowledge_02",
        "social_dancer_knowledge_03",
        "social_dancer_knowledge_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "social_dancer_shock_01",
        "social_dancer_shock_02",
        "social_dancer_shock_03",
        "social_dancer_shock_04",
      ],
    },
    novice: "social_dancer_novice",
    novice_links: ["social_entertainer"],
  },
  social_musician: {
    master_links: [],
    master: "social_musician_master",
    branch_1: {
      links: [],
      skills: [
        "social_musician_ability_01",
        "social_musician_ability_02",
        "social_musician_ability_03",
        "social_musician_ability_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "social_musician_wound_01",
        "social_musician_wound_02",
        "social_musician_wound_03",
        "social_musician_wound_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "social_musician_knowledge_01",
        "social_musician_knowledge_02",
        "social_musician_knowledge_03",
        "social_musician_knowledge_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "social_musician_shock_01",
        "social_musician_shock_02",
        "social_musician_shock_03",
        "social_musician_shock_04",
      ],
    },
    novice: "social_musician_novice",
    novice_links: ["social_entertainer"],
  },
  science_doctor: {
    master_links: [],
    master: "science_doctor_master",
    branch_1: {
      links: [],
      skills: [
        "science_doctor_wound_speed_01",
        "science_doctor_wound_speed_02",
        "science_doctor_wound_speed_03",
        "science_doctor_wound_speed_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "science_doctor_wound_01",
        "science_doctor_wound_02",
        "science_doctor_wound_03",
        "science_doctor_wound_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "science_doctor_ability_01",
        "science_doctor_ability_02",
        "science_doctor_ability_03",
        "science_doctor_ability_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "science_doctor_support_01",
        "science_doctor_support_02",
        "science_doctor_support_03",
        "science_doctor_support_04",
      ],
    },
    novice: "science_doctor_novice",
    novice_links: ["science_medic"],
  },
  outdoors_ranger: {
    master_links: [],
    master: "outdoors_ranger_master",
    branch_1: {
      links: [],
      skills: [
        "outdoors_ranger_movement_01",
        "outdoors_ranger_movement_02",
        "outdoors_ranger_movement_03",
        "outdoors_ranger_movement_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "outdoors_ranger_tracking_01",
        "outdoors_ranger_tracking_02",
        "outdoors_ranger_tracking_03",
        "outdoors_ranger_tracking_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "outdoors_ranger_harvest_01",
        "outdoors_ranger_harvest_02",
        "outdoors_ranger_harvest_03",
        "outdoors_ranger_harvest_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "outdoors_ranger_support_01",
        "outdoors_ranger_support_02",
        "outdoors_ranger_support_03",
        "outdoors_ranger_support_04",
      ],
    },
    novice: "outdoors_ranger_novice",
    novice_links: ["outdoors_scout"],
  },
  outdoors_creaturehandler: {
    master_links: [],
    master: "outdoors_creaturehandler_master",
    branch_1: {
      links: [],
      skills: [
        "outdoors_creaturehandler_taming_01",
        "outdoors_creaturehandler_taming_02",
        "outdoors_creaturehandler_taming_03",
        "outdoors_creaturehandler_taming_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "outdoors_creaturehandler_training_01",
        "outdoors_creaturehandler_training_02",
        "outdoors_creaturehandler_training_03",
        "outdoors_creaturehandler_training_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "outdoors_creaturehandler_healing_01",
        "outdoors_creaturehandler_healing_02",
        "outdoors_creaturehandler_healing_03",
        "outdoors_creaturehandler_healing_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "outdoors_creaturehandler_support_01",
        "outdoors_creaturehandler_support_02",
        "outdoors_creaturehandler_support_03",
        "outdoors_creaturehandler_support_04",
      ],
    },
    novice: "outdoors_creaturehandler_novice",
    novice_links: ["outdoors_scout"],
  },
  outdoors_bio_engineer: {
    master_links: [],
    master: "outdoors_bio_engineer_master",
    branch_1: {
      links: [],
      skills: [
        "outdoors_bio_engineer_creature_01",
        "outdoors_bio_engineer_creature_02",
        "outdoors_bio_engineer_creature_03",
        "outdoors_bio_engineer_creature_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "outdoors_bio_engineer_tissue_01",
        "outdoors_bio_engineer_tissue_02",
        "outdoors_bio_engineer_tissue_03",
        "outdoors_bio_engineer_tissue_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "outdoors_bio_engineer_dna_harvesting_01",
        "outdoors_bio_engineer_dna_harvesting_02",
        "outdoors_bio_engineer_dna_harvesting_03",
        "outdoors_bio_engineer_dna_harvesting_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "outdoors_bio_engineer_production_01",
        "outdoors_bio_engineer_production_02",
        "outdoors_bio_engineer_production_03",
        "outdoors_bio_engineer_production_04",
      ],
    },
    novice: "outdoors_bio_engineer_novice",
    novice_links: ["outdoors_scout", "science_medic"],
  },
  crafting_armorsmith: {
    master_links: [],
    master: "crafting_armorsmith_master",
    branch_1: {
      links: [],
      skills: [
        "crafting_armorsmith_personal_01",
        "crafting_armorsmith_personal_02",
        "crafting_armorsmith_personal_03",
        "crafting_armorsmith_personal_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "crafting_armorsmith_heavy_01",
        "crafting_armorsmith_heavy_02",
        "crafting_armorsmith_heavy_03",
        "crafting_armorsmith_heavy_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "crafting_armorsmith_deflectors_01",
        "crafting_armorsmith_deflectors_02",
        "crafting_armorsmith_deflectors_03",
        "crafting_armorsmith_deflectors_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_armorsmith_complexity_01",
        "crafting_armorsmith_complexity_02",
        "crafting_armorsmith_complexity_03",
        "crafting_armorsmith_complexity_04",
      ],
    },
    novice: "crafting_armorsmith_novice",
    novice_links: ["crafting_artisan"],
  },
  crafting_weaponsmith: {
    master_links: [],
    master: "crafting_weaponsmith_master",
    branch_1: {
      links: [],
      skills: [
        "crafting_weaponsmith_melee_01",
        "crafting_weaponsmith_melee_02",
        "crafting_weaponsmith_melee_03",
        "crafting_weaponsmith_melee_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "crafting_weaponsmith_firearms_01",
        "crafting_weaponsmith_firearms_02",
        "crafting_weaponsmith_firearms_03",
        "crafting_weaponsmith_firearms_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "crafting_weaponsmith_munitions_01",
        "crafting_weaponsmith_munitions_02",
        "crafting_weaponsmith_munitions_03",
        "crafting_weaponsmith_munitions_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_weaponsmith_techniques_01",
        "crafting_weaponsmith_techniques_02",
        "crafting_weaponsmith_techniques_03",
        "crafting_weaponsmith_techniques_04",
      ],
    },
    novice: "crafting_weaponsmith_novice",
    novice_links: ["crafting_artisan"],
  },
  crafting_chef: {
    master_links: [],
    master: "crafting_chef_master",
    branch_1: {
      links: [],
      skills: [
        "crafting_chef_dish_01",
        "crafting_chef_dish_02",
        "crafting_chef_dish_03",
        "crafting_chef_dish_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "crafting_chef_dessert_01",
        "crafting_chef_dessert_02",
        "crafting_chef_dessert_03",
        "crafting_chef_dessert_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "crafting_chef_drink_01",
        "crafting_chef_drink_02",
        "crafting_chef_drink_03",
        "crafting_chef_drink_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_chef_techniques_01",
        "crafting_chef_techniques_02",
        "crafting_chef_techniques_03",
        "crafting_chef_techniques_04",
      ],
    },
    novice: "crafting_chef_novice",
    novice_links: ["crafting_artisan"],
  },
  crafting_tailor: {
    master_links: [],
    master: "crafting_tailor_master",
    branch_1: {
      links: [],
      skills: [
        "crafting_tailor_casual_01",
        "crafting_tailor_casual_02",
        "crafting_tailor_casual_03",
        "crafting_tailor_casual_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "crafting_tailor_field_01",
        "crafting_tailor_field_02",
        "crafting_tailor_field_03",
        "crafting_tailor_field_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "crafting_tailor_formal_01",
        "crafting_tailor_formal_02",
        "crafting_tailor_formal_03",
        "crafting_tailor_formal_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_tailor_production_01",
        "crafting_tailor_production_02",
        "crafting_tailor_production_03",
        "crafting_tailor_production_04",
      ],
    },
    novice: "crafting_tailor_novice",
    novice_links: ["crafting_artisan"],
  },
  crafting_architect: {
    master_links: [],
    master: "crafting_architect_master",
    branch_1: {
      links: [],
      skills: [
        "crafting_architect_production_01",
        "crafting_architect_production_02",
        "crafting_architect_production_03",
        "crafting_architect_production_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "crafting_architect_techniques_01",
        "crafting_architect_techniques_02",
        "crafting_architect_techniques_03",
        "crafting_architect_techniques_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "crafting_architect_harvesting_01",
        "crafting_architect_harvesting_02",
        "crafting_architect_harvesting_03",
        "crafting_architect_harvesting_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_architect_blueprints_01",
        "crafting_architect_blueprints_02",
        "crafting_architect_blueprints_03",
        "crafting_architect_blueprints_04",
      ],
    },
    novice: "crafting_architect_novice",
    novice_links: ["crafting_artisan"],
  },
  crafting_droidengineer: {
    master_links: [],
    master: "crafting_droidengineer_master",
    branch_1: {
      links: [],
      skills: [
        "crafting_droidengineer_production_01",
        "crafting_droidengineer_production_02",
        "crafting_droidengineer_production_03",
        "crafting_droidengineer_production_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "crafting_droidengineer_techniques_01",
        "crafting_droidengineer_techniques_02",
        "crafting_droidengineer_techniques_03",
        "crafting_droidengineer_techniques_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "crafting_droidengineer_refinement_01",
        "crafting_droidengineer_refinement_02",
        "crafting_droidengineer_refinement_03",
        "crafting_droidengineer_refinement_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_droidengineer_blueprints_01",
        "crafting_droidengineer_blueprints_02",
        "crafting_droidengineer_blueprints_03",
        "crafting_droidengineer_blueprints_04",
      ],
    },
    novice: "crafting_droidengineer_novice",
    novice_links: ["crafting_artisan"],
  },
  crafting_merchant: {
    master_links: [],
    master: "crafting_merchant_master",
    branch_1: {
      links: [],
      skills: [
        "crafting_merchant_advertising_01",
        "crafting_merchant_advertising_02",
        "crafting_merchant_advertising_03",
        "crafting_merchant_advertising_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "crafting_merchant_sales_01",
        "crafting_merchant_sales_02",
        "crafting_merchant_sales_03",
        "crafting_merchant_sales_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "crafting_merchant_hiring_01",
        "crafting_merchant_hiring_02",
        "crafting_merchant_hiring_03",
        "crafting_merchant_hiring_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "crafting_merchant_management_01",
        "crafting_merchant_management_02",
        "crafting_merchant_management_03",
        "crafting_merchant_management_04",
      ],
    },
    novice: "crafting_merchant_novice",
    novice_links: ["crafting_artisan"],
  },
  combat_smuggler: {
    master_links: [],
    master: "combat_smuggler_master",
    branch_1: {
      links: [],
      skills: [
        "combat_smuggler_underworld_01",
        "combat_smuggler_underworld_02",
        "combat_smuggler_underworld_03",
        "combat_smuggler_underworld_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_smuggler_slicing_01",
        "combat_smuggler_slicing_02",
        "combat_smuggler_slicing_03",
        "combat_smuggler_slicing_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_smuggler_combat_01",
        "combat_smuggler_combat_02",
        "combat_smuggler_combat_03",
        "combat_smuggler_combat_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_smuggler_spice_01",
        "combat_smuggler_spice_02",
        "combat_smuggler_spice_03",
        "combat_smuggler_spice_04",
      ],
    },
    novice: "combat_smuggler_novice",
    novice_links: ["combat_marksman", "combat_brawler"],
  },
  combat_bountyhunter: {
    master_links: [],
    master: "combat_bountyhunter_master",
    branch_1: {
      links: [],
      skills: [
        "combat_bountyhunter_investigation_01",
        "combat_bountyhunter_investigation_02",
        "combat_bountyhunter_investigation_03",
        "combat_bountyhunter_investigation_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_bountyhunter_droidcontrol_01",
        "combat_bountyhunter_droidcontrol_02",
        "combat_bountyhunter_droidcontrol_03",
        "combat_bountyhunter_droidcontrol_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_bountyhunter_droidresponse_01",
        "combat_bountyhunter_droidresponse_02",
        "combat_bountyhunter_droidresponse_03",
        "combat_bountyhunter_droidresponse_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_bountyhunter_support_01",
        "combat_bountyhunter_support_02",
        "combat_bountyhunter_support_03",
        "combat_bountyhunter_support_04",
      ],
    },
    novice: "combat_bountyhunter_novice",
    novice_links: ["combat_marksman", "outdoors_scout"],
  },
  combat_commando: {
    master_links: [],
    master: "combat_commando_master",
    branch_1: {
      links: [],
      skills: [
        "combat_commando_heavyweapon_accuracy_01",
        "combat_commando_heavyweapon_accuracy_02",
        "combat_commando_heavyweapon_accuracy_03",
        "combat_commando_heavyweapon_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_commando_heavyweapon_speed_01",
        "combat_commando_heavyweapon_speed_02",
        "combat_commando_heavyweapon_speed_03",
        "combat_commando_heavyweapon_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_commando_thrownweapon_01",
        "combat_commando_thrownweapon_02",
        "combat_commando_thrownweapon_03",
        "combat_commando_thrownweapon_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_commando_support_01",
        "combat_commando_support_02",
        "combat_commando_support_03",
        "combat_commando_support_04",
      ],
    },
    novice: "combat_commando_novice",
    novice_links: ["combat_marksman", "combat_brawler"],
  },
  science_combatmedic: {
    master_links: [],
    master: "science_combatmedic_master",
    branch_1: {
      links: [],
      skills: [
        "science_combatmedic_healing_range_01",
        "science_combatmedic_healing_range_02",
        "science_combatmedic_healing_range_03",
        "science_combatmedic_healing_range_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "science_combatmedic_healing_range_speed_01",
        "science_combatmedic_healing_range_speed_02",
        "science_combatmedic_healing_range_speed_03",
        "science_combatmedic_healing_range_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "science_combatmedic_medicine_01",
        "science_combatmedic_medicine_02",
        "science_combatmedic_medicine_03",
        "science_combatmedic_medicine_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "science_combatmedic_support_01",
        "science_combatmedic_support_02",
        "science_combatmedic_support_03",
        "science_combatmedic_support_04",
      ],
    },
    novice: "science_combatmedic_novice",
    novice_links: ["combat_marksman", "science_medic"],
  },
  social_imagedesigner: {
    master_links: [],
    master: "social_imagedesigner_master",
    branch_1: {
      links: [],
      skills: [
        "social_imagedesigner_hairstyle_01",
        "social_imagedesigner_hairstyle_02",
        "social_imagedesigner_hairstyle_03",
        "social_imagedesigner_hairstyle_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "social_imagedesigner_exotic_01",
        "social_imagedesigner_exotic_02",
        "social_imagedesigner_exotic_03",
        "social_imagedesigner_exotic_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "social_imagedesigner_bodyform_01",
        "social_imagedesigner_bodyform_02",
        "social_imagedesigner_bodyform_03",
        "social_imagedesigner_bodyform_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "social_imagedesigner_markings_01",
        "social_imagedesigner_markings_02",
        "social_imagedesigner_markings_03",
        "social_imagedesigner_markings_04",
      ],
    },
    novice: "social_imagedesigner_novice",
    novice_links: ["social_entertainer"],
  },
  outdoors_squadleader: {
    master_links: [],
    master: "outdoors_squadleader_master",
    branch_1: {
      links: [],
      skills: [
        "outdoors_squadleader_movement_01",
        "outdoors_squadleader_movement_02",
        "outdoors_squadleader_movement_03",
        "outdoors_squadleader_movement_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "outdoors_squadleader_offense_01",
        "outdoors_squadleader_offense_02",
        "outdoors_squadleader_offense_03",
        "outdoors_squadleader_offense_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "outdoors_squadleader_defense_01",
        "outdoors_squadleader_defense_02",
        "outdoors_squadleader_defense_03",
        "outdoors_squadleader_defense_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "outdoors_squadleader_support_01",
        "outdoors_squadleader_support_02",
        "outdoors_squadleader_support_03",
        "outdoors_squadleader_support_04",
      ],
    },
    novice: "outdoors_squadleader_novice",
    novice_links: ["outdoors_scout", "combat_marksman"],
  },
  social_politician: {
    master_links: [],
    master: "social_politician_master",
    branch_1: {
      links: [],
      skills: [
        "social_politician_fiscal_01",
        "social_politician_fiscal_02",
        "social_politician_fiscal_03",
        "social_politician_fiscal_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "social_politician_martial_01",
        "social_politician_martial_02",
        "social_politician_martial_03",
        "social_politician_martial_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "social_politician_civic_01",
        "social_politician_civic_02",
        "social_politician_civic_03",
        "social_politician_civic_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "social_politician_urban_01",
        "social_politician_urban_02",
        "social_politician_urban_03",
        "social_politician_urban_04",
      ],
    },
    novice: "social_politician_novice",
    novice_links: [""],
  },
  force_sensitive_combat_prowess: {
    master_links: [],
    master: "force_sensitive_combat_prowess_master",
    branch_1: {
      links: [],
      skills: [
        "force_sensitive_combat_prowess_ranged_accuracy_01",
        "force_sensitive_combat_prowess_ranged_accuracy_02",
        "force_sensitive_combat_prowess_ranged_accuracy_03",
        "force_sensitive_combat_prowess_ranged_accuracy_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_sensitive_combat_prowess_ranged_speed_01",
        "force_sensitive_combat_prowess_ranged_speed_02",
        "force_sensitive_combat_prowess_ranged_speed_03",
        "force_sensitive_combat_prowess_ranged_speed_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_sensitive_combat_prowess_melee_accuracy_01",
        "force_sensitive_combat_prowess_melee_accuracy_02",
        "force_sensitive_combat_prowess_melee_accuracy_03",
        "force_sensitive_combat_prowess_melee_accuracy_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_sensitive_combat_prowess_melee_speed_01",
        "force_sensitive_combat_prowess_melee_speed_02",
        "force_sensitive_combat_prowess_melee_speed_03",
        "force_sensitive_combat_prowess_melee_speed_04",
      ],
    },
    novice: "force_sensitive_combat_prowess_novice",
    novice_links: [],
  },
  force_sensitive_enhanced_reflexes: {
    master_links: [],
    master: "force_sensitive_enhanced_reflexes_master",
    branch_1: {
      links: [],
      skills: [
        "force_sensitive_enhanced_reflexes_ranged_defense_01",
        "force_sensitive_enhanced_reflexes_ranged_defense_02",
        "force_sensitive_enhanced_reflexes_ranged_defense_03",
        "force_sensitive_enhanced_reflexes_ranged_defense_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_sensitive_enhanced_reflexes_melee_defense_01",
        "force_sensitive_enhanced_reflexes_melee_defense_02",
        "force_sensitive_enhanced_reflexes_melee_defense_03",
        "force_sensitive_enhanced_reflexes_melee_defense_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_sensitive_enhanced_reflexes_vehicle_control_01",
        "force_sensitive_enhanced_reflexes_vehicle_control_02",
        "force_sensitive_enhanced_reflexes_vehicle_control_03",
        "force_sensitive_enhanced_reflexes_vehicle_control_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_sensitive_enhanced_reflexes_survival_01",
        "force_sensitive_enhanced_reflexes_survival_02",
        "force_sensitive_enhanced_reflexes_survival_03",
        "force_sensitive_enhanced_reflexes_survival_04",
      ],
    },
    novice: "force_sensitive_enhanced_reflexes_novice",
    novice_links: [],
  },
  force_sensitive_crafting_mastery: {
    master_links: [],
    master: "force_sensitive_crafting_mastery_master",
    branch_1: {
      links: [],
      skills: [
        "force_sensitive_crafting_mastery_experimentation_01",
        "force_sensitive_crafting_mastery_experimentation_02",
        "force_sensitive_crafting_mastery_experimentation_03",
        "force_sensitive_crafting_mastery_experimentation_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_sensitive_crafting_mastery_assembly_01",
        "force_sensitive_crafting_mastery_assembly_02",
        "force_sensitive_crafting_mastery_assembly_03",
        "force_sensitive_crafting_mastery_assembly_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_sensitive_crafting_mastery_repair_01",
        "force_sensitive_crafting_mastery_repair_02",
        "force_sensitive_crafting_mastery_repair_03",
        "force_sensitive_crafting_mastery_repair_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_sensitive_crafting_mastery_technique_01",
        "force_sensitive_crafting_mastery_technique_02",
        "force_sensitive_crafting_mastery_technique_03",
        "force_sensitive_crafting_mastery_technique_04",
      ],
    },
    novice: "force_sensitive_crafting_novicey_novice",
    novice_links: [],
  },
  force_sensitive_heightened_senses: {
    master_links: [],
    master: "force_sensitive_heightened_senses_master",
    branch_1: {
      links: [],
      skills: [
        "force_sensitive_heightened_senses_healing_01",
        "force_sensitive_heightened_senses_healing_02",
        "force_sensitive_heightened_senses_healing_03",
        "force_sensitive_heightened_senses_healing_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_sensitive_heightened_senses_surveying_01",
        "force_sensitive_heightened_senses_surveying_02",
        "force_sensitive_heightened_senses_surveying_03",
        "force_sensitive_heightened_senses_surveying_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_sensitive_heightened_senses_persuasion_01",
        "force_sensitive_heightened_senses_persuasion_02",
        "force_sensitive_heightened_senses_persuasion_03",
        "force_sensitive_heightened_senses_persuasion_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_sensitive_heightened_senses_luck_01",
        "force_sensitive_heightened_senses_luck_02",
        "force_sensitive_heightened_senses_luck_03",
        "force_sensitive_heightened_senses_luck_04",
      ],
    },
    novice: "force_sensitive_heightened_senses_novice",
    novice_links: [],
  },
  force_discipline_light_saber: {
    master_links: [],
    master: "force_discipline_light_saber_master",
    branch_1: {
      links: [],
      skills: [
        "force_discipline_light_saber_one_hand_01",
        "force_discipline_light_saber_one_hand_02",
        "force_discipline_light_saber_one_hand_03",
        "force_discipline_light_saber_one_hand_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_discipline_light_saber_two_hand_01",
        "force_discipline_light_saber_two_hand_02",
        "force_discipline_light_saber_two_hand_03",
        "force_discipline_light_saber_two_hand_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_discipline_light_saber_polearm_01",
        "force_discipline_light_saber_polearm_02",
        "force_discipline_light_saber_polearm_03",
        "force_discipline_light_saber_polearm_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_discipline_light_saber_technique_01",
        "force_discipline_light_saber_technique_02",
        "force_discipline_light_saber_technique_03",
        "force_discipline_light_saber_technique_04",
      ],
    },
    novice: "force_discipline_light_saber_novice",
    novice_links: [],
  },
  force_discipline_powers: {
    master_links: [],
    master: "force_discipline_powers_master",
    branch_1: {
      links: [],
      skills: [
        "force_discipline_powers_lightning_01",
        "force_discipline_powers_lightning_02",
        "force_discipline_powers_lightning_03",
        "force_discipline_powers_lightning_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_discipline_powers_mental_01",
        "force_discipline_powers_mental_02",
        "force_discipline_powers_mental_03",
        "force_discipline_powers_mental_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_discipline_powers_debuff_01",
        "force_discipline_powers_debuff_02",
        "force_discipline_powers_debuff_03",
        "force_discipline_powers_debuff_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_discipline_powers_push_01",
        "force_discipline_powers_push_02",
        "force_discipline_powers_push_03",
        "force_discipline_powers_push_04",
      ],
    },
    novice: "force_discipline_powers_novice",
    novice_links: [],
  },
  force_discipline_healing: {
    master_links: [],
    master: "force_discipline_healing_master",
    branch_1: {
      links: [],
      skills: [
        "force_discipline_healing_damage_01",
        "force_discipline_healing_damage_02",
        "force_discipline_healing_damage_03",
        "force_discipline_healing_damage_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_discipline_healing_wound_01",
        "force_discipline_healing_wound_02",
        "force_discipline_healing_wound_03",
        "force_discipline_healing_wound_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_discipline_healing_other_01",
        "force_discipline_healing_other_02",
        "force_discipline_healing_other_03",
        "force_discipline_healing_other_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_discipline_healing_states_01",
        "force_discipline_healing_states_02",
        "force_discipline_healing_states_03",
        "force_discipline_healing_states_04",
      ],
    },
    novice: "force_discipline_healing_novice",
    novice_links: [],
  },
  force_discipline_enhancements: {
    master_links: [],
    master: "force_discipline_enhancements_master",
    branch_1: {
      links: [],
      skills: [
        "force_discipline_enhancements_movement_01",
        "force_discipline_enhancements_movement_02",
        "force_discipline_enhancements_movement_03",
        "force_discipline_enhancements_movement_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_discipline_enhancements_protection_01",
        "force_discipline_enhancements_protection_02",
        "force_discipline_enhancements_protection_03",
        "force_discipline_enhancements_protection_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_discipline_enhancements_resistance_01",
        "force_discipline_enhancements_resistance_02",
        "force_discipline_enhancements_resistance_03",
        "force_discipline_enhancements_resistance_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_discipline_enhancements_synergy_01",
        "force_discipline_enhancements_synergy_02",
        "force_discipline_enhancements_synergy_03",
        "force_discipline_enhancements_synergy_04",
      ],
    },
    novice: "force_discipline_enhancements_novice",
    novice_links: [],
  },
  force_discipline_defender: {
    master_links: [],
    master: "force_discipline_defender_master",
    branch_1: {
      links: [],
      skills: [
        "force_discipline_defender_melee_defense_01",
        "force_discipline_defender_melee_defense_02",
        "force_discipline_defender_melee_defense_03",
        "force_discipline_defender_melee_defense_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "force_discipline_defender_ranged_defense_01",
        "force_discipline_defender_ranged_defense_02",
        "force_discipline_defender_ranged_defense_03",
        "force_discipline_defender_ranged_defense_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "force_discipline_defender_force_defense_01",
        "force_discipline_defender_force_defense_02",
        "force_discipline_defender_force_defense_03",
        "force_discipline_defender_force_defense_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "force_discipline_defender_preternatural_defense_01",
        "force_discipline_defender_preternatural_defense_02",
        "force_discipline_defender_preternatural_defense_03",
        "force_discipline_defender_preternatural_defense_04",
      ],
    },
    novice: "force_discipline_defender_novice",
    novice_links: [],
  },
  combat_gladiator: {
    master_links: [],
    master: "combat_gladiator_master",
    branch_1: {
      links: [],
      skills: [
        "combat_gladiator_thraex_01",
        "combat_gladiator_thraex_02",
        "combat_gladiator_thraex_03",
        "combat_gladiator_thraex_04",
      ],
    },
    branch_2: {
      links: [],
      skills: [
        "combat_gladiator_murmillo_01",
        "combat_gladiator_murmillo_02",
        "combat_gladiator_murmillo_03",
        "combat_gladiator_murmillo_04",
      ],
    },
    branch_3: {
      links: [],
      skills: [
        "combat_gladiator_dimachaerus_01",
        "combat_gladiator_dimachaerus_02",
        "combat_gladiator_dimachaerus_03",
        "combat_gladiator_dimachaerus_04",
      ],
    },
    branch_4: {
      links: [],
      skills: [
        "combat_gladiator_secutor_01",
        "combat_gladiator_secutor_02",
        "combat_gladiator_secutor_03",
        "combat_gladiator_secutor_04",
      ],
    },
    novice: "combat_gladiator_novice",
    novice_links: [],
  },
};

export const ALL_SKILLS_WHICH_PROFESSION = {
  combat_1hsword_novice: "Fencer",
  combat_1hsword_master: "Fencer",
  combat_1hsword_accuracy_01: "Fencer",
  combat_1hsword_accuracy_02: "Fencer",
  combat_1hsword_accuracy_03: "Fencer",
  combat_1hsword_accuracy_04: "Fencer",
  combat_1hsword_speed_01: "Fencer",
  combat_1hsword_speed_02: "Fencer",
  combat_1hsword_speed_03: "Fencer",
  combat_1hsword_speed_04: "Fencer",
  combat_1hsword_ability_01: "Fencer",
  combat_1hsword_ability_02: "Fencer",
  combat_1hsword_ability_03: "Fencer",
  combat_1hsword_ability_04: "Fencer",
  combat_1hsword_support_01: "Fencer",
  combat_1hsword_support_02: "Fencer",
  combat_1hsword_support_03: "Fencer",
  combat_1hsword_support_04: "Fencer",
  combat_2hsword_novice: "Swordsman",
  combat_2hsword_master: "Swordsman",
  combat_2hsword_accuracy_01: "Swordsman",
  combat_2hsword_accuracy_02: "Swordsman",
  combat_2hsword_accuracy_03: "Swordsman",
  combat_2hsword_accuracy_04: "Swordsman",
  combat_2hsword_speed_01: "Swordsman",
  combat_2hsword_speed_02: "Swordsman",
  combat_2hsword_speed_03: "Swordsman",
  combat_2hsword_speed_04: "Swordsman",
  combat_2hsword_ability_01: "Swordsman",
  combat_2hsword_ability_02: "Swordsman",
  combat_2hsword_ability_03: "Swordsman",
  combat_2hsword_ability_04: "Swordsman",
  combat_2hsword_support_01: "Swordsman",
  combat_2hsword_support_02: "Swordsman",
  combat_2hsword_support_03: "Swordsman",
  combat_2hsword_support_04: "Swordsman",
  combat_bountyhunter_novice: "Bounty Hunter",
  combat_bountyhunter_master: "Bounty Hunter",
  combat_bountyhunter_investigation_01: "Bounty Hunter",
  combat_bountyhunter_investigation_02: "Bounty Hunter",
  combat_bountyhunter_investigation_03: "Bounty Hunter",
  combat_bountyhunter_investigation_04: "Bounty Hunter",
  combat_bountyhunter_droidcontrol_01: "Bounty Hunter",
  combat_bountyhunter_droidcontrol_02: "Bounty Hunter",
  combat_bountyhunter_droidcontrol_03: "Bounty Hunter",
  combat_bountyhunter_droidcontrol_04: "Bounty Hunter",
  combat_bountyhunter_droidresponse_01: "Bounty Hunter",
  combat_bountyhunter_droidresponse_02: "Bounty Hunter",
  combat_bountyhunter_droidresponse_03: "Bounty Hunter",
  combat_bountyhunter_droidresponse_04: "Bounty Hunter",
  combat_bountyhunter_support_01: "Bounty Hunter",
  combat_bountyhunter_support_02: "Bounty Hunter",
  combat_bountyhunter_support_03: "Bounty Hunter",
  combat_bountyhunter_support_04: "Bounty Hunter",
  combat_brawler_novice: "Brawler",
  combat_brawler_master: "Brawler",
  combat_brawler_unarmed_01: "Brawler",
  combat_brawler_unarmed_02: "Brawler",
  combat_brawler_unarmed_03: "Brawler",
  combat_brawler_unarmed_04: "Brawler",
  combat_brawler_1handmelee_01: "Brawler",
  combat_brawler_1handmelee_02: "Brawler",
  combat_brawler_1handmelee_03: "Brawler",
  combat_brawler_1handmelee_04: "Brawler",
  combat_brawler_2handmelee_01: "Brawler",
  combat_brawler_2handmelee_02: "Brawler",
  combat_brawler_2handmelee_03: "Brawler",
  combat_brawler_2handmelee_04: "Brawler",
  combat_brawler_polearm_01: "Brawler",
  combat_brawler_polearm_02: "Brawler",
  combat_brawler_polearm_03: "Brawler",
  combat_brawler_polearm_04: "Brawler",
  combat_carbine_novice: "Carbineer",
  combat_carbine_master: "Carbineer",
  combat_carbine_accuracy_01: "Carbineer",
  combat_carbine_accuracy_02: "Carbineer",
  combat_carbine_accuracy_03: "Carbineer",
  combat_carbine_accuracy_04: "Carbineer",
  combat_carbine_speed_01: "Carbineer",
  combat_carbine_speed_02: "Carbineer",
  combat_carbine_speed_03: "Carbineer",
  combat_carbine_speed_04: "Carbineer",
  combat_carbine_ability_01: "Carbineer",
  combat_carbine_ability_02: "Carbineer",
  combat_carbine_ability_03: "Carbineer",
  combat_carbine_ability_04: "Carbineer",
  combat_carbine_support_01: "Carbineer",
  combat_carbine_support_02: "Carbineer",
  combat_carbine_support_03: "Carbineer",
  combat_carbine_support_04: "Carbineer",
  combat_commando_novice: "Commando",
  combat_commando_master: "Commando",
  combat_commando_heavyweapon_accuracy_01: "Commando",
  combat_commando_heavyweapon_accuracy_02: "Commando",
  combat_commando_heavyweapon_accuracy_03: "Commando",
  combat_commando_heavyweapon_accuracy_04: "Commando",
  combat_commando_heavyweapon_speed_01: "Commando",
  combat_commando_heavyweapon_speed_02: "Commando",
  combat_commando_heavyweapon_speed_03: "Commando",
  combat_commando_heavyweapon_speed_04: "Commando",
  combat_commando_thrownweapon_01: "Commando",
  combat_commando_thrownweapon_02: "Commando",
  combat_commando_thrownweapon_03: "Commando",
  combat_commando_thrownweapon_04: "Commando",
  combat_commando_support_01: "Commando",
  combat_commando_support_02: "Commando",
  combat_commando_support_03: "Commando",
  combat_commando_support_04: "Commando",
  combat_marksman_novice: "Marksman",
  combat_marksman_master: "Marksman",
  combat_marksman_rifle_01: "Marksman",
  combat_marksman_rifle_02: "Marksman",
  combat_marksman_rifle_03: "Marksman",
  combat_marksman_rifle_04: "Marksman",
  combat_marksman_pistol_01: "Marksman",
  combat_marksman_pistol_02: "Marksman",
  combat_marksman_pistol_03: "Marksman",
  combat_marksman_pistol_04: "Marksman",
  combat_marksman_carbine_01: "Marksman",
  combat_marksman_carbine_02: "Marksman",
  combat_marksman_carbine_03: "Marksman",
  combat_marksman_carbine_04: "Marksman",
  combat_marksman_support_01: "Marksman",
  combat_marksman_support_02: "Marksman",
  combat_marksman_support_03: "Marksman",
  combat_marksman_support_04: "Marksman",
  combat_pistol_novice: "Pistoleer",
  combat_pistol_master: "Pistoleer",
  combat_pistol_accuracy_01: "Pistoleer",
  combat_pistol_accuracy_02: "Pistoleer",
  combat_pistol_accuracy_03: "Pistoleer",
  combat_pistol_accuracy_04: "Pistoleer",
  combat_pistol_speed_01: "Pistoleer",
  combat_pistol_speed_02: "Pistoleer",
  combat_pistol_speed_03: "Pistoleer",
  combat_pistol_speed_04: "Pistoleer",
  combat_pistol_ability_01: "Pistoleer",
  combat_pistol_ability_02: "Pistoleer",
  combat_pistol_ability_03: "Pistoleer",
  combat_pistol_ability_04: "Pistoleer",
  combat_pistol_support_01: "Pistoleer",
  combat_pistol_support_02: "Pistoleer",
  combat_pistol_support_03: "Pistoleer",
  combat_pistol_support_04: "Pistoleer",
  combat_polearm_novice: "Pikeman",
  combat_polearm_master: "Pikeman",
  combat_polearm_accuracy_01: "Pikeman",
  combat_polearm_accuracy_02: "Pikeman",
  combat_polearm_accuracy_03: "Pikeman",
  combat_polearm_accuracy_04: "Pikeman",
  combat_polearm_speed_01: "Pikeman",
  combat_polearm_speed_02: "Pikeman",
  combat_polearm_speed_03: "Pikeman",
  combat_polearm_speed_04: "Pikeman",
  combat_polearm_ability_01: "Pikeman",
  combat_polearm_ability_02: "Pikeman",
  combat_polearm_ability_03: "Pikeman",
  combat_polearm_ability_04: "Pikeman",
  combat_polearm_support_01: "Pikeman",
  combat_polearm_support_02: "Pikeman",
  combat_polearm_support_03: "Pikeman",
  combat_polearm_support_04: "Pikeman",
  combat_rifleman_novice: "Rifleman",
  combat_rifleman_master: "Rifleman",
  combat_rifleman_accuracy_01: "Rifleman",
  combat_rifleman_accuracy_02: "Rifleman",
  combat_rifleman_accuracy_03: "Rifleman",
  combat_rifleman_accuracy_04: "Rifleman",
  combat_rifleman_speed_01: "Rifleman",
  combat_rifleman_speed_02: "Rifleman",
  combat_rifleman_speed_03: "Rifleman",
  combat_rifleman_speed_04: "Rifleman",
  combat_rifleman_ability_01: "Rifleman",
  combat_rifleman_ability_02: "Rifleman",
  combat_rifleman_ability_03: "Rifleman",
  combat_rifleman_ability_04: "Rifleman",
  combat_rifleman_support_01: "Rifleman",
  combat_rifleman_support_02: "Rifleman",
  combat_rifleman_support_03: "Rifleman",
  combat_rifleman_support_04: "Rifleman",
  combat_smuggler_novice: "Smuggler",
  combat_smuggler_master: "Smuggler",
  combat_smuggler_underworld_01: "Smuggler",
  combat_smuggler_underworld_02: "Smuggler",
  combat_smuggler_underworld_03: "Smuggler",
  combat_smuggler_underworld_04: "Smuggler",
  combat_smuggler_slicing_01: "Smuggler",
  combat_smuggler_slicing_02: "Smuggler",
  combat_smuggler_slicing_03: "Smuggler",
  combat_smuggler_slicing_04: "Smuggler",
  combat_smuggler_combat_01: "Smuggler",
  combat_smuggler_combat_02: "Smuggler",
  combat_smuggler_combat_03: "Smuggler",
  combat_smuggler_combat_04: "Smuggler",
  combat_smuggler_spice_01: "Smuggler",
  combat_smuggler_spice_02: "Smuggler",
  combat_smuggler_spice_03: "Smuggler",
  combat_smuggler_spice_04: "Smuggler",
  combat_unarmed_novice: "Teras Kasi Artist",
  combat_unarmed_master: "Teras Kasi Artist",
  combat_unarmed_accuracy_01: "Teras Kasi Artist",
  combat_unarmed_accuracy_02: "Teras Kasi Artist",
  combat_unarmed_accuracy_03: "Teras Kasi Artist",
  combat_unarmed_accuracy_04: "Teras Kasi Artist",
  combat_unarmed_speed_01: "Teras Kasi Artist",
  combat_unarmed_speed_02: "Teras Kasi Artist",
  combat_unarmed_speed_03: "Teras Kasi Artist",
  combat_unarmed_speed_04: "Teras Kasi Artist",
  combat_unarmed_ability_01: "Teras Kasi Artist",
  combat_unarmed_ability_02: "Teras Kasi Artist",
  combat_unarmed_ability_03: "Teras Kasi Artist",
  combat_unarmed_ability_04: "Teras Kasi Artist",
  combat_unarmed_support_01: "Teras Kasi Artist",
  combat_unarmed_support_02: "Teras Kasi Artist",
  combat_unarmed_support_03: "Teras Kasi Artist",
  combat_unarmed_support_04: "Teras Kasi Artist",
  crafting_architect_novice: "Architect",
  crafting_architect_master: "Architect",
  crafting_architect_production_01: "Architect",
  crafting_architect_production_02: "Architect",
  crafting_architect_production_03: "Architect",
  crafting_architect_production_04: "Architect",
  crafting_architect_techniques_01: "Architect",
  crafting_architect_techniques_02: "Architect",
  crafting_architect_techniques_03: "Architect",
  crafting_architect_techniques_04: "Architect",
  crafting_architect_harvesting_01: "Architect",
  crafting_architect_harvesting_02: "Architect",
  crafting_architect_harvesting_03: "Architect",
  crafting_architect_harvesting_04: "Architect",
  crafting_architect_blueprints_01: "Architect",
  crafting_architect_blueprints_02: "Architect",
  crafting_architect_blueprints_03: "Architect",
  crafting_architect_blueprints_04: "Architect",
  crafting_armorsmith_novice: "Armorsmith",
  crafting_armorsmith_master: "Armorsmith",
  crafting_armorsmith_personal_01: "Armorsmith",
  crafting_armorsmith_personal_02: "Armorsmith",
  crafting_armorsmith_personal_03: "Armorsmith",
  crafting_armorsmith_personal_04: "Armorsmith",
  crafting_armorsmith_heavy_01: "Armorsmith",
  crafting_armorsmith_heavy_02: "Armorsmith",
  crafting_armorsmith_heavy_03: "Armorsmith",
  crafting_armorsmith_heavy_04: "Armorsmith",
  crafting_armorsmith_deflectors_01: "Armorsmith",
  crafting_armorsmith_deflectors_02: "Armorsmith",
  crafting_armorsmith_deflectors_03: "Armorsmith",
  crafting_armorsmith_deflectors_04: "Armorsmith",
  crafting_armorsmith_complexity_01: "Armorsmith",
  crafting_armorsmith_complexity_02: "Armorsmith",
  crafting_armorsmith_complexity_03: "Armorsmith",
  crafting_armorsmith_complexity_04: "Armorsmith",
  crafting_artisan_novice: "Artisan",
  crafting_artisan_master: "Artisan",
  crafting_artisan_engineering_01: "Artisan",
  crafting_artisan_engineering_02: "Artisan",
  crafting_artisan_engineering_03: "Artisan",
  crafting_artisan_engineering_04: "Artisan",
  crafting_artisan_domestic_01: "Artisan",
  crafting_artisan_domestic_02: "Artisan",
  crafting_artisan_domestic_03: "Artisan",
  crafting_artisan_domestic_04: "Artisan",
  crafting_artisan_business_01: "Artisan",
  crafting_artisan_business_02: "Artisan",
  crafting_artisan_business_03: "Artisan",
  crafting_artisan_business_04: "Artisan",
  crafting_artisan_survey_01: "Artisan",
  crafting_artisan_survey_02: "Artisan",
  crafting_artisan_survey_03: "Artisan",
  crafting_artisan_survey_04: "Artisan",
  crafting_chef_novice: "Chef",
  crafting_chef_master: "Chef",
  crafting_chef_dish_01: "Chef",
  crafting_chef_dish_02: "Chef",
  crafting_chef_dish_03: "Chef",
  crafting_chef_dish_04: "Chef",
  crafting_chef_dessert_01: "Chef",
  crafting_chef_dessert_02: "Chef",
  crafting_chef_dessert_03: "Chef",
  crafting_chef_dessert_04: "Chef",
  crafting_chef_drink_01: "Chef",
  crafting_chef_drink_02: "Chef",
  crafting_chef_drink_03: "Chef",
  crafting_chef_drink_04: "Chef",
  crafting_chef_techniques_01: "Chef",
  crafting_chef_techniques_02: "Chef",
  crafting_chef_techniques_03: "Chef",
  crafting_chef_techniques_04: "Chef",
  crafting_droidengineer_novice: "Droid Engineer",
  crafting_droidengineer_master: "Droid Engineer",
  crafting_droidengineer_production_01: "Droid Engineer",
  crafting_droidengineer_production_02: "Droid Engineer",
  crafting_droidengineer_production_03: "Droid Engineer",
  crafting_droidengineer_production_04: "Droid Engineer",
  crafting_droidengineer_techniques_01: "Droid Engineer",
  crafting_droidengineer_techniques_02: "Droid Engineer",
  crafting_droidengineer_techniques_03: "Droid Engineer",
  crafting_droidengineer_techniques_04: "Droid Engineer",
  crafting_droidengineer_refinement_01: "Droid Engineer",
  crafting_droidengineer_refinement_02: "Droid Engineer",
  crafting_droidengineer_refinement_03: "Droid Engineer",
  crafting_droidengineer_refinement_04: "Droid Engineer",
  crafting_droidengineer_blueprints_01: "Droid Engineer",
  crafting_droidengineer_blueprints_02: "Droid Engineer",
  crafting_droidengineer_blueprints_03: "Droid Engineer",
  crafting_droidengineer_blueprints_04: "Droid Engineer",
  crafting_merchant_novice: "Merchant",
  crafting_merchant_master: "Merchant",
  crafting_merchant_advertising_01: "Merchant",
  crafting_merchant_advertising_02: "Merchant",
  crafting_merchant_advertising_03: "Merchant",
  crafting_merchant_advertising_04: "Merchant",
  crafting_merchant_sales_01: "Merchant",
  crafting_merchant_sales_02: "Merchant",
  crafting_merchant_sales_03: "Merchant",
  crafting_merchant_sales_04: "Merchant",
  crafting_merchant_hiring_01: "Merchant",
  crafting_merchant_hiring_02: "Merchant",
  crafting_merchant_hiring_03: "Merchant",
  crafting_merchant_hiring_04: "Merchant",
  crafting_merchant_management_01: "Merchant",
  crafting_merchant_management_02: "Merchant",
  crafting_merchant_management_03: "Merchant",
  crafting_merchant_management_04: "Merchant",
  crafting_tailor_novice: "Tailor",
  crafting_tailor_master: "Tailor",
  crafting_tailor_casual_01: "Tailor",
  crafting_tailor_casual_02: "Tailor",
  crafting_tailor_casual_03: "Tailor",
  crafting_tailor_casual_04: "Tailor",
  crafting_tailor_field_01: "Tailor",
  crafting_tailor_field_02: "Tailor",
  crafting_tailor_field_03: "Tailor",
  crafting_tailor_field_04: "Tailor",
  crafting_tailor_formal_01: "Tailor",
  crafting_tailor_formal_02: "Tailor",
  crafting_tailor_formal_03: "Tailor",
  crafting_tailor_formal_04: "Tailor",
  crafting_tailor_production_01: "Tailor",
  crafting_tailor_production_02: "Tailor",
  crafting_tailor_production_03: "Tailor",
  crafting_tailor_production_04: "Tailor",
  crafting_weaponsmith_novice: "Weaponsmith",
  crafting_weaponsmith_master: "Weaponsmith",
  crafting_weaponsmith_melee_01: "Weaponsmith",
  crafting_weaponsmith_melee_02: "Weaponsmith",
  crafting_weaponsmith_melee_03: "Weaponsmith",
  crafting_weaponsmith_melee_04: "Weaponsmith",
  crafting_weaponsmith_firearms_01: "Weaponsmith",
  crafting_weaponsmith_firearms_02: "Weaponsmith",
  crafting_weaponsmith_firearms_03: "Weaponsmith",
  crafting_weaponsmith_firearms_04: "Weaponsmith",
  crafting_weaponsmith_munitions_01: "Weaponsmith",
  crafting_weaponsmith_munitions_02: "Weaponsmith",
  crafting_weaponsmith_munitions_03: "Weaponsmith",
  crafting_weaponsmith_munitions_04: "Weaponsmith",
  crafting_weaponsmith_techniques_01: "Weaponsmith",
  crafting_weaponsmith_techniques_02: "Weaponsmith",
  crafting_weaponsmith_techniques_03: "Weaponsmith",
  crafting_weaponsmith_techniques_04: "Weaponsmith",
  outdoors_bio_engineer_novice: "Bio-Engineer",
  outdoors_bio_engineer_master: "Bio-Engineer",
  outdoors_bio_engineer_creature_01: "Bio-Engineer",
  outdoors_bio_engineer_creature_02: "Bio-Engineer",
  outdoors_bio_engineer_creature_03: "Bio-Engineer",
  outdoors_bio_engineer_creature_04: "Bio-Engineer",
  outdoors_bio_engineer_tissue_01: "Bio-Engineer",
  outdoors_bio_engineer_tissue_02: "Bio-Engineer",
  outdoors_bio_engineer_tissue_03: "Bio-Engineer",
  outdoors_bio_engineer_tissue_04: "Bio-Engineer",
  outdoors_bio_engineer_dna_harvesting_01: "Bio-Engineer",
  outdoors_bio_engineer_dna_harvesting_02: "Bio-Engineer",
  outdoors_bio_engineer_dna_harvesting_03: "Bio-Engineer",
  outdoors_bio_engineer_dna_harvesting_04: "Bio-Engineer",
  outdoors_bio_engineer_production_01: "Bio-Engineer",
  outdoors_bio_engineer_production_02: "Bio-Engineer",
  outdoors_bio_engineer_production_03: "Bio-Engineer",
  outdoors_bio_engineer_production_04: "Bio-Engineer",
  outdoors_creaturehandler_novice: "Creature Handler",
  outdoors_creaturehandler_master: "Creature Handler",
  outdoors_creaturehandler_taming_01: "Creature Handler",
  outdoors_creaturehandler_taming_02: "Creature Handler",
  outdoors_creaturehandler_taming_03: "Creature Handler",
  outdoors_creaturehandler_taming_04: "Creature Handler",
  outdoors_creaturehandler_training_01: "Creature Handler",
  outdoors_creaturehandler_training_02: "Creature Handler",
  outdoors_creaturehandler_training_03: "Creature Handler",
  outdoors_creaturehandler_training_04: "Creature Handler",
  outdoors_creaturehandler_healing_01: "Creature Handler",
  outdoors_creaturehandler_healing_02: "Creature Handler",
  outdoors_creaturehandler_healing_03: "Creature Handler",
  outdoors_creaturehandler_healing_04: "Creature Handler",
  outdoors_creaturehandler_support_01: "Creature Handler",
  outdoors_creaturehandler_support_02: "Creature Handler",
  outdoors_creaturehandler_support_03: "Creature Handler",
  outdoors_creaturehandler_support_04: "Creature Handler",
  outdoors_ranger_novice: "Ranger",
  outdoors_ranger_master: "Ranger",
  outdoors_ranger_movement_01: "Ranger",
  outdoors_ranger_movement_02: "Ranger",
  outdoors_ranger_movement_03: "Ranger",
  outdoors_ranger_movement_04: "Ranger",
  outdoors_ranger_tracking_01: "Ranger",
  outdoors_ranger_tracking_02: "Ranger",
  outdoors_ranger_tracking_03: "Ranger",
  outdoors_ranger_tracking_04: "Ranger",
  outdoors_ranger_harvest_01: "Ranger",
  outdoors_ranger_harvest_02: "Ranger",
  outdoors_ranger_harvest_03: "Ranger",
  outdoors_ranger_harvest_04: "Ranger",
  outdoors_ranger_support_01: "Ranger",
  outdoors_ranger_support_02: "Ranger",
  outdoors_ranger_support_03: "Ranger",
  outdoors_ranger_support_04: "Ranger",
  outdoors_scout_novice: "Scout",
  outdoors_scout_master: "Scout",
  outdoors_scout_movement_01: "Scout",
  outdoors_scout_movement_02: "Scout",
  outdoors_scout_movement_03: "Scout",
  outdoors_scout_movement_04: "Scout",
  outdoors_scout_tools_01: "Scout",
  outdoors_scout_tools_02: "Scout",
  outdoors_scout_tools_03: "Scout",
  outdoors_scout_tools_04: "Scout",
  outdoors_scout_harvest_01: "Scout",
  outdoors_scout_harvest_02: "Scout",
  outdoors_scout_harvest_03: "Scout",
  outdoors_scout_harvest_04: "Scout",
  outdoors_scout_camp_01: "Scout",
  outdoors_scout_camp_02: "Scout",
  outdoors_scout_camp_03: "Scout",
  outdoors_scout_camp_04: "Scout",
  outdoors_squadleader_novice: "Squad Leader",
  outdoors_squadleader_master: "Squad Leader",
  outdoors_squadleader_movement_01: "Squad Leader",
  outdoors_squadleader_movement_02: "Squad Leader",
  outdoors_squadleader_movement_03: "Squad Leader",
  outdoors_squadleader_movement_04: "Squad Leader",
  outdoors_squadleader_offense_01: "Squad Leader",
  outdoors_squadleader_offense_02: "Squad Leader",
  outdoors_squadleader_offense_03: "Squad Leader",
  outdoors_squadleader_offense_04: "Squad Leader",
  outdoors_squadleader_defense_01: "Squad Leader",
  outdoors_squadleader_defense_02: "Squad Leader",
  outdoors_squadleader_defense_03: "Squad Leader",
  outdoors_squadleader_defense_04: "Squad Leader",
  outdoors_squadleader_support_01: "Squad Leader",
  outdoors_squadleader_support_02: "Squad Leader",
  outdoors_squadleader_support_03: "Squad Leader",
  outdoors_squadleader_support_04: "Squad Leader",
  science_combatmedic_novice: "Combat Medic",
  science_combatmedic_master: "Combat Medic",
  science_combatmedic_healing_range_01: "Combat Medic",
  science_combatmedic_healing_range_02: "Combat Medic",
  science_combatmedic_healing_range_03: "Combat Medic",
  science_combatmedic_healing_range_04: "Combat Medic",
  science_combatmedic_healing_range_speed_01: "Combat Medic",
  science_combatmedic_healing_range_speed_02: "Combat Medic",
  science_combatmedic_healing_range_speed_03: "Combat Medic",
  science_combatmedic_healing_range_speed_04: "Combat Medic",
  science_combatmedic_medicine_01: "Combat Medic",
  science_combatmedic_medicine_02: "Combat Medic",
  science_combatmedic_medicine_03: "Combat Medic",
  science_combatmedic_medicine_04: "Combat Medic",
  science_combatmedic_support_01: "Combat Medic",
  science_combatmedic_support_02: "Combat Medic",
  science_combatmedic_support_03: "Combat Medic",
  science_combatmedic_support_04: "Combat Medic",
  science_doctor_novice: "Doctor",
  science_doctor_master: "Doctor",
  science_doctor_wound_speed_01: "Doctor",
  science_doctor_wound_speed_02: "Doctor",
  science_doctor_wound_speed_03: "Doctor",
  science_doctor_wound_speed_04: "Doctor",
  science_doctor_wound_01: "Doctor",
  science_doctor_wound_02: "Doctor",
  science_doctor_wound_03: "Doctor",
  science_doctor_wound_04: "Doctor",
  science_doctor_ability_01: "Doctor",
  science_doctor_ability_02: "Doctor",
  science_doctor_ability_03: "Doctor",
  science_doctor_ability_04: "Doctor",
  science_doctor_support_01: "Doctor",
  science_doctor_support_02: "Doctor",
  science_doctor_support_03: "Doctor",
  science_doctor_support_04: "Doctor",
  science_medic_novice: "Medic",
  science_medic_master: "Medic",
  science_medic_injury_01: "Medic",
  science_medic_injury_02: "Medic",
  science_medic_injury_03: "Medic",
  science_medic_injury_04: "Medic",
  science_medic_injury_speed_01: "Medic",
  science_medic_injury_speed_02: "Medic",
  science_medic_injury_speed_03: "Medic",
  science_medic_injury_speed_04: "Medic",
  science_medic_ability_01: "Medic",
  science_medic_ability_02: "Medic",
  science_medic_ability_03: "Medic",
  science_medic_ability_04: "Medic",
  science_medic_crafting_01: "Medic",
  science_medic_crafting_02: "Medic",
  science_medic_crafting_03: "Medic",
  science_medic_crafting_04: "Medic",
  social_dancer_novice: "Dancer",
  social_dancer_master: "Dancer",
  social_dancer_ability_01: "Dancer",
  social_dancer_ability_02: "Dancer",
  social_dancer_ability_03: "Dancer",
  social_dancer_ability_04: "Dancer",
  social_dancer_wound_01: "Dancer",
  social_dancer_wound_02: "Dancer",
  social_dancer_wound_03: "Dancer",
  social_dancer_wound_04: "Dancer",
  social_dancer_knowledge_01: "Dancer",
  social_dancer_knowledge_02: "Dancer",
  social_dancer_knowledge_03: "Dancer",
  social_dancer_knowledge_04: "Dancer",
  social_dancer_shock_01: "Dancer",
  social_dancer_shock_02: "Dancer",
  social_dancer_shock_03: "Dancer",
  social_dancer_shock_04: "Dancer",
  social_entertainer_novice: "Entertainer",
  social_entertainer_master: "Entertainer",
  social_entertainer_hairstyle_01: "Entertainer",
  social_entertainer_hairstyle_02: "Entertainer",
  social_entertainer_hairstyle_03: "Entertainer",
  social_entertainer_hairstyle_04: "Entertainer",
  social_entertainer_music_01: "Entertainer",
  social_entertainer_music_02: "Entertainer",
  social_entertainer_music_03: "Entertainer",
  social_entertainer_music_04: "Entertainer",
  social_entertainer_dance_01: "Entertainer",
  social_entertainer_dance_02: "Entertainer",
  social_entertainer_dance_03: "Entertainer",
  social_entertainer_dance_04: "Entertainer",
  social_entertainer_healing_01: "Entertainer",
  social_entertainer_healing_02: "Entertainer",
  social_entertainer_healing_03: "Entertainer",
  social_entertainer_healing_04: "Entertainer",
  social_imagedesigner_novice: "Image Designer",
  social_imagedesigner_master: "Image Designer",
  social_imagedesigner_hairstyle_01: "Image Designer",
  social_imagedesigner_hairstyle_02: "Image Designer",
  social_imagedesigner_hairstyle_03: "Image Designer",
  social_imagedesigner_hairstyle_04: "Image Designer",
  social_imagedesigner_exotic_01: "Image Designer",
  social_imagedesigner_exotic_02: "Image Designer",
  social_imagedesigner_exotic_03: "Image Designer",
  social_imagedesigner_exotic_04: "Image Designer",
  social_imagedesigner_bodyform_01: "Image Designer",
  social_imagedesigner_bodyform_02: "Image Designer",
  social_imagedesigner_bodyform_03: "Image Designer",
  social_imagedesigner_bodyform_04: "Image Designer",
  social_imagedesigner_markings_01: "Image Designer",
  social_imagedesigner_markings_02: "Image Designer",
  social_imagedesigner_markings_03: "Image Designer",
  social_imagedesigner_markings_04: "Image Designer",
  social_musician_novice: "Musician",
  social_musician_master: "Musician",
  social_musician_ability_01: "Musician",
  social_musician_ability_02: "Musician",
  social_musician_ability_03: "Musician",
  social_musician_ability_04: "Musician",
  social_musician_wound_01: "Musician",
  social_musician_wound_02: "Musician",
  social_musician_wound_03: "Musician",
  social_musician_wound_04: "Musician",
  social_musician_knowledge_01: "Musician",
  social_musician_knowledge_02: "Musician",
  social_musician_knowledge_03: "Musician",
  social_musician_knowledge_04: "Musician",
  social_musician_shock_01: "Musician",
  social_musician_shock_02: "Musician",
  social_musician_shock_03: "Musician",
  social_musician_shock_04: "Musician",
  social_politician_novice: "Politician",
  social_politician_master: "Politician",
  social_politician_fiscal_01: "Politician",
  social_politician_fiscal_02: "Politician",
  social_politician_fiscal_03: "Politician",
  social_politician_fiscal_04: "Politician",
  social_politician_martial_01: "Politician",
  social_politician_martial_02: "Politician",
  social_politician_martial_03: "Politician",
  social_politician_martial_04: "Politician",
  social_politician_civic_01: "Politician",
  social_politician_civic_02: "Politician",
  social_politician_civic_03: "Politician",
  social_politician_civic_04: "Politician",
  social_politician_urban_01: "Politician",
  social_politician_urban_02: "Politician",
  social_politician_urban_03: "Politician",
  social_politician_urban_04: "Politician",
  force_sensitive_combat_prowess_novice:"Combat Prowess",
force_sensitive_combat_prowess_master:"Combat Prowess",
force_sensitive_combat_prowess_ranged_accuracy_01:"Combat Prowess",
force_sensitive_combat_prowess_ranged_accuracy_02:"Combat Prowess",
force_sensitive_combat_prowess_ranged_accuracy_03:"Combat Prowess",
force_sensitive_combat_prowess_ranged_accuracy_04:"Combat Prowess",
force_sensitive_combat_prowess_ranged_speed_01:"Combat Prowess",
force_sensitive_combat_prowess_ranged_speed_02:"Combat Prowess",
force_sensitive_combat_prowess_ranged_speed_03:"Combat Prowess",
force_sensitive_combat_prowess_ranged_speed_04:"Combat Prowess",
force_sensitive_combat_prowess_melee_accuracy_01:"Combat Prowess",
force_sensitive_combat_prowess_melee_accuracy_02:"Combat Prowess",
force_sensitive_combat_prowess_melee_accuracy_03:"Combat Prowess",
force_sensitive_combat_prowess_melee_accuracy_04:"Combat Prowess",
force_sensitive_combat_prowess_melee_speed_01:"Combat Prowess",
force_sensitive_combat_prowess_melee_speed_02:"Combat Prowess",
force_sensitive_combat_prowess_melee_speed_03:"Combat Prowess",
force_sensitive_combat_prowess_melee_speed_04:"Combat Prowess",
force_sensitive_enhanced_reflexes_novice:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_master:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_ranged_defense_01:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_ranged_defense_02:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_ranged_defense_03:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_ranged_defense_04:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_melee_defense_01:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_melee_defense_02:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_melee_defense_03:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_melee_defense_04:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_vehicle_control_01:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_vehicle_control_02:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_vehicle_control_03:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_vehicle_control_04:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_survival_01:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_survival_02:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_survival_03:"Enhanced Reflexes",
force_sensitive_enhanced_reflexes_survival_04:"Enhanced Reflexes",
force_sensitive_crafting_mastery_novice:"Crafting Mastery",
force_sensitive_crafting_mastery_master:"Crafting Mastery",
force_sensitive_crafting_mastery_experimentation_01:"Crafting Mastery",
force_sensitive_crafting_mastery_experimentation_02:"Crafting Mastery",
force_sensitive_crafting_mastery_experimentation_03:"Crafting Mastery",
force_sensitive_crafting_mastery_experimentation_04:"Crafting Mastery",
force_sensitive_crafting_mastery_assembly_01:"Crafting Mastery",
force_sensitive_crafting_mastery_assembly_02:"Crafting Mastery",
force_sensitive_crafting_mastery_assembly_03:"Crafting Mastery",
force_sensitive_crafting_mastery_assembly_04:"Crafting Mastery",
force_sensitive_crafting_mastery_repair_01:"Crafting Mastery",
force_sensitive_crafting_mastery_repair_02:"Crafting Mastery",
force_sensitive_crafting_mastery_repair_03:"Crafting Mastery",
force_sensitive_crafting_mastery_repair_04:"Crafting Mastery",
force_sensitive_crafting_mastery_technique_01:"Crafting Mastery",
force_sensitive_crafting_mastery_technique_02:"Crafting Mastery",
force_sensitive_crafting_mastery_technique_03:"Crafting Mastery",
force_sensitive_crafting_mastery_technique_04:"Crafting Mastery",
force_sensitive_heightened_senses_novice:"Heightened Senses",
force_sensitive_heightened_senses_master:"Heightened Senses",
force_sensitive_heightened_senses_healing_01:"Heightened Senses",
force_sensitive_heightened_senses_healing_02:"Heightened Senses",
force_sensitive_heightened_senses_healing_03:"Heightened Senses",
force_sensitive_heightened_senses_healing_04:"Heightened Senses",
force_sensitive_heightened_senses_surveying_01:"Heightened Senses",
force_sensitive_heightened_senses_surveying_02:"Heightened Senses",
force_sensitive_heightened_senses_surveying_03:"Heightened Senses",
force_sensitive_heightened_senses_surveying_04:"Heightened Senses",
force_sensitive_heightened_senses_persuasion_01:"Heightened Senses",
force_sensitive_heightened_senses_persuasion_02:"Heightened Senses",
force_sensitive_heightened_senses_persuasion_03:"Heightened Senses",
force_sensitive_heightened_senses_persuasion_04:"Heightened Senses",
force_sensitive_heightened_senses_luck_01:"Heightened Senses",
force_sensitive_heightened_senses_luck_02:"Heightened Senses",
force_sensitive_heightened_senses_luck_03:"Heightened Senses",
force_sensitive_heightened_senses_luck_04:"Heightened Senses",
force_discipline_light_saber_novice:"Lightsaber",
force_discipline_light_saber_master:"Lightsaber",
force_discipline_light_saber_one_hand_01:"Lightsaber",
force_discipline_light_saber_one_hand_02:"Lightsaber",
force_discipline_light_saber_one_hand_03:"Lightsaber",
force_discipline_light_saber_one_hand_04:"Lightsaber",
force_discipline_light_saber_two_hand_01:"Lightsaber",
force_discipline_light_saber_two_hand_02:"Lightsaber",
force_discipline_light_saber_two_hand_03:"Lightsaber",
force_discipline_light_saber_two_hand_04:"Lightsaber",
force_discipline_light_saber_polearm_01:"Lightsaber",
force_discipline_light_saber_polearm_02:"Lightsaber",
force_discipline_light_saber_polearm_03:"Lightsaber",
force_discipline_light_saber_polearm_04:"Lightsaber",
force_discipline_light_saber_technique_01:"Lightsaber",
force_discipline_light_saber_technique_02:"Lightsaber",
force_discipline_light_saber_technique_03:"Lightsaber",
force_discipline_light_saber_technique_04:"Lightsaber",
force_discipline_powers_novice:"Powers",
force_discipline_powers_master:"Powers",
force_discipline_powers_lightning_01:"Powers",
force_discipline_powers_lightning_02:"Powers",
force_discipline_powers_lightning_03:"Powers",
force_discipline_powers_lightning_04:"Powers",
force_discipline_powers_mental_01:"Powers",
force_discipline_powers_mental_02:"Powers",
force_discipline_powers_mental_03:"Powers",
force_discipline_powers_mental_04:"Powers",
force_discipline_powers_debuff_01:"Powers",
force_discipline_powers_debuff_02:"Powers",
force_discipline_powers_debuff_03:"Powers",
force_discipline_powers_debuff_04:"Powers",
force_discipline_powers_push_01:"Powers",
force_discipline_powers_push_02:"Powers",
force_discipline_powers_push_03:"Powers",
force_discipline_powers_push_04:"Powers",
force_discipline_healing_novice:"Healing",
force_discipline_healing_master:"Healing",
force_discipline_healing_damage_01:"Healing",
force_discipline_healing_damage_02:"Healing",
force_discipline_healing_damage_03:"Healing",
force_discipline_healing_damage_04:"Healing",
force_discipline_healing_wound_01:"Healing",
force_discipline_healing_wound_02:"Healing",
force_discipline_healing_wound_03:"Healing",
force_discipline_healing_wound_04:"Healing",
force_discipline_healing_other_01:"Healing",
force_discipline_healing_other_02:"Healing",
force_discipline_healing_other_03:"Healing",
force_discipline_healing_other_04:"Healing",
force_discipline_healing_states_01:"Healing",
force_discipline_healing_states_02:"Healing",
force_discipline_healing_states_03:"Healing",
force_discipline_healing_states_04:"Healing",
force_discipline_enhancements_novice:"Enchancements",
force_discipline_enhancements_master:"Enchancements",
force_discipline_enhancements_movement_01:"Enchancements",
force_discipline_enhancements_movement_02:"Enchancements",
force_discipline_enhancements_movement_03:"Enchancements",
force_discipline_enhancements_movement_04:"Enchancements",
force_discipline_enhancements_protection_01:"Enchancements",
force_discipline_enhancements_protection_02:"Enchancements",
force_discipline_enhancements_protection_03:"Enchancements",
force_discipline_enhancements_protection_04:"Enchancements",
force_discipline_enhancements_resistance_01:"Enchancements",
force_discipline_enhancements_resistance_02:"Enchancements",
force_discipline_enhancements_resistance_03:"Enchancements",
force_discipline_enhancements_resistance_04:"Enchancements",
force_discipline_enhancements_synergy_01:"Enchancements",
force_discipline_enhancements_synergy_02:"Enchancements",
force_discipline_enhancements_synergy_03:"Enchancements",
force_discipline_enhancements_synergy_04:"Enchancements",
force_discipline_defender_novice:"Defender",
force_discipline_defender_master:"Defender",
force_discipline_defender_melee_defense_01:"Defender",
force_discipline_defender_melee_defense_02:"Defender",
force_discipline_defender_melee_defense_03:"Defender",
force_discipline_defender_melee_defense_04:"Defender",
force_discipline_defender_ranged_defense_01:"Defender",
force_discipline_defender_ranged_defense_02:"Defender",
force_discipline_defender_ranged_defense_03:"Defender",
force_discipline_defender_ranged_defense_04:"Defender",
force_discipline_defender_force_defense_01:"Defender",
force_discipline_defender_force_defense_02:"Defender",
force_discipline_defender_force_defense_03:"Defender",
force_discipline_defender_force_defense_04:"Defender",
force_discipline_defender_preternatural_defense_01:"Defender",
force_discipline_defender_preternatural_defense_02:"Defender",
force_discipline_defender_preternatural_defense_03:"Defender",
force_discipline_defender_preternatural_defense_04:"Defender",
combat_gladiator_novice: "Gladiator",
combat_gladiator_master: "Gladiator",
combat_gladiator_thraex_01: "Gladiator",
combat_gladiator_thraex_02: "Gladiator",
combat_gladiator_thraex_03: "Gladiator",
combat_gladiator_thraex_04: "Gladiator",
combat_gladiator_murmillo_01: "Gladiator",
combat_gladiator_murmillo_02: "Gladiator",
combat_gladiator_murmillo_03: "Gladiator",
combat_gladiator_murmillo_04: "Gladiator",
combat_gladiator_dimachaerus_01: "Gladiator",
combat_gladiator_dimachaerus_02: "Gladiator",
combat_gladiator_dimachaerus_03: "Gladiator",
combat_gladiator_dimachaerus_04: "Gladiator",
combat_gladiator_secutor_01: "Gladiator",
combat_gladiator_secutor_02: "Gladiator",
combat_gladiator_secutor_03: "Gladiator",
combat_gladiator_secutor_04: "Gladiator",
};

export const NOVICE_SKILL = {
  Entertainer: "social_entertainer",
  Scout: "outdoors_scout",
  Medic: "science_medic",
  Artisan: "crafting_artisan",
  Brawler: "combat_brawler",
  Marksman: "combat_marksman",
  Rifleman: "combat_rifleman",
  Pistoleer: "combat_pistol",
  Carbineer: "combat_carbine",
  "Teras Kasi Artist": "combat_unarmed",
  Fencer: "combat_1hsword",
  Swordsman: "combat_2hsword",
  Pikeman: "combat_polearm",
  Dancer: "social_dancer",
  Musician: "social_musician",
  Doctor: "science_doctor",
  Ranger: "outdoors_ranger",
  "Creature Handler": "outdoors_creaturehandler",
  "Bio-Engineer": "outdoors_bio_engineer",
  Armorsmith: "crafting_armorsmith",
  Weaponsmith: "crafting_weaponsmith",
  Chef: "crafting_chef",
  Tailor: "crafting_tailor",
  Architect: "crafting_architect",
  "Droid Engineer": "crafting_droidengineer",
  Merchant: "crafting_merchant",
  Smuggler: "combat_smuggler",
  "Bounty Hunter": "combat_bountyhunter",
  Commando: "combat_commando",
  "Combat Medic": "science_combatmedic",
  "Image Designer": "social_imagedesigner",
  "Squad Leader": "outdoors_squadleader",
  Politician: "social_politician",
  "Combat Prowess":	"force_sensitive_combat_prowess",
  "Enhanced Reflexes":	"force_sensitive_enhanced_reflexes",
  "Crafting Mastery":	"force_sensitive_crafting_mastery",
  "Heightened Senses":	"force_sensitive_heightened_senses",
  Lightsaber:	"force_discipline_light_saber",
  Powers:	"force_discipline_powers",
  Healing:	"force_discipline_healing",
  Enchancements:	"force_discipline_enhancements",
  Defender:	"force_discipline_defender",
  Gladiator: "combat_gladiator",
};

export const EXPERIENCE_TITLES = {
  apprenticeship: "Apprenticeship",
  bio_engineer: "Bio-Engineer",
  bio_engineer_dna_harvesting: "DNA Sampling",
  bountyhunter: "Bounty Hunter",
  business_general: "Business",
  camp: "Wilderness Survival",
  combat_general: "Combat",
  combat_meleespecialize_onehand: "Onehanded Weapons",
  combat_meleespecialize_onehandlightsaber: "Onehanded Lightsaber",
  combat_meleespecialize_polearm: "Polearm Weapons",
  combat_meleespecialize_polearmlightsaber: "Polearm Lightsaber",
  combat_meleespecialize_twohand: "Twohanded Weapons",
  combat_meleespecialize_twohandlightsaber: "Twohanded Lightsaber",
  combat_meleespecialize_unarmed: "Unarmed Combat",
  combat_rangedspecialize_carbine: "Carbine Weapons",
  combat_rangedspecialize_heavy: "Heavy Weapons",
  combat_rangedspecialize_pistol: "Pistol Weapons",
  combat_rangedspecialize_rifle: "Rifle Weapons",
  combat_rangespecialize_bactarifle: "Bacta Rifles",
  combatmedic: "Combat Medic",
  crafting_bio_engineer_creature: "Bio-Engineer Crafting",
  crafting_bio_engineer_tissue: "Tissue Engineering",
  crafting_clothing_armor: "Armor Crafting",
  crafting_clothing_general: "Tailoring",
  crafting_droid_general: "Droid Crafting",
  crafting_food_general: "Food Crafting",
  crafting_general: "General Crafting",
  crafting_medicine_general: "Medicine Crafting",
  crafting_scout: "Scout Crafting",
  crafting_scout_camp: "Scout Camp Crafting",
  crafting_scout_trap: "Scout Trap Crafting",
  crafting_spice: "Spice Crafting",
  crafting_structure_general: "Structure Crafting",
  crafting_weapons_general: "Weapon Crafting",
  crafting_weapons_melee: "Melee Weapon Crafting",
  crafting_weapons_munition: "Munitions Crafting",
  crafting_weapons_munitions: "Munitions Crafting",
  crafting_weapons_ranged: "Ranged Weapons Crafting",
  creaturehandler: "Creature Handling",
  dance: "Dancing",
  entertainer_healing: "Entertainer Healing",
  farmer: "Farming",
  force_rank_xp: "Force Rank",
  fs_combat: "Force-sensitive Combat",
  fs_crafting: "Force-sensitive Crafting",
  fs_reflex: "Force-sensitive Reflex",
  fs_senses: "Force-sensitive Senses",
  imagedesigner: "Image Designer",
  industrialist: "Industralist",
  jedi_general: "Jedi",
  medical: "Medical",
  merchant: "Merchant",
  music: "Musician",
  pilot_general: "Pilot General",
  pilot_imperial: "Imperial Piloting Experience",
  pilot_neutral: "Neutral Piloting Experience",
  political: "Political",
  prestige_imperial: "Imperial Prestige",
  prestige_pilot: "Pilot Prestige",
  prestige_rebel: "Rebel Prestige",
  ranger: "Ranger",
  resource_harvesting_inorganic: "Surveying",
  resource_harvesting_organic: "Hunting",
  reverse_engineering: "Reverse Engineering",
  scout: "Scouting",
  shipwright: "Shipwright",
  slicing: "Slicing",
  smuggler: "Smuggling",
  space_combat_general: "Starship Combat",
  squadleader: "Squad Leadership",
  trapping: "Trapping",
  unobtainable: "Unobtainable Experience",
  combat_gladiator: "Gladitorial Experience"
};

export const SKILLS = {
  bothan: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      camouflage: 15,
      cover: 10
    },
    schematics: ["_"],
  },
  human: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      general_experimentation: 15,
      leadership: 10
    },
    schematics: ["_"],
  },
  ithorian: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      advanced_assembly: 10,
      chassis_assembly: 10,
      tame_bonus: 10,
      dizzy_defense: 10,
      stun_defense: 10,
      melee_defense: 10,
      power_systems: 10,
      shields_assembly: 10
    },
    schematics: ["_"],
  },
  mon_calamari: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      alert: 15,
      structure_assembly: 10,
      weapon_assembly: 10
    },
    schematics: ["_"],
  },
  rodian: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      blind_defense: 15,
      onehandmelee_accuracy: 10,
      twohandmelee_accuracy: 10,
      weapon_assembly: 10
    },
    schematics: ["_"],
  },
  sullustan: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      booster_assembly: 10,
      creature_harvesting: 10,
      engine_assembly: 10,
      trapping: 10,
      weapon_systems: 10
    },
    schematics: ["_"],
  },
  trandoshan: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      creature_harvesting: 10,
      melee_defense: 10,
      regeneration: 1,
      unarmed_accuracy: 10,
      unarmed_damage: 15,
      unarmed_speed: 5
    },
    schematics: ["_"],
  },
  twilek: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "_"
    ],
    skillModifiers: {
      healing_music_shock: 5,
      healing_dance_shock: 15,
      healing_music_wound: 5,
      healing_dance_wound: 15
    },
    schematics: ["_"],
  },
  wookiee: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "wookieeroar"
    ],
    skillModifiers: {
      tame_bonus: 10,
      rescue: 10,
      trapping: 10,
      warcry: 10,
    },
    schematics: ["_"],
  },
  zabrak: {
    title: "",
    skillPoints: 0,
    preReqs: [""],
    xp: { id: "_", cost: 0 },
    commands: [
      "equilibrium",
      "vitalize"
    ],
    skillModifiers: {
      anti_shock: 5,
      dizzy_defense: 10,
      intimidate_defense: 10,
      stun_defense: 10,
    },
    schematics: ["_"],
  },
  social_entertainer_novice: {
  title: "Novice Entertainer",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_entertainer_novice",
    "musician",
    "dancer",
    "imagedesigner",
    "startDance",
    "stopDance",
    "startMusic",
    "stopMusic",
    "flourish+1",
    "flourish+2",
    "flourish+3",
    "flourish+4",
    "flourish+5",
    "flourish+6",
    "flourish+7",
    "flourish+8",
    "startDance+basic",
    "startDance+rhythmic",
    "startMusic+starwars1",
    "slitherhorn",
  ],
  skillModifiers: {
    healing_dance_wound: 5,
    healing_music_wound: 5,
    healing_music_ability: 5,
    healing_dance_ability: 5,
    hair: 1,
    face: 1,
  },
  schematics: ["craftInstrumentGroupA"]
},
social_entertainer_master: {
  title: "Master Entertainer",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_hairstyle_04",
    "social_entertainer_music_04",
    "social_entertainer_dance_04",
    "social_entertainer_healing_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_entertainer_master",
    "startDance+footloose2",
    "startDance+formal2",
    "startMusic+ceremonial",
    "mandoviol",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
    healing_music_ability: 10,
    healing_dance_wound: 10,
    healing_music_wound: 10,
  },
  schematics: [""]
},
social_entertainer_hairstyle_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_novice",
  ],
  xp: { id: "imagedesigner", cost: 1000 },
  commands: [
    "private_entertainer_hair_1",
  ],
  skillModifiers: {
    hair: 1,
  },
  schematics: [""]
},
social_entertainer_hairstyle_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_hairstyle_01",
  ],
  xp: { id: "imagedesigner", cost: 5000 },
  commands: [
    "private_entertainer_hair_2",
  ],
  skillModifiers: {
    markings: 1,
    face: 1,
  },
  schematics: [""]
},
social_entertainer_hairstyle_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_hairstyle_02",
  ],
  xp: { id: "imagedesigner", cost: 10000 },
  commands: [
    "private_entertainer_hair_3",
  ],
  skillModifiers: {
    hair: 1,
  },
  schematics: [""]
},
social_entertainer_hairstyle_04: {
  title: "Hairstylist",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_hairstyle_03",
  ],
  xp: { id: "imagedesigner", cost: 15000 },
  commands: [
    "private_entertainer_hair_4",
  ],
  skillModifiers: {
    hair: 1,
    face: 1,
  },
  schematics: [""]
},
social_entertainer_music_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_novice",
  ],
  xp: { id: "music", cost: 1000 },
  commands: [
    "private_entertainer_music_1",
    "startMusic+rock",
    "fizz",
  ],
  skillModifiers: {
    healing_music_ability: 5,
  },
  schematics: [""]
},
social_entertainer_music_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_music_01",
  ],
  xp: { id: "music", cost: 5000 },
  commands: [
    "private_entertainer_music_2",
    "startMusic+starwars2",
  ],
  skillModifiers: {
    healing_music_ability: 5,
  },
  schematics: ["craftInstrumentGroupB"]
},
social_entertainer_music_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_music_02",
  ],
  xp: { id: "music", cost: 15000 },
  commands: [
    "private_entertainer_music_3",
    "startMusic+folk",
    "fanfar",
  ],
  skillModifiers: {
    healing_music_ability: 5,
  },
  schematics: [""]
},
social_entertainer_music_04: {
  title: "Apprentice Musician",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_music_03",
  ],
  xp: { id: "music", cost: 45000 },
  commands: [
    "private_entertainer_music_4",
    "startMusic+starwars3",
    "kloohorn",
  ],
  skillModifiers: {
    healing_music_ability: 10,
  },
  schematics: [""]
},
social_entertainer_dance_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_novice",
  ],
  xp: { id: "dance", cost: 1000 },
  commands: [
    "private_entertainer_dance_1",
    "startDance+basic2",
  ],
  skillModifiers: {
    healing_dance_ability: 5,
  },
  schematics: [""]
},
social_entertainer_dance_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_dance_01",
  ],
  xp: { id: "dance", cost: 5000 },
  commands: [
    "private_entertainer_dance_2",
    "startDance+rhythmic2",
  ],
  skillModifiers: {
    healing_dance_ability: 5,
  },
  schematics: [""]
},
social_entertainer_dance_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_dance_02",
  ],
  xp: { id: "dance", cost: 15000 },
  commands: [
    "private_entertainer_dance_3",
    "startDance+footloose",
  ],
  skillModifiers: {
    healing_dance_ability: 5,
  },
  schematics: [""]
},
social_entertainer_dance_04: {
  title: "Apprentice Dancer",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_dance_03",
  ],
  xp: { id: "dance", cost: 45000 },
  commands: [
    "private_entertainer_dance_4",
    "startDance+formal",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
  },
  schematics: [""]
},
social_entertainer_healing_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_novice",
  ],
  xp: { id: "entertainer_healing", cost: 1000 },
  commands: [
    "private_entertainer_healing_1",
  ],
  skillModifiers: {
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
social_entertainer_healing_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_healing_01",
  ],
  xp: { id: "entertainer_healing", cost: 5000 },
  commands: [
    "private_entertainer_healing_2",
  ],
  skillModifiers: {
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
social_entertainer_healing_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_healing_02",
  ],
  xp: { id: "entertainer_healing", cost: 10000 },
  commands: [
    "private_entertainer_healing_3",
  ],
  skillModifiers: {
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
social_entertainer_healing_04: {
  title: "Apprentice Performer",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_healing_03",
  ],
  xp: { id: "entertainer_healing", cost: 25000 },
  commands: [
    "private_entertainer_healing_4",
  ],
  skillModifiers: {
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
outdoors_scout_novice: {
  title: "Novice Scout",
  skillPoints: 5,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_scout_novice",
    "harvestCorpse",
  ],
  skillModifiers: {
    trapping: 5,
    camp: 5,
    creature_knowledge: 5,
    creature_harvesting: 15,
  },
  schematics: ["craftScoutCampGroupA","craftScoutTrapGroupNovice"]
},
outdoors_scout_master: {
  title: "Master Scout",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_movement_04",
    "outdoors_scout_tools_04",
    "outdoors_scout_harvest_04",
    "outdoors_scout_camp_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_scout_master",
  ],
  skillModifiers: {
    slope_move: 10,
    burst_run: 10,
    camp: 10,
    foraging: 15,
    creature_knowledge: 10,
    creature_harvesting: 5,
    mask_scent: 30,
    trapping: 20,
  },
  schematics: [""]
},
outdoors_scout_movement_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_novice",
  ],
  xp: { id: "scout", cost: 1000 },
  commands: [
    "private_scout_movement_1",
  ],
  skillModifiers: {
    slope_move: 20,
  },
  schematics: [""]
},
outdoors_scout_movement_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_movement_01",
  ],
  xp: { id: "scout", cost: 5000 },
  commands: [
    "private_scout_movement_2",
    "maskscent",
  ],
  skillModifiers: {
    burst_run: 20,
    mask_scent: 20,
  },
  schematics: [""]
},
outdoors_scout_movement_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_movement_02",
  ],
  xp: { id: "scout", cost: 10000 },
  commands: [
    "private_scout_movement_3",
  ],
  skillModifiers: {
    slope_move: 20,
    mask_scent: 20,
  },
  schematics: [""]
},
outdoors_scout_movement_04: {
  title: "Explorer",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_movement_03",
  ],
  xp: { id: "scout", cost: 15000 },
  commands: [
    "private_scout_movement_4",
  ],
  skillModifiers: {
    burst_run: 20,
    mask_scent: 30,
  },
  schematics: [""]
},
outdoors_scout_tools_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_novice",
  ],
  xp: { id: "trapping", cost: 1000 },
  commands: [
    "private_scout_tools_1",
  ],
  skillModifiers: {
    trapping: 5,
  },
  schematics: ["craftScoutTrapGroupA"]
},
outdoors_scout_tools_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_tools_01",
  ],
  xp: { id: "trapping", cost: 5000 },
  commands: [
    "private_scout_tools_2",
  ],
  skillModifiers: {
    trapping: 5,
  },
  schematics: ["craftScoutTrapGroupB"]
},
outdoors_scout_tools_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_tools_02",
  ],
  xp: { id: "trapping", cost: 10000 },
  commands: [
    "private_scout_tools_3",
  ],
  skillModifiers: {
    trapping: 5,
  },
  schematics: ["craftScoutTrapGroupC"]
},
outdoors_scout_tools_04: {
  title: "Trapper",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_tools_03",
  ],
  xp: { id: "trapping", cost: 15000 },
  commands: [
    "private_scout_tools_4",
  ],
  skillModifiers: {
    trapping: 10,
  },
  schematics: ["craftScoutTrapGroupD"]
},
outdoors_scout_harvest_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_novice",
  ],
  xp: { id: "scout", cost: 1000 },
  commands: [
    "private_scout_harvest_1",
  ],
  skillModifiers: {
    creature_knowledge: 5,
    creature_harvesting: 5,
  },
  schematics: [""]
},
outdoors_scout_harvest_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_harvest_01",
  ],
  xp: { id: "scout", cost: 5000 },
  commands: [
    "private_scout_harvest_2",
  ],
  skillModifiers: {
    creature_knowledge: 10,
    creature_harvesting: 10,
    creature_hit_bonus: 10,
  },
  schematics: [""]
},
outdoors_scout_harvest_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_harvest_02",
  ],
  xp: { id: "scout", cost: 10000 },
  commands: [
    "private_scout_harvest_3",
  ],
  skillModifiers: {
    creature_knowledge: 10,
    creature_harvesting: 5,
  },
  schematics: [""]
},
outdoors_scout_harvest_04: {
  title: "Hunter",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_harvest_03",
  ],
  xp: { id: "scout", cost: 15000 },
  commands: [
    "private_scout_harvest_4",
  ],
  skillModifiers: {
    creature_knowledge: 10,
    creature_harvesting: 10,
  },
  schematics: [""]
},
outdoors_scout_camp_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_novice",
  ],
  xp: { id: "camp", cost: 1000 },
  commands: [
    "private_scout_camp_1",
    "forage",
  ],
  skillModifiers: {
    camp: 5,
    foraging: 5,
  },
  schematics: [""]
},
outdoors_scout_camp_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_camp_01",
  ],
  xp: { id: "camp", cost: 5000 },
  commands: [
    "private_scout_camp_2",
  ],
  skillModifiers: {
    camp: 10,
    foraging: 10,
  },
  schematics: ["craftScoutCampGroupB"]
},
outdoors_scout_camp_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_camp_02",
  ],
  xp: { id: "camp", cost: 10000 },
  commands: [
    "private_scout_camp_3",
  ],
  skillModifiers: {
    camp: 10,
    foraging: 10,
  },
  schematics: [""]
},
outdoors_scout_camp_04: {
  title: "Survivalist",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_camp_03",
  ],
  xp: { id: "camp", cost: 20000 },
  commands: [
    "private_scout_camp_4",
  ],
  skillModifiers: {
    camp: 10,
    foraging: 10,
  },
  schematics: ["craftScoutCampGroupC"]
},
science_medic_novice: {
  title: "Novice Medic",
  skillPoints: 5,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_medic_novice",
    "healDamage",
    "healWound",
    "medicalForage",
    "tendWound",
    "tendDamage",
    "diagnose",
  ],
  skillModifiers: {
    healing_injury_treatment: 5,
    healing_wound_treatment: 5,
    healing_ability: 5,
    healing_injury_speed: 5,
    medicine_assembly: 10,
    medicine_experimentation: 10,
    medical_foraging: 10,
  },
  schematics: ["craftMedicineComponentGroupA","craftMedicineStimpackGroupA"]
},
science_medic_master: {
  title: "Master Medic",
  skillPoints: 1,
  preReqs: [
    "science_medic_injury_04",
    "science_medic_injury_speed_04",
    "science_medic_ability_04",
    "science_medic_crafting_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_medic_master",
  ],
  skillModifiers: {
    healing_injury_treatment: 25,
    healing_ability: 10,
    medical_foraging: 25,
  },
  schematics: ["craftMedicineStimpackGroupD"]
},
science_medic_injury_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_novice",
  ],
  xp: { id: "medical", cost: 1000 },
  commands: [
    "private_medic_injury_1",
  ],
  skillModifiers: {
    healing_injury_treatment: 15,
  },
  schematics: [""]
},
science_medic_injury_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_injury_01",
  ],
  xp: { id: "medical", cost: 5000 },
  commands: [
    "private_medic_injury_2",
    "firstAid",
  ],
  skillModifiers: {
    healing_injury_treatment: 15,
  },
  schematics: [""]
},
science_medic_injury_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_injury_02",
  ],
  xp: { id: "medical", cost: 10000 },
  commands: [
    "private_medic_injury_3",
  ],
  skillModifiers: {
    healing_injury_treatment: 15,
  },
  schematics: [""]
},
science_medic_injury_04: {
  title: "Field Stabilizer",
  skillPoints: 1,
  preReqs: [
    "science_medic_injury_03",
  ],
  xp: { id: "medical", cost: 15000 },
  commands: [
    "private_medic_injury_4",
    "quickHeal",
  ],
  skillModifiers: {
    healing_injury_treatment: 25,
  },
  schematics: [""]
},
science_medic_injury_speed_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_novice",
  ],
  xp: { id: "medical", cost: 1000 },
  commands: [
    "private_medic_speed_1",
  ],
  skillModifiers: {
    healing_injury_speed: 15,
  },
  schematics: [""]
},
science_medic_injury_speed_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_injury_speed_01",
  ],
  xp: { id: "medical", cost: 5000 },
  commands: [
    "private_medic_speed_2",
    "dragIncapacitatedPlayer",
  ],
  skillModifiers: {
    healing_injury_speed: 15,
  },
  schematics: [""]
},
science_medic_injury_speed_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_injury_speed_02",
  ],
  xp: { id: "medical", cost: 10000 },
  commands: [
    "private_medic_speed_3",
  ],
  skillModifiers: {
    healing_injury_speed: 15,
  },
  schematics: [""]
},
science_medic_injury_speed_04: {
  title: "Emergency Technician",
  skillPoints: 1,
  preReqs: [
    "science_medic_injury_speed_03",
  ],
  xp: { id: "medical", cost: 15000 },
  commands: [
    "private_medic_speed_4",
  ],
  skillModifiers: {
    healing_injury_speed: 25,
  },
  schematics: [""]
},
science_medic_ability_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_novice",
  ],
  xp: { id: "medical", cost: 1000 },
  commands: [
    "private_medic_ability_1",
  ],
  skillModifiers: {
    healing_ability: 5,
    medical_foraging: 15,
  },
  schematics: [""]
},
science_medic_ability_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_ability_01",
  ],
  xp: { id: "medical", cost: 5000 },
  commands: [
    "private_medic_ability_2",
  ],
  skillModifiers: {
    healing_ability: 10,
    medical_foraging: 15,
  },
  schematics: [""]
},
science_medic_ability_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_ability_02",
  ],
  xp: { id: "medical", cost: 10000 },
  commands: [
    "private_medic_ability_3",
  ],
  skillModifiers: {
    healing_ability: 10,
    medical_foraging: 15,
  },
  schematics: [""]
},
science_medic_ability_04: {
  title: "First Responder",
  skillPoints: 1,
  preReqs: [
    "science_medic_ability_03",
  ],
  xp: { id: "medical", cost: 15000 },
  commands: [
    "private_medic_ability_4",
  ],
  skillModifiers: {
    healing_ability: 10,
    medical_foraging: 20,
  },
  schematics: [""]
},
science_medic_crafting_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_novice",
  ],
  xp: { id: "crafting_medicine_general", cost: 500 },
  commands: [
    "private_medic_crafting_1",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftMedpackGroupA"]
},
science_medic_crafting_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_crafting_01",
  ],
  xp: { id: "crafting_medicine_general", cost: 1000 },
  commands: [
    "private_medic_crafting_2",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftMedicineComponentGroupB","craftMedicineStimpackGroupB"]
},
science_medic_crafting_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "science_medic_crafting_02",
  ],
  xp: { id: "crafting_medicine_general", cost: 3000 },
  commands: [
    "private_medic_crafting_3",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftMedpackBGroupA","craftMedpackGroupB"]
},
science_medic_crafting_04: {
  title: "Stimpack Chemist",
  skillPoints: 1,
  preReqs: [
    "science_medic_crafting_03",
  ],
  xp: { id: "crafting_medicine_general", cost: 6000 },
  commands: [
    "private_medic_crafting_4",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftMedicineStimpackGroupC","craftMedicineComponentGroupD","craftMedpackBGroupB"]
},
crafting_artisan_novice: {
  title: "Novice Artisan",
  skillPoints: 5,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_artisan_novice",
    "sample",
    "survey",
  ],
  skillModifiers: {
    surveying: 20,
    general_assembly: 20,
    general_experimentation: 20,
    clothing_customization: 20,
    armor_customization: 20,
  },
  schematics: ["craftArtisanNewbieGroupA","craftArtisanNewbieGroupB","craftArtisanSurveyGroupA"]
},
crafting_artisan_master: {
  title: "Master Artisan",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_engineering_04",
    "crafting_artisan_domestic_04",
    "crafting_artisan_business_04",
    "crafting_artisan_survey_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_artisan_master",
    "customizeVehicle",
  ],
  skillModifiers: {},
  schematics: ["craftArtisanMasterGroupA","craftArtisanVehicle"]
},
crafting_artisan_engineering_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_novice",
  ],
  xp: { id: "crafting_general", cost: 500 },
  commands: [
    "private_artisan_engineering_1",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    armor_customization: 20,
  },
  schematics: ["craftArtisanEngineeringGroupA","craftArtisanToolGroupA"]
},
crafting_artisan_engineering_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_engineering_01",
  ],
  xp: { id: "crafting_general", cost: 1000 },
  commands: [
    "private_artisan_engineering_2",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    armor_customization: 20,
  },
  schematics: ["craftArtisanEngineeringGroupB"]
},
crafting_artisan_engineering_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_engineering_02",
  ],
  xp: { id: "crafting_general", cost: 3000 },
  commands: [
    "private_artisan_engineering_3",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    armor_customization: 20,
  },
  schematics: ["craftArtisanEngineeringGroupC"]
},
crafting_artisan_engineering_04: {
  title: "Engineer",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_engineering_03",
  ],
  xp: { id: "crafting_general", cost: 6000 },
  commands: [
    "private_artisan_engineering_4",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    armor_customization: 20,
  },
  schematics: ["craftArtisanEngineeringGroupD"]
},
crafting_artisan_domestic_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_novice",
  ],
  xp: { id: "crafting_general", cost: 500 },
  commands: [
    "private_artisan_domestic_1",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    clothing_customization: 20,
  },
  schematics: ["craftArtisanDomesticGroupA"]
},
crafting_artisan_domestic_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_domestic_01",
  ],
  xp: { id: "crafting_general", cost: 1000 },
  commands: [
    "private_artisan_domestic_2",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    clothing_customization: 20,
  },
  schematics: ["craftArtisanDomesticGroupB"]
},
crafting_artisan_domestic_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_domestic_02",
  ],
  xp: { id: "crafting_general", cost: 3000 },
  commands: [
    "private_artisan_domestic_3",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    clothing_customization: 20,
  },
  schematics: ["craftArtisanDomesticGroupC"]
},
crafting_artisan_domestic_04: {
  title: "Homemaker",
  skillPoints: 1,
  preReqs: [
    "crafting_artisan_domestic_03",
  ],
  xp: { id: "crafting_general", cost: 6000 },
  commands: [
    "private_artisan_domestic_4",
  ],
  skillModifiers: {
    general_assembly: 10,
    general_experimentation: 10,
    clothing_customization: 20,
  },
  schematics: ["craftArtisanDomesticGroupD"]
},
crafting_artisan_business_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_novice",
  ],
  xp: { id: "crafting_general", cost: 500 },
  commands: [
    "private_artisan_business_1",
    "access_fee",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_artisan_business_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_business_01",
  ],
  xp: { id: "crafting_general", cost: 1000 },
  commands: [
    "private_artisan_business_2",
    "premium_auctions",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_artisan_business_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_business_02",
  ],
  xp: { id: "crafting_general", cost: 3000 },
  commands: [
    "private_artisan_business_3",
  ],
  skillModifiers: {
    manage_vendor: 1,
    hiring: 10,
    vendor_item_limit: 100,
  },
  schematics: [""]
},
crafting_artisan_business_04: {
  title: "Businessman",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_business_03",
  ],
  xp: { id: "crafting_general", cost: 6000 },
  commands: [
    "private_artisan_business_4",
  ],
  skillModifiers: {
    manage_vendor: 1,
    hiring: 10,
    vendor_item_limit: 150,
  },
  schematics: [""]
},
crafting_artisan_survey_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_novice",
  ],
  xp: { id: "resource_harvesting_inorganic", cost: 500 },
  commands: [
    "private_artisan_survey_1",
  ],
  skillModifiers: {
    surveying: 15,
  },
  schematics: [""]
},
crafting_artisan_survey_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_survey_01",
  ],
  xp: { id: "resource_harvesting_inorganic", cost: 2500 },
  commands: [
    "private_artisan_survey_2",
  ],
  skillModifiers: {
    surveying: 20,
  },
  schematics: [""]
},
crafting_artisan_survey_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_survey_02",
  ],
  xp: { id: "resource_harvesting_inorganic", cost: 5000 },
  commands: [
    "private_artisan_survey_3",
  ],
  skillModifiers: {
    surveying: 20,
  },
  schematics: [""]
},
crafting_artisan_survey_04: {
  title: "Surveyor",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_survey_03",
  ],
  xp: { id: "resource_harvesting_inorganic", cost: 10000 },
  commands: [
    "private_artisan_survey_4",
  ],
  skillModifiers: {
    surveying: 25,
  },
  schematics: [""]
},
combat_brawler_novice: {
  title: "Novice Brawler",
  skillPoints: 5,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_brawler_novice",
    "polearmLunge1",
    "unarmedLunge1",
    "melee1hLunge1",
    "melee2hLunge1",
    "taunt",
    "warcry1",
    "intimidate1",
    "berserk1",
    "cert_knife_dagger",
    "centerOfBeing",
  ],
  skillModifiers: {
    unarmed_accuracy: 10,
    unarmed_damage: 15,
    unarmed_speed: 5,
    polearm_accuracy: 10,
    polearm_speed: 5,
    onehandmelee_accuracy: 10,
    onehandmelee_speed: 5,
    twohandmelee_accuracy: 10,
    twohandmelee_speed: 5,
    private_onehandmelee_combat_difficulty: 100,
    private_twohandmelee_combat_difficulty: 100,
    private_unarmed_combat_difficulty: 100,
    private_polearm_combat_difficulty: 100,
    taunt: 10,
    unarmed_center_of_being_efficacy: 10,
    polearm_center_of_being_efficacy: 10,
    onehandmelee_center_of_being_efficacy: 10,
    twohandmelee_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 5,
    center_of_being_duration_onehandmelee: 5,
    center_of_being_duration_twohandmelee: 5,
    center_of_being_duration_polearm: 5,
  },
  schematics: [""]
},
combat_brawler_master: {
  title: "Master Brawler",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_unarmed_04",
    "combat_brawler_1handmelee_04",
    "combat_brawler_2handmelee_04",
    "combat_brawler_polearm_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_brawler_master",
    "polearmLunge2",
    "unarmedLunge2",
    "melee1hLunge2",
    "melee2hLunge2",
    "warcry2",
    "intimidate2",
    "berserk2",
  ],
  skillModifiers: {
    warcry: 20,
    intimidate: 20,
    berserk: 20,
    unarmed_accuracy: 5,
    unarmed_speed: 5,
    onehandmelee_speed: 5,
    onehandmelee_accuracy: 5,
    twohandmelee_speed: 5,
    twohandmelee_accuracy: 5,
    polearm_speed: 5,
    polearm_accuracy: 5,
    melee_defense: 5,
    ranged_defense: 5,
    private_onehandmelee_combat_difficulty: 100,
    private_twohandmelee_combat_difficulty: 100,
    private_unarmed_combat_difficulty: 100,
    private_polearm_combat_difficulty: 100,
    taunt: 30,
    polearm_toughness: 5,
    onehandmelee_toughness: 5,
    twohandmelee_toughness: 5,
    unarmed_toughness: 5,
    unarmed_center_of_being_efficacy: 10,
    polearm_center_of_being_efficacy: 10,
    onehandmelee_center_of_being_efficacy: 10,
    twohandmelee_center_of_being_efficacy: 10,
    center_of_being_duration_onehandmelee: 5,
    center_of_being_duration_twohandmelee: 5,
    center_of_being_duration_polearm: 5,
  },
  schematics: [""]
},
combat_brawler_unarmed_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_novice",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 1000 },
  commands: [
    "private_brawler_unarmed_1",
    "unarmedHit1",
  ],
  skillModifiers: {
    unarmed_speed: 5,
    unarmed_accuracy: 10,
    private_unarmed_combat_difficulty: 100,
    unarmed_damage: 5,
    unarmed_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 2,
  },
  schematics: [""]
},
combat_brawler_unarmed_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_unarmed_01",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 5000 },
  commands: [
    "private_brawler_unarmed_2",
    "unarmedStun1",
  ],
  skillModifiers: {
    unarmed_speed: 5,
    unarmed_accuracy: 10,
    private_unarmed_combat_difficulty: 100,
    unarmed_damage: 10,
    unarmed_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 2,
  },
  schematics: [""]
},
combat_brawler_unarmed_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_unarmed_02",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 15000 },
  commands: [
    "private_brawler_unarmed_3",
    "unarmedBlind1",
  ],
  skillModifiers: {
    unarmed_speed: 5,
    unarmed_accuracy: 10,
    private_unarmed_combat_difficulty: 100,
    unarmed_toughness: 10,
    unarmed_damage: 10,
    unarmed_center_of_being_efficacy: 5,
    center_of_being_duration_unarmed: 2,
  },
  schematics: [""]
},
combat_brawler_unarmed_04: {
  title: "Teras Kasi Student",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_unarmed_03",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 70000 },
  commands: [
    "private_brawler_unarmed_4",
    "unarmedSpinAttack1",
  ],
  skillModifiers: {
    unarmed_speed: 5,
    unarmed_accuracy: 10,
    melee_defense: 2,
    private_unarmed_combat_difficulty: 100,
    unarmed_toughness: 10,
    unarmed_damage: 10,
    unarmed_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 2,
  },
  schematics: [""]
},
combat_brawler_1handmelee_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_novice",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 1000 },
  commands: [
    "private_brawler_1hand_1",
    "melee1hHit1",
    "cert_sword_01",
    "cert_baton_gaderiffi",
    "cert_sword_02",
  ],
  skillModifiers: {
    onehandmelee_speed: 5,
    onehandmelee_accuracy: 10,
    private_onehandmelee_combat_difficulty: 100,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_1handmelee_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_1handmelee_01",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 5000 },
  commands: [
    "private_brawler_1hand_2",
    "melee1hBodyHit1",
    "cert_knife_vibroblade",
  ],
  skillModifiers: {
    onehandmelee_speed: 5,
    onehandmelee_accuracy: 10,
    private_onehandmelee_combat_difficulty: 100,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_1handmelee_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_1handmelee_02",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 15000 },
  commands: [
    "private_brawler_1hand_3",
    "melee1hDizzyHit1",
    "cert_sword_blade_ryyk",
  ],
  skillModifiers: {
    onehandmelee_speed: 5,
    onehandmelee_accuracy: 10,
    private_onehandmelee_combat_difficulty: 100,
    onehandmelee_toughness: 10,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_1handmelee_04: {
  title: "Apprentice Swordsman",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_1handmelee_03",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 70000 },
  commands: [
    "private_brawler_1hand_4",
    "melee1hSpinAttack1",
    "cert_sword_blade_rantok",
  ],
  skillModifiers: {
    onehandmelee_speed: 5,
    onehandmelee_accuracy: 10,
    private_onehandmelee_combat_difficulty: 100,
    onehandmelee_toughness: 10,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_2handmelee_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_novice",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 1000 },
  commands: [
    "private_brawler_2hand_1",
    "melee2hHit1",
    "cert_sword_2h_axe",
  ],
  skillModifiers: {
    twohandmelee_speed: 5,
    twohandmelee_accuracy: 10,
    private_twohandmelee_combat_difficulty: 100,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_2handmelee_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_2handmelee_01",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 5000 },
  commands: [
    "private_brawler_2hand_2",
    "melee2hHeadHit1",
    "cert_sword_2h_katana",
  ],
  skillModifiers: {
    twohandmelee_speed: 5,
    twohandmelee_accuracy: 10,
    private_twohandmelee_combat_difficulty: 100,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_2handmelee_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_2handmelee_02",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 15000 },
  commands: [
    "private_brawler_2hand_3",
    "melee2hSweep1",
    "cert_axe_vibro",
  ],
  skillModifiers: {
    twohandmelee_speed: 5,
    twohandmelee_accuracy: 10,
    private_twohandmelee_combat_difficulty: 100,
    twohandmelee_toughness: 10,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_2handmelee_04: {
  title: "Apprentice Heavy Swordsman",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_2handmelee_03",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 70000 },
  commands: [
    "private_brawler_2hand_4",
    "melee2hSpinAttack1",
    "cert_sword_2h_cleaver",
  ],
  skillModifiers: {
    twohandmelee_speed: 5,
    twohandmelee_accuracy: 10,
    private_twohandmelee_combat_difficulty: 100,
    twohandmelee_toughness: 10,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_polearm_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_novice",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 1000 },
  commands: [
    "private_brawler_polearm_1",
    "polearmHit1",
    "cert_lance_staff_wood_s2",
    "cert_lance_staff_metal",
  ],
  skillModifiers: {
    polearm_speed: 5,
    polearm_accuracy: 10,
    private_polearm_combat_difficulty: 100,
    center_of_being_duration_polearm: 2,
    polearm_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_polearm_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_polearm_01",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 5000 },
  commands: [
    "private_brawler_polearm_2",
    "polearmLegHit1",
    "cert_lance_controllerfp",
  ],
  skillModifiers: {
    polearm_speed: 5,
    polearm_accuracy: 10,
    private_polearm_combat_difficulty: 100,
    center_of_being_duration_polearm: 2,
    polearm_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_polearm_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_polearm_02",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 15000 },
  commands: [
    "private_brawler_polearm_3",
    "polearmStun1",
    "cert_lance_vibro_axe",
  ],
  skillModifiers: {
    polearm_speed: 5,
    polearm_accuracy: 10,
    private_polearm_combat_difficulty: 100,
    polearm_toughness: 4,
    center_of_being_duration_polearm: 2,
    polearm_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_brawler_polearm_04: {
  title: "Apprentice Pikeman",
  skillPoints: 1,
  preReqs: [
    "combat_brawler_polearm_03",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 70000 },
  commands: [
    "private_brawler_polearm_4",
    "polearmSpinAttack1",
  ],
  skillModifiers: {
    polearm_speed: 5,
    polearm_accuracy: 10,
    private_polearm_combat_difficulty: 100,
    polearm_toughness: 4,
    center_of_being_duration_polearm: 1,
    polearm_center_of_being_efficacy: 5,
  },
  schematics: [""]
},
combat_marksman_novice: {
  title: "Novice Marksman",
  skillPoints: 5,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_marksman_novice",
    "pointBlankArea1",
    "pointBlankSingle1",
    "overChargeShot1",
    "cert_rifle_dlt20",
    "cert_pistol_d18",
    "cert_carbine_dh17",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 5,
    rifle_accuracy: 10,
    rifle_speed: 5,
    carbine_speed: 5,
    carbine_accuracy: 10,
    private_rifle_combat_difficulty: 100,
    private_carbine_combat_difficulty: 100,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_master: {
  title: "Master Marksman",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_rifle_04",
    "combat_marksman_pistol_04",
    "combat_marksman_carbine_04",
    "combat_marksman_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_marksman_master",
    "overChargeShot2",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 5,
    rifle_accuracy: 10,
    rifle_speed: 5,
    carbine_speed: 5,
    carbine_accuracy: 10,
    ranged_defense: 5,
    private_rifle_combat_difficulty: 100,
    private_carbine_combat_difficulty: 100,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_rifle_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_novice",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 1000 },
  commands: [
    "private_marksman_rifle_1",
    "headShot1",
    "cert_rifle_dlt20a",
    "cert_rifle_tusken",
  ],
  skillModifiers: {
    rifle_accuracy: 10,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 100,
    rifle_concealment_chance: 5,
  },
  schematics: [""]
},
combat_marksman_rifle_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_rifle_01",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 5000 },
  commands: [
    "private_marksman_rifle_2",
    "takeCover",
    "cert_rifle_sg82",
    "cert_rifle_laser",
  ],
  skillModifiers: {
    rifle_accuracy: 10,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 100,
    rifle_concealment_chance: 5,
  },
  schematics: [""]
},
combat_marksman_rifle_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_rifle_02",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 15000 },
  commands: [
    "private_marksman_rifle_3",
    "headShot2",
    "cert_rifle_spraystick",
  ],
  skillModifiers: {
    rifle_accuracy: 10,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 100,
    rifle_concealment_chance: 5,
  },
  schematics: [""]
},
combat_marksman_rifle_04: {
  title: "Apprentice Sharpshooter",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_rifle_03",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 70000 },
  commands: [
    "private_marksman_rifle_4",
    "mindShot1",
    "cert_rifle_jawa_ion",
    "cert_rifle_e11",
  ],
  skillModifiers: {
    rifle_accuracy: 10,
    rifle_speed: 5,
    ranged_defense: 2,
    private_rifle_combat_difficulty: 100,
    rifle_concealment_chance: 5,
  },
  schematics: [""]
},
combat_marksman_pistol_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_novice",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 1000 },
  commands: [
    "private_marksman_pistol_1",
    "bodyShot1",
    "cert_pistol_dl44",
    "cert_pistol_dl44_metal",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 5,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_pistol_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_pistol_01",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 5000 },
  commands: [
    "private_marksman_pistol_2",
    "rollShot",
    "diveShot",
    "kipUpShot",
    "cert_pistol_scout_blaster",
    "cert_pistol_dh17",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 5,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_pistol_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_pistol_02",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 15000 },
  commands: [
    "private_marksman_pistol_3",
    "bodyShot2",
    "cert_pistol_striker",
    "cert_pistol_power5",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 5,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_pistol_04: {
  title: "Apprentice Gunfighter",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_pistol_03",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 70000 },
  commands: [
    "private_marksman_pistol_4",
    "healthShot1",
    "cert_pistol_srcombat",
    "cert_pistol_tangle",
    "cert_pistol_fwg5",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 5,
    ranged_defense: 2,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_carbine_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_novice",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 1000 },
  commands: [
    "private_marksman_carbine_1",
    "legShot1",
    "cert_carbine_dh17_snubnose",
  ],
  skillModifiers: {
    carbine_speed: 5,
    carbine_accuracy: 10,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_carbine_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_carbine_01",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 5000 },
  commands: [
    "private_marksman_carbine_2",
    "fullAutoSingle1",
    "cert_carbine_e11",
  ],
  skillModifiers: {
    carbine_speed: 5,
    carbine_accuracy: 10,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_carbine_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_carbine_02",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 15000 },
  commands: [
    "private_marksman_carbine_3",
    "legShot2",
    "cert_carbine_laser",
  ],
  skillModifiers: {
    carbine_speed: 5,
    carbine_accuracy: 10,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_carbine_04: {
  title: "Apprentice Carbine Specialist",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_carbine_03",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 70000 },
  commands: [
    "private_marksman_carbine_4",
    "actionShot1",
    "cert_carbine_dxr6",
    "cert_carbine_ee3",
  ],
  skillModifiers: {
    carbine_speed: 5,
    carbine_accuracy: 10,
    ranged_defense: 2,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_marksman_support_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_novice",
  ],
  xp: { id: "combat_general", cost: 300 },
  commands: [
    "private_marksman_support_1",
    "threatenShot",
    "aim",
  ],
  skillModifiers: {
    ranged_defense: 2,
    aim: 10,
  },
  schematics: [""]
},
combat_marksman_support_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_support_01",
  ],
  xp: { id: "combat_general", cost: 2250 },
  commands: [
    "private_marksman_support_2",
    "tumbleToProne",
    "tumbleToKneeling",
    "tumbleToStanding",
  ],
  skillModifiers: {
    melee_defense: 2,
    aim: 10,
  },
  schematics: [""]
},
combat_marksman_support_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_support_02",
  ],
  xp: { id: "combat_general", cost: 6000 },
  commands: [
    "private_marksman_support_3",
    "warningShot",
  ],
  skillModifiers: {
    ranged_defense: 2,
    aim: 5,
  },
  schematics: [""]
},
combat_marksman_support_04: {
  title: "Guardsman",
  skillPoints: 1,
  preReqs: [
    "combat_marksman_support_03",
  ],
  xp: { id: "combat_general", cost: 22000 },
  commands: [
    "private_marksman_support_4",
    "suppressionFire1",
  ],
  skillModifiers: {
    alert: 10,
    ranged_defense: 2,
    aim: 5,
  },
  schematics: [""]
},
combat_rifleman_novice: {
  title: "Novice Rifleman",
  skillPoints: 6,
  preReqs: [
    "combat_marksman_rifle_04",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 125000 },
  commands: [
    "private_rifle_novice",
    "strafeShot1",
    "cert_rifle_t21",
  ],
  skillModifiers: {
    rifle_accuracy: 5,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 100,
    block: 10,
    rifle_concealment_chance: 15,
  },
  schematics: [""]
},
combat_rifleman_master: {
  title: "Master Rifleman",
  skillPoints: 1,
  preReqs: [
    "combat_rifleman_accuracy_04",
    "combat_rifleman_speed_04",
    "combat_rifleman_ability_04",
    "combat_rifleman_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_rifle_master",
    "strafeShot2",
    "ranged_damage_mitigation_3",
  ],
  skillModifiers: {
    rifle_accuracy: 40,
    rifle_speed: 15,
    rifle_hit_while_moving: 10,
    rifle_aim: 40,
    ranged_defense: 15,
    private_rifle_combat_difficulty: 100,
    block: 10,
    rifle_concealment_chance: 5,
  },
  schematics: [""]
},
combat_rifleman_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_rifleman_novice",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 175000 },
  commands: [
    "private_rifle_accuracy_1",
    "mindShot2",
  ],
  skillModifiers: {
    rifle_accuracy: 10,
    rifle_aim: 15,
    private_rifle_combat_difficulty: 125,
    rifle_concealment_chance: 15,
  },
  schematics: [""]
},
combat_rifleman_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_rifleman_accuracy_01",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 250000 },
  commands: [
    "private_rifle_accuracy_2",
    "headShot3",
  ],
  skillModifiers: {
    rifle_accuracy: 15,
    rifle_aim: 15,
    private_rifle_combat_difficulty: 100,
    rifle_concealment_chance: 15,
  },
  schematics: [""]
},
combat_rifleman_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_rifleman_accuracy_02",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 350000 },
  commands: [
    "private_rifle_accuracy_3",
    "surpriseShot",
  ],
  skillModifiers: {
    rifle_accuracy: 20,
    rifle_aim: 15,
    private_rifle_combat_difficulty: 100,
    rifle_concealment_chance: 15,
  },
  schematics: [""]
},
combat_rifleman_accuracy_04: {
  title: "Sniper",
  skillPoints: 2,
  preReqs: [
    "combat_rifleman_accuracy_03",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 450000 },
  commands: [
    "private_rifle_accuracy_4",
    "sniperShot",
  ],
  skillModifiers: {
    rifle_accuracy: 20,
    rifle_aim: 15,
    private_rifle_combat_difficulty: 125,
    rifle_concealment_chance: 15,
  },
  schematics: [""]
},
combat_rifleman_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_rifleman_novice",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 175000 },
  commands: [
    "private_rifle_speed_1",
    "concealShot",
    "ranged_damage_mitigation_1",
  ],
  skillModifiers: {
    ranged_defense: 10,
    take_cover: 20,
    private_rifle_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_rifleman_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_rifleman_speed_01",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 250000 },
  commands: [
    "private_rifle_speed_2",
  ],
  skillModifiers: {
    ranged_defense: 10,
    take_cover: 20,
    private_rifle_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_rifleman_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_rifleman_speed_02",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 350000 },
  commands: [
    "private_rifle_speed_3",
    "sneak",
    "ranged_damage_mitigation_2",
  ],
  skillModifiers: {
    ranged_defense: 10,
    take_cover: 20,
    private_rifle_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_rifleman_speed_04: {
  title: "Assassin",
  skillPoints: 2,
  preReqs: [
    "combat_rifleman_speed_03",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 450000 },
  commands: [
    "private_rifle_speed_4",
  ],
  skillModifiers: {
    ranged_defense: 10,
    take_cover: 20,
    private_rifle_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_rifleman_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_rifleman_novice",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 175000 },
  commands: [
    "private_rifle_ability_1",
    "flushingShot1",
  ],
  skillModifiers: {
    block: 15,
    private_rifle_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_rifleman_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_rifleman_ability_01",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 250000 },
  commands: [
    "private_rifle_ability_2",
    "startleShot1",
  ],
  skillModifiers: {
    block: 15,
    private_rifle_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_rifleman_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_rifleman_ability_02",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 350000 },
  commands: [
    "private_rifle_ability_3",
    "flushingShot2",
  ],
  skillModifiers: {
    block: 15,
    posture_change_up_defense: 30,
    stun_defense: 10,
    blind_defense: 10,
    dizzy_defense: 10,
    private_rifle_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_rifleman_ability_04: {
  title: "Gunner",
  skillPoints: 2,
  preReqs: [
    "combat_rifleman_ability_03",
  ],
  xp: { id: "combat_rangedspecialize_rifle", cost: 450000 },
  commands: [
    "private_rifle_ability_4",
    "startleShot2",
  ],
  skillModifiers: {
    block: 15,
    ranged_defense: 15,
    private_rifle_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_rifleman_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_rifleman_novice",
  ],
  xp: { id: "combat_general", cost: 60000 },
  commands: [
    "private_rifle_support_1",
    "flurryShot1",
  ],
  skillModifiers: {
    melee_defense: 10,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_rifleman_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_rifleman_support_01",
  ],
  xp: { id: "combat_general", cost: 85000 },
  commands: [
    "private_rifle_support_2",
  ],
  skillModifiers: {
    melee_defense: 10,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_rifleman_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_rifleman_support_02",
  ],
  xp: { id: "combat_general", cost: 120000 },
  commands: [
    "private_rifle_support_3",
    "flurryShot2",
  ],
  skillModifiers: {
    melee_defense: 10,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_rifleman_support_04: {
  title: "Soldier",
  skillPoints: 2,
  preReqs: [
    "combat_rifleman_support_03",
  ],
  xp: { id: "combat_general", cost: 150000 },
  commands: [
    "private_rifle_support_4",
  ],
  skillModifiers: {
    melee_defense: 10,
    rifle_speed: 5,
    private_rifle_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_pistol_novice: {
  title: "Novice Pistoleer",
  skillPoints: 6,
  preReqs: [
    "combat_marksman_pistol_04",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 125000 },
  commands: [
    "private_pistol_novice",
    "healthShot2",
    "cert_pistol_dx2",
    "cert_pistol_republic_blaster",
  ],
  skillModifiers: {
    pistol_accuracy: 5,
    pistol_speed: 5,
    private_pistol_combat_difficulty: 100,
    dodge: 10,
  },
  schematics: [""]
},
combat_pistol_master: {
  title: "Master Pistoleer",
  skillPoints: 1,
  preReqs: [
    "combat_pistol_accuracy_04",
    "combat_pistol_speed_04",
    "combat_pistol_ability_04",
    "combat_pistol_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_pistol_master",
    "multiTargetPistolShot",
    "disarmingShot2",
    "ranged_damage_mitigation_3",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 21,
    pistol_hit_while_moving: 10,
    pistol_aim: 4,
    ranged_defense: 5,
    melee_defense: 5,
    private_pistol_combat_difficulty: 100,
    dodge: 25,
  },
  schematics: [""]
},
combat_pistol_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_pistol_novice",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 175000 },
  commands: [
    "private_pistol_accuracy_1",
    "pointBlankSingle2",
  ],
  skillModifiers: {
    private_pistol_combat_difficulty: 125,
    dodge: 15,
  },
  schematics: [""]
},
combat_pistol_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_pistol_accuracy_01",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 250000 },
  commands: [
    "private_pistol_accuracy_2",
  ],
  skillModifiers: {
    dodge: 15,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_pistol_accuracy_02",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 350000 },
  commands: [
    "private_pistol_accuracy_3",
    "bodyShot3",
  ],
  skillModifiers: {
    dodge: 20,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_accuracy_04: {
  title: "Gunslinger",
  skillPoints: 2,
  preReqs: [
    "combat_pistol_accuracy_03",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 450000 },
  commands: [
    "private_pistol_accuracy_4",
    "pointBlankArea2",
  ],
  skillModifiers: {
    dodge: 20,
    private_pistol_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_pistol_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_pistol_novice",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 175000 },
  commands: [
    "private_pistol_speed_1",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_hit_while_moving: 5,
    pistol_aim: 3,
    private_pistol_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_pistol_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_pistol_speed_01",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 250000 },
  commands: [
    "private_pistol_speed_2",
  ],
  skillModifiers: {
    pistol_accuracy: 5,
    pistol_hit_while_moving: 5,
    pistol_aim: 3,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_pistol_speed_02",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 350000 },
  commands: [
    "private_pistol_speed_3",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_hit_while_moving: 5,
    pistol_aim: 3,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_speed_04: {
  title: "Dead-Eye",
  skillPoints: 2,
  preReqs: [
    "combat_pistol_speed_03",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 450000 },
  commands: [
    "private_pistol_speed_4",
  ],
  skillModifiers: {
    pistol_accuracy: 5,
    pistol_hit_while_moving: 5,
    pistol_aim: 3,
    private_pistol_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_pistol_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_pistol_novice",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 175000 },
  commands: [
    "private_pistol_ability_1",
    "disarmingShot1",
    "ranged_damage_mitigation_1",
  ],
  skillModifiers: {
    stun_defense: 40,
    private_pistol_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_pistol_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_pistol_ability_01",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 250000 },
  commands: [
    "private_pistol_ability_2",
    "doubleTap",
  ],
  skillModifiers: {
    blind_defense: 40,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_pistol_ability_02",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 350000 },
  commands: [
    "private_pistol_ability_3",
    "stoppingShot",
    "ranged_damage_mitigation_2",
  ],
  skillModifiers: {
    dizzy_defense: 40,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_ability_04: {
  title: "Trickshot",
  skillPoints: 2,
  preReqs: [
    "combat_pistol_ability_03",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 450000 },
  commands: [
    "private_pistol_ability_4",
    "fanShot",
  ],
  skillModifiers: {
    posture_change_down_defense: 20,
    knockdown_defense: 50,
    private_pistol_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_pistol_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_pistol_novice",
  ],
  xp: { id: "combat_general", cost: 60000 },
  commands: [
    "private_pistol_defense_1",
    "pistolMeleeDefense1",
  ],
  skillModifiers: {
    melee_defense: 10,
    pistol_speed: 6,
    private_pistol_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_pistol_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_pistol_support_01",
  ],
  xp: { id: "combat_general", cost: 85000 },
  commands: [
    "private_pistol_defense_2",
  ],
  skillModifiers: {
    melee_defense: 10,
    pistol_speed: 6,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_pistol_support_02",
  ],
  xp: { id: "combat_general", cost: 120000 },
  commands: [
    "private_pistol_defense_3",
    "pistolMeleeDefense2",
  ],
  skillModifiers: {
    melee_defense: 10,
    pistol_speed: 6,
    pistol_accuracy_while_standing: 15,
    private_pistol_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_pistol_support_04: {
  title: "Quickdraw",
  skillPoints: 2,
  preReqs: [
    "combat_pistol_support_03",
  ],
  xp: { id: "combat_general", cost: 150000 },
  commands: [
    "private_pistol_defense_4",
  ],
  skillModifiers: {
    melee_defense: 10,
    pistol_speed: 6,
    private_pistol_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_carbine_novice: {
  title: "Novice Carbineer",
  skillPoints: 6,
  preReqs: [
    "combat_marksman_carbine_04",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 125000 },
  commands: [
    "private_carbine_novice",
    "actionShot2",
    "fullAutoSingle2",
    "cert_carbine_elite",
    "cert_carbine_nym_slugthrower",
  ],
  skillModifiers: {
    carbine_speed: 5,
    carbine_accuracy: 5,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_master: {
  title: "Master Carbineer",
  skillPoints: 1,
  preReqs: [
    "combat_carbine_support_04",
    "combat_carbine_speed_04",
    "combat_carbine_ability_04",
    "combat_carbine_accuracy_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_carbine_master",
    "ranged_damage_mitigation_3",
  ],
  skillModifiers: {
    carbine_speed: 15,
    carbine_accuracy: 20,
    carbine_hit_while_moving: 10,
    carbine_aim: 25,
    ranged_defense: 25,
    private_carbine_combat_difficulty: 100,
    counterattack: 25,
  },
  schematics: [""]
},
combat_carbine_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_carbine_novice",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 175000 },
  commands: [
    "private_carbine_accuracy_1",
    "scatterShot1",
  ],
  skillModifiers: {
    carbine_speed: 5,
    private_carbine_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_carbine_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_carbine_accuracy_01",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 250000 },
  commands: [
    "private_carbine_accuracy_2",
    "wildShot1",
  ],
  skillModifiers: {
    carbine_speed: 5,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_carbine_accuracy_02",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 350000 },
  commands: [
    "private_carbine_accuracy_3",
    "scatterShot2",
  ],
  skillModifiers: {
    carbine_speed: 5,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_accuracy_04: {
  title: "Mercenary",
  skillPoints: 2,
  preReqs: [
    "combat_carbine_accuracy_03",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 450000 },
  commands: [
    "private_carbine_accuracy_4",
    "wildShot2",
  ],
  skillModifiers: {
    carbine_speed: 5,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_carbine_novice",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 175000 },
  commands: [
    "private_carbine_speed_1",
    "legShot3",
  ],
  skillModifiers: {
    carbine_accuracy: 5,
    private_carbine_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_carbine_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_carbine_speed_01",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 250000 },
  commands: [
    "private_carbine_speed_2",
  ],
  skillModifiers: {
    carbine_accuracy: 10,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_carbine_speed_02",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 350000 },
  commands: [
    "private_carbine_speed_3",
    "cripplingShot",
  ],
  skillModifiers: {
    carbine_accuracy: 15,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_speed_04: {
  title: "Marauder",
  skillPoints: 2,
  preReqs: [
    "combat_carbine_speed_03",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 450000 },
  commands: [
    "private_carbine_speed_4",
  ],
  skillModifiers: {
    carbine_accuracy: 25,
    private_carbine_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_carbine_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_carbine_novice",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 175000 },
  commands: [
    "private_carbine_ability_1",
    "burstShot1",
    "ranged_damage_mitigation_1",
  ],
  skillModifiers: {
    counterattack: 20,
    private_carbine_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_carbine_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_carbine_ability_01",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 250000 },
  commands: [
    "private_carbine_ability_2",
  ],
  skillModifiers: {
    knockdown_defense: 15,
    intimidate_defense: 25,
    counterattack: 20,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_carbine_ability_02",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 350000 },
  commands: [
    "private_carbine_ability_3",
    "burstShot2",
    "ranged_damage_mitigation_2",
  ],
  skillModifiers: {
    counterattack: 20,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_ability_04: {
  title: "Infiltrator",
  skillPoints: 2,
  preReqs: [
    "combat_carbine_ability_03",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 450000 },
  commands: [
    "private_carbine_ability_4",
    "suppressionFire2",
  ],
  skillModifiers: {
    counterattack: 20,
    private_carbine_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_carbine_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_carbine_novice",
  ],
  xp: { id: "combat_general", cost: 60000 },
  commands: [
    "private_carbine_support_1",
    "fullAutoArea1",
  ],
  skillModifiers: {
    carbine_hit_while_moving: 5,
    private_carbine_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_carbine_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_carbine_support_01",
  ],
  xp: { id: "combat_general", cost: 85000 },
  commands: [
    "private_carbine_support_2",
    "chargeShot1",
  ],
  skillModifiers: {
    carbine_hit_while_moving: 5,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_carbine_support_02",
  ],
  xp: { id: "combat_general", cost: 120000 },
  commands: [
    "private_carbine_support_3",
    "fullAutoArea2",
  ],
  skillModifiers: {
    carbine_hit_while_moving: 5,
    private_carbine_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_carbine_support_04: {
  title: "Assaulter",
  skillPoints: 2,
  preReqs: [
    "combat_carbine_support_03",
  ],
  xp: { id: "combat_general", cost: 150000 },
  commands: [
    "private_carbine_support_4",
    "chargeShot2",
  ],
  skillModifiers: {
    carbine_hit_while_moving: 5,
    private_carbine_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_unarmed_novice: {
  title: "Teras Kasi Novice",
  skillPoints: 6,
  preReqs: [
    "combat_brawler_unarmed_04",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 125000 },
  commands: [
    "private_unarmed_novice",
    "unarmedHit2",
    "meditate",
    "cert_vibroknuckler",
  ],
  skillModifiers: {
    unarmed_damage: 70,
    combat_equillibrium: 10,
    unarmed_speed: 10,
    unarmed_accuracy: 20,
    private_unarmed_combat_difficulty: 100,
    meditate: 15,
    unarmed_toughness: 4,
    private_med_dot: 5,
    unarmed_passive_defense: 15,
    unarmed_center_of_being_efficacy: 15,
    center_of_being_duration_unarmed: 5,
  },
  schematics: [""]
},
combat_unarmed_master: {
  title: "Teras Kasi Master",
  skillPoints: 1,
  preReqs: [
    "combat_unarmed_accuracy_04",
    "combat_unarmed_speed_04",
    "combat_unarmed_ability_04",
    "combat_unarmed_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_unarmed_master",
    "unarmedHit3",
    "melee_damage_mitigation_3",
  ],
  skillModifiers: {
    unarmed_damage: 70,
    combat_equillibrium: 15,
    unarmed_speed: 20,
    unarmed_accuracy: 35,
    private_unarmed_combat_difficulty: 100,
    meditate: 25,
    private_med_dot: 10,
    private_med_wound: 10,
    unarmed_passive_defense: 25,
    unarmed_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 5,
  },
  schematics: [""]
},
combat_unarmed_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_unarmed_novice",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 175000 },
  commands: [
    "private_unarmed_accuarcy_1",
  ],
  skillModifiers: {
    private_unarmed_combat_difficulty: 125,
    meditate: 15,
    private_med_dot: 5,
  },
  schematics: [""]
},
combat_unarmed_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_unarmed_accuracy_01",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 250000 },
  commands: [
    "private_unarmed_accuarcy_2",
    "powerBoost",
  ],
  skillModifiers: {
    private_unarmed_combat_difficulty: 100,
    meditate: 15,
    private_med_dot: 10,
    private_med_wound: 5,
  },
  schematics: [""]
},
combat_unarmed_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_unarmed_accuracy_02",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 350000 },
  commands: [
    "private_unarmed_accuracy_3",
  ],
  skillModifiers: {
    private_unarmed_combat_difficulty: 100,
    meditate: 15,
    private_med_dot: 10,
    private_med_wound: 5,
  },
  schematics: [""]
},
combat_unarmed_accuracy_04: {
  title: "Teras Kasi Mystic",
  skillPoints: 2,
  preReqs: [
    "combat_unarmed_accuracy_03",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 450000 },
  commands: [
    "private_unarmed_accuracy_4",
    "forceOfWill",
  ],
  skillModifiers: {
    private_unarmed_combat_difficulty: 100,
    meditate: 15,
    private_med_dot: 10,
    private_med_wound: 5,
  },
  schematics: [""]
},
combat_unarmed_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_unarmed_novice",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 175000 },
  commands: [
    "private_unarmed_speed_1",
    "unarmedKnockdown1",
    "melee_damage_mitigation_1",
  ],
  skillModifiers: {
    combat_equillibrium: 10,
    blind_defense: 10,
    posture_change_down_defense: 10,
    private_unarmed_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_unarmed_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_unarmed_speed_01",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 250000 },
  commands: [
    "private_unarmed_speed_2",
  ],
  skillModifiers: {
    stun_defense: 10,
    combat_equillibrium: 10,
    posture_change_down_defense: 10,
    private_unarmed_combat_difficulty: 100,
    unarmed_toughness: 15,
  },
  schematics: [""]
},
combat_unarmed_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_unarmed_speed_02",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 350000 },
  commands: [
    "private_unarmed_speed_3",
    "melee_damage_mitigation_2",
  ],
  skillModifiers: {
    stun_defense: 5,
    combat_equillibrium: 10,
    posture_change_down_defense: 10,
    dizzy_defense: 5,
    knockdown_defense: 20,
    private_unarmed_combat_difficulty: 100,
    unarmed_toughness: 4,
  },
  schematics: [""]
},
combat_unarmed_speed_04: {
  title: "Teras Kasi Monk",
  skillPoints: 2,
  preReqs: [
    "combat_unarmed_speed_03",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 450000 },
  commands: [
    "private_unarmed_speed_4",
    "unarmedKnockdown2",
  ],
  skillModifiers: {
    private_unarmed_combat_difficulty: 125,
    unarmed_toughness: 4,
  },
  schematics: [""]
},
combat_unarmed_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_unarmed_novice",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 175000 },
  commands: [
    "private_unarmed_ability_1",
    "unarmedDizzy1",
  ],
  skillModifiers: {
    unarmed_damage: 15,
    unarmed_speed: 15,
    private_unarmed_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_unarmed_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_unarmed_ability_01",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 250000 },
  commands: [
    "private_unarmed_ability_2",
    "unarmedCombo1",
  ],
  skillModifiers: {
    unarmed_damage: 15,
    unarmed_speed: 15,
    private_unarmed_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_unarmed_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_unarmed_ability_02",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 350000 },
  commands: [
    "private_unarmed_ability_3",
    "unarmedSpinAttack2",
  ],
  skillModifiers: {
    unarmed_damage: 15,
    unarmed_speed: 15,
    private_unarmed_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_unarmed_ability_04: {
  title: "Teras Kasi Expert",
  skillPoints: 2,
  preReqs: [
    "combat_unarmed_ability_03",
  ],
  xp: { id: "combat_meleespecialize_unarmed", cost: 450000 },
  commands: [
    "private_unarmed_ability_4",
    "unarmedCombo2",
  ],
  skillModifiers: {
    unarmed_damage: 15,
    unarmed_speed: 15,
    private_unarmed_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_unarmed_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_unarmed_novice",
  ],
  xp: { id: "combat_general", cost: 60000 },
  commands: [
    "private_unarmed_support_1",
    "unarmedBodyHit1",
  ],
  skillModifiers: {
    melee_defense: 15,
    ranged_defense: 5,
    unarmed_accuracy: 30,
    private_unarmed_combat_difficulty: 125,
    unarmed_passive_defense: 15,
    unarmed_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 2,
  },
  schematics: [""]
},
combat_unarmed_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_unarmed_support_01",
  ],
  xp: { id: "combat_general", cost: 85000 },
  commands: [
    "private_unarmed_support_2",
    "unarmedLegHit1",
  ],
  skillModifiers: {
    private_unarmed_combat_difficulty: 100,
    melee_defense: 15,
    ranged_defense: 10,
    unarmed_accuracy: 20,
    unarmed_toughness: 5,
    unarmed_passive_defense: 11,
    unarmed_center_of_being_efficacy: 5,
    center_of_being_duration_unarmed: 2,
  },
  schematics: [""]
},
combat_unarmed_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_unarmed_support_02",
  ],
  xp: { id: "combat_general", cost: 120000 },
  commands: [
    "private_unarmed_support_3",
  ],
  skillModifiers: {
    melee_defense: 15,
    ranged_defense: 15,
    unarmed_accuracy: 30,
    private_unarmed_combat_difficulty: 100,
    unarmed_passive_defense: 15,
    unarmed_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 2,
  },
  schematics: [""]
},
combat_unarmed_support_04: {
  title: "Teras Kasi Warrior",
  skillPoints: 2,
  preReqs: [
    "combat_unarmed_support_03",
  ],
  xp: { id: "combat_general", cost: 150000 },
  commands: [
    "private_unarmed_support_4",
    "unarmedHeadHit1",
  ],
  skillModifiers: {
    private_unarmed_combat_difficulty: 100,
    melee_defense: 15,
    ranged_defense: 15,
    unarmed_accuracy: 20,
    unarmed_toughness: 5,
    unarmed_passive_defense: 15,
    unarmed_center_of_being_efficacy: 10,
    center_of_being_duration_unarmed: 1,
  },
  schematics: [""]
},
combat_1hsword_novice: {
  title: "Novice Fencer",
  skillPoints: 6,
  preReqs: [
    "combat_brawler_1handmelee_04",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 125000 },
  commands: [
    "private_1hand_novice",
    "melee1hHit2",
    "cert_baton_stun",
  ],
  skillModifiers: {
    onehandmelee_accuracy: 20,
    onehandmelee_speed: 5,
    melee_defense: 15,
    ranged_defense: 15,
    dodge: 15,
    private_onehandmelee_combat_difficulty: 100,
    onehandmelee_toughness: 4,
    center_of_being_duration_onehandmelee: 5,
    onehandmelee_center_of_being_efficacy: 15,
  },
  schematics: [""]
},
combat_1hsword_master: {
  title: "Master Fencer",
  skillPoints: 1,
  preReqs: [
    "combat_1hsword_accuracy_04",
    "combat_1hsword_speed_04",
    "combat_1hsword_ability_04",
    "combat_1hsword_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_1hand_master",
    "melee1hHit3",
    "melee_damage_mitigation_3",
  ],
  skillModifiers: {
    onehandmelee_accuracy: 20,
    onehandmelee_speed: 5,
    alert: 10,
    melee_defense: 5,
    combat_equillibrium: 10,
    dodge: 15,
    private_onehandmelee_combat_difficulty: 100,
    center_of_being_duration_onehandmelee: 5,
    onehandmelee_center_of_being_efficacy: 15,
  },
  schematics: [""]
},
combat_1hsword_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_1hsword_novice",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 175000 },
  commands: [
    "private_1hand_accuracy_1",
    "melee1hScatterHit1",
  ],
  skillModifiers: {
    melee_defense: 12,
    ranged_defense: 12,
    private_onehandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_1hsword_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_1hsword_accuracy_01",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 250000 },
  commands: [
    "private_1hand_accuracy_2",
  ],
  skillModifiers: {
    ranged_defense: 15,
    melee_defense: 15,
    private_onehandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_1hsword_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_1hsword_accuracy_02",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 350000 },
  commands: [
    "private_1hand_accuracy_3",
    "melee1hDizzyHit2",
  ],
  skillModifiers: {
    melee_defense: 12,
    ranged_defense: 12,
    private_onehandmelee_combat_difficulty: 100,
    onehandmelee_toughness: 4,
  },
  schematics: [""]
},
combat_1hsword_accuracy_04: {
  title: "Duelist",
  skillPoints: 2,
  preReqs: [
    "combat_1hsword_accuracy_03",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 450000 },
  commands: [
    "private_1hand_accuracy_4",
    "melee1hScatterHit2",
  ],
  skillModifiers: {
    ranged_defense: 15,
    melee_defense: 15,
    private_onehandmelee_combat_difficulty: 125,
    onehandmelee_toughness: 4,
  },
  schematics: [""]
},
combat_1hsword_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_1hsword_novice",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 175000 },
  commands: [
    "private_1hand_speed_1",
    "melee1hHealthHit1",
  ],
  skillModifiers: {
    onehandmelee_speed: 5,
    private_onehandmelee_combat_difficulty: 125,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 5,
  },
  schematics: [""]
},
combat_1hsword_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_1hsword_speed_01",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 250000 },
  commands: [
    "private_1hand_speed_2",
  ],
  skillModifiers: {
    posture_change_down_defense: 20,
    knockdown_defense: 20,
    onehandmelee_speed: 20,
    private_onehandmelee_combat_difficulty: 100,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_1hsword_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_1hsword_speed_02",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 350000 },
  commands: [
    "private_1hand_speed_3",
    "melee1hSpinAttack2",
  ],
  skillModifiers: {
    private_onehandmelee_combat_difficulty: 100,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_1hsword_speed_04: {
  title: "Swashbuckler",
  skillPoints: 2,
  preReqs: [
    "combat_1hsword_speed_03",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 450000 },
  commands: [
    "private_1hand_speed_4",
    "melee1hHealthHit2",
  ],
  skillModifiers: {
    posture_change_down_defense: 30,
    knockdown_defense: 30,
    onehandmelee_speed: 20,
    dodge: 15,
    private_onehandmelee_combat_difficulty: 125,
    center_of_being_duration_onehandmelee: 2,
    onehandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_1hsword_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_1hsword_novice",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 175000 },
  commands: [
    "private_1hand_ability_1",
    "melee1hBodyHit2",
    "melee_damage_mitigation_1",
  ],
  skillModifiers: {
    private_onehandmelee_combat_difficulty: 125,
    dodge: 15,
  },
  schematics: [""]
},
combat_1hsword_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_1hsword_ability_01",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 250000 },
  commands: [
    "private_1hand_ability_2",
  ],
  skillModifiers: {
    blind_defense: 10,
    dizzy_defense: 10,
    intimidate_defense: 10,
    private_onehandmelee_combat_difficulty: 100,
    dodge: 15,
  },
  schematics: [""]
},
combat_1hsword_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_1hsword_ability_02",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 350000 },
  commands: [
    "private_1hand_ability_3",
    "melee1hBodyHit3",
    "melee_damage_mitigation_2",
  ],
  skillModifiers: {
    private_onehandmelee_combat_difficulty: 100,
    dodge: 15,
  },
  schematics: [""]
},
combat_1hsword_ability_04: {
  title: "Bladesmaster",
  skillPoints: 2,
  preReqs: [
    "combat_1hsword_ability_03",
  ],
  xp: { id: "combat_meleespecialize_onehand", cost: 450000 },
  commands: [
    "private_1hand_ability_4",
  ],
  skillModifiers: {
    blind_defense: 30,
    dizzy_defense: 30,
    intimidate_defense: 10,
    dodge: 15,
    private_onehandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_1hsword_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_1hsword_novice",
  ],
  xp: { id: "combat_general", cost: 60000 },
  commands: [
    "private_1hand_support_1",
    "melee1hBlindHit1",
  ],
  skillModifiers: {
    private_onehandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_1hsword_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_1hsword_support_01",
  ],
  xp: { id: "combat_general", cost: 85000 },
  commands: [
    "private_1hand_support_2",
  ],
  skillModifiers: {
    combat_equillibrium: 10,
    onehandmelee_accuracy: 30,
    private_onehandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_1hsword_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_1hsword_support_02",
  ],
  xp: { id: "combat_general", cost: 120000 },
  commands: [
    "private_1hand_support_3",
    "melee1hBlindHit2",
  ],
  skillModifiers: {
    private_onehandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_1hsword_support_04: {
  title: "Blade Weaver",
  skillPoints: 2,
  preReqs: [
    "combat_1hsword_support_03",
  ],
  xp: { id: "combat_general", cost: 150000 },
  commands: [
    "private_1hand_support_4",
  ],
  skillModifiers: {
    combat_equillibrium: 10,
    onehandmelee_accuracy: 30,
    private_onehandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_2hsword_novice: {
  title: "Novice Swordsman",
  skillPoints: 6,
  preReqs: [
    "combat_brawler_2handmelee_04",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 125000 },
  commands: [
    "private_2hand_novice",
    "melee2hHit2",
    "cert_sword_2h_maul",
  ],
  skillModifiers: {
    twohandmelee_accuracy: 15,
    twohandmelee_speed: 5,
    melee_defense: 5,
    counterattack: 15,
    private_twohandmelee_combat_difficulty: 100,
    twohandmelee_toughness: 15,
    center_of_being_duration_twohandmelee: 5,
    twohandmelee_center_of_being_efficacy: 15,
  },
  schematics: [""]
},
combat_2hsword_master: {
  title: "Master Swordsman",
  skillPoints: 1,
  preReqs: [
    "combat_2hsword_accuracy_04",
    "combat_2hsword_speed_04",
    "combat_2hsword_ability_04",
    "combat_2hsword_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_2hand_master",
    "melee2hHit3",
    "melee_damage_mitigation_3",
  ],
  skillModifiers: {
    twohandmelee_accuracy: 15,
    twohandmelee_speed: 5,
    melee_defense: 5,
    stun_defense: 30,
    blind_defense: 10,
    knockdown_defense: 10,
    ranged_defense: 5,
    counterattack: 25,
    private_twohandmelee_combat_difficulty: 100,
    center_of_being_duration_twohandmelee: 5,
    twohandmelee_center_of_being_efficacy: 15,
  },
  schematics: [""]
},
combat_2hsword_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_2hsword_novice",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 175000 },
  commands: [
    "private_2hand_accuracy_1",
    "melee2hArea1",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_2hsword_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_2hsword_accuracy_01",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 250000 },
  commands: [
    "private_2hand_accuracy_2",
    "melee2hArea2",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_2hsword_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_2hsword_accuracy_02",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 350000 },
  commands: [
    "private_2hand_accuracy_3",
  ],
  skillModifiers: {
    intimidate_defense: 20,
    dizzy_defense: 20,
    stun_defense: 20,
    private_twohandmelee_combat_difficulty: 100,
    twohandmelee_toughness: 4,
  },
  schematics: [""]
},
combat_2hsword_accuracy_04: {
  title: "Cleaver",
  skillPoints: 2,
  preReqs: [
    "combat_2hsword_accuracy_03",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 450000 },
  commands: [
    "private_2hand_accuracy_4",
    "melee2hArea3",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 125,
    twohandmelee_toughness: 4,
  },
  schematics: [""]
},
combat_2hsword_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_2hsword_novice",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 175000 },
  commands: [
    "private_2hand_speed_1",
    "melee2hHeadHit2",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_2hsword_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_2hsword_speed_01",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 250000 },
  commands: [
    "private_2hand_speed_2",
  ],
  skillModifiers: {
    twohandmelee_speed: 15,
    private_twohandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_2hsword_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_2hsword_speed_02",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 350000 },
  commands: [
    "melee2hHeadHit3",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_2hsword_speed_04: {
  title: "Battlemaster",
  skillPoints: 2,
  preReqs: [
    "combat_2hsword_speed_03",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    twohandmelee_speed: 15,
    private_twohandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_2hsword_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_2hsword_novice",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 175000 },
  commands: [
    "melee2hSpinAttack2",
    "melee_damage_mitigation_1",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 125,
    counterattack: 15,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_2hsword_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_2hsword_ability_01",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
    ranged_defense: 5,
    posture_change_down_defense: 10,
    private_twohandmelee_combat_difficulty: 100,
    counterattack: 15,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_2hsword_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_2hsword_ability_02",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 350000 },
  commands: [
    "melee2hSweep2",
    "melee_damage_mitigation_2",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 100,
    counterattack: 15,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_2hsword_ability_04: {
  title: "Expert Heavy Swordsman",
  skillPoints: 2,
  preReqs: [
    "combat_2hsword_ability_03",
  ],
  xp: { id: "combat_meleespecialize_twohand", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
    ranged_defense: 5,
    knockdown_defense: 15,
    counterattack: 15,
    private_twohandmelee_combat_difficulty: 125,
    center_of_being_duration_twohandmelee: 2,
    twohandmelee_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_2hsword_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_2hsword_novice",
  ],
  xp: { id: "combat_general", cost: 60000 },
  commands: [
    "melee2hMindHit1",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_2hsword_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_2hsword_support_01",
  ],
  xp: { id: "combat_general", cost: 85000 },
  commands: [
    "",
  ],
  skillModifiers: {
    twohandmelee_accuracy: 20,
    private_twohandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_2hsword_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_2hsword_support_02",
  ],
  xp: { id: "combat_general", cost: 120000 },
  commands: [
    "melee2hMindHit2",
    "cert_sword_2h_scythe",
  ],
  skillModifiers: {
    private_twohandmelee_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_2hsword_support_04: {
  title: "Warrior",
  skillPoints: 2,
  preReqs: [
    "combat_2hsword_support_03",
  ],
  xp: { id: "combat_general", cost: 150000 },
  commands: [
    "",
  ],
  skillModifiers: {
    twohandmelee_accuracy: 30,
    private_twohandmelee_combat_difficulty: 125,
    counterattack: 10,
  },
  schematics: [""]
},
combat_polearm_novice: {
  title: "Novice Pikeman",
  skillPoints: 6,
  preReqs: [
    "combat_brawler_polearm_04",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 125000 },
  commands: [
    "private_polearm_novice",
    "polearmHit2",
    "cert_lance_vibrolance",
  ],
  skillModifiers: {
    polearm_accuracy: 20,
    polearm_speed: 10,
    melee_defense: 5,
    block: 25,
    private_polearm_combat_difficulty: 100,
    polearm_toughness: 10,
    center_of_being_duration_polearm: 5,
    polearm_center_of_being_efficacy: 15,
  },
  schematics: [""]
},
combat_polearm_master: {
  title: "Master Pikeman",
  skillPoints: 1,
  preReqs: [
    "combat_polearm_accuracy_04",
    "combat_polearm_speed_04",
    "combat_polearm_ability_04",
    "combat_polearm_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_polearm_master",
    "polearmHit3",
    "melee_damage_mitigation_3",
  ],
  skillModifiers: {
    polearm_accuracy: 20,
    polearm_speed: 10,
    melee_defense: 15,
    ranged_defense: 15,
    posture_change_down_defense: 10,
    dizzy_defense: 20,
    stun_defense: 30,
    block: 30,
    private_polearm_combat_difficulty: 100,
    center_of_being_duration_polearm: 5,
    polearm_center_of_being_efficacy: 15,
  },
  schematics: [""]
},
combat_polearm_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_polearm_novice",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 175000 },
  commands: [
    "private_polearm_accuracy_1",
    "polearmStun2",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_polearm_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_polearm_accuracy_01",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 250000 },
  commands: [
    "private_polearm_accuracy_2",
  ],
  skillModifiers: {
    polearm_speed: 15,
    private_polearm_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_polearm_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_polearm_accuracy_02",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 350000 },
  commands: [
    "private_polearm_accuracy_3",
    "polearmSpinAttack2",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_polearm_accuracy_04: {
  title: "Heavy Cleaver",
  skillPoints: 2,
  preReqs: [
    "combat_polearm_accuracy_03",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 450000 },
  commands: [
    "private_polearm_accuracy_4",
  ],
  skillModifiers: {
    polearm_speed: 15,
    private_polearm_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_polearm_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_polearm_novice",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 175000 },
  commands: [
    "polearmLegHit2",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_polearm_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_polearm_speed_01",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 250000 },
  commands: [
    "polearmArea1",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_polearm_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_polearm_speed_02",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 350000 },
  commands: [
    "polearmLegHit3",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_polearm_speed_04: {
  title: "Pike Weaver",
  skillPoints: 2,
  preReqs: [
    "combat_polearm_speed_03",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 450000 },
  commands: [
    "polearmArea2",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 125,
  },
  schematics: [""]
},
combat_polearm_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_polearm_novice",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 175000 },
  commands: [
    "polearmSweep1",
    "melee_damage_mitigation_1",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 125,
    block: 15,
    center_of_being_duration_polearm: 2,
    polearm_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_polearm_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_polearm_ability_01",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
    ranged_defense: 5,
    knockdown_defense: 10,
    posture_change_down_defense: 10,
    dizzy_defense: 10,
    stun_defense: 10,
    blind_defense: 10,
    private_polearm_combat_difficulty: 100,
    block: 15,
    center_of_being_duration_polearm: 2,
    polearm_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_polearm_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_polearm_ability_02",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 350000 },
  commands: [
    "polearmSweep2",
    "melee_damage_mitigation_2",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 100,
    block: 15,
    center_of_being_duration_polearm: 2,
    polearm_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_polearm_ability_04: {
  title: "Foot Soldier",
  skillPoints: 2,
  preReqs: [
    "combat_polearm_ability_03",
  ],
  xp: { id: "combat_meleespecialize_polearm", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
    ranged_defense: 5,
    knockdown_defense: 10,
    posture_change_down_defense: 10,
    dizzy_defense: 10,
    stun_defense: 10,
    blind_defense: 10,
    block: 15,
    private_polearm_combat_difficulty: 125,
    polearm_toughness: 4,
    center_of_being_duration_polearm: 2,
    polearm_center_of_being_efficacy: 10,
  },
  schematics: [""]
},
combat_polearm_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_polearm_novice",
  ],
  xp: { id: "combat_general", cost: 60000 },
  commands: [
    "polearmActionHit1",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 125,
    polearm_toughness: 4,
  },
  schematics: [""]
},
combat_polearm_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_polearm_support_01",
  ],
  xp: { id: "combat_general", cost: 85000 },
  commands: [
    "",
  ],
  skillModifiers: {
    polearm_accuracy: 30,
    private_polearm_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_polearm_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_polearm_support_02",
  ],
  xp: { id: "combat_general", cost: 120000 },
  commands: [
    "polearmActionHit2",
  ],
  skillModifiers: {
    private_polearm_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_polearm_support_04: {
  title: "Sentinel",
  skillPoints: 2,
  preReqs: [
    "combat_polearm_support_03",
  ],
  xp: { id: "combat_general", cost: 150000 },
  commands: [
    "",
  ],
  skillModifiers: {
    polearm_accuracy: 30,
    private_polearm_combat_difficulty: 125,
  },
  schematics: [""]
},
social_dancer_novice: {
  title: "Novice Dancer",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_dance_04",
    "social_entertainer_healing_04",
  ],
  xp: { id: "dance", cost: 50000 },
  commands: [
    "startDance+popular",
    "startDance+poplock",
    "registerWithLocation",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
    healing_dance_wound: 5,
    healing_dance_shock: 10,
    healing_dance_mind: 10,
  },
  schematics: [""]
},
social_dancer_master: {
  title: "Master Dancer",
  skillPoints: 0,
  preReqs: [
    "social_dancer_ability_04",
    "social_dancer_wound_04",
    "social_dancer_knowledge_04",
    "social_dancer_shock_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "startDance+lyrical2",
    "startDance+exotic3",
    "startDance+exotic4",
    "place_cantina",
    "place_theater",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
    healing_dance_wound: 15,
    healing_dance_shock: 25,
    healing_dance_mind: 25,
    melee_defense: 7,
    ranged_defense: 7,
    private_place_cantina: 100,
    private_place_theater: 100,
  },
  schematics: [""]
},
social_dancer_ability_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_novice",
  ],
  xp: { id: "dance", cost: 87500 },
  commands: [
    "spotlight",
    "colorlights",
    "dazzle",
  ],
  skillModifiers: {
    healing_dance_mind: 10,
  },
  schematics: [""]
},
social_dancer_ability_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_ability_01",
  ],
  xp: { id: "dance", cost: 125000 },
  commands: [
    "distract",
  ],
  skillModifiers: {
    healing_dance_mind: 10,
  },
  schematics: [""]
},
social_dancer_ability_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_ability_02",
  ],
  xp: { id: "dance", cost: 175000 },
  commands: [
    "smokebomb",
  ],
  skillModifiers: {
    healing_dance_mind: 20,
  },
  schematics: [""]
},
social_dancer_ability_04: {
  title: "Dazzler",
  skillPoints: 0,
  preReqs: [
    "social_dancer_ability_03",
  ],
  xp: { id: "dance", cost: 225000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_mind: 25,
  },
  schematics: [""]
},
social_dancer_wound_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_novice",
  ],
  xp: { id: "entertainer_healing", cost: 25000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_wound: 5,
  },
  schematics: [""]
},
social_dancer_wound_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_wound_01",
  ],
  xp: { id: "entertainer_healing", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_wound: 10,
  },
  schematics: [""]
},
social_dancer_wound_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_wound_02",
  ],
  xp: { id: "entertainer_healing", cost: 100000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_wound: 10,
  },
  schematics: [""]
},
social_dancer_wound_04: {
  title: "Captivator",
  skillPoints: 0,
  preReqs: [
    "social_dancer_wound_03",
  ],
  xp: { id: "entertainer_healing", cost: 125000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_wound: 15,
  },
  schematics: [""]
},
social_dancer_knowledge_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_novice",
  ],
  xp: { id: "dance", cost: 87500 },
  commands: [
    "startDance+popular2",
    "startDance+tumble",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
  },
  schematics: [""]
},
social_dancer_knowledge_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_knowledge_01",
  ],
  xp: { id: "dance", cost: 125000 },
  commands: [
    "startDance+poplock2",
    "startDance+tumble2",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
  },
  schematics: [""]
},
social_dancer_knowledge_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_knowledge_02",
  ],
  xp: { id: "dance", cost: 175000 },
  commands: [
    "startDance+lyrical",
    "startDance+breakdance",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
  },
  schematics: [""]
},
social_dancer_knowledge_04: {
  title: "Choreographer",
  skillPoints: 0,
  preReqs: [
    "social_dancer_knowledge_03",
  ],
  xp: { id: "dance", cost: 225000 },
  commands: [
    "startDance+breakdance2",
    "startDance+exotic",
    "startDance+exotic2",
  ],
  skillModifiers: {
    healing_dance_ability: 10,
  },
  schematics: [""]
},
social_dancer_shock_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_novice",
  ],
  xp: { id: "entertainer_healing", cost: 25000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_shock: 10,
  },
  schematics: [""]
},
social_dancer_shock_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_shock_01",
  ],
  xp: { id: "entertainer_healing", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_shock: 10,
  },
  schematics: [""]
},
social_dancer_shock_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_dancer_shock_02",
  ],
  xp: { id: "entertainer_healing", cost: 100000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_shock: 20,
  },
  schematics: [""]
},
social_dancer_shock_04: {
  title: "Enthraller",
  skillPoints: 0,
  preReqs: [
    "social_dancer_shock_03",
  ],
  xp: { id: "entertainer_healing", cost: 125000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_dance_shock: 25,
  },
  schematics: [""]
},
social_musician_novice: {
  title: "Novice Musician",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_music_04",
    "social_entertainer_healing_04",
  ],
  xp: { id: "music", cost: 50000 },
  commands: [
    "traz",
    "registerWithLocation",
    "startMusic+starwars4",
  ],
  skillModifiers: {
    healing_music_ability: 5,
    healing_music_wound: 5,
    healing_music_shock: 10,
    healing_music_mind: 10,
    instrument_assembly: 10,
  },
  schematics: ["craftInstrumentGroupC"]
},
social_musician_master: {
  title: "Master Musician",
  skillPoints: 0,
  preReqs: [
    "social_musician_ability_04",
    "social_musician_wound_04",
    "social_musician_knowledge_04",
    "social_musician_shock_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "startMusic+virtuoso",
    "nalargon",
    "place_cantina",
    "place_theater",
  ],
  skillModifiers: {
    healing_music_ability: 15,
    healing_music_wound: 15,
    healing_music_shock: 25,
    healing_music_mind: 25,
    instrument_assembly: 25,
    ranged_defense: 7,
    melee_defense: 7,
    private_place_cantina: 100,
    private_place_theater: 100,
  },
  schematics: [""]
},
social_musician_ability_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_novice",
  ],
  xp: { id: "music", cost: 87500 },
  commands: [
    "spotlight",
    "colorlights",
    "dazzle",
  ],
  skillModifiers: {
    instrument_assembly: 10,
    healing_music_mind: 10,
  },
  schematics: [""]
},
social_musician_ability_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_ability_01",
  ],
  xp: { id: "music", cost: 125000 },
  commands: [
    "firejet",
  ],
  skillModifiers: {
    instrument_assembly: 15,
    healing_music_mind: 10,
  },
  schematics: ["craftInstrumentGroupD"]
},
social_musician_ability_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_ability_02",
  ],
  xp: { id: "music", cost: 175000 },
  commands: [
    "ventriloquism",
  ],
  skillModifiers: {
    instrument_assembly: 15,
    healing_music_mind: 20,
  },
  schematics: ["craftInstrumentGroupE"]
},
social_musician_ability_04: {
  title: "Virtuoso",
  skillPoints: 0,
  preReqs: [
    "social_musician_ability_03",
  ],
  xp: { id: "music", cost: 225000 },
  commands: [
    "",
  ],
  skillModifiers: {
    instrument_assembly: 25,
    healing_music_mind: 25,
  },
  schematics: ["craftInstrumentGroupF"]
},
social_musician_wound_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_novice",
  ],
  xp: { id: "entertainer_healing", cost: 25000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_wound: 5,
  },
  schematics: [""]
},
social_musician_wound_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_wound_01",
  ],
  xp: { id: "entertainer_healing", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_wound: 10,
  },
  schematics: [""]
},
social_musician_wound_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_wound_02",
  ],
  xp: { id: "entertainer_healing", cost: 100000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_wound: 10,
  },
  schematics: [""]
},
social_musician_wound_04: {
  title: "Skilled Musician",
  skillPoints: 0,
  preReqs: [
    "social_musician_wound_03",
  ],
  xp: { id: "entertainer_healing", cost: 125000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_wound: 15,
  },
  schematics: [""]
},
social_musician_knowledge_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_novice",
  ],
  xp: { id: "music", cost: 87500 },
  commands: [
    "startMusic+ballad",
  ],
  skillModifiers: {
    healing_music_ability: 5,
  },
  schematics: [""]
},
social_musician_knowledge_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_knowledge_01",
  ],
  xp: { id: "music", cost: 125000 },
  commands: [
    "bandfill",
    "startMusic+funk",
  ],
  skillModifiers: {
    healing_music_ability: 10,
  },
  schematics: [""]
},
social_musician_knowledge_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_knowledge_02",
  ],
  xp: { id: "music", cost: 175000 },
  commands: [
    "startMusic+waltz",
    "flutedroopy",
  ],
  skillModifiers: {
    healing_music_ability: 10,
  },
  schematics: [""]
},
social_musician_knowledge_04: {
  title: "Composer",
  skillPoints: 0,
  preReqs: [
    "social_musician_knowledge_03",
  ],
  xp: { id: "music", cost: 225000 },
  commands: [
    "startMusic+jazz",
    "omnibox",
  ],
  skillModifiers: {
    healing_music_ability: 15,
  },
  schematics: [""]
},
social_musician_shock_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_novice",
  ],
  xp: { id: "entertainer_healing", cost: 25000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_shock: 10,
  },
  schematics: [""]
},
social_musician_shock_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_shock_01",
  ],
  xp: { id: "entertainer_healing", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_shock: 10,
  },
  schematics: [""]
},
social_musician_shock_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_musician_shock_02",
  ],
  xp: { id: "entertainer_healing", cost: 100000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_shock: 20,
  },
  schematics: [""]
},
social_musician_shock_04: {
  title: "Mesmerizer",
  skillPoints: 0,
  preReqs: [
    "social_musician_shock_03",
  ],
  xp: { id: "entertainer_healing", cost: 125000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_music_shock: 25,
  },
  schematics: [""]
},
science_doctor_novice: {
  title: "Novice Doctor",
  skillPoints: 6,
  preReqs: [
    "science_medic_master",
  ],
  xp: { id: "medical", cost: 11250 },
  commands: [
    "healState",
    "registerWithLocation",
  ],
  skillModifiers: {
    healing_wound_treatment: 5,
    healing_wound_speed: 5,
    medicine_assembly: 10,
    medicine_experimentation: 10,
    healing_ability: 5,
  },
  schematics: ["craftCurePoisonGroupA","craftStimpackStateGroupA"]
},
science_doctor_master: {
  title: "Master Doctor",
  skillPoints: 1,
  preReqs: [
    "science_doctor_wound_speed_04",
    "science_doctor_wound_04",
    "science_doctor_ability_04",
    "science_doctor_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "place_hospital",
  ],
  skillModifiers: {
    healing_wound_treatment: 25,
    healing_wound_speed: 25,
    healing_ability: 10,
    private_place_hospital: 100,
  },
  schematics: ["craftMedpackGroupE","craftMedpackBGroupE","craftCureDiseaseGroupC","craftMedpackBEnhanceGroupD"]
},
science_doctor_wound_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_doctor_novice",
  ],
  xp: { id: "medical", cost: 15000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_wound_speed: 15,
  },
  schematics: [""]
},
science_doctor_wound_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_doctor_wound_speed_01",
  ],
  xp: { id: "medical", cost: 30000 },
  commands: [
    "curePoison",
  ],
  skillModifiers: {
    healing_wound_speed: 15,
  },
  schematics: [""]
},
science_doctor_wound_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_doctor_wound_speed_02",
  ],
  xp: { id: "medical", cost: 45000 },
  commands: [
    "extinguishFire",
  ],
  skillModifiers: {
    healing_wound_speed: 15,
  },
  schematics: [""]
},
science_doctor_wound_speed_04: {
  title: "Field Surgeon",
  skillPoints: 2,
  preReqs: [
    "science_doctor_wound_speed_03",
  ],
  xp: { id: "medical", cost: 60000 },
  commands: [
    "cureDisease",
  ],
  skillModifiers: {
    healing_wound_speed: 25,
  },
  schematics: [""]
},
science_doctor_wound_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_doctor_novice",
  ],
  xp: { id: "medical", cost: 15000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_wound_treatment: 10,
  },
  schematics: [""]
},
science_doctor_wound_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_doctor_wound_01",
  ],
  xp: { id: "medical", cost: 30000 },
  commands: [
    "healEnhance",
  ],
  skillModifiers: {
    healing_wound_treatment: 15,
  },
  schematics: [""]
},
science_doctor_wound_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_doctor_wound_02",
  ],
  xp: { id: "medical", cost: 45000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_wound_treatment: 15,
  },
  schematics: [""]
},
science_doctor_wound_04: {
  title: "Master Surgeon",
  skillPoints: 2,
  preReqs: [
    "science_doctor_wound_03",
  ],
  xp: { id: "medical", cost: 60000 },
  commands: [
    "revivePlayer",
  ],
  skillModifiers: {
    healing_wound_treatment: 25,
  },
  schematics: [""]
},
science_doctor_ability_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_doctor_novice",
  ],
  xp: { id: "medical", cost: 15000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_ability: 5,
  },
  schematics: [""]
},
science_doctor_ability_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_doctor_ability_01",
  ],
  xp: { id: "medical", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_ability: 10,
  },
  schematics: [""]
},
science_doctor_ability_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_doctor_ability_02",
  ],
  xp: { id: "medical", cost: 45000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_ability: 10,
  },
  schematics: [""]
},
science_doctor_ability_04: {
  title: "Medical Professor",
  skillPoints: 2,
  preReqs: [
    "science_doctor_ability_03",
  ],
  xp: { id: "medical", cost: 60000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_ability: 10,
  },
  schematics: [""]
},
science_doctor_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_doctor_novice",
  ],
  xp: { id: "crafting_medicine_general", cost: 15000 },
  commands: [
    "",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftCureDiseaseGroupA","craftMedpackEnhanceGroupA","craftStimpackStateGroupB"]
},
science_doctor_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_doctor_support_01",
  ],
  xp: { id: "crafting_medicine_general", cost: 21000 },
  commands: [
    "",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftMedpackGroupC","craftCurePoisonGroupB","craftMedpackEnhanceGroupB","craftMedpackBEnhanceGroupA"]
},
science_doctor_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_doctor_support_02",
  ],
  xp: { id: "crafting_medicine_general", cost: 27000 },
  commands: [
    "",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftMedicineStimpackGroupE","craftMedpackBGroupC","craftCureDiseaseGroupB","craftMedpackEnhanceGroupC","craftMedpackBEnhanceGroupB"]
},
science_doctor_support_04: {
  title: "Master Chemist",
  skillPoints: 2,
  preReqs: [
    "science_doctor_support_03",
  ],
  xp: { id: "crafting_medicine_general", cost: 33000 },
  commands: [
    "",
  ],
  skillModifiers: {
    medicine_assembly: 10,
    medicine_experimentation: 10,
  },
  schematics: ["craftMedpackGroupD","craftMedpackBGroupD","craftCurePoisonGroupC","craftMedpackEnhanceGroupD","craftMedpackBEnhanceGroupC"]
},
outdoors_ranger_novice: {
  title: "Novice Ranger",
  skillPoints: 6,
  preReqs: [
    "outdoors_scout_master",
  ],
  xp: { id: "scout", cost: 15000 },
  commands: [
    "areatrack",
    "areatrack_animal",
  ],
  skillModifiers: {
    slope_move: 5,
    camp: 5,
    foraging: 5,
    creature_knowledge: 5,
    creature_harvesting: 5,
    private_areatrack: 10,
  },
  schematics: ["craftRangerCampGroupA"]
},
outdoors_ranger_master: {
  title: "Master Ranger",
  skillPoints: 1,
  preReqs: [
    "outdoors_ranger_movement_04",
    "outdoors_ranger_tracking_04",
    "outdoors_ranger_harvest_04",
    "outdoors_ranger_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    camouflage: 20,
    camp: 5,
    foraging: 5,
    creature_knowledge: 10,
    creature_harvesting: 60,
    trapping: 10,
    rescue: 10,
    ranged_defense: 10,
    melee_defense: 10,
  },
  schematics: ["craftRangerCamoGroupMaster"]
},
outdoors_ranger_movement_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_ranger_novice",
  ],
  xp: { id: "scout", cost: 20000 },
  commands: [
    "conceal",
  ],
  skillModifiers: {
    camouflage: 40,
  },
  schematics: ["craftRangerCamoGroupA"]
},
outdoors_ranger_movement_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_ranger_movement_01",
  ],
  xp: { id: "scout", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    slope_move: 20,
    burst_run: 10,
  },
  schematics: ["craftRangerCamoGroupB"]
},
outdoors_ranger_movement_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_ranger_movement_02",
  ],
  xp: { id: "scout", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    camouflage: 40,
  },
  schematics: ["craftRangerCamoGroupC"]
},
outdoors_ranger_movement_04: {
  title: "Wayfarer",
  skillPoints: 2,
  preReqs: [
    "outdoors_ranger_movement_03",
  ],
  xp: { id: "scout", cost: 70000 },
  commands: [
    "",
  ],
  skillModifiers: {
    slope_move: 20,
    burst_run: 10,
  },
  schematics: ["craftRangerCamoGroupD"]
},
outdoors_ranger_tracking_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_ranger_novice",
  ],
  xp: { id: "camp", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    camp: 10,
    foraging: 10,
  },
  schematics: [""]
},
outdoors_ranger_tracking_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_ranger_tracking_01",
  ],
  xp: { id: "camp", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    camp: 10,
    foraging: 10,
  },
  schematics: ["craftRangerCampGroupB"]
},
outdoors_ranger_tracking_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_ranger_tracking_02",
  ],
  xp: { id: "camp", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    camp: 10,
    foraging: 10,
  },
  schematics: [""]
},
outdoors_ranger_tracking_04: {
  title: "Frontiersman",
  skillPoints: 2,
  preReqs: [
    "outdoors_ranger_tracking_03",
  ],
  xp: { id: "camp", cost: 60000 },
  commands: [
    "",
  ],
  skillModifiers: {
    camp: 10,
    foraging: 10,
  },
  schematics: ["craftRangerCampGroupC"]
},
outdoors_ranger_harvest_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_ranger_novice",
  ],
  xp: { id: "scout", cost: 20000 },
  commands: [
    "areatrack_direction",
  ],
  skillModifiers: {
    creature_knowledge: 5,
    creature_harvesting: 5,
    private_areatrack: 10,
  },
  schematics: [""]
},
outdoors_ranger_harvest_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_ranger_harvest_01",
  ],
  xp: { id: "scout", cost: 30000 },
  commands: [
    "areatrack_npc",
  ],
  skillModifiers: {
    creature_knowledge: 10,
    creature_harvesting: 10,
    creature_hit_bonus: 10,
    private_areatrack: 10,
  },
  schematics: [""]
},
outdoors_ranger_harvest_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_ranger_harvest_02",
  ],
  xp: { id: "scout", cost: 50000 },
  commands: [
    "areatrack_distance",
  ],
  skillModifiers: {
    creature_knowledge: 10,
    creature_harvesting: 10,
    private_areatrack: 10,
  },
  schematics: [""]
},
outdoors_ranger_harvest_04: {
  title: "Tracker",
  skillPoints: 2,
  preReqs: [
    "outdoors_ranger_harvest_03",
  ],
  xp: { id: "scout", cost: 70000 },
  commands: [
    "areatrack_player",
  ],
  skillModifiers: {
    creature_knowledge: 10,
    creature_harvesting: 10,
    creature_hit_bonus: 5,
    private_areatrack: 10,
  },
  schematics: [""]
},
outdoors_ranger_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_ranger_novice",
  ],
  xp: { id: "trapping", cost: 20000 },
  commands: [
    "rescue",
  ],
  skillModifiers: {
    trapping: 10,
    rescue: 10,
  },
  schematics: [""]
},
outdoors_ranger_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_ranger_support_01",
  ],
  xp: { id: "trapping", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    trapping: 10,
    rescue: 10,
  },
  schematics: ["craftRangerTrapGroupA"]
},
outdoors_ranger_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_ranger_support_02",
  ],
  xp: { id: "trapping", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    trapping: 10,
    rescue: 10,
  },
  schematics: ["craftRangerTrapGroupB"]
},
outdoors_ranger_support_04: {
  title: "Trap Master",
  skillPoints: 2,
  preReqs: [
    "outdoors_ranger_support_03",
  ],
  xp: { id: "trapping", cost: 70000 },
  commands: [
    "",
  ],
  skillModifiers: {
    trapping: 10,
    rescue: 10,
  },
  schematics: [""]
},
outdoors_creaturehandler_novice: {
  title: "Novice Creature Handler",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_movement_04",
    "outdoors_scout_harvest_04",
  ],
  xp: { id: "scout", cost: 17500 },
  commands: [
    "pet_follow",
    "pet_release",
    "pet_attack",
    "tame",
  ],
  skillModifiers: {
    stored_pets: 4,
    keep_creature: 1,
    tame_non_aggro: 5,
    tame_level: 12,
  },
  schematics: [""]
},
outdoors_creaturehandler_master: {
  title: "Master Creature Handler",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_taming_04",
    "outdoors_creaturehandler_training_04",
    "outdoors_creaturehandler_healing_04",
    "outdoors_creaturehandler_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "pet_transfer",
    "pet_rangedattack",
  ],
  skillModifiers: {
    keep_creature: 1,
    tame_non_aggro: 5,
    tame_aggro: 15,
    private_creature_empathy: 10,
    private_creature_training: 10,
    private_creature_management: 10,
    tame_level: 10,
    stored_pets: 4,
  },
  schematics: [""]
},
outdoors_creaturehandler_taming_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_novice",
  ],
  xp: { id: "creaturehandler", cost: 17500 },
  commands: [
    "",
  ],
  skillModifiers: {
    tame_non_aggro: 5,
    tame_level: 2,
  },
  schematics: [""]
},
outdoors_creaturehandler_taming_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_taming_01",
  ],
  xp: { id: "creaturehandler", cost: 52500 },
  commands: [
    "",
  ],
  skillModifiers: {
    tame_non_aggro: 5,
    tame_aggro: 10,
    tame_level: 2,
  },
  schematics: [""]
},
outdoors_creaturehandler_taming_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_taming_02",
  ],
  xp: { id: "creaturehandler", cost: 87500 },
  commands: [
    "pet_specialattack1",
  ],
  skillModifiers: {
    tame_non_aggro: 5,
    tame_aggro: 10,
    tame_level: 3,
  },
  schematics: [""]
},
outdoors_creaturehandler_taming_04: {
  title: "Creature Tamer",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_taming_03",
  ],
  xp: { id: "creaturehandler", cost: 140000 },
  commands: [
    "pet_specialattack2",
  ],
  skillModifiers: {
    tame_non_aggro: 5,
    tame_aggro: 15,
    tame_level: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_training_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_novice",
  ],
  xp: { id: "creaturehandler", cost: 17500 },
  commands: [
    "pet_stay",
  ],
  skillModifiers: {
    private_creature_training: 10,
    tame_level: 2,
    stored_pets: 2,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_training_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_training_01",
  ],
  xp: { id: "creaturehandler", cost: 52500 },
  commands: [
    "pet_guard",
  ],
  skillModifiers: {
    stored_pets: 3,
    private_creature_training: 10,
    tame_level: 2,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_training_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_training_02",
  ],
  xp: { id: "creaturehandler", cost: 87500 },
  commands: [
    "pet_patrol",
  ],
  skillModifiers: {
    private_creature_training: 10,
    tame_level: 3,
    stored_pets: 3,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_training_04: {
  title: "Creature Trainer",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_training_03",
  ],
  xp: { id: "creaturehandler", cost: 140000 },
  commands: [
    "pet_formation",
  ],
  skillModifiers: {
    stored_pets: 4,
    private_creature_training: 10,
    tame_level: 5,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_healing_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_novice",
  ],
  xp: { id: "creaturehandler", cost: 17500 },
  commands: [
    "trick1",
  ],
  skillModifiers: {
    private_creature_empathy: 10,
    tame_level: 2,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_healing_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_healing_01",
  ],
  xp: { id: "creaturehandler", cost: 52500 },
  commands: [
    "emboldenpets",
  ],
  skillModifiers: {
    private_creature_empathy: 10,
    tame_level: 2,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_healing_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_healing_02",
  ],
  xp: { id: "creaturehandler", cost: 87500 },
  commands: [
    "trick2",
  ],
  skillModifiers: {
    private_creature_empathy: 10,
    tame_level: 3,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_healing_04: {
  title: "Creature Empath",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_healing_03",
  ],
  xp: { id: "creaturehandler", cost: 140000 },
  commands: [
    "enragepets",
  ],
  skillModifiers: {
    private_creature_empathy: 10,
    tame_level: 5,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_support_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_novice",
  ],
  xp: { id: "creaturehandler", cost: 17500 },
  commands: [
    "pet_group",
  ],
  skillModifiers: {
    private_creature_management: 10,
    tame_level: 2,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_support_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_support_01",
  ],
  xp: { id: "creaturehandler", cost: 52500 },
  commands: [
    "pet_followother",
  ],
  skillModifiers: {
    private_creature_management: 10,
    tame_level: 2,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_support_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_support_02",
  ],
  xp: { id: "creaturehandler", cost: 87500 },
  commands: [
    "pet_friend",
  ],
  skillModifiers: {
    keep_creature: 1,
    private_creature_management: 10,
    tame_level: 3,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_creaturehandler_support_04: {
  title: "Pack Master",
  skillPoints: 1,
  preReqs: [
    "outdoors_creaturehandler_support_03",
  ],
  xp: { id: "creaturehandler", cost: 140000 },
  commands: [
    "train_mount",
  ],
  skillModifiers: {
    private_creature_management: 10,
    tame_level: 5,
    tame_non_aggro: 5,
  },
  schematics: [""]
},
outdoors_bio_engineer_novice: {
  title: "Novice Bio-Engineer",
  skillPoints: 6,
  preReqs: [
    "outdoors_scout_harvest_04",
    "science_medic_crafting_04",
  ],
  xp: { id: "crafting_medicine_general", cost: 10000 },
  commands: [
    "sampleDNA",
  ],
  skillModifiers: {
    bio_engineer_assembly: 10,
    bio_engineer_experimentation: 10,
    dna_harvesting: 15,
  },
  schematics: ["craftBasicTissueGroup","craftBasicCreatureGroup"]
},
outdoors_bio_engineer_master: {
  title: "Master Bio-Engineer",
  skillPoints: 1,
  preReqs: [
    "outdoors_bio_engineer_creature_04",
    "outdoors_bio_engineer_tissue_04",
    "outdoors_bio_engineer_dna_harvesting_04",
    "outdoors_bio_engineer_production_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    bio_engineer_assembly: 25,
    bio_engineer_experimentation: 25,
    dna_harvesting: 25,
  },
  schematics: ["craftAdvancedTissueGroup","craftAdvancedCreatureGroup"]
},
outdoors_bio_engineer_creature_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_bio_engineer_novice",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftDomesticCreatureGroupA"]
},
outdoors_bio_engineer_creature_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_bio_engineer_creature_01",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftAggressiveCreatureGroupA"]
},
outdoors_bio_engineer_creature_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_bio_engineer_creature_02",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftDomesticCreatureGroupB"]
},
outdoors_bio_engineer_creature_04: {
  title: "Breeder",
  skillPoints: 2,
  preReqs: [
    "outdoors_bio_engineer_creature_03",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 80000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftAggressiveCreatureGroupB"]
},
outdoors_bio_engineer_tissue_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_bio_engineer_novice",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftTissueGroupA"]
},
outdoors_bio_engineer_tissue_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_bio_engineer_tissue_01",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftTissueGroupB"]
},
outdoors_bio_engineer_tissue_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_bio_engineer_tissue_02",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftTissueGroupC"]
},
outdoors_bio_engineer_tissue_04: {
  title: "Expert Bio-Engineer",
  skillPoints: 2,
  preReqs: [
    "outdoors_bio_engineer_tissue_03",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 80000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftTissueGroupD"]
},
outdoors_bio_engineer_dna_harvesting_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_bio_engineer_novice",
  ],
  xp: { id: "bio_engineer_dna_harvesting", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    dna_harvesting: 15,
  },
  schematics: [""]
},
outdoors_bio_engineer_dna_harvesting_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_bio_engineer_dna_harvesting_01",
  ],
  xp: { id: "bio_engineer_dna_harvesting", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    dna_harvesting: 15,
  },
  schematics: [""]
},
outdoors_bio_engineer_dna_harvesting_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_bio_engineer_dna_harvesting_02",
  ],
  xp: { id: "bio_engineer_dna_harvesting", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    dna_harvesting: 15,
  },
  schematics: [""]
},
outdoors_bio_engineer_dna_harvesting_04: {
  title: "Field Scientist",
  skillPoints: 2,
  preReqs: [
    "outdoors_bio_engineer_dna_harvesting_03",
  ],
  xp: { id: "bio_engineer_dna_harvesting", cost: 80000 },
  commands: [
    "",
  ],
  skillModifiers: {
    dna_harvesting: 15,
  },
  schematics: [""]
},
outdoors_bio_engineer_production_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "outdoors_bio_engineer_novice",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    bio_engineer_assembly: 10,
    bio_engineer_experimentation: 10,
  },
  schematics: [""]
},
outdoors_bio_engineer_production_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "outdoors_bio_engineer_production_01",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    bio_engineer_assembly: 15,
    bio_engineer_experimentation: 15,
  },
  schematics: [""]
},
outdoors_bio_engineer_production_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "outdoors_bio_engineer_production_02",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    bio_engineer_assembly: 15,
    bio_engineer_experimentation: 15,
  },
  schematics: [""]
},
outdoors_bio_engineer_production_04: {
  title: "Geneticist",
  skillPoints: 2,
  preReqs: [
    "outdoors_bio_engineer_production_03",
  ],
  xp: { id: "crafting_bio_engineer_creature", cost: 80000 },
  commands: [
    "",
  ],
  skillModifiers: {
    bio_engineer_assembly: 25,
    bio_engineer_experimentation: 25,
  },
  schematics: [""]
},
crafting_armorsmith_novice: {
  title: "Novice Armorsmith",
  skillPoints: 6,
  preReqs: [
    "crafting_artisan_engineering_04",
  ],
  xp: { id: "crafting_general", cost: 16800 },
  commands: [
    "",
  ],
  skillModifiers: {
    armor_assembly: 10,
    armor_experimentation: 10,
    armor_customization: 20,
  },
  schematics: ["craftArmorPersonalGroupA"]
},
crafting_armorsmith_master: {
  title: "Master Armorsmith",
  skillPoints: 1,
  preReqs: [
    "crafting_armorsmith_personal_04",
    "crafting_armorsmith_heavy_04",
    "crafting_armorsmith_deflectors_04",
    "crafting_armorsmith_complexity_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    armor_assembly: 25,
    armor_experimentation: 25,
    armor_customization: 55,
  },
  schematics: ["craftArmorLightLayersGroupE","craftArmorPersonalGroupF"]
},
crafting_armorsmith_personal_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_armorsmith_novice",
  ],
  xp: { id: "crafting_clothing_armor", cost: 28000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorPersonalGroupB"]
},
crafting_armorsmith_personal_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_armorsmith_personal_01",
  ],
  xp: { id: "crafting_clothing_armor", cost: 39200 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorPersonalGroupC"]
},
crafting_armorsmith_personal_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_armorsmith_personal_02",
  ],
  xp: { id: "crafting_clothing_armor", cost: 50400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorPersonalGroupD"]
},
crafting_armorsmith_personal_04: {
  title: "Master of Armor Design",
  skillPoints: 2,
  preReqs: [
    "crafting_armorsmith_personal_03",
  ],
  xp: { id: "crafting_clothing_armor", cost: 61600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorPersonalGroupE"]
},
crafting_armorsmith_heavy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_armorsmith_novice",
  ],
  xp: { id: "crafting_clothing_armor", cost: 28000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorLightLayersGroupA"]
},
crafting_armorsmith_heavy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_armorsmith_heavy_01",
  ],
  xp: { id: "crafting_clothing_armor", cost: 39200 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorLightLayersGroupB"]
},
crafting_armorsmith_heavy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_armorsmith_heavy_02",
  ],
  xp: { id: "crafting_clothing_armor", cost: 50400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorLightLayersGroupC"]
},
crafting_armorsmith_heavy_04: {
  title: "Materials Specialist",
  skillPoints: 2,
  preReqs: [
    "crafting_armorsmith_heavy_03",
  ],
  xp: { id: "crafting_clothing_armor", cost: 61600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorLightLayersGroupD"]
},
crafting_armorsmith_deflectors_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_armorsmith_novice",
  ],
  xp: { id: "crafting_clothing_armor", cost: 28000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorShieldsGroupA"]
},
crafting_armorsmith_deflectors_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_armorsmith_deflectors_01",
  ],
  xp: { id: "crafting_clothing_armor", cost: 39200 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorShieldsGroupB"]
},
crafting_armorsmith_deflectors_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_armorsmith_deflectors_02",
  ],
  xp: { id: "crafting_clothing_armor", cost: 50400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorShieldsGroupC"]
},
crafting_armorsmith_deflectors_04: {
  title: "Deflector Technologist",
  skillPoints: 2,
  preReqs: [
    "crafting_armorsmith_deflectors_03",
  ],
  xp: { id: "crafting_clothing_armor", cost: 61600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftArmorShieldsGroupD"]
},
crafting_armorsmith_complexity_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_armorsmith_novice",
  ],
  xp: { id: "crafting_clothing_armor", cost: 28000 },
  commands: [
    "",
  ],
  skillModifiers: {
    armor_assembly: 10,
    armor_experimentation: 10,
    armor_customization: 20,
  },
  schematics: [""]
},
crafting_armorsmith_complexity_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_armorsmith_complexity_01",
  ],
  xp: { id: "crafting_clothing_armor", cost: 39200 },
  commands: [
    "",
  ],
  skillModifiers: {
    armor_assembly: 15,
    armor_experimentation: 15,
    armor_customization: 20,
  },
  schematics: [""]
},
crafting_armorsmith_complexity_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_armorsmith_complexity_02",
  ],
  xp: { id: "crafting_clothing_armor", cost: 50400 },
  commands: [
    "",
  ],
  skillModifiers: {
    armor_assembly: 20,
    armor_experimentation: 20,
    armor_customization: 20,
  },
  schematics: [""]
},
crafting_armorsmith_complexity_04: {
  title: "Expert Armorsmith",
  skillPoints: 2,
  preReqs: [
    "crafting_armorsmith_complexity_03",
  ],
  xp: { id: "crafting_clothing_armor", cost: 61600 },
  commands: [
    "",
  ],
  skillModifiers: {
    armor_assembly: 20,
    armor_experimentation: 20,
    armor_customization: 20,
  },
  schematics: [""]
},
crafting_weaponsmith_novice: {
  title: "Novice Weaponsmith",
  skillPoints: 6,
  preReqs: [
    "crafting_artisan_engineering_04",
  ],
  xp: { id: "crafting_general", cost: 21000 },
  commands: [
    "",
  ],
  skillModifiers: {
    weapon_assembly: 10,
    weapon_experimentation: 10,
  },
  schematics: ["craftWeaponMeleeGroupA","craftWeaponRangedGroupA","craftMunitionsGroupA"]
},
crafting_weaponsmith_master: {
  title: "Master Weaponsmith",
  skillPoints: 1,
  preReqs: [
    "crafting_weaponsmith_melee_04",
    "crafting_weaponsmith_firearms_04",
    "crafting_weaponsmith_munitions_04",
    "crafting_weaponsmith_techniques_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    weapon_assembly: 25,
    weapon_experimentation: 25,
  },
  schematics: ["craftWeaponRangedGroupF","craftMunitionsGroupF","craftWeaponMeleeGroupF"]
},
crafting_weaponsmith_melee_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_weaponsmith_novice",
  ],
  xp: { id: "crafting_weapons_general", cost: 35000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponMeleeGroupB"]
},
crafting_weaponsmith_melee_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_weaponsmith_melee_01",
  ],
  xp: { id: "crafting_weapons_general", cost: 49000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponMeleeGroupC"]
},
crafting_weaponsmith_melee_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_weaponsmith_melee_02",
  ],
  xp: { id: "crafting_weapons_general", cost: 63000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponMeleeGroupD"]
},
crafting_weaponsmith_melee_04: {
  title: "Swordsmith",
  skillPoints: 2,
  preReqs: [
    "crafting_weaponsmith_melee_03",
  ],
  xp: { id: "crafting_weapons_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponMeleeGroupE"]
},
crafting_weaponsmith_firearms_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_weaponsmith_novice",
  ],
  xp: { id: "crafting_weapons_general", cost: 35000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponRangedGroupB"]
},
crafting_weaponsmith_firearms_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_weaponsmith_firearms_01",
  ],
  xp: { id: "crafting_weapons_general", cost: 49000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponRangedGroupC"]
},
crafting_weaponsmith_firearms_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_weaponsmith_firearms_02",
  ],
  xp: { id: "crafting_weapons_general", cost: 63000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponRangedGroupD"]
},
crafting_weaponsmith_firearms_04: {
  title: "Gunsmith",
  skillPoints: 2,
  preReqs: [
    "crafting_weaponsmith_firearms_03",
  ],
  xp: { id: "crafting_weapons_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftWeaponRangedGroupE"]
},
crafting_weaponsmith_munitions_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_weaponsmith_novice",
  ],
  xp: { id: "crafting_weapons_general", cost: 35000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftMunitionsGroupB"]
},
crafting_weaponsmith_munitions_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_weaponsmith_munitions_01",
  ],
  xp: { id: "crafting_weapons_general", cost: 49000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftMunitionsGroupC"]
},
crafting_weaponsmith_munitions_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_weaponsmith_munitions_02",
  ],
  xp: { id: "crafting_weapons_general", cost: 63000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftMunitionsGroupD"]
},
crafting_weaponsmith_munitions_04: {
  title: "Explosives Manufacturer",
  skillPoints: 2,
  preReqs: [
    "crafting_weaponsmith_munitions_03",
  ],
  xp: { id: "crafting_weapons_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftMunitionsGroupE"]
},
crafting_weaponsmith_techniques_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_weaponsmith_novice",
  ],
  xp: { id: "crafting_weapons_general", cost: 35000 },
  commands: [
    "",
  ],
  skillModifiers: {
    weapon_assembly: 10,
    weapon_experimentation: 10,
  },
  schematics: [""]
},
crafting_weaponsmith_techniques_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_weaponsmith_techniques_01",
  ],
  xp: { id: "crafting_weapons_general", cost: 49000 },
  commands: [
    "",
  ],
  skillModifiers: {
    weapon_assembly: 15,
    weapon_experimentation: 15,
  },
  schematics: [""]
},
crafting_weaponsmith_techniques_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_weaponsmith_techniques_02",
  ],
  xp: { id: "crafting_weapons_general", cost: 63000 },
  commands: [
    "",
  ],
  skillModifiers: {
    weapon_assembly: 20,
    weapon_experimentation: 20,
  },
  schematics: [""]
},
crafting_weaponsmith_techniques_04: {
  title: "Expert Weaponsmith",
  skillPoints: 2,
  preReqs: [
    "crafting_weaponsmith_techniques_03",
  ],
  xp: { id: "crafting_weapons_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {
    weapon_assembly: 20,
    weapon_experimentation: 20,
  },
  schematics: [""]
},
crafting_chef_novice: {
  title: "Novice Chef",
  skillPoints: 6,
  preReqs: [
    "crafting_artisan_domestic_04",
  ],
  xp: { id: "crafting_general", cost: 19200 },
  commands: [
    "",
  ],
  skillModifiers: {
    food_assembly: 20,
    food_experimentation: 20,
  },
  schematics: ["craftFoodNoviceGroupA","craftFoodNoviceGroupB","craftFoodNoviceGroupC"]
},
crafting_chef_master: {
  title: "Master Chef",
  skillPoints: 1,
  preReqs: [
    "crafting_chef_drink_04",
    "crafting_chef_dish_04",
    "crafting_chef_dessert_04",
    "crafting_chef_techniques_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "place_cantina",
  ],
  skillModifiers: {
    food_assembly: 10,
    food_experimentation: 10,
    private_place_cantina: 100,
  },
  schematics: ["craftFoodMaster"]
},
crafting_chef_dish_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_chef_novice",
  ],
  xp: { id: "crafting_food_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDishGroupA"]
},
crafting_chef_dish_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_chef_dish_01",
  ],
  xp: { id: "crafting_food_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDishGroupB"]
},
crafting_chef_dish_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_chef_dish_02",
  ],
  xp: { id: "crafting_food_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDishGroupC"]
},
crafting_chef_dish_04: {
  title: "Iron Chef",
  skillPoints: 2,
  preReqs: [
    "crafting_chef_dish_03",
  ],
  xp: { id: "crafting_food_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDishGroupD"]
},
crafting_chef_dessert_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_chef_novice",
  ],
  xp: { id: "crafting_food_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDessertGroupA"]
},
crafting_chef_dessert_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_chef_dessert_01",
  ],
  xp: { id: "crafting_food_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDessertGroupB"]
},
crafting_chef_dessert_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_chef_dessert_02",
  ],
  xp: { id: "crafting_food_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDessertGroupC"]
},
crafting_chef_dessert_04: {
  title: "Accomplished Baker",
  skillPoints: 2,
  preReqs: [
    "crafting_chef_dessert_03",
  ],
  xp: { id: "crafting_food_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDessertGroupD"]
},
crafting_chef_drink_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_chef_novice",
  ],
  xp: { id: "crafting_food_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDrinkGroupA"]
},
crafting_chef_drink_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_chef_drink_01",
  ],
  xp: { id: "crafting_food_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDrinkGroupB"]
},
crafting_chef_drink_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_chef_drink_02",
  ],
  xp: { id: "crafting_food_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDrinkGroupC"]
},
crafting_chef_drink_04: {
  title: "Expert Bartender",
  skillPoints: 2,
  preReqs: [
    "crafting_chef_drink_03",
  ],
  xp: { id: "crafting_food_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftFoodDrinkGroupD"]
},
crafting_chef_techniques_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_chef_novice",
  ],
  xp: { id: "crafting_food_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {
    food_assembly: 10,
    food_experimentation: 10,
  },
  schematics: [""]
},
crafting_chef_techniques_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_chef_techniques_01",
  ],
  xp: { id: "crafting_food_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {
    food_assembly: 20,
    food_experimentation: 20,
  },
  schematics: [""]
},
crafting_chef_techniques_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_chef_techniques_02",
  ],
  xp: { id: "crafting_food_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {
    food_assembly: 20,
    food_experimentation: 20,
  },
  schematics: [""]
},
crafting_chef_techniques_04: {
  title: "Culinary Master",
  skillPoints: 2,
  preReqs: [
    "crafting_chef_techniques_03",
  ],
  xp: { id: "crafting_food_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {
    food_assembly: 20,
    food_experimentation: 20,
  },
  schematics: [""]
},
crafting_tailor_novice: {
  title: "Novice Tailor",
  skillPoints: 6,
  preReqs: [
    "crafting_artisan_domestic_04",
  ],
  xp: { id: "crafting_general", cost: 19200 },
  commands: [
    "",
  ],
  skillModifiers: {
    clothing_assembly: 20,
    clothing_experimentation: 20,
    clothing_customization: 20,
  },
  schematics: ["craftClothingNoviceGroupA","craftClothingNoviceGroupB","craftClothingNoviceGroupC"]
},
crafting_tailor_master: {
  title: "Master Tailor",
  skillPoints: 1,
  preReqs: [
    "crafting_tailor_casual_04",
    "crafting_tailor_field_04",
    "crafting_tailor_formal_04",
    "crafting_tailor_production_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    clothing_assembly: 10,
    clothing_experimentation: 20,
    clothing_customization: 55,
  },
  schematics: ["craftClothingMaster"]
},
crafting_tailor_casual_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_tailor_novice",
  ],
  xp: { id: "crafting_clothing_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingCasualGroupA"]
},
crafting_tailor_casual_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_tailor_casual_01",
  ],
  xp: { id: "crafting_clothing_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingCasualGroupB"]
},
crafting_tailor_casual_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_tailor_casual_02",
  ],
  xp: { id: "crafting_clothing_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingCasualGroupC"]
},
crafting_tailor_casual_04: {
  title: "Clothier",
  skillPoints: 2,
  preReqs: [
    "crafting_tailor_casual_03",
  ],
  xp: { id: "crafting_clothing_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingCasualGroupD"]
},
crafting_tailor_field_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_tailor_novice",
  ],
  xp: { id: "crafting_clothing_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFieldGroupA"]
},
crafting_tailor_field_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_tailor_field_01",
  ],
  xp: { id: "crafting_clothing_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFieldGroupB"]
},
crafting_tailor_field_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_tailor_field_02",
  ],
  xp: { id: "crafting_clothing_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFieldGroupC"]
},
crafting_tailor_field_04: {
  title: "Uniform Marshal",
  skillPoints: 2,
  preReqs: [
    "crafting_tailor_field_03",
  ],
  xp: { id: "crafting_clothing_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFieldGroupD"]
},
crafting_tailor_formal_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_tailor_novice",
  ],
  xp: { id: "crafting_clothing_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFormalGroupA"]
},
crafting_tailor_formal_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_tailor_formal_01",
  ],
  xp: { id: "crafting_clothing_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFormalGroupB"]
},
crafting_tailor_formal_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_tailor_formal_02",
  ],
  xp: { id: "crafting_clothing_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFormalGroupC"]
},
crafting_tailor_formal_04: {
  title: "Costumier",
  skillPoints: 2,
  preReqs: [
    "crafting_tailor_formal_03",
  ],
  xp: { id: "crafting_clothing_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftClothingFormalGroupD"]
},
crafting_tailor_production_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_tailor_novice",
  ],
  xp: { id: "crafting_clothing_general", cost: 32000 },
  commands: [
    "",
  ],
  skillModifiers: {
    clothing_assembly: 10,
    clothing_experimentation: 15,
    clothing_customization: 20,
  },
  schematics: [""]
},
crafting_tailor_production_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_tailor_production_01",
  ],
  xp: { id: "crafting_clothing_general", cost: 44800 },
  commands: [
    "",
  ],
  skillModifiers: {
    clothing_assembly: 20,
    clothing_experimentation: 15,
    clothing_customization: 20,
  },
  schematics: [""]
},
crafting_tailor_production_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_tailor_production_02",
  ],
  xp: { id: "crafting_clothing_general", cost: 57600 },
  commands: [
    "",
  ],
  skillModifiers: {
    clothing_assembly: 20,
    clothing_experimentation: 15,
    clothing_customization: 20,
  },
  schematics: [""]
},
crafting_tailor_production_04: {
  title: "Expert Tailor",
  skillPoints: 2,
  preReqs: [
    "crafting_tailor_production_03",
  ],
  xp: { id: "crafting_clothing_general", cost: 70400 },
  commands: [
    "",
  ],
  skillModifiers: {
    clothing_assembly: 20,
    clothing_experimentation: 15,
    clothing_customization: 20,
  },
  schematics: [""]
},
crafting_architect_novice: {
  title: "Novice Architect",
  skillPoints: 6,
  preReqs: [
    "crafting_artisan_engineering_04",
  ],
  xp: { id: "crafting_general", cost: 33000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_assembly: 20,
    structure_experimentation: 20,
  },
  schematics: ["craftFurnitureGroupAA","craftStructureGroupAA","craftInstallationGroupAA"]
},
crafting_architect_master: {
  title: "Master Architect",
  skillPoints: 1,
  preReqs: [
    "crafting_architect_production_04",
    "crafting_architect_techniques_04",
    "crafting_architect_harvesting_04",
    "crafting_architect_blueprints_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_assembly: 10,
    structure_experimentation: 10,
  },
  schematics: ["craftStructureGroupE","craftFurnitureGroupE","craftPlayerCityE"]
},
crafting_architect_production_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_architect_novice",
  ],
  xp: { id: "crafting_structure_general", cost: 55000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_assembly: 10,
  },
  schematics: ["craftFurnitureGroupA"]
},
crafting_architect_production_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_architect_production_01",
  ],
  xp: { id: "crafting_structure_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_assembly: 20,
  },
  schematics: ["craftFurnitureGroupB"]
},
crafting_architect_production_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_architect_production_02",
  ],
  xp: { id: "crafting_structure_general", cost: 99000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_assembly: 20,
  },
  schematics: ["craftFurnitureGroupC"]
},
crafting_architect_production_04: {
  title: "Interior Designer",
  skillPoints: 2,
  preReqs: [
    "crafting_architect_production_03",
  ],
  xp: { id: "crafting_structure_general", cost: 121000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_assembly: 20,
  },
  schematics: ["craftFurnitureGroupD"]
},
crafting_architect_techniques_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_architect_novice",
  ],
  xp: { id: "crafting_structure_general", cost: 55000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_experimentation: 10,
  },
  schematics: ["craftPlayerCityA"]
},
crafting_architect_techniques_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_architect_techniques_01",
  ],
  xp: { id: "crafting_structure_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_experimentation: 20,
  },
  schematics: ["craftPlayerCityB"]
},
crafting_architect_techniques_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_architect_techniques_02",
  ],
  xp: { id: "crafting_structure_general", cost: 99000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_experimentation: 20,
  },
  schematics: ["craftPlayerCityC"]
},
crafting_architect_techniques_04: {
  title: "Foreman",
  skillPoints: 2,
  preReqs: [
    "crafting_architect_techniques_03",
  ],
  xp: { id: "crafting_structure_general", cost: 121000 },
  commands: [
    "",
  ],
  skillModifiers: {
    structure_experimentation: 20,
  },
  schematics: ["craftPlayerCityD"]
},
crafting_architect_harvesting_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_architect_novice",
  ],
  xp: { id: "crafting_structure_general", cost: 55000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftInstallationGroupA"]
},
crafting_architect_harvesting_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_architect_harvesting_01",
  ],
  xp: { id: "crafting_structure_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftInstallationGroupB"]
},
crafting_architect_harvesting_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_architect_harvesting_02",
  ],
  xp: { id: "crafting_structure_general", cost: 99000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftInstallationGroupC"]
},
crafting_architect_harvesting_04: {
  title: "Installation Designer",
  skillPoints: 2,
  preReqs: [
    "crafting_architect_harvesting_03",
  ],
  xp: { id: "crafting_structure_general", cost: 121000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftInstallationGroupD"]
},
crafting_architect_blueprints_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_architect_novice",
  ],
  xp: { id: "crafting_structure_general", cost: 55000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftStructureGroupA"]
},
crafting_architect_blueprints_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_architect_blueprints_01",
  ],
  xp: { id: "crafting_structure_general", cost: 77000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftStructureGroupB"]
},
crafting_architect_blueprints_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_architect_blueprints_02",
  ],
  xp: { id: "crafting_structure_general", cost: 99000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftStructureGroupC"]
},
crafting_architect_blueprints_04: {
  title: "Home Designer",
  skillPoints: 2,
  preReqs: [
    "crafting_architect_blueprints_03",
  ],
  xp: { id: "crafting_structure_general", cost: 121000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftStructureGroupD"]
},
crafting_droidengineer_novice: {
  title: "Novice Droid Engineer",
  skillPoints: 6,
  preReqs: [
    "crafting_artisan_engineering_04",
  ],
  xp: { id: "crafting_general", cost: 28800 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_assembly: 20,
    droid_experimentation: 20,
    droid_customization: 32,
  },
  schematics: ["craftdroidGroupA","craftdroiddefmodGroupA","craftdroidgenmodGroupA","craftDroidRepairCompA"]
},
crafting_droidengineer_master: {
  title: "Master Droid Engineer",
  skillPoints: 1,
  preReqs: [
    "crafting_droidengineer_production_04",
    "crafting_droidengineer_techniques_04",
    "crafting_droidengineer_refinement_04",
    "crafting_droidengineer_blueprints_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_assembly: 10,
    droid_experimentation: 10,
  },
  schematics: ["craftdroidGroupF","craftdroidgenmodGroupF","craftdroiddefmodGroupF","craftDroidRepairCompB"]
},
crafting_droidengineer_production_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_droidengineer_novice",
  ],
  xp: { id: "crafting_droid_general", cost: 48000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroidgenmodGroupB"]
},
crafting_droidengineer_production_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_droidengineer_production_01",
  ],
  xp: { id: "crafting_droid_general", cost: 67200 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroidgenmodGroupC"]
},
crafting_droidengineer_production_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_droidengineer_production_02",
  ],
  xp: { id: "crafting_droid_general", cost: 86400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroidgenmodGroupD","craftdroidgenmodGroupDD"]
},
crafting_droidengineer_production_04: {
  title: "Droid Builder",
  skillPoints: 2,
  preReqs: [
    "crafting_droidengineer_production_03",
  ],
  xp: { id: "crafting_droid_general", cost: 105600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroidgenmodGroupE"]
},
crafting_droidengineer_techniques_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_droidengineer_novice",
  ],
  xp: { id: "crafting_droid_general", cost: 48000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroiddefmodGroupB","craftDroidWoundRepairA"]
},
crafting_droidengineer_techniques_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_droidengineer_techniques_01",
  ],
  xp: { id: "crafting_droid_general", cost: 67200 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroiddefmodGroupC","craftDroidWoundRepairB"]
},
crafting_droidengineer_techniques_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_droidengineer_techniques_02",
  ],
  xp: { id: "crafting_droid_general", cost: 86400 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroiddefmodGroupD","craftDroidWoundRepairC"]
},
crafting_droidengineer_techniques_04: {
  title: "Expert Droid Engineer",
  skillPoints: 2,
  preReqs: [
    "crafting_droidengineer_techniques_03",
  ],
  xp: { id: "crafting_droid_general", cost: 105600 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: ["craftdroiddefmodGroupE","craftDroidWoundRepairD"]
},
crafting_droidengineer_refinement_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_droidengineer_novice",
  ],
  xp: { id: "crafting_droid_general", cost: 48000 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_experimentation: 10,
    droid_customization: 8,
  },
  schematics: ["craftDroidDamageRepairA"]
},
crafting_droidengineer_refinement_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_droidengineer_refinement_01",
  ],
  xp: { id: "crafting_droid_general", cost: 67200 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_experimentation: 20,
    droid_customization: 8,
  },
  schematics: ["craftDroidDamageRepairB"]
},
crafting_droidengineer_refinement_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_droidengineer_refinement_02",
  ],
  xp: { id: "crafting_droid_general", cost: 86400 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_experimentation: 20,
    droid_customization: 8,
  },
  schematics: ["craftDroidDamageRepairC"]
},
crafting_droidengineer_refinement_04: {
  title: "Droid Refiner",
  skillPoints: 2,
  preReqs: [
    "crafting_droidengineer_refinement_03",
  ],
  xp: { id: "crafting_droid_general", cost: 105600 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_experimentation: 20,
    droid_customization: 8,
  },
  schematics: ["craftDroidDamageRepairD"]
},
crafting_droidengineer_blueprints_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_droidengineer_novice",
  ],
  xp: { id: "crafting_droid_general", cost: 48000 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_assembly: 10,
  },
  schematics: ["craftdroidGroupB"]
},
crafting_droidengineer_blueprints_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_droidengineer_blueprints_01",
  ],
  xp: { id: "crafting_droid_general", cost: 67200 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_assembly: 20,
  },
  schematics: ["craftdroidGroupC"]
},
crafting_droidengineer_blueprints_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_droidengineer_blueprints_02",
  ],
  xp: { id: "crafting_droid_general", cost: 86400 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_assembly: 20,
  },
  schematics: ["craftdroidGroupD"]
},
crafting_droidengineer_blueprints_04: {
  title: "Droid Designer",
  skillPoints: 2,
  preReqs: [
    "crafting_droidengineer_blueprints_03",
  ],
  xp: { id: "crafting_droid_general", cost: 105600 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_assembly: 20,
  },
  schematics: ["craftdroidGroupE"]
},
crafting_merchant_novice: {
  title: "Novice Merchant",
  skillPoints: 0,
  preReqs: [
    "crafting_artisan_business_04",
  ],
  xp: { id: "merchant", cost: 5000 },
  commands: [
    "",
  ],
  skillModifiers: {
    manage_vendor: 1,
    hiring: 10,
    vendor_item_limit: 500,
  },
  schematics: [""]
},
crafting_merchant_master: {
  title: "Master Merchant",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_advertising_04",
    "crafting_merchant_sales_04",
    "crafting_merchant_hiring_04",
    "crafting_merchant_management_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "vendor_fees_1",
  ],
  skillModifiers: {
    manage_vendor: 2,
    hiring: 10,
    vendor_item_limit: 1000,
  },
  schematics: [""]
},
crafting_merchant_advertising_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_novice",
  ],
  xp: { id: "merchant", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_merchant_advertising_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_advertising_01",
  ],
  xp: { id: "merchant", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_merchant_advertising_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_advertising_02",
  ],
  xp: { id: "merchant", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_merchant_advertising_04: {
  title: "Propagandist",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_advertising_03",
  ],
  xp: { id: "merchant", cost: 40000 },
  commands: [
    "ad_fees_1",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_merchant_sales_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_novice",
  ],
  xp: { id: "merchant", cost: 10000 },
  commands: [
    "merchant_fees_1",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_merchant_sales_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_sales_01",
  ],
  xp: { id: "merchant", cost: 20000 },
  commands: [
    "vendor_fees_1",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_merchant_sales_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_sales_02",
  ],
  xp: { id: "merchant", cost: 30000 },
  commands: [
    "merchant_fees_1",
  ],
  skillModifiers: {
    vendor_item_limit: 100,
  },
  schematics: [""]
},
crafting_merchant_sales_04: {
  title: "Entrepreneur",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_sales_03",
  ],
  xp: { id: "merchant", cost: 40000 },
  commands: [
    "maintenance_fees_1",
    "place_merchant_tent",
  ],
  skillModifiers: {
    manage_vendor: 1,
    private_place_merchant_tent: 100,
    vendor_item_limit: 150,
  },
  schematics: [""]
},
crafting_merchant_hiring_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_novice",
  ],
  xp: { id: "merchant", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hiring: 20,
  },
  schematics: [""]
},
crafting_merchant_hiring_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_hiring_01",
  ],
  xp: { id: "merchant", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hiring: 10,
  },
  schematics: [""]
},
crafting_merchant_hiring_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_hiring_02",
  ],
  xp: { id: "merchant", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hiring: 15,
  },
  schematics: [""]
},
crafting_merchant_hiring_04: {
  title: "Recruiter",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_hiring_03",
  ],
  xp: { id: "merchant", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hiring: 15,
  },
  schematics: [""]
},
crafting_merchant_management_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_novice",
  ],
  xp: { id: "merchant", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    manage_vendor: 1,
    shop_sign: 1,
    vendor_item_limit: 500,
  },
  schematics: [""]
},
crafting_merchant_management_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_management_01",
  ],
  xp: { id: "merchant", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    manage_vendor: 1,
    shop_sign: 1,
    vendor_item_limit: 500,
  },
  schematics: [""]
},
crafting_merchant_management_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_management_02",
  ],
  xp: { id: "merchant", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    manage_vendor: 2,
    shop_sign: 1,
    vendor_item_limit: 500,
  },
  schematics: [""]
},
crafting_merchant_management_04: {
  title: "Manager",
  skillPoints: 0,
  preReqs: [
    "crafting_merchant_management_03",
  ],
  xp: { id: "merchant", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    manage_vendor: 2,
    shop_sign: 1,
    vendor_item_limit: 500,
  },
  schematics: [""]
},
combat_smuggler_novice: {
  title: "Novice Smuggler",
  skillPoints: 6,
  preReqs: [
    "combat_marksman_pistol_04",
    "combat_brawler_unarmed_04",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 50000 },
  commands: [
    "slice_containers",
  ],
  skillModifiers: {
    spice_assembly: 20,
    spice_experimentation: 20,
  },
  schematics: ["craftSmugglerSpiceNovice","craftSmugglerToolsA"]
},
combat_smuggler_master: {
  title: "Master Smuggler",
  skillPoints: 1,
  preReqs: [
    "combat_smuggler_underworld_04",
    "combat_smuggler_slicing_04",
    "combat_smuggler_combat_04",
    "combat_smuggler_spice_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_smuggler_underworld_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_smuggler_novice",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 75000 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_all_comprehend: 100,
  },
  schematics: [""]
},
combat_smuggler_underworld_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_smuggler_underworld_01",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 100000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_smuggler_underworld_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_smuggler_underworld_02",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 200000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_smuggler_underworld_04: {
  title: "Fixer",
  skillPoints: 2,
  preReqs: [
    "combat_smuggler_underworld_03",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 300000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_smuggler_slicing_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_smuggler_novice",
  ],
  xp: { id: "slicing", cost: 5000 },
  commands: [
    "slice_terminals",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_smuggler_slicing_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_smuggler_slicing_01",
  ],
  xp: { id: "slicing", cost: 10000 },
  commands: [
    "slice_weaponsbasic",
  ],
  skillModifiers: {},
  schematics: ["craftSmugglerToolsB"]
},
combat_smuggler_slicing_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_smuggler_slicing_02",
  ],
  xp: { id: "slicing", cost: 25000 },
  commands: [
    "slice_armor",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_smuggler_slicing_04: {
  title: "Slicer",
  skillPoints: 2,
  preReqs: [
    "combat_smuggler_slicing_03",
  ],
  xp: { id: "slicing", cost: 50000 },
  commands: [
    "slice_weaponsadvanced",
  ],
  skillModifiers: {},
  schematics: ["craftSmugglerToolsC"]
},
combat_smuggler_combat_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_smuggler_novice",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 175000 },
  commands: [
    "feignDeath",
    "ranged_damage_mitigation_1",
  ],
  skillModifiers: {
    feign_death: 45,
  },
  schematics: [""]
},
combat_smuggler_combat_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_smuggler_combat_01",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 250000 },
  commands: [
    "panicShot",
  ],
  skillModifiers: {
    feign_death: 5,
  },
  schematics: [""]
},
combat_smuggler_combat_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_smuggler_combat_02",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 350000 },
  commands: [
    "lowBlow",
    "melee_damage_mitigation_1",
  ],
  skillModifiers: {
    feign_death: 10,
  },
  schematics: [""]
},
combat_smuggler_combat_04: {
  title: "Rogue",
  skillPoints: 2,
  preReqs: [
    "combat_smuggler_combat_03",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 450000 },
  commands: [
    "lastDitch",
  ],
  skillModifiers: {
    feign_death: 10,
  },
  schematics: [""]
},
combat_smuggler_spice_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_smuggler_novice",
  ],
  xp: { id: "crafting_spice", cost: 8000 },
  commands: [
    "",
  ],
  skillModifiers: {
    spice_assembly: 20,
    spice_experimentation: 20,
  },
  schematics: ["craftSmugglerSpiceA"]
},
combat_smuggler_spice_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_smuggler_spice_01",
  ],
  xp: { id: "crafting_spice", cost: 12000 },
  commands: [
    "",
  ],
  skillModifiers: {
    spice_assembly: 20,
    spice_experimentation: 20,
  },
  schematics: ["craftSmugglerSpiceB"]
},
combat_smuggler_spice_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_smuggler_spice_02",
  ],
  xp: { id: "crafting_spice", cost: 16000 },
  commands: [
    "",
  ],
  skillModifiers: {
    spice_assembly: 20,
    spice_experimentation: 20,
  },
  schematics: ["craftSmugglerSpiceC"]
},
combat_smuggler_spice_04: {
  title: "Fence",
  skillPoints: 2,
  preReqs: [
    "combat_smuggler_spice_03",
  ],
  xp: { id: "crafting_spice", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    spice_assembly: 20,
    spice_experimentation: 20,
  },
  schematics: ["craftSmugglerSpiceD"]
},
combat_bountyhunter_novice: {
  title: "Novice Bounty Hunter",
  skillPoints: 6,
  preReqs: [
    "combat_marksman_master",
    "outdoors_scout_movement_04",
  ],
  xp: { id: "combat_general", cost: 40000 },
  commands: [
    "cert_pistol_scatter",
    "cert_rifle_lightning",
  ],
  skillModifiers: {
    bounty_mission_level: 1,
    heavy_rifle_lightning_accuracy: 20,
    heavy_rifle_lightning_speed: 10,
    private_heavyweapon_combat_difficulty: 1600,
  },
  schematics: [""]
},
combat_bountyhunter_master: {
  title: "Master Bounty Hunter",
  skillPoints: 1,
  preReqs: [
    "combat_bountyhunter_investigation_04",
    "combat_bountyhunter_droidcontrol_04",
    "combat_bountyhunter_droidresponse_04",
    "combat_bountyhunter_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "sprayShot",
    "fastBlast",
    "fireLightningCone2",
    "ranged_damage_mitigation_3",
  ],
  skillModifiers: {
    droid_tracks: 4,
    droid_track_chance: 10,
    droid_find_chance: 10,
    droid_find_speed: 10,
    droid_track_speed: 10,
    ranged_defense: 7,
    pistol_accuracy: 10,
    carbine_accuracy: 10,
    private_heavyweapon_combat_difficulty: 100,
    private_carbine_difficulty: 100,
    private_pistol_difficulty: 100,
  },
  schematics: [""]
},
combat_bountyhunter_investigation_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_bountyhunter_novice",
  ],
  xp: { id: "bountyhunter", cost: 1000 },
  commands: [
    "droid_find",
    "ranged_damage_mitigation_1",
  ],
  skillModifiers: {
    droid_find_chance: 70,
    droid_find_speed: 10,
    bounty_mission_level: 1,
  },
  schematics: [""]
},
combat_bountyhunter_investigation_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_bountyhunter_investigation_01",
  ],
  xp: { id: "bountyhunter", cost: 5000 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_find_chance: 50,
    droid_find_speed: 40,
  },
  schematics: [""]
},
combat_bountyhunter_investigation_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_bountyhunter_investigation_02",
  ],
  xp: { id: "bountyhunter", cost: 10000 },
  commands: [
    "droid_track",
    "ranged_damage_mitigation_2",
  ],
  skillModifiers: {
    droid_tracks: 4,
    droid_track_chance: 50,
    droid_track_speed: 40,
    droid_find_speed: 30,
    bounty_mission_level: 1,
  },
  schematics: [""]
},
combat_bountyhunter_investigation_04: {
  title: "Stalker",
  skillPoints: 0,
  preReqs: [
    "combat_bountyhunter_investigation_03",
  ],
  xp: { id: "bountyhunter", cost: 18000 },
  commands: [
    "",
  ],
  skillModifiers: {
    droid_tracks: 4,
    droid_track_chance: 40,
    droid_track_speed: 30,
  },
  schematics: [""]
},
combat_bountyhunter_droidcontrol_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_bountyhunter_novice",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 150000 },
  commands: [
    "underHandShot",
  ],
  skillModifiers: {
    carbine_accuracy: 10,
    carbine_speed: 10,
    private_carbine_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_droidcontrol_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_bountyhunter_droidcontrol_01",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    carbine_accuracy: 10,
    carbine_speed: 10,
    private_carbine_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_droidcontrol_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_bountyhunter_droidcontrol_02",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 350000 },
  commands: [
    "knockdownFire",
  ],
  skillModifiers: {
    carbine_accuracy: 20,
    carbine_speed: 20,
    private_carbine_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_droidcontrol_04: {
  title: "Enforcer",
  skillPoints: 2,
  preReqs: [
    "combat_bountyhunter_droidcontrol_03",
  ],
  xp: { id: "combat_rangedspecialize_carbine", cost: 450000 },
  commands: [
    "confusionShot",
  ],
  skillModifiers: {
    carbine_accuracy: 10,
    carbine_speed: 10,
    private_carbine_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_droidresponse_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_bountyhunter_novice",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 150000 },
  commands: [
    "bleedingShot",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 10,
    private_pistol_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_droidresponse_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_bountyhunter_droidresponse_01",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 250000 },
  commands: [
    "eyeShot",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 10,
    private_pistol_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_droidresponse_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_bountyhunter_droidresponse_02",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    pistol_accuracy: 20,
    pistol_speed: 20,
    private_pistol_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_droidresponse_04: {
  title: "Desperado",
  skillPoints: 2,
  preReqs: [
    "combat_bountyhunter_droidresponse_03",
  ],
  xp: { id: "combat_rangedspecialize_pistol", cost: 450000 },
  commands: [
    "torsoShot",
  ],
  skillModifiers: {
    pistol_accuracy: 10,
    pistol_speed: 10,
    private_pistol_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_bountyhunter_novice",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 150000 },
  commands: [
    "fireLightningSingle1",
  ],
  skillModifiers: {
    heavy_rifle_lightning_speed: 10,
    heavy_rifle_lightning_accuracy: 10,
    private_heavyweapon_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_bountyhunter_support_01",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 250000 },
  commands: [
    "fireLightningCone1",
  ],
  skillModifiers: {
    heavy_rifle_lightning_speed: 10,
    heavy_rifle_lightning_accuracy: 10,
    private_heavyweapon_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_bountyhunter_support_02",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    heavy_rifle_lightning_speed: 20,
    heavy_rifle_lightning_accuracy: 20,
    private_heavyweapon_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_bountyhunter_support_04: {
  title: "Avenger",
  skillPoints: 2,
  preReqs: [
    "combat_bountyhunter_support_03",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 450000 },
  commands: [
    "fireLightningSingle2",
  ],
  skillModifiers: {
    heavy_rifle_lightning_speed: 10,
    heavy_rifle_lightning_accuracy: 10,
    private_heavyweapon_combat_difficulty: 200,
  },
  schematics: [""]
},
combat_commando_novice: {
  title: "Novice Commando",
  skillPoints: 6,
  preReqs: [
    "combat_marksman_master",
    "combat_brawler_unarmed_04",
  ],
  xp: { id: "combat_general", cost: 40000 },
  commands: [
    "cert_rocket_launcher",
    "cert_pistol_launcher",
    "cert_rifle_flame_thrower",
    "cert_rifle_acid_beam",
    "cert_grenade_fragmentation",
  ],
  skillModifiers: {
    heavy_flame_thrower_accuracy: 10,
    heavy_rifle_acid_accuracy: 10,
    private_heavyweapon_combat_difficulty: 1700,
    thrown_accuracy: 15,
  },
  schematics: [""]
},
combat_commando_master: {
  title: "Master Commando",
  skillPoints: 1,
  preReqs: [
    "combat_commando_heavyweapon_accuracy_04",
    "combat_commando_heavyweapon_speed_04",
    "combat_commando_thrownweapon_04",
    "combat_commando_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "cert_grenade_proton",
    "flameCone2",
    "fireAcidCone2",
    "ranged_damage_mitigation_3",
  ],
  skillModifiers: {
    heavy_rocket_launcher_accuracy: 40,
    thrown_accuracy: 40,
    heavy_flame_thrower_accuracy: 30,
    heavy_rifle_acid_accuracy: 30,
    melee_defense: 25,
    ranged_defense: 25,
  },
  schematics: [""]
},
combat_commando_heavyweapon_accuracy_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_commando_novice",
  ],
  xp: { id: "combat_general", cost: 50000 },
  commands: [
    "cert_grenade_cryoban",
    "ranged_damage_mitigation_1",
  ],
  skillModifiers: {
    thrown_accuracy: 10,
    thrown_speed: 10,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_heavyweapon_accuracy_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_commando_heavyweapon_accuracy_01",
  ],
  xp: { id: "combat_general", cost: 80000 },
  commands: [
    "cert_grenade_glop",
  ],
  skillModifiers: {
    thrown_speed: 10,
    knockdown_defense: 5,
  },
  schematics: [""]
},
combat_commando_heavyweapon_accuracy_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_commando_heavyweapon_accuracy_02",
  ],
  xp: { id: "combat_general", cost: 100000 },
  commands: [
    "cert_grenade_imperial_detonator",
    "ranged_damage_mitigation_2",
  ],
  skillModifiers: {
    thrown_accuracy: 10,
    thrown_speed: 10,
    ranged_defense: 5,
  },
  schematics: [""]
},
combat_commando_heavyweapon_accuracy_04: {
  title: "Grenadier",
  skillPoints: 2,
  preReqs: [
    "combat_commando_heavyweapon_accuracy_03",
  ],
  xp: { id: "combat_general", cost: 130000 },
  commands: [
    "cert_grenade_thermal_detonator",
  ],
  skillModifiers: {
    thrown_accuracy: 10,
    thrown_speed: 10,
    melee_defense: 5,
  },
  schematics: [""]
},
combat_commando_heavyweapon_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_commando_novice",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 100000 },
  commands: [
    "cert_heavy_particle_beam",
  ],
  skillModifiers: {
    heavy_rocket_launcher_accuracy: 20,
    heavy_rocket_launcher_speed: 20,
    heavy_particle_beam_accuracy: 10,
    heavy_particle_beam_speed: 10,
  },
  schematics: [""]
},
combat_commando_heavyweapon_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_commando_heavyweapon_speed_01",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 200000 },
  commands: [
    "cert_heavy_acid_beam",
  ],
  skillModifiers: {
    heavy_rocket_launcher_accuracy: 20,
    heavy_rocket_launcher_speed: 20,
    heavy_particle_beam_accuracy: 20,
    heavy_particle_beam_speed: 20,
    heavy_acid_beam_speed: 10,
    heavy_acid_beam_accuracy: 10,
  },
  schematics: [""]
},
combat_commando_heavyweapon_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_commando_heavyweapon_speed_02",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 300000 },
  commands: [
    "cert_heavy_lightning_beam",
  ],
  skillModifiers: {
    heavy_lightning_beam_speed: 10,
    heavy_lightning_beam_accuracy: 10,
    heavy_rocket_launcher_accuracy: 20,
    heavy_rocket_launcher_speed: 20,
    heavy_particle_beam_accuracy: 20,
    heavy_particle_beam_speed: 20,
    heavy_acid_beam_speed: 20,
    heavy_acid_beam_accuracy: 20,
  },
  schematics: [""]
},
combat_commando_heavyweapon_speed_04: {
  title: "Demolitionist",
  skillPoints: 2,
  preReqs: [
    "combat_commando_heavyweapon_speed_03",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 400000 },
  commands: [
    "",
  ],
  skillModifiers: {
    heavy_lightning_beam_speed: 30,
    heavy_lightning_beam_accuracy: 30,
    heavy_particle_beam_accuracy: 20,
    heavy_particle_beam_speed: 20,
    heavy_acid_beam_speed: 20,
    heavy_acid_beam_accuracy: 20,
  },
  schematics: [""]
},
combat_commando_thrownweapon_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_commando_novice",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 150000 },
  commands: [
    "flameSingle1",
  ],
  skillModifiers: {
    heavy_flame_thrower_accuracy: 15,
    heavy_flame_thrower_speed: 10,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_thrownweapon_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_commando_thrownweapon_01",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 250000 },
  commands: [
    "flameCone1",
  ],
  skillModifiers: {
    heavy_flame_thrower_accuracy: 15,
    heavy_flame_thrower_speed: 10,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_thrownweapon_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_commando_thrownweapon_02",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    heavy_flame_thrower_accuracy: 25,
    heavy_flame_thrower_speed: 15,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_thrownweapon_04: {
  title: "Shock Trooper",
  skillPoints: 2,
  preReqs: [
    "combat_commando_thrownweapon_03",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 450000 },
  commands: [
    "flameSingle2",
  ],
  skillModifiers: {
    heavy_flame_thrower_accuracy: 15,
    heavy_flame_thrower_speed: 10,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "combat_commando_novice",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 175000 },
  commands: [
    "fireAcidSingle1",
  ],
  skillModifiers: {
    heavy_rifle_acid_accuracy: 15,
    heavy_rifle_acid_speed: 10,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "combat_commando_support_01",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 250000 },
  commands: [
    "fireAcidCone1",
  ],
  skillModifiers: {
    heavy_rifle_acid_accuracy: 15,
    heavy_rifle_acid_speed: 10,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "combat_commando_support_02",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    heavy_rifle_acid_accuracy: 25,
    heavy_rifle_acid_speed: 15,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
combat_commando_support_04: {
  title: "Heavy Infantry",
  skillPoints: 2,
  preReqs: [
    "combat_commando_support_03",
  ],
  xp: { id: "combat_rangedspecialize_heavy", cost: 450000 },
  commands: [
    "fireAcidSingle2",
  ],
  skillModifiers: {
    heavy_rifle_acid_accuracy: 15,
    heavy_rifle_acid_speed: 10,
    private_heavyweapon_combat_difficulty: 100,
  },
  schematics: [""]
},
science_combatmedic_novice: {
  title: "Novice Combat Medic",
  skillPoints: 6,
  preReqs: [
    "combat_marksman_support_04",
    "science_medic_master",
  ],
  xp: { id: "medical", cost: 12500 },
  commands: [
    "applyPoison",
  ],
  skillModifiers: {
    healing_range: 5,
    healing_range_speed: 5,
    combat_medicine_assembly: 20,
    combat_medicine_experimentation: 20,
    combat_healing_ability: 5,
    combat_medic_effectiveness: 5,
  },
  schematics: ["craftStimpackRangeGroupA","craftApplyPoisonGroupA","craftMedicineComponentGroupC"]
},
science_combatmedic_master: {
  title: "Master Combat Medic",
  skillPoints: 1,
  preReqs: [
    "science_combatmedic_healing_range_04",
    "science_combatmedic_healing_range_speed_04",
    "science_combatmedic_medicine_04",
    "science_combatmedic_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "place_hospital",
  ],
  skillModifiers: {
    healing_range: 25,
    healing_range_speed: 25,
    slope_move: 10,
    combat_healing_ability: 25,
    combat_medic_effectiveness: 25,
    private_place_hospital: 100,
  },
  schematics: ["craftApplyPoisonAreaGroupC","craftApplyDiseaseGroupC","craftApplyDiseaseAreaGroupC"]
},
science_combatmedic_healing_range_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_combatmedic_novice",
  ],
  xp: { id: "medical", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_range: 15,
    combat_medic_effectiveness: 15,
  },
  schematics: [""]
},
science_combatmedic_healing_range_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_combatmedic_healing_range_01",
  ],
  xp: { id: "medical", cost: 25000 },
  commands: [
    "applyDisease",
  ],
  skillModifiers: {
    healing_range: 15,
    combat_medic_effectiveness: 15,
  },
  schematics: [""]
},
science_combatmedic_healing_range_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_combatmedic_healing_range_02",
  ],
  xp: { id: "medical", cost: 37500 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_range: 15,
    combat_medic_effectiveness: 15,
  },
  schematics: [""]
},
science_combatmedic_healing_range_04: {
  title: "Medical Tactician",
  skillPoints: 2,
  preReqs: [
    "science_combatmedic_healing_range_03",
  ],
  xp: { id: "medical", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_range: 25,
    combat_medic_effectiveness: 25,
  },
  schematics: [""]
},
science_combatmedic_healing_range_speed_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_combatmedic_novice",
  ],
  xp: { id: "medical", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_range_speed: 15,
  },
  schematics: [""]
},
science_combatmedic_healing_range_speed_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_combatmedic_healing_range_speed_01",
  ],
  xp: { id: "medical", cost: 25000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_range_speed: 15,
  },
  schematics: [""]
},
science_combatmedic_healing_range_speed_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_combatmedic_healing_range_speed_02",
  ],
  xp: { id: "medical", cost: 37500 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_range_speed: 15,
  },
  schematics: [""]
},
science_combatmedic_healing_range_speed_04: {
  title: "Chemical Warfare Expert",
  skillPoints: 2,
  preReqs: [
    "science_combatmedic_healing_range_speed_03",
  ],
  xp: { id: "medical", cost: 50000 },
  commands: [
    "healMind",
  ],
  skillModifiers: {
    healing_range_speed: 25,
  },
  schematics: [""]
},
science_combatmedic_medicine_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_combatmedic_novice",
  ],
  xp: { id: "crafting_medicine_general", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_medicine_assembly: 20,
    combat_medicine_experimentation: 20,
  },
  schematics: ["craftStimpackRangeGroupB","craftApplyPoisonAreaGroupA","craftApplyDiseaseGroupA"]
},
science_combatmedic_medicine_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_combatmedic_medicine_01",
  ],
  xp: { id: "crafting_medicine_general", cost: 17500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_medicine_assembly: 20,
    combat_medicine_experimentation: 20,
  },
  schematics: ["craftStimpackRangeGroupC","craftApplyPoisonGroupB","craftApplyDiseaseAreaGroupA","craftMedicineComponentGroupE"]
},
science_combatmedic_medicine_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_combatmedic_medicine_02",
  ],
  xp: { id: "crafting_medicine_general", cost: 22500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_medicine_assembly: 20,
    combat_medicine_experimentation: 20,
  },
  schematics: ["craftStimpackRangeGroupD","craftApplyPoisonAreaGroupB","craftApplyDiseaseGroupB"]
},
science_combatmedic_medicine_04: {
  title: "Toxicologist",
  skillPoints: 2,
  preReqs: [
    "science_combatmedic_medicine_03",
  ],
  xp: { id: "crafting_medicine_general", cost: 27500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_medicine_assembly: 20,
    combat_medicine_experimentation: 20,
  },
  schematics: ["craftStimpackRangeGroupE","craftApplyPoisonGroupC","craftApplyDiseaseAreaGroupB"]
},
science_combatmedic_support_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "science_combatmedic_novice",
  ],
  xp: { id: "medical", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_healing_ability: 15,
    slope_move: 10,
  },
  schematics: [""]
},
science_combatmedic_support_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "science_combatmedic_support_01",
  ],
  xp: { id: "medical", cost: 25000 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_healing_ability: 15,
    slope_move: 10,
  },
  schematics: [""]
},
science_combatmedic_support_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "science_combatmedic_support_02",
  ],
  xp: { id: "medical", cost: 37500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_healing_ability: 15,
    slope_move: 10,
  },
  schematics: [""]
},
science_combatmedic_support_04: {
  title: "Expert Combat Medic",
  skillPoints: 2,
  preReqs: [
    "science_combatmedic_support_03",
  ],
  xp: { id: "medical", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_healing_ability: 25,
    slope_move: 10,
    burst_run: 10,
  },
  schematics: [""]
},
social_imagedesigner_novice: {
  title: "Novice Image Designer",
  skillPoints: 0,
  preReqs: [
    "social_entertainer_hairstyle_04",
  ],
  xp: { id: "imagedesigner", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hair: 1,
    body: 1,
    face: 1,
  },
  schematics: [""]
},
social_imagedesigner_master: {
  title: "Master Image Designer",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_hairstyle_04",
    "social_imagedesigner_exotic_04",
    "social_imagedesigner_bodyform_04",
    "social_imagedesigner_markings_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    markings: 2,
    body: 2,
    face: 2,
  },
  schematics: [""]
},
social_imagedesigner_hairstyle_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_novice",
  ],
  xp: { id: "imagedesigner", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hair: 1,
  },
  schematics: [""]
},
social_imagedesigner_hairstyle_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_hairstyle_01",
  ],
  xp: { id: "imagedesigner", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hair: 2,
  },
  schematics: [""]
},
social_imagedesigner_hairstyle_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_hairstyle_02",
  ],
  xp: { id: "imagedesigner", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hair: 2,
  },
  schematics: [""]
},
social_imagedesigner_hairstyle_04: {
  title: "Expert Hairstylist",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_hairstyle_03",
  ],
  xp: { id: "imagedesigner", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    hair: 2,
  },
  schematics: [""]
},
social_imagedesigner_exotic_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_novice",
  ],
  xp: { id: "imagedesigner", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    face: 1,
  },
  schematics: [""]
},
social_imagedesigner_exotic_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_exotic_01",
  ],
  xp: { id: "imagedesigner", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    face: 1,
  },
  schematics: [""]
},
social_imagedesigner_exotic_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_exotic_02",
  ],
  xp: { id: "imagedesigner", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    face: 2,
  },
  schematics: [""]
},
social_imagedesigner_exotic_04: {
  title: "Plastic Surgeon",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_exotic_03",
  ],
  xp: { id: "imagedesigner", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    face: 2,
  },
  schematics: [""]
},
social_imagedesigner_bodyform_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_novice",
  ],
  xp: { id: "imagedesigner", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    body: 1,
  },
  schematics: [""]
},
social_imagedesigner_bodyform_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_bodyform_01",
  ],
  xp: { id: "imagedesigner", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    body: 1,
  },
  schematics: [""]
},
social_imagedesigner_bodyform_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_bodyform_02",
  ],
  xp: { id: "imagedesigner", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    body: 2,
  },
  schematics: [""]
},
social_imagedesigner_bodyform_04: {
  title: "Personal Trainer",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_bodyform_03",
  ],
  xp: { id: "imagedesigner", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    body: 2,
  },
  schematics: [""]
},
social_imagedesigner_markings_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_novice",
  ],
  xp: { id: "imagedesigner", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    markings: 1,
  },
  schematics: [""]
},
social_imagedesigner_markings_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_markings_01",
  ],
  xp: { id: "imagedesigner", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    markings: 1,
  },
  schematics: [""]
},
social_imagedesigner_markings_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_markings_02",
  ],
  xp: { id: "imagedesigner", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    markings: 2,
  },
  schematics: [""]
},
social_imagedesigner_markings_04: {
  title: "Tattoo Artist",
  skillPoints: 0,
  preReqs: [
    "social_imagedesigner_markings_03",
  ],
  xp: { id: "imagedesigner", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    markings: 2,
  },
  schematics: [""]
},
outdoors_squadleader_novice: {
  title: "Novice Squad Leader",
  skillPoints: 1,
  preReqs: [
    "outdoors_scout_movement_04",
    "outdoors_scout_camp_04",
    "combat_marksman_support_04",
  ],
  xp: { id: "combat_general", cost: 7500 },
  commands: [
    "sysgroup",
  ],
  skillModifiers: {},
  schematics: [""]
},
outdoors_squadleader_master: {
  title: "Master Squad Leader",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_movement_04",
    "outdoors_squadleader_offense_04",
    "outdoors_squadleader_defense_04",
    "outdoors_squadleader_support_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_melee_defense: 5,
    group_ranged_defense: 5,
    group_burst_run: 10,
    group_slope_move: 10,
  },
  schematics: [""]
},
outdoors_squadleader_movement_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_novice",
  ],
  xp: { id: "squadleader", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_slope_move: 25,
  },
  schematics: [""]
},
outdoors_squadleader_movement_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_movement_01",
  ],
  xp: { id: "squadleader", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_burst_run: 25,
  },
  schematics: [""]
},
outdoors_squadleader_movement_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_movement_02",
  ],
  xp: { id: "squadleader", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_slope_move: 25,
  },
  schematics: [""]
},
outdoors_squadleader_movement_04: {
  title: "Field Commander",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_movement_03",
  ],
  xp: { id: "squadleader", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_burst_run: 25,
  },
  schematics: [""]
},
outdoors_squadleader_offense_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_novice",
  ],
  xp: { id: "squadleader", cost: 175000 },
  commands: [
    "steadyaim",
  ],
  skillModifiers: {},
  schematics: [""]
},
outdoors_squadleader_offense_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_offense_01",
  ],
  xp: { id: "squadleader", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    steadyaim: 10,
  },
  schematics: [""]
},
outdoors_squadleader_offense_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_offense_02",
  ],
  xp: { id: "squadleader", cost: 350000 },
  commands: [
    "volleyFire",
  ],
  skillModifiers: {},
  schematics: [""]
},
outdoors_squadleader_offense_04: {
  title: "Strategist",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_offense_03",
  ],
  xp: { id: "squadleader", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    volley: 10,
  },
  schematics: [""]
},
outdoors_squadleader_defense_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_novice",
  ],
  xp: { id: "squadleader", cost: 175000 },
  commands: [
    "formup",
  ],
  skillModifiers: {},
  schematics: [""]
},
outdoors_squadleader_defense_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_defense_01",
  ],
  xp: { id: "squadleader", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_melee_defense: 10,
  },
  schematics: [""]
},
outdoors_squadleader_defense_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_defense_02",
  ],
  xp: { id: "squadleader", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_melee_defense: 15,
  },
  schematics: [""]
},
outdoors_squadleader_defense_04: {
  title: "Commissar",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_defense_03",
  ],
  xp: { id: "squadleader", cost: 450000 },
  commands: [
    "boostmorale",
  ],
  skillModifiers: {},
  schematics: [""]
},
outdoors_squadleader_support_01: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_novice",
  ],
  xp: { id: "squadleader", cost: 175000 },
  commands: [
    "rally",
  ],
  skillModifiers: {},
  schematics: [""]
},
outdoors_squadleader_support_02: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_support_01",
  ],
  xp: { id: "squadleader", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_ranged_defense: 10,
  },
  schematics: [""]
},
outdoors_squadleader_support_03: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_support_02",
  ],
  xp: { id: "squadleader", cost: 350000 },
  commands: [
    "retreat",
  ],
  skillModifiers: {},
  schematics: [""]
},
outdoors_squadleader_support_04: {
  title: "Tactician",
  skillPoints: 1,
  preReqs: [
    "outdoors_squadleader_support_03",
  ],
  xp: { id: "squadleader", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    group_ranged_defense: 15,
  },
  schematics: [""]
},
social_politician_novice: {
  title: "Novice Politician",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "place_cityhall",
    "manage_taxes",
    "grantZoningRights",
  ],
  skillModifiers: {
    private_place_cityhall: 100,
  },
  schematics: [""]
},
social_politician_master: {
  title: "Master Politician",
  skillPoints: 0,
  preReqs: [
    "social_politician_fiscal_04",
    "social_politician_martial_04",
    "social_politician_civic_04",
    "social_politician_urban_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_fiscal_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_novice",
  ],
  xp: { id: "political", cost: 1000 },
  commands: [
    "city_map",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_fiscal_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_fiscal_01",
  ],
  xp: { id: "political", cost: 2500 },
  commands: [
    "place_bank",
    "place_shuttleport",
  ],
  skillModifiers: {
    private_place_bank: 100,
    private_place_shuttleport: 100,
  },
  schematics: [""]
},
social_politician_fiscal_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_fiscal_02",
  ],
  xp: { id: "political", cost: 5000 },
  commands: [
    "city_spec_industry",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_fiscal_04: {
  title: "Accountant",
  skillPoints: 0,
  preReqs: [
    "social_politician_fiscal_03",
  ],
  xp: { id: "political", cost: 10000 },
  commands: [
    "city_spec_research",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_martial_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_novice",
  ],
  xp: { id: "political", cost: 1000 },
  commands: [
    "manage_militia",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_martial_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_martial_01",
  ],
  xp: { id: "political", cost: 2500 },
  commands: [
    "place_cloning",
    "city_spec_cloning",
  ],
  skillModifiers: {
    private_place_cloning: 100,
  },
  schematics: [""]
},
social_politician_martial_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_martial_02",
  ],
  xp: { id: "political", cost: 5000 },
  commands: [
    "city_spec_stronghold",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_martial_04: {
  title: "Warmaster",
  skillPoints: 0,
  preReqs: [
    "social_politician_martial_03",
  ],
  xp: { id: "political", cost: 10000 },
  commands: [
    "place_faction_terminal",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_civic_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_novice",
  ],
  xp: { id: "political", cost: 1000 },
  commands: [
    "installMissionTerminal",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_civic_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_civic_01",
  ],
  xp: { id: "political", cost: 2500 },
  commands: [
    "recruitSkillTrainer",
    "place_garage",
  ],
  skillModifiers: {
    private_place_garage: 100,
  },
  schematics: [""]
},
social_politician_civic_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_civic_02",
  ],
  xp: { id: "political", cost: 5000 },
  commands: [
    "city_spec_entertainer",
    "city_spec_doctor",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_civic_04: {
  title: "Statesman",
  skillPoints: 0,
  preReqs: [
    "social_politician_civic_03",
  ],
  xp: { id: "political", cost: 10000 },
  commands: [
    "city_spec_missions",
    "city_spec_sample_rich",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_urban_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_novice",
  ],
  xp: { id: "political", cost: 1000 },
  commands: [
    "place_streetlamp",
    "place_statue",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_urban_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_urban_01",
  ],
  xp: { id: "political", cost: 2500 },
  commands: [
    "place_fountain",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_politician_urban_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "social_politician_urban_02",
  ],
  xp: { id: "political", cost: 5000 },
  commands: [
    "place_small_garden",
    "place_medium_garden",
  ],
  skillModifiers: {
    private_place_small_garden: 100,
    private_place_medium_garden: 100,
  },
  schematics: [""]
},
social_politician_urban_04: {
  title: "Urban Planner",
  skillPoints: 0,
  preReqs: [
    "social_politician_urban_03",
  ],
  xp: { id: "political", cost: 10000 },
  commands: [
    "place_large_garden",
    "place_exotic_garden",
  ],
  skillModifiers: {
    private_place_large_garden: 100,
    private_place_exotic_garden: 100,
  },
  schematics: [""]
},
social_language: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_basic: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_basic_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_basic_speak: 100,
  },
  schematics: [""]
},
social_language_basic_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_basic_comprehend: 100,
  },
  schematics: [""]
},
social_language_rodian: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_rodian_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+rodese",
  ],
  skillModifiers: {
    language_rodian_speak: 100,
  },
  schematics: [""]
},
social_language_rodian_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_rodian_comprehend: 100,
  },
  schematics: [""]
},
social_language_trandoshan: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_trandoshan_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+dosh",
  ],
  skillModifiers: {
    language_trandoshan_speak: 100,
  },
  schematics: [""]
},
social_language_trandoshan_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_trandoshan_comprehend: 100,
  },
  schematics: [""]
},
social_language_moncalamari: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_moncalamari_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+moncalamarian",
  ],
  skillModifiers: {
    language_moncalamari_speak: 100,
  },
  schematics: [""]
},
social_language_moncalamari_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_moncalamari_comprehend: 100,
  },
  schematics: [""]
},
social_language_wookiee: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_wookiee_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+shyriiwook",
  ],
  skillModifiers: {
    language_wookiee_speak: 100,
  },
  schematics: [""]
},
social_language_wookiee_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_wookiee_comprehend: 100,
  },
  schematics: [""]
},
social_language_bothan: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_bothan_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+bothese",
  ],
  skillModifiers: {
    language_bothan_speak: 100,
  },
  schematics: [""]
},
social_language_bothan_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_bothan_comprehend: 100,
  },
  schematics: [""]
},
social_language_twilek: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_twilek_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+ryl",
  ],
  skillModifiers: {
    language_twilek_speak: 100,
  },
  schematics: [""]
},
social_language_twilek_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_twilek_comprehend: 100,
  },
  schematics: [""]
},
social_language_zabrak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_zabrak_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+zabrak",
  ],
  skillModifiers: {
    language_zabrak_speak: 100,
  },
  schematics: [""]
},
social_language_zabrak_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_zabrak_comprehend: 100,
  },
  schematics: [""]
},
social_language_lekku: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "unobtainable", cost: 1 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_lekku_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "unobtainable", cost: 1 },
  commands: [
    "language+lekku",
  ],
  skillModifiers: {
    language_lekku_speak: 100,
  },
  schematics: [""]
},
social_language_lekku_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "unobtainable", cost: 1 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_lekku_comprehend: 100,
  },
  schematics: [""]
},
social_language_ithorian: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_ithorian_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+ithorian",
  ],
  skillModifiers: {
    language_ithorian_speak: 100,
  },
  schematics: [""]
},
social_language_ithorian_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_ithorian_comprehend: 100,
  },
  schematics: [""]
},
social_language_sullustan: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
social_language_sullustan_speak: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "language+sullustan",
  ],
  skillModifiers: {
    language_sullustan_speak: 100,
  },
  schematics: [""]
},
social_language_sullustan_comprehend: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    language_sullustan_comprehend: 100,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "fs_combat", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_combat_prowess_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_ranged_accuracy_04",
    "force_sensitive_combat_prowess_ranged_speed_04",
    "force_sensitive_combat_prowess_melee_accuracy_04",
    "force_sensitive_combat_prowess_melee_speed_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_accuracy_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_novice",
  ],
  xp: { id: "fs_combat", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_accuracy_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_ranged_accuracy_01",
  ],
  xp: { id: "fs_combat", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_accuracy_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_ranged_accuracy_02",
  ],
  xp: { id: "fs_combat", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_accuracy_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_ranged_accuracy_03",
  ],
  xp: { id: "fs_combat", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_speed_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_novice",
  ],
  xp: { id: "fs_combat", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_speed: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_speed_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_ranged_speed_01",
  ],
  xp: { id: "fs_combat", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_speed: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_speed_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_ranged_speed_02",
  ],
  xp: { id: "fs_combat", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_speed: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_ranged_speed_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_ranged_speed_03",
  ],
  xp: { id: "fs_combat", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_speed: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_accuracy_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_novice",
  ],
  xp: { id: "fs_combat", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_accuracy_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_melee_accuracy_01",
  ],
  xp: { id: "fs_combat", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_accuracy_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_melee_accuracy_02",
  ],
  xp: { id: "fs_combat", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_accuracy_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_melee_accuracy_03",
  ],
  xp: { id: "fs_combat", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_accuracy: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_speed_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_novice",
  ],
  xp: { id: "fs_combat", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_speed: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_speed_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_melee_speed_01",
  ],
  xp: { id: "fs_combat", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_speed: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_speed_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_melee_speed_02",
  ],
  xp: { id: "fs_combat", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_speed: 3,
  },
  schematics: [""]
},
force_sensitive_combat_prowess_melee_speed_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_combat_prowess_melee_speed_03",
  ],
  xp: { id: "fs_combat", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_speed: 3,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "fs_reflex", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_enhanced_reflexes_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_ranged_defense_04",
    "force_sensitive_enhanced_reflexes_melee_defense_04",
    "force_sensitive_enhanced_reflexes_vehicle_control_04",
    "force_sensitive_enhanced_reflexes_survival_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_enhanced_reflexes_ranged_defense_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_novice",
  ],
  xp: { id: "fs_reflex", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_ranged_defense_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_ranged_defense_01",
  ],
  xp: { id: "fs_reflex", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_ranged_defense_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_ranged_defense_02",
  ],
  xp: { id: "fs_reflex", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_ranged_defense_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_ranged_defense_03",
  ],
  xp: { id: "fs_reflex", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_melee_defense_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_novice",
  ],
  xp: { id: "fs_reflex", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_melee_defense_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_melee_defense_01",
  ],
  xp: { id: "fs_reflex", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_melee_defense_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_melee_defense_02",
  ],
  xp: { id: "fs_reflex", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_melee_defense_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_melee_defense_03",
  ],
  xp: { id: "fs_reflex", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_vehicle_control_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_novice",
  ],
  xp: { id: "fs_reflex", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_vehicle_control: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_vehicle_control_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_vehicle_control_01",
  ],
  xp: { id: "fs_reflex", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_vehicle_control: 5,
    force_vehicle_speed: 1,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_vehicle_control_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_vehicle_control_02",
  ],
  xp: { id: "fs_reflex", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_vehicle_control: 5,
    force_vehicle_speed: 1,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_vehicle_control_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_vehicle_control_03",
  ],
  xp: { id: "fs_reflex", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_vehicle_control: 5,
    force_vehicle_speed: 1,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_survival_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_novice",
  ],
  xp: { id: "fs_reflex", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    camp: 5,
    foraging: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_survival_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_survival_01",
  ],
  xp: { id: "fs_reflex", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    trapping: 5,
    mask_scent: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_survival_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_survival_02",
  ],
  xp: { id: "fs_reflex", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    slope_move: 5,
  },
  schematics: [""]
},
force_sensitive_enhanced_reflexes_survival_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_enhanced_reflexes_survival_03",
  ],
  xp: { id: "fs_reflex", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    creature_knowledge: 5,
    creature_harvesting: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "fs_crafting", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_crafting_mastery_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_experimentation_04",
    "force_sensitive_crafting_mastery_assembly_04",
    "force_sensitive_crafting_mastery_repair_04",
    "force_sensitive_crafting_mastery_technique_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_crafting_mastery_experimentation_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_novice",
  ],
  xp: { id: "fs_crafting", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_experimentation: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_experimentation_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_experimentation_01",
  ],
  xp: { id: "fs_crafting", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_experimentation: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_experimentation_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_experimentation_02",
  ],
  xp: { id: "fs_crafting", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_experimentation: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_experimentation_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_experimentation_03",
  ],
  xp: { id: "fs_crafting", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_experimentation: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_assembly_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_novice",
  ],
  xp: { id: "fs_crafting", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_assembly: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_assembly_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_assembly_01",
  ],
  xp: { id: "fs_crafting", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_assembly: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_assembly_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_assembly_02",
  ],
  xp: { id: "fs_crafting", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_assembly: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_assembly_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_assembly_03",
  ],
  xp: { id: "fs_crafting", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_assembly: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_repair_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_novice",
  ],
  xp: { id: "fs_crafting", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_repair_bonus: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_repair_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_repair_01",
  ],
  xp: { id: "fs_crafting", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_repair_bonus: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_repair_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_repair_02",
  ],
  xp: { id: "fs_crafting", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_repair_bonus: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_repair_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_repair_03",
  ],
  xp: { id: "fs_crafting", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_repair_bonus: 5,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_technique_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_novice",
  ],
  xp: { id: "fs_crafting", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_failure_reduction: 1,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_technique_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_technique_01",
  ],
  xp: { id: "fs_crafting", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_failure_reduction: 1,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_technique_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_technique_02",
  ],
  xp: { id: "fs_crafting", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_failure_reduction: 1,
  },
  schematics: [""]
},
force_sensitive_crafting_mastery_technique_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_crafting_mastery_technique_03",
  ],
  xp: { id: "fs_crafting", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_failure_reduction: 1,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "fs_senses", cost: 50000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_heightened_senses_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_healing_04",
    "force_sensitive_heightened_senses_surveying_04",
    "force_sensitive_heightened_senses_persuasion_04",
    "force_sensitive_heightened_senses_luck_04",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_sensitive_heightened_senses_healing_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_novice",
  ],
  xp: { id: "fs_senses", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_injury_treatment: 5,
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_healing_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_healing_01",
  ],
  xp: { id: "fs_senses", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_injury_speed: 5,
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_healing_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_healing_02",
  ],
  xp: { id: "fs_senses", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_injury_treatment: 5,
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_healing_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_healing_03",
  ],
  xp: { id: "fs_senses", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    healing_injury_speed: 5,
    healing_dance_wound: 5,
    healing_music_wound: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_surveying_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_novice",
  ],
  xp: { id: "fs_senses", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    surveying: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_surveying_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_surveying_01",
  ],
  xp: { id: "fs_senses", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    surveying: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_surveying_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_surveying_02",
  ],
  xp: { id: "fs_senses", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    surveying: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_surveying_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_surveying_03",
  ],
  xp: { id: "fs_senses", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    surveying: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_persuasion_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_novice",
  ],
  xp: { id: "fs_senses", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_persuade: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_persuasion_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_persuasion_01",
  ],
  xp: { id: "fs_senses", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_persuade: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_persuasion_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_persuasion_02",
  ],
  xp: { id: "fs_senses", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_persuade: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_persuasion_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_persuasion_03",
  ],
  xp: { id: "fs_senses", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_persuade: 5,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_luck_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_novice",
  ],
  xp: { id: "fs_senses", cost: 175000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_luck: 1,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_luck_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_luck_01",
  ],
  xp: { id: "fs_senses", cost: 250000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_luck: 1,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_luck_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_luck_02",
  ],
  xp: { id: "fs_senses", cost: 350000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_luck: 1,
  },
  schematics: [""]
},
force_sensitive_heightened_senses_luck_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_sensitive_heightened_senses_luck_03",
  ],
  xp: { id: "fs_senses", cost: 450000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_luck: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_novice: {
  title: "",
  skillPoints: 8,
  preReqs: [],
  xp: { id: "jedi_general", cost: 20000 },
  commands: [
    "saberPolearmHit1",
    "saber1hHit1",
    "saber2hHit1",
    "cert_onehandlightsaber_gen1",
    "cert_polearmlightsaber_gen1",
    "cert_twohandlightsaber_gen1",
  ],
  skillModifiers: {
    onehandlightsaber_accuracy: 25,
    onehandlightsaber_speed: 25,
    twohandlightsaber_accuracy: 25,
    twohandlightsaber_speed: 25,
    polearmlightsaber_accuracy: 25,
    polearmlightsaber_speed: 25,
    saber_block: 10,
    lightsaber_toughness: 10,
    jedi_saber_assembly: 10,
    jedi_saber_experimentation: 10,
    private_onehandlightsaber_combat_difficulty: 200,
    private_twohandlightsaber_combat_difficulty: 200,
    private_polearmlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 200,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_master: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_light_saber_one_hand_04",
    "force_discipline_light_saber_two_hand_04",
    "force_discipline_light_saber_polearm_04",
    "force_discipline_light_saber_technique_04",
  ],
  xp: { id: "jedi_general", cost: 3200000 },
  commands: [
    "saberThrow3",
    "saber1hFlurry2",
    "saber2hPhantom",
    "saberPolearmDervish2",
    "cert_onehandlightsaber_gen4",
    "cert_polearmlightsaber_gen4",
    "cert_twohandlightsaber_gen4",
  ],
  skillModifiers: {
    onehandlightsaber_accuracy: 25,
    onehandlightsaber_speed: 25,
    twohandlightsaber_accuracy: 25,
    twohandlightsaber_speed: 25,
    polearmlightsaber_accuracy: 25,
    polearmlightsaber_speed: 25,
    saber_block: 25,
    lightsaber_toughness: 15,
    jedi_saber_assembly: 30,
    jedi_saber_experimentation: 25,
    jedi_force_power_max: 500,
    jedi_force_power_regen: 5,
  },
  schematics: ["craftSaberMaster"]
},
force_discipline_light_saber_one_hand_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_light_saber_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "saber1hHeadHit1",
    "saber1hComboHit1",
  ],
  skillModifiers: {
    onehandlightsaber_accuracy: 5,
    onehandlightsaber_speed: 5,
    private_onehandlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_one_hand_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_light_saber_one_hand_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "saber1hHit2",
    "saber1hHeadHit2",
    "cert_onehandlightsaber_gen2",
  ],
  skillModifiers: {
    onehandlightsaber_accuracy: 10,
    onehandlightsaber_speed: 10,
    private_onehandlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: ["craftSaberOneHand2"]
},
force_discipline_light_saber_one_hand_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_light_saber_one_hand_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "saber1hComboHit2",
    "saber1hHeadHit3",
  ],
  skillModifiers: {
    onehandlightsaber_accuracy: 15,
    onehandlightsaber_speed: 15,
    private_onehandlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_one_hand_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_light_saber_one_hand_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "saber1hHit3",
    "saber1hComboHit3",
    "saber1hFlurry",
    "cert_onehandlightsaber_gen3",
  ],
  skillModifiers: {
    onehandlightsaber_accuracy: 20,
    onehandlightsaber_speed: 20,
    private_onehandlightsaber_combat_difficulty: 300,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: ["craftSaberOneHand3"]
},
force_discipline_light_saber_two_hand_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_light_saber_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "saber2hBodyHit1",
    "saber2hSweep1",
  ],
  skillModifiers: {
    twohandlightsaber_accuracy: 5,
    twohandlightsaber_speed: 5,
    private_twohandlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_two_hand_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_light_saber_two_hand_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "saber2hHit2",
    "saber2hBodyHit2",
    "cert_twohandlightsaber_gen2",
  ],
  skillModifiers: {
    twohandlightsaber_accuracy: 10,
    twohandlightsaber_speed: 10,
    private_twohandlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: ["craftSaberTwoHand2"]
},
force_discipline_light_saber_two_hand_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_light_saber_two_hand_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "saber2hBodyHit3",
    "saber2hSweep2",
  ],
  skillModifiers: {
    twohandlightsaber_accuracy: 15,
    twohandlightsaber_speed: 15,
    private_twohandlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_two_hand_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_light_saber_two_hand_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "saber2hHit3",
    "saber2hSweep3",
    "saber2hFrenzy",
    "cert_twohandlightsaber_gen3",
  ],
  skillModifiers: {
    twohandlightsaber_accuracy: 20,
    twohandlightsaber_speed: 20,
    private_twohandlightsaber_combat_difficulty: 300,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: ["craftSaberTwoHand3"]
},
force_discipline_light_saber_polearm_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_light_saber_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "saberPolearmLegHit1",
    "saberPolearmSpinAttack1",
  ],
  skillModifiers: {
    polearmlightsaber_accuracy: 5,
    polearmlightsaber_speed: 5,
    private_polearmlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_polearm_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_light_saber_polearm_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "saberPolearmHit2",
    "saberPolearmLegHit2",
    "cert_polearmlightsaber_gen2",
  ],
  skillModifiers: {
    polearmlightsaber_accuracy: 10,
    polearmlightsaber_speed: 10,
    private_polearmlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: ["craftSaberPoleArm2"]
},
force_discipline_light_saber_polearm_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_light_saber_polearm_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "saberPolearmLegHit3",
    "saberPolearmSpinAttack2",
  ],
  skillModifiers: {
    polearmlightsaber_accuracy: 15,
    polearmlightsaber_speed: 15,
    private_polearmlightsaber_combat_difficulty: 200,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_polearm_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_light_saber_polearm_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "saberPolearmHit3",
    "saberPolearmSpinAttack3",
    "saberPolearmDervish",
    "cert_polearmlightsaber_gen3",
  ],
  skillModifiers: {
    polearmlightsaber_accuracy: 20,
    polearmlightsaber_speed: 20,
    private_polearmlightsaber_combat_difficulty: 300,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: ["craftSaberPoleArm3"]
},
force_discipline_light_saber_technique_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_light_saber_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "saberSlash1",
  ],
  skillModifiers: {
    saber_block: 5,
    lightsaber_toughness: 5,
    jedi_saber_assembly: 15,
    jedi_saber_experimentation: 10,
    private_onehandlightsaber_combat_difficulty: 100,
    private_twohandlightsaber_combat_difficulty: 100,
    private_polearmlightsaber_combat_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_technique_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_light_saber_technique_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "saberThrow1",
  ],
  skillModifiers: {
    saber_block: 10,
    lightsaber_toughness: 5,
    jedi_saber_assembly: 15,
    jedi_saber_experimentation: 15,
    private_onehandlightsaber_combat_difficulty: 100,
    private_twohandlightsaber_combat_difficulty: 100,
    private_polearmlightsaber_combat_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_technique_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_light_saber_technique_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "saberSlash2",
  ],
  skillModifiers: {
    saber_block: 15,
    lightsaber_toughness: 10,
    jedi_saber_assembly: 15,
    jedi_saber_experimentation: 20,
    private_onehandlightsaber_combat_difficulty: 100,
    private_twohandlightsaber_combat_difficulty: 100,
    private_polearmlightsaber_combat_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_light_saber_technique_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_light_saber_technique_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "saberThrow2",
  ],
  skillModifiers: {
    saber_block: 20,
    lightsaber_toughness: 10,
    jedi_saber_assembly: 15,
    jedi_saber_experimentation: 20,
    private_onehandlightsaber_combat_difficulty: 100,
    private_twohandlightsaber_combat_difficulty: 100,
    private_polearmlightsaber_combat_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_powers_novice: {
  title: "",
  skillPoints: 8,
  preReqs: [],
  xp: { id: "jedi_general", cost: 20000 },
  commands: [
    "animalScare",
  ],
  skillModifiers: {
    private_jedi_difficulty: 50,
    jedi_force_power_max: 200,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_master: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_powers_lightning_04",
    "force_discipline_powers_mental_04",
    "force_discipline_powers_debuff_04",
    "force_discipline_powers_push_04",
  ],
  xp: { id: "jedi_general", cost: 3200000 },
  commands: [
    "jediMindTrick",
    "forceChoke",
    "forceKnockdown3",
  ],
  skillModifiers: {
    forceintimidate_accuracy: 35,
    forcethrow_accuracy: 30,
    forceknockdown_accuracy: 35,
    forceweaken_accuracy: 30,
    mindblast_accuracy: 30,
    forcelightning_accuracy: 30,
    force_choke: 5,
    private_jedi_difficulty: 200,
    jedi_force_power_max: 500,
    jedi_force_power_regen: 5,
  },
  schematics: [""]
},
force_discipline_powers_lightning_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_powers_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "forceLightningSingle1",
  ],
  skillModifiers: {
    private_force_lightning_single_power: 1,
    forcelightning_accuracy: 20,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_lightning_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_powers_lightning_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "forceLightningCone1",
  ],
  skillModifiers: {
    private_force_lightning_cone_power: 1,
    forcelightning_accuracy: 20,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_lightning_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_powers_lightning_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "forceLightningSingle2",
  ],
  skillModifiers: {
    private_force_lightning_single_power: 2,
    forcelightning_accuracy: 20,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_lightning_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_powers_lightning_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "forceLightningCone2",
  ],
  skillModifiers: {
    private_force_lightning_cone_power: 2,
    forcelightning_accuracy: 20,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_powers_mental_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_powers_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "mindBlast1",
  ],
  skillModifiers: {
    mindblast_accuracy: 20,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_mental_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_powers_mental_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "animalCalm",
  ],
  skillModifiers: {
    mindblast_accuracy: 20,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_mental_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_powers_mental_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "mindBlast2",
  ],
  skillModifiers: {
    mindblast_accuracy: 20,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_mental_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_powers_mental_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "animalAttack",
  ],
  skillModifiers: {
    mindblast_accuracy: 20,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_powers_debuff_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_powers_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "forceWeaken1",
  ],
  skillModifiers: {
    forceweaken_accuracy: 20,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_debuff_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_powers_debuff_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "forceIntimidate1",
  ],
  skillModifiers: {
    forceweaken_accuracy: 20,
    forceintimidate_accuracy: 25,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_debuff_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_powers_debuff_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "forceWeaken2",
  ],
  skillModifiers: {
    forceweaken_accuracy: 20,
    forceintimidate_accuracy: 25,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_debuff_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_powers_debuff_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "forceIntimidate2",
  ],
  skillModifiers: {
    forceweaken_accuracy: 20,
    forceintimidate_accuracy: 25,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_powers_push_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_powers_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "forceThrow1",
  ],
  skillModifiers: {
    forcethrow_accuracy: 20,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_push_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_powers_push_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "forceKnockdown1",
  ],
  skillModifiers: {
    forcethrow_accuracy: 20,
    forceknockdown_accuracy: 25,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_push_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_powers_push_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "forceThrow2",
  ],
  skillModifiers: {
    forcethrow_accuracy: 20,
    forceknockdown_accuracy: 25,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_powers_push_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_powers_push_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "forceKnockdown2",
  ],
  skillModifiers: {
    forcethrow_accuracy: 20,
    forceknockdown_accuracy: 25,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_healing_novice: {
  title: "",
  skillPoints: 8,
  preReqs: [],
  xp: { id: "jedi_general", cost: 20000 },
  commands: [
    "healHealthSelf1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 50,
    jedi_force_power_max: 200,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_master: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_healing_damage_04",
    "force_discipline_healing_wound_04",
    "force_discipline_healing_other_04",
    "force_discipline_healing_states_04",
  ],
  xp: { id: "jedi_general", cost: 3200000 },
  commands: [
    "totalHealSelf",
    "totalHealOther",
  ],
  skillModifiers: {
    private_jedi_difficulty: 200,
    jedi_force_power_max: 500,
    jedi_force_power_regen: 5,
  },
  schematics: [""]
},
force_discipline_healing_damage_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_healing_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "healMindSelf1",
    "healActionSelf1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_damage_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_healing_damage_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "healAllSelf1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_damage_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_healing_damage_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "healMindSelf2",
    "healActionSelf2",
    "healHealthSelf2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_damage_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_healing_damage_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "healAllSelf2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_healing_wound_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_healing_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "healHealthWoundSelf1",
    "healActionWoundSelf1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_wound_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_healing_wound_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "healMindWoundSelf1",
    "healBattleFatigueSelf1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_wound_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_healing_wound_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "healActionWoundSelf2",
    "healHealthWoundSelf2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_wound_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_healing_wound_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "healBattleFatigueSelf2",
    "healMindWoundSelf2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_healing_other_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_healing_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "healMindWoundOther1",
    "healHealthWoundOther1",
    "healActionWoundOther1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_other_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_healing_other_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "healAllOther1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_other_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_healing_other_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "healHealthWoundOther2",
    "healActionWoundOther2",
    "healMindWoundOther2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_other_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_healing_other_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "healAllOther2",
    "healStatesOther",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_healing_states_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_healing_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "stopBleeding",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_states_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_healing_states_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "forceCureDisease",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_states_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_healing_states_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "forceCurePoison",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_healing_states_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_healing_states_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "healStatesSelf",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_enhancements_novice: {
  title: "",
  skillPoints: 8,
  preReqs: [],
  xp: { id: "jedi_general", cost: 20000 },
  commands: [
    "forceAbsorb1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 50,
    jedi_force_power_max: 200,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_master: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_enhancements_movement_04",
    "force_discipline_enhancements_protection_04",
    "force_discipline_enhancements_resistance_04",
    "force_discipline_enhancements_synergy_04",
  ],
  xp: { id: "jedi_general", cost: 3200000 },
  commands: [
    "forceRun3",
    "regainConsciousness",
  ],
  skillModifiers: {
    private_jedi_difficulty: 200,
    jedi_force_power_max: 500,
    jedi_force_power_regen: 5,
  },
  schematics: [""]
},
force_discipline_enhancements_movement_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_enhancements_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "forceSpeed1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_movement_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_enhancements_movement_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "forceRun1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_movement_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_enhancements_movement_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "forceSpeed2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_movement_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_enhancements_movement_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "forceRun2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_enhancements_protection_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_enhancements_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "forceFeedback1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_protection_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_enhancements_protection_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "forceArmor1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_protection_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_enhancements_protection_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "forceFeedback2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_protection_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_enhancements_protection_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "forceAbsorb2",
    "forceArmor2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_enhancements_resistance_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_enhancements_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "forceResistBleeding",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_resistance_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_enhancements_resistance_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "forceResistDisease",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_resistance_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_enhancements_resistance_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "forceResistPoison",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_resistance_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_enhancements_resistance_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "forceResistStates",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_enhancements_synergy_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_enhancements_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "transferForce",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_synergy_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_enhancements_synergy_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "channelForce",
    "forceShield1",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_synergy_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_enhancements_synergy_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "drainForce",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_enhancements_synergy_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_enhancements_synergy_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "forceMeditate",
    "forceShield2",
  ],
  skillModifiers: {
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_defender_novice: {
  title: "",
  skillPoints: 8,
  preReqs: [],
  xp: { id: "jedi_general", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 20,
    ranged_defense: 15,
    force_defense: 20,
    jedi_state_defense: 15,
    jedi_toughness: 5,
    private_jedi_difficulty: 50,
    jedi_force_power_max: 200,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_master: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_defender_melee_defense_04",
    "force_discipline_defender_ranged_defense_04",
    "force_discipline_defender_force_defense_04",
    "force_discipline_defender_preternatural_defense_04",
  ],
  xp: { id: "jedi_general", cost: 3200000 },
  commands: [
    "avoidIncapacitation",
  ],
  skillModifiers: {
    melee_defense: 25,
    ranged_defense: 20,
    force_defense: 25,
    jedi_state_defense: 15,
    jedi_toughness: 8,
    private_jedi_difficulty: 200,
    jedi_force_power_max: 500,
    jedi_force_power_regen: 5,
  },
  schematics: [""]
},
force_discipline_defender_melee_defense_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_defender_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 5,
    jedi_toughness: 1,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_melee_defense_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_defender_melee_defense_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 10,
    jedi_toughness: 1,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_melee_defense_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_defender_melee_defense_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 15,
    jedi_toughness: 2,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_melee_defense_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_defender_melee_defense_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "",
  ],
  skillModifiers: {
    melee_defense: 20,
    jedi_toughness: 4,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_defender_ranged_defense_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_defender_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 5,
    jedi_toughness: 1,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_ranged_defense_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_defender_ranged_defense_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 10,
    jedi_toughness: 1,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_ranged_defense_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_defender_ranged_defense_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 10,
    jedi_toughness: 2,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_ranged_defense_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_defender_ranged_defense_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "",
  ],
  skillModifiers: {
    ranged_defense: 15,
    jedi_toughness: 4,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_defender_force_defense_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_defender_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_defense: 10,
    jedi_toughness: 1,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_force_defense_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_defender_force_defense_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_defense: 10,
    jedi_toughness: 1,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_force_defense_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_defender_force_defense_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_defense: 15,
    jedi_toughness: 2,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_force_defense_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_defender_force_defense_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_defense: 20,
    jedi_toughness: 4,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_discipline_defender_preternatural_defense_01: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "force_discipline_defender_novice",
  ],
  xp: { id: "jedi_general", cost: 200000 },
  commands: [
    "",
  ],
  skillModifiers: {
    jedi_state_defense: 5,
    jedi_toughness: 1,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_preternatural_defense_02: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "force_discipline_defender_preternatural_defense_01",
  ],
  xp: { id: "jedi_general", cost: 400000 },
  commands: [
    "",
  ],
  skillModifiers: {
    jedi_state_defense: 5,
    jedi_toughness: 1,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 100,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_preternatural_defense_03: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "force_discipline_defender_preternatural_defense_02",
  ],
  xp: { id: "jedi_general", cost: 800000 },
  commands: [
    "",
  ],
  skillModifiers: {
    jedi_state_defense: 10,
    jedi_toughness: 2,
    private_jedi_difficulty: 100,
    jedi_force_power_max: 150,
    jedi_force_power_regen: 1,
  },
  schematics: [""]
},
force_discipline_defender_preternatural_defense_04: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "force_discipline_defender_preternatural_defense_03",
  ],
  xp: { id: "jedi_general", cost: 1600000 },
  commands: [
    "",
  ],
  skillModifiers: {
    jedi_state_defense: 15,
    jedi_toughness: 4,
    private_jedi_difficulty: 125,
    jedi_force_power_max: 175,
    jedi_force_power_regen: 2,
  },
  schematics: [""]
},
force_rank_light_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "force_rank_xp", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 5,
    force_manipulation_light: 5,
    force_control_light: 5,
  },
  schematics: [""]
},
force_rank_light_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_10",
  ],
  xp: { id: "force_rank_xp", cost: 500000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 20,
    force_manipulation_light: 15,
    force_control_light: 20,
  },
  schematics: [""]
},
force_rank_light_rank_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_novice",
  ],
  xp: { id: "force_rank_xp", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 5,
    force_manipulation_light: 3,
    force_control_light: 5,
  },
  schematics: [""]
},
force_rank_light_rank_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_01",
  ],
  xp: { id: "force_rank_xp", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 5,
    force_manipulation_light: 4,
    force_control_light: 5,
  },
  schematics: [""]
},
force_rank_light_rank_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_02",
  ],
  xp: { id: "force_rank_xp", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 5,
    force_manipulation_light: 4,
    force_control_light: 5,
  },
  schematics: [""]
},
force_rank_light_rank_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_03",
  ],
  xp: { id: "force_rank_xp", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 5,
    force_manipulation_light: 4,
    force_control_light: 5,
  },
  schematics: [""]
},
force_rank_light_rank_05: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_04",
  ],
  xp: { id: "force_rank_xp", cost: 60000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 10,
    force_manipulation_light: 5,
    force_control_light: 10,
  },
  schematics: [""]
},
force_rank_light_rank_06: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_05",
  ],
  xp: { id: "force_rank_xp", cost: 80000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 10,
    force_manipulation_light: 5,
    force_control_light: 10,
  },
  schematics: [""]
},
force_rank_light_rank_07: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_06",
  ],
  xp: { id: "force_rank_xp", cost: 100000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 10,
    force_manipulation_light: 5,
    force_control_light: 10,
  },
  schematics: [""]
},
force_rank_light_rank_08: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_07",
  ],
  xp: { id: "force_rank_xp", cost: 150000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 15,
    force_manipulation_light: 10,
    force_control_light: 15,
  },
  schematics: [""]
},
force_rank_light_rank_09: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_08",
  ],
  xp: { id: "force_rank_xp", cost: 200000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 15,
    force_manipulation_light: 10,
    force_control_light: 15,
  },
  schematics: [""]
},
force_rank_light_rank_10: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_light_rank_09",
  ],
  xp: { id: "force_rank_xp", cost: 300000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_light: 15,
    force_manipulation_light: 10,
    force_control_light: 15,
  },
  schematics: [""]
},
force_rank_dark_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "force_rank_xp", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 5,
    force_manipulation_dark: 5,
    force_control_dark: 5,
  },
  schematics: [""]
},
force_rank_dark_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_10",
  ],
  xp: { id: "force_rank_xp", cost: 500000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 20,
    force_manipulation_dark: 15,
    force_control_dark: 20,
  },
  schematics: [""]
},
force_rank_dark_rank_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_novice",
  ],
  xp: { id: "force_rank_xp", cost: 10000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 5,
    force_manipulation_dark: 3,
    force_control_dark: 5,
  },
  schematics: [""]
},
force_rank_dark_rank_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_01",
  ],
  xp: { id: "force_rank_xp", cost: 20000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 5,
    force_manipulation_dark: 4,
    force_control_dark: 5,
  },
  schematics: [""]
},
force_rank_dark_rank_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_02",
  ],
  xp: { id: "force_rank_xp", cost: 30000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 5,
    force_manipulation_dark: 4,
    force_control_dark: 5,
  },
  schematics: [""]
},
force_rank_dark_rank_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_03",
  ],
  xp: { id: "force_rank_xp", cost: 40000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 5,
    force_manipulation_dark: 4,
    force_control_dark: 5,
  },
  schematics: [""]
},
force_rank_dark_rank_05: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_04",
  ],
  xp: { id: "force_rank_xp", cost: 60000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 10,
    force_manipulation_dark: 5,
    force_control_dark: 10,
  },
  schematics: [""]
},
force_rank_dark_rank_06: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_05",
  ],
  xp: { id: "force_rank_xp", cost: 80000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 10,
    force_manipulation_dark: 5,
    force_control_dark: 10,
  },
  schematics: [""]
},
force_rank_dark_rank_07: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_06",
  ],
  xp: { id: "force_rank_xp", cost: 100000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 10,
    force_manipulation_dark: 5,
    force_control_dark: 10,
  },
  schematics: [""]
},
force_rank_dark_rank_08: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_07",
  ],
  xp: { id: "force_rank_xp", cost: 150000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 15,
    force_manipulation_dark: 10,
    force_control_dark: 15,
  },
  schematics: [""]
},
force_rank_dark_rank_09: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_08",
  ],
  xp: { id: "force_rank_xp", cost: 200000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 15,
    force_manipulation_dark: 10,
    force_control_dark: 15,
  },
  schematics: [""]
},
force_rank_dark_rank_10: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_rank_dark_rank_09",
  ],
  xp: { id: "force_rank_xp", cost: 300000 },
  commands: [
    "",
  ],
  skillModifiers: {
    force_power_dark: 15,
    force_manipulation_dark: 10,
    force_control_dark: 15,
  },
  schematics: [""]
},
force_title_jedi_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_title_jedi_rank_04",
  ],
  xp: { id: "jedi_general", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_title_jedi_rank_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_title_jedi_novice",
  ],
  xp: { id: "jedi_general", cost: 0 },
  commands: [
    "cert_onehandlightsaber_training",
  ],
  skillModifiers: {
    private_onehandlightsaber_combat_difficulty: 500,
    private_twohandlightsaber_combat_difficulty: 500,
    private_polearmlightsaber_combat_difficulty: 500,
  },
  schematics: ["craftSaberTraining","craftJediTool"]
},
force_title_jedi_rank_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_title_jedi_rank_01",
  ],
  xp: { id: "jedi_general", cost: 0 },
  commands: [
    "cert_onehandlightsaber_gen1",
    "cert_polearmlightsaber_gen1",
    "cert_twohandlightsaber_gen1",
  ],
  skillModifiers: {
    jedi_force_power_max: 750,
    jedi_force_power_regen: 15,
    onehandlightsaber_accuracy: 50,
    twohandlightsaber_accuracy: 50,
    polearmlightsaber_accuracy: 50,
  },
  schematics: ["craftSaberNovice"]
},
force_title_jedi_rank_03: {
  title: "",
  skillPoints: 0,
  preReqs: [],
  xp: { id: "jedi_general", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
force_title_jedi_rank_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "force_title_jedi_rank_03",
  ],
  xp: { id: "jedi_general", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
crafting_shipwright_novice: {
  title: "",
  skillPoints: 6,
  preReqs: [
    "crafting_artisan_engineering_04",
  ],
  xp: { id: "crafting_general", cost: 30000 },
  commands: [
    "private_shipwright_novice",
  ],
  skillModifiers: {
    chassis_assembly: 10,
    engine_assembly: 10,
    booster_assembly: 10,
    power_systems: 10,
    weapon_systems: 10,
    shields_assembly: 10,
    advanced_assembly: 10,
    chassis_experimentation: 10,
    weapon_systems_experimentation: 20,
    engine_experimentation: 20,
    booster_experimentation: 20,
    power_systems_experimentation: 10,
    shields_experimentation: 10,
    advanced_ship_experimentation: 10,
    defense_reverse: 1,
    propulsion_reverse: 1,
    engineering_reverse: 1,
    systems_reverse: 1,
  },
  schematics: ["craftShipwrightNoviceGroupA"]
},
crafting_shipwright_master: {
  title: "",
  skillPoints: 1,
  preReqs: [
    "crafting_shipwright_engineering_04",
    "crafting_shipwright_propulsion_04",
    "crafting_shipwright_systems_04",
    "crafting_shipwright_defense_04",
  ],
  xp: { id: "shipwright", cost: 200000 },
  commands: [
    "private_shipwright_master",
  ],
  skillModifiers: {
    chassis_assembly: 25,
    chassis_experimentation: 25,
    weapon_systems_experimentation: 25,
    weapon_systems: 25,
    engine_experimentation: 25,
    engine_assembly: 25,
    booster_experimentation: 25,
    booster_assembly: 25,
    power_systems_experimentation: 25,
    power_systems: 25,
    shields_experimentation: 25,
    shields_assembly: 25,
    advanced_ship_experimentation: 25,
    advanced_assembly: 25,
    defense_reverse: 1,
    propulsion_reverse: 1,
    systems_reverse: 1,
    engineering_reverse: 1,
  },
  schematics: ["craftShipwrightMaster"]
},
crafting_shipwright_engineering_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_shipwright_novice",
  ],
  xp: { id: "shipwright", cost: 20000 },
  commands: [
    "private_shipwright_engineering_1",
  ],
  skillModifiers: {
    chassis_assembly: 10,
    chassis_experimentation: 10,
    engineering_reverse: 2,
  },
  schematics: ["craftShipwrightEngGroupA"]
},
crafting_shipwright_engineering_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_shipwright_engineering_01",
  ],
  xp: { id: "shipwright", cost: 50000 },
  commands: [
    "private_shipwright_engineering_2",
  ],
  skillModifiers: {
    chassis_assembly: 15,
    chassis_experimentation: 15,
    engineering_reverse: 2,
  },
  schematics: ["craftShipwrightEngGroupB"]
},
crafting_shipwright_engineering_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_shipwright_engineering_02",
  ],
  xp: { id: "shipwright", cost: 100000 },
  commands: [
    "private_shipwright_engineering_3",
  ],
  skillModifiers: {
    chassis_assembly: 20,
    chassis_experimentation: 20,
    engineering_reverse: 2,
  },
  schematics: ["craftShipwrightEngGroupC"]
},
crafting_shipwright_engineering_04: {
  title: "",
  skillPoints: 2,
  preReqs: [
    "crafting_shipwright_engineering_03",
  ],
  xp: { id: "shipwright", cost: 150000 },
  commands: [
    "private_shipwright_engineering_4",
  ],
  skillModifiers: {
    chassis_assembly: 20,
    chassis_experimentation: 20,
    engineering_reverse: 2,
  },
  schematics: ["craftShipwrightEngGroupD"]
},
crafting_shipwright_propulsion_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_shipwright_novice",
  ],
  xp: { id: "shipwright", cost: 20000 },
  commands: [
    "private_shipwright_propulsion_1",
  ],
  skillModifiers: {
    engine_assembly: 10,
    booster_assembly: 10,
    engine_experimentation: 20,
    booster_experimentation: 20,
    propulsion_reverse: 2,
  },
  schematics: ["craftShipwrightPropulsionGroupA"]
},
crafting_shipwright_propulsion_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_shipwright_propulsion_01",
  ],
  xp: { id: "shipwright", cost: 50000 },
  commands: [
    "private_shipwright_propulsion_2",
  ],
  skillModifiers: {
    engine_assembly: 15,
    booster_assembly: 15,
    engine_experimentation: 25,
    booster_experimentation: 25,
    propulsion_reverse: 2,
  },
  schematics: ["craftShipwrightPropulsionGroupB"]
},
crafting_shipwright_propulsion_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_shipwright_propulsion_02",
  ],
  xp: { id: "shipwright", cost: 100000 },
  commands: [
    "private_shipwright_propulsion_3",
  ],
  skillModifiers: {
    engine_assembly: 20,
    booster_assembly: 20,
    engine_experimentation: 30,
    booster_experimentation: 30,
    propulsion_reverse: 2,
  },
  schematics: ["craftShipwrightPropulsionGroupC"]
},
crafting_shipwright_propulsion_04: {
  title: "",
  skillPoints: 2,
  preReqs: [
    "crafting_shipwright_propulsion_03",
  ],
  xp: { id: "shipwright", cost: 150000 },
  commands: [
    "private_shipwright_propulsion_4",
  ],
  skillModifiers: {
    engine_assembly: 20,
    booster_assembly: 20,
    engine_experimentation: 30,
    booster_experimentation: 30,
    propulsion_reverse: 2,
  },
  schematics: ["craftShipwrightPropulsionGroupD"]
},
crafting_shipwright_systems_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_shipwright_novice",
  ],
  xp: { id: "shipwright", cost: 20000 },
  commands: [
    "private_shipwright_systems_1",
  ],
  skillModifiers: {
    power_systems: 10,
    advanced_assembly: 10,
    power_systems_experimentation: 10,
    advanced_ship_experimentation: 10,
    systems_reverse: 2,
  },
  schematics: ["craftShipwrightSystemsGroupA"]
},
crafting_shipwright_systems_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_shipwright_systems_01",
  ],
  xp: { id: "shipwright", cost: 50000 },
  commands: [
    "private_shipwright_systems_2",
  ],
  skillModifiers: {
    power_systems: 15,
    advanced_assembly: 15,
    power_systems_experimentation: 15,
    advanced_ship_experimentation: 15,
    systems_reverse: 2,
  },
  schematics: ["craftShipwrightSystemsGroupB"]
},
crafting_shipwright_systems_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_shipwright_systems_02",
  ],
  xp: { id: "shipwright", cost: 100000 },
  commands: [
    "private_shipwright_systems_3",
  ],
  skillModifiers: {
    power_systems: 20,
    advanced_assembly: 20,
    power_systems_experimentation: 20,
    advanced_ship_experimentation: 20,
    systems_reverse: 2,
  },
  schematics: ["craftShipwrightSystemsGroupC"]
},
crafting_shipwright_systems_04: {
  title: "",
  skillPoints: 2,
  preReqs: [
    "crafting_shipwright_systems_03",
  ],
  xp: { id: "shipwright", cost: 150000 },
  commands: [
    "private_shipwright_systems_4",
  ],
  skillModifiers: {
    power_systems: 20,
    advanced_assembly: 20,
    power_systems_experimentation: 20,
    advanced_ship_experimentation: 20,
    systems_reverse: 2,
  },
  schematics: ["craftShipwrightSystemsGroupD"]
},
crafting_shipwright_defense_01: {
  title: "",
  skillPoints: 5,
  preReqs: [
    "crafting_shipwright_novice",
  ],
  xp: { id: "shipwright", cost: 20000 },
  commands: [
    "private_shipwright_defense_1",
  ],
  skillModifiers: {
    weapon_systems: 10,
    weapon_systems_experimentation: 20,
    defense_reverse: 2,
    shields_assembly: 10,
    shields_experimentation: 10,
  },
  schematics: ["craftShipwrightDefenseGroupA"]
},
crafting_shipwright_defense_02: {
  title: "",
  skillPoints: 4,
  preReqs: [
    "crafting_shipwright_defense_01",
  ],
  xp: { id: "shipwright", cost: 50000 },
  commands: [
    "private_shipwright_defense_2",
  ],
  skillModifiers: {
    weapon_systems: 15,
    weapon_systems_experimentation: 25,
    defense_reverse: 2,
    shields_assembly: 15,
    shields_experimentation: 15,
  },
  schematics: ["craftShipwrightDefenseGroupB"]
},
crafting_shipwright_defense_03: {
  title: "",
  skillPoints: 3,
  preReqs: [
    "crafting_shipwright_defense_02",
  ],
  xp: { id: "shipwright", cost: 100000 },
  commands: [
    "private_shipwright_defense_3",
  ],
  skillModifiers: {
    weapon_systems: 20,
    weapon_systems_experimentation: 30,
    defense_reverse: 2,
    shields_assembly: 20,
    shields_experimentation: 20,
  },
  schematics: ["craftShipwrightDefenseGroupC"]
},
crafting_shipwright_defense_04: {
  title: "",
  skillPoints: 2,
  preReqs: [
    "crafting_shipwright_defense_03",
  ],
  xp: { id: "shipwright", cost: 150000 },
  commands: [
    "private_shipwright_defense_4",
  ],
  skillModifiers: {
    weapon_systems: 20,
    weapon_systems_experimentation: 30,
    defense_reverse: 2,
    shields_assembly: 20,
    shields_experimentation: 20,
  },
  schematics: ["craftShipwrightDefenseGroupD"]
},
pilot: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_rebel_navy_novice",
    "cert_starships_z95headhunter",
    "cert_ordnance_level1",
    "cert_droid_astromech_1",
    "droidcommand_mutedroid",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_04",
    "pilot_rebel_navy_weapons_04",
    "pilot_rebel_navy_procedures_04",
    "pilot_rebel_navy_droid_04",
  ],
  xp: { id: "space_combat_general", cost: 7500000 },
  commands: [
    "private_rebel_navy_master",
    "cert_starships_bwing",
    "cert_starships_ykl37r",
    "cert_ordnance_level9",
    "cert_ordnance_levelten",
    "cert_droid_astromech_6",
    "jstart3",
    "inspacerr",
    "cert_starships_firespray",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_rebel_navy_starships_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "private_rebel_navy_starships_1",
    "cert_starships_ywing",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_starships_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_01",
    "pilot_rebel_navy_weapons_01",
    "pilot_rebel_navy_procedures_01",
    "pilot_rebel_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "private_rebel_navy_starships_2",
    "cert_starships_ywinglongprobe",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_starships_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_02",
    "pilot_rebel_navy_weapons_02",
    "pilot_rebel_navy_procedures_02",
    "pilot_rebel_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "private_rebel_navy_starships_3",
    "cert_starships_xwing",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_starships_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_03",
    "pilot_rebel_navy_weapons_03",
    "pilot_rebel_navy_procedures_03",
    "pilot_rebel_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "private_rebel_navy_starships_4",
    "cert_starships_awing",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_weapons_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "cert_ordnance_level2",
    "cert_ordnance_level3",
  ],
  skillModifiers: {
    missile_launching: 65,
  },
  schematics: [""]
},
pilot_rebel_navy_weapons_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_01",
    "pilot_rebel_navy_weapons_01",
    "pilot_rebel_navy_procedures_01",
    "pilot_rebel_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "cert_ordnance_level4",
    "cert_ordnance_level5",
  ],
  skillModifiers: {
    missile_launching: 10,
  },
  schematics: [""]
},
pilot_rebel_navy_weapons_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_02",
    "pilot_rebel_navy_weapons_02",
    "pilot_rebel_navy_procedures_02",
    "pilot_rebel_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "cert_ordnance_level6",
    "cert_ordnance_level7",
  ],
  skillModifiers: {
    missile_launching: 10,
  },
  schematics: [""]
},
pilot_rebel_navy_weapons_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_03",
    "pilot_rebel_navy_weapons_03",
    "pilot_rebel_navy_procedures_03",
    "pilot_rebel_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "cert_ordnance_level8",
  ],
  skillModifiers: {
    missile_launching: 15,
  },
  schematics: [""]
},
pilot_rebel_navy_procedures_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "iffscramble",
    "jstart1",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_rebel_navy_procedures_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_01",
    "pilot_rebel_navy_weapons_01",
    "pilot_rebel_navy_procedures_01",
    "pilot_rebel_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "eshields",
    "vrepair",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_rebel_navy_procedures_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_02",
    "pilot_rebel_navy_weapons_02",
    "pilot_rebel_navy_procedures_02",
    "pilot_rebel_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "jstart2",
    "inspacerepair",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_rebel_navy_procedures_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_03",
    "pilot_rebel_navy_weapons_03",
    "pilot_rebel_navy_procedures_03",
    "pilot_rebel_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "inspacereload",
    "vrepairother",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_rebel_navy_droid_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "private_rebel_navy_droid_1",
    "droidcommand_shieldnormalize",
    "droidcommand_shieldbacktofronttwenty",
    "droidcommand_shieldfronttobacktwenty",
    "droidcommand_shieldadjustfrontone",
    "droidcommand_shieldadjustrearone",
    "cert_droid_astromech_2",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_droid_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_01",
    "pilot_rebel_navy_weapons_01",
    "pilot_rebel_navy_procedures_01",
    "pilot_rebel_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "private_rebel_navy_droid_2",
    "droidcommand_shieldbacktofrontfifty",
    "droidcommand_shieldfronttobackfifty",
    "droidcommand_shieldadjustfronttwo",
    "droidcommand_shieldadjustreartwo",
    "cert_droid_astromech_3",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_droid_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_02",
    "pilot_rebel_navy_weapons_02",
    "pilot_rebel_navy_procedures_02",
    "pilot_rebel_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "private_rebel_navy_droid_3",
    "droidcommand_shieldbacktofronteighty",
    "droidcommand_shieldfronttobackeighty",
    "droidcommand_shieldadjustfrontthree",
    "droidcommand_shieldadjustrearthree",
    "cert_droid_astromech_4",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_rebel_navy_droid_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_rebel_navy_starships_03",
    "pilot_rebel_navy_weapons_03",
    "pilot_rebel_navy_procedures_03",
    "pilot_rebel_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "private_rebel_navy_droid_4",
    "droidcommand_shieldbacktofronthundred",
    "droidcommand_shieldfronttobackhundred",
    "droidcommand_shieldadjustfrontfour",
    "droidcommand_shieldadjustrearfour",
    "cert_droid_astromech_5",
    "droidcommand_shieldemergencyfront",
    "droidcommand_shieldemergencyrear",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_imperial_navy_novice",
    "cert_starships_tiefighterlight",
    "cert_ordnance_level1",
    "cert_droid_astromech_1",
    "droidcommand_mutedroid",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_04",
    "pilot_imperial_navy_weapons_04",
    "pilot_imperial_navy_procedures_04",
    "pilot_imperial_navy_droid_04",
  ],
  xp: { id: "space_combat_general", cost: 7500000 },
  commands: [
    "private_imperial_navy_master",
    "cert_starships_decimator",
    "cert_starships_tieoppressor",
    "cert_ordnance_level9",
    "cert_ordnance_levelten",
    "cert_droid_astromech_6",
    "bstrike3",
    "cert_starships_firespray",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_imperial_navy_starships_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "private_imperial_navy_starships_1",
    "cert_starships_tiefighter",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_starships_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_01",
    "pilot_imperial_navy_weapons_01",
    "pilot_imperial_navy_procedures_01",
    "pilot_imperial_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "private_imperial_navy_starships_2",
    "cert_starships_tiefighterin",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_starships_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_02",
    "pilot_imperial_navy_weapons_02",
    "pilot_imperial_navy_procedures_02",
    "pilot_imperial_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "private_imperial_navy_starships_3",
    "cert_starships_tieinterceptor",
    "cert_starships_tiebomber",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_starships_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_03",
    "pilot_imperial_navy_weapons_03",
    "pilot_imperial_navy_procedures_03",
    "pilot_imperial_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "private_imperial_navy_starships_4",
    "cert_starships_tieadvanced",
    "cert_starships_tieaggressor",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_weapons_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "cert_ordnance_level2",
    "cert_ordnance_level3",
  ],
  skillModifiers: {
    missile_launching: 65,
  },
  schematics: [""]
},
pilot_imperial_navy_weapons_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_01",
    "pilot_imperial_navy_weapons_01",
    "pilot_imperial_navy_procedures_01",
    "pilot_imperial_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "cert_ordnance_level4",
    "cert_ordnance_level5",
  ],
  skillModifiers: {
    missile_launching: 10,
  },
  schematics: [""]
},
pilot_imperial_navy_weapons_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_02",
    "pilot_imperial_navy_weapons_02",
    "pilot_imperial_navy_procedures_02",
    "pilot_imperial_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "cert_ordnance_level6",
    "cert_ordnance_level7",
  ],
  skillModifiers: {
    missile_launching: 10,
  },
  schematics: [""]
},
pilot_imperial_navy_weapons_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_03",
    "pilot_imperial_navy_weapons_03",
    "pilot_imperial_navy_procedures_03",
    "pilot_imperial_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "cert_ordnance_level8",
  ],
  skillModifiers: {
    missile_launching: 15,
  },
  schematics: [""]
},
pilot_imperial_navy_procedures_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "pumpreactor",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_imperial_navy_procedures_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_01",
    "pilot_imperial_navy_weapons_01",
    "pilot_imperial_navy_procedures_01",
    "pilot_imperial_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "eweapons",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_imperial_navy_procedures_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_02",
    "pilot_imperial_navy_weapons_02",
    "pilot_imperial_navy_procedures_02",
    "pilot_imperial_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "bstrike1",
    "nblast",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_imperial_navy_procedures_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_03",
    "pilot_imperial_navy_weapons_03",
    "pilot_imperial_navy_procedures_03",
    "pilot_imperial_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "bstrike2",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_imperial_navy_droid_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "private_imperial_navy_droid_1",
    "droidcommand_weaponoverloadone",
    "droidcommand_weaponeffeciencyone",
    "droidcommand_weaponnormalize",
    "droidcommand_engineoverloadone",
    "droidcommand_engineefficiencyone",
    "droidcommand_enginenormalize",
    "cert_droid_astromech_2",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_droid_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_01",
    "pilot_imperial_navy_weapons_01",
    "pilot_imperial_navy_procedures_01",
    "pilot_imperial_navy_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "private_imperial_navy_droid_2",
    "droidcommand_weaponoverloadtwo",
    "droidcommand_weaponeffeciencytwo",
    "droidcommand_engineoverloadtwo",
    "droidcommand_engineefficiencytwo",
    "cert_droid_astromech_3",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_droid_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_02",
    "pilot_imperial_navy_weapons_02",
    "pilot_imperial_navy_procedures_02",
    "pilot_imperial_navy_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "private_imperial_navy_droid_3",
    "droidcommand_weaponoverloadthree",
    "droidcommand_weaponeffeciencythree",
    "droidcommand_engineoverloadthree",
    "droidcommand_engineefficiencythree",
    "cert_droid_astromech_4",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_imperial_navy_droid_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_imperial_navy_starships_03",
    "pilot_imperial_navy_weapons_03",
    "pilot_imperial_navy_procedures_03",
    "pilot_imperial_navy_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "private_imperial_navy_droid_4",
    "droidcommand_weaponoverloadfour",
    "droidcommand_weaponeffeciencyfour",
    "droidcommand_engineoverloadfour",
    "droidcommand_engineefficiencyfour",
    "cert_droid_astromech_5",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "", cost: 0 },
  commands: [
    "private_neutral_novice",
    "cert_starships_lighthuttfighter",
    "cert_ordnance_level1",
    "cert_droid_astromech_1",
    "droidcommand_mutedroid",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_master: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_04",
    "pilot_neutral_weapons_04",
    "pilot_neutral_procedures_04",
    "pilot_neutral_droid_04",
  ],
  xp: { id: "space_combat_general", cost: 7500000 },
  commands: [
    "private_neutral_master",
    "cert_starships_yt1300",
    "cert_ordnance_level9",
    "cert_ordnance_levelten",
    "cert_droid_astromech_6",
    "ptrap2",
    "epulse3",
    "cert_starships_firespray",
    "cert_starships_hutt_turret_ship",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_neutral_starships_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "private_neutral_starships_1",
    "cert_starships_mediumhuttfighter",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_starships_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_01",
    "pilot_neutral_weapons_01",
    "pilot_neutral_procedures_01",
    "pilot_neutral_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "private_neutral_starships_2",
    "cert_starships_heavyhuttfighter",
    "cert_starships_lightblacksunfighter",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_starships_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_02",
    "pilot_neutral_weapons_02",
    "pilot_neutral_procedures_02",
    "pilot_neutral_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "private_neutral_starships_3",
    "cert_starships_mediumblacksunfighter",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_starships_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_03",
    "pilot_neutral_weapons_03",
    "pilot_neutral_procedures_03",
    "pilot_neutral_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "private_neutral_starships_4",
    "cert_starships_heavyblacksunfighter",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_weapons_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "cert_ordnance_level2",
    "cert_ordnance_level3",
  ],
  skillModifiers: {
    missile_launching: 65,
  },
  schematics: [""]
},
pilot_neutral_weapons_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_01",
    "pilot_neutral_weapons_01",
    "pilot_neutral_procedures_01",
    "pilot_neutral_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "cert_ordnance_level4",
    "cert_ordnance_level5",
  ],
  skillModifiers: {
    missile_launching: 10,
  },
  schematics: [""]
},
pilot_neutral_weapons_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_02",
    "pilot_neutral_weapons_02",
    "pilot_neutral_procedures_02",
    "pilot_neutral_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "cert_ordnance_level6",
    "cert_ordnance_level7",
  ],
  skillModifiers: {
    missile_launching: 10,
  },
  schematics: [""]
},
pilot_neutral_weapons_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_03",
    "pilot_neutral_weapons_03",
    "pilot_neutral_procedures_03",
    "pilot_neutral_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "cert_ordnance_level8",
  ],
  skillModifiers: {
    missile_launching: 15,
  },
  schematics: [""]
},
pilot_neutral_procedures_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "ethrust",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_neutral_procedures_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_01",
    "pilot_neutral_weapons_01",
    "pilot_neutral_procedures_01",
    "pilot_neutral_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "ptrap1",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_neutral_procedures_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_02",
    "pilot_neutral_weapons_02",
    "pilot_neutral_procedures_02",
    "pilot_neutral_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "iffscramble",
    "epulse1",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_neutral_procedures_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_03",
    "pilot_neutral_weapons_03",
    "pilot_neutral_procedures_03",
    "pilot_neutral_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "epulse2",
  ],
  skillModifiers: {
    pilot_special_tactics: 20,
  },
  schematics: [""]
},
pilot_neutral_droid_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_novice",
  ],
  xp: { id: "space_combat_general", cost: 7500 },
  commands: [
    "private_neutral_droid_1",
    "droidcommand_reactoroverloadone",
    "droidcommand_reactornormalize",
    "cert_droid_astromech_2",
    "droidcommand_weapcappowerupone",
    "droidcommand_weapcapequalize",
    "droidcommand_weapcaptoshieldone",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_droid_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_01",
    "pilot_neutral_weapons_01",
    "pilot_neutral_procedures_01",
    "pilot_neutral_droid_01",
  ],
  xp: { id: "space_combat_general", cost: 60000 },
  commands: [
    "private_neutral_droid_2",
    "droidcommand_reactoroverloadtwo",
    "cert_droid_astromech_3",
    "droidcommand_weapcappoweruptwo",
    "droidcommand_weapcaptoshieldtwo",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_droid_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_02",
    "pilot_neutral_weapons_02",
    "pilot_neutral_procedures_02",
    "pilot_neutral_droid_02",
  ],
  xp: { id: "space_combat_general", cost: 200000 },
  commands: [
    "private_neutral_droid_3",
    "droidcommand_reactoroverloadthree",
    "cert_droid_astromech_4",
    "droidcommand_weapcappowerupthree",
    "droidcommand_weapcaptoshieldthree",
  ],
  skillModifiers: {},
  schematics: [""]
},
pilot_neutral_droid_04: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "pilot_neutral_starships_03",
    "pilot_neutral_weapons_03",
    "pilot_neutral_procedures_03",
    "pilot_neutral_droid_03",
  ],
  xp: { id: "space_combat_general", cost: 1000000 },
  commands: [
    "private_neutral_droid_4",
    "droidcommand_reactoroverloadfour",
    "cert_droid_astromech_5",
    "droidcommand_weapcappowerupfour",
    "droidcommand_weapcaptoshieldfour",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_gladiator_novice: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "",
  ],
  xp: { id: "combat_gladiator", cost: 5000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_gladiator_master: {
  title: "Titan",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_thraex_04",
    "combat_gladiator_murmillo_04",
    "combat_gladiator_dimachaerus_04",
    "combat_gladiator_secutor_04",
  ],
  xp: { id: "combat_gladiator", cost: 25000 },
  commands: [
    "",
  ],
  skillModifiers: {},
  schematics: [""]
},
combat_gladiator_thraex_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_novice",
  ],
  xp: { id: "combat_gladiator", cost: 6250 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_thraex_hit: 1,
  },
  schematics: [""]
},
combat_gladiator_thraex_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_thraex_01",
  ],
  xp: { id: "combat_gladiator", cost: 9375 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_thraex_hit: 2,
  },
  schematics: [""]
},
combat_gladiator_thraex_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_thraex_02",
  ],
  xp: { id: "combat_gladiator", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_thraex_hit: 3,
  },
  schematics: [""]
},
combat_gladiator_thraex_04: {
  title: "Thraex",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_thraex_03",
  ],
  xp: { id: "combat_gladiator", cost: 18750 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_thraex_hit: 4,
  },
  schematics: [""]
},
combat_gladiator_murmillo_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_novice",
  ],
  xp: { id: "combat_gladiator", cost: 6250 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_murmillo_defense: 1,
  },
  schematics: [""]
},
combat_gladiator_murmillo_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_murmillo_01",
  ],
  xp: { id: "combat_gladiator", cost: 9375 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_murmillo_defense: 2,
  },
  schematics: [""]
},
combat_gladiator_murmillo_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_murmillo_02",
  ],
  xp: { id: "combat_gladiator", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_murmillo_defense: 3,
  },
  schematics: [""]
},
combat_gladiator_murmillo_04: {
  title: "Murmillo",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_murmillo_03",
  ],
  xp: { id: "combat_gladiator", cost: 18750 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_murmillo_defense: 4,
  },
  schematics: [""]
},
combat_gladiator_dimachaerus_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_novice",
  ],
  xp: { id: "combat_gladiator", cost: 6250 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_dimachaerus_hit: 1,
  },
  schematics: [""]
},
combat_gladiator_dimachaerus_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_dimachaerus_01",
  ],
  xp: { id: "combat_gladiator", cost: 9375 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_dimachaerus_hit: 2,
  },
  schematics: [""]
},
combat_gladiator_dimachaerus_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_dimachaerus_02",
  ],
  xp: { id: "combat_gladiator", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_dimachaerus_hit: 3,
  },
  schematics: [""]
},
combat_gladiator_dimachaerus_04: {
  title: "Dimachaerus",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_dimachaerus_03",
  ],
  xp: { id: "combat_gladiator", cost: 18750 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_dimachaerus_hit: 4,
  },
  schematics: [""]
},
combat_gladiator_secutor_01: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_novice",
  ],
  xp: { id: "combat_gladiator", cost: 6250 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_secutor_defense: 1,
  },
  schematics: [""]
},
combat_gladiator_secutor_02: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_secutor_01",
  ],
  xp: { id: "combat_gladiator", cost: 9375 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_secutor_defense: 2,
  },
  schematics: [""]
},
combat_gladiator_secutor_03: {
  title: "",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_secutor_02",
  ],
  xp: { id: "combat_gladiator", cost: 12500 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_secutor_defense: 3,
  },
  schematics: [""]
},
combat_gladiator_secutor_04: {
  title: "Secutor",
  skillPoints: 0,
  preReqs: [
    "combat_gladiator_secutor_03",
  ],
  xp: { id: "combat_gladiator", cost: 18750 },
  commands: [
    "",
  ],
  skillModifiers: {
    combat_secutor_defense: 4,
  },
  schematics: [""]
},
};

export const SKILL_MOD = {
  absorption_bleeding: "Bleeding Absorption",
  absorption_disease: "Disease Absorption",
  absorption_fire: "Fire Absorption",
  absorption_poison: "Poison Absorption",
  advanced_assembly: "Advanced Assembly",
  advanced_ship_experimentation: "Advanced Component Experimentation",
  advertising: "Advertising",
  aim: "General Ranged Aiming",
  alert: "Alertness",
  anti_blind: "Anti-Blind",
  anti_dizzy: "Anti-Dizzy",
  anti_intimidate: "Anti-Intimidate",
  anti_shock: "Anti-Shock",
  anti_stun: "Anti-Stun",
  armor_assembly: "Armor Assembly",
  armor_complexity: "Armor Complexity",
  armor_customization: "Armor Customization",
  armor_experimentation: "Armor Experimentation",
  armor_repair: "Armor Repair",
  artisan_clothing_customization: "Artisan Clothing Customization",
  berserk: "Berserk",
  bio_engineer_assembly: "Bio-Engineer Assembly",
  bio_engineer_experimentation: "Bio-Engineer Experimentation",
  blind_defense: "Defense Vs. Blind",
  block: "Block",
  body: "Bodyform",
  booster_assembly: "Booster Assembly",
  booster_experimentation: "Booster Experimentation",
  bounty_mission_level: "Bounty Mission Difficulty",
  burst_run: "Burst Run Efficiency",
  business_acumen: "Business Acumen",
  camouflage: "Camouflage",
  camp: "Camping",
  camp_advanced: "Advanced Camping",
  camp_repel_creature: "Repel Creatures",
  camprepelcreature: "Camping - Repel Creatures",
  carbine_acccuracy: "Carbine Accuracy",
  carbine_accuracy: "Carbine Accuracy",
  carbine_aim: "Carbine Aiming",
  carbine_counterattack: "Carbine Counterattacks",
  carbine_damage: "Carbine Damage",
  carbine_hit_while_moving: "Carbine Accuracy While Moving",
  carbine_kneeling: "Carbine Accuracy While Kneeling",
  carbine_prone: "Carbine Accuracy While Prone",
  carbine_speed: "Carbine Speed",
  carbine_standing: "Carbine Accuracy While Standing",
  center_of_being_duration_onehandmelee: "One-handed Center Of Being Duration",
  center_of_being_duration_polearm: "Polearm Center Of Being Duration",
  center_of_being_duration_twohandmelee: "Two-handed melee Center of Being",
  center_of_being_duration_unarmed: "Unarmed Center Of Being Duration",
  chassis_assembly: "Chassis Assembly",
  chassis_experimentation: "Chassis Experimentation",
  clothing_assembly: "Clothing Assembly",
  clothing_complexity: "Clothing Complexity",
  clothing_customization: "Clothing Customization",
  clothing_experimentation: "Clothing Experimentation",
  clothing_repair: "Clothing Repair",
  combat_bleeding_defense: "Combat Bleeding Defense",
  combat_equilibrium: "Combat Equilibrium",
  combat_equillibrium: "Combat Equilibrium",
  combat_haste: "Combat Haste",
  combat_healing_ability: "Combat Medicine Use",
  combat_medic_effectiveness: "Combat Medic Effectiveness",
  combat_medicine_assembly: "Combat Medicine Assembly",
  combat_medicine_experimentation: "Combat Medicine Experimentation",
  conceal_contraband: "Contraband Concealment",
  counterattack: "Counterattack",
  cover: "Taking Cover",
  crafting_repair: "Repair",
  creature_assembly: "Creature Assembly",
  creature_empathy: "Creature Empathy",
  creature_experimentation: "Creature Experimentation",
  creature_harvesting: "Creature Harvesting",
  creature_hit_bonus: "Creature To-Hit Bonus",
  creature_knowledge: "Creature Knowledge",
  creature_management: "Creature Management",
  creature_training: "Creature Training",
  creatureknowledge: "Creature Knowledge",
  dance_heal_injury: "Healing with Dance",
  defense_reverse: "Defense Reverse Engineering",
  disguise_effectiveness: "Disguising",
  dissipation_bleeding: "Bleeding Dissipation",
  dissipation_disease: "Disease Dissipation",
  dissipation_fire: "Fire Dissipation",
  dissipation_poison: "Poison Dissipation",
  dizzy_defense: "Defense Vs. Dizzy",
  dna_harvesting: "DNA Harvesting",
  dodge: "Dodge",
  domestic_assembly: "Domestic Arts Assembly",
  droid_assembly: "Droid Assembly",
  droid_complexity: "Droid Complexity",
  droid_customization: "Droid Customization",
  droid_experimentation: "Droid Experimentation",
  droid_find_chance: "Droid Precision",
  droid_find_speed: "Droid Speed",
  droid_track_chance: "Tracking Droid Effectiveness",
  droid_track_speed: "Droid Tracking Speed",
  droid_tracks: "Tracking Droids",
  engine_assembly: "Engine Assembly",
  engine_experimentation: "Engine Experimentation",
  engineering_assembly: "Engineering Assembly",
  engineering_reverse: "Chassis/Armor Reverse Engineering",
  face: "Face-form",
  factory_efficiency: "Factory Efficiency",
  factory_speed: "Factory Speed",
  farm_efficiency: "Farm Efficiency",
  farm_maintenance: "Farm Maintenance",
  farm_management: "Farm Management",
  farm_produce_flora: "Flora Production",
  farm_produce_livestock: "Livestock Production",
  farm_speed: "Farm Production Speed",
  feign_death: "Feign Death",
  firearm_assembly: "Firearm Assembly",
  firearm_complexity: "Firearm Complexity",
  firearm_experimentation: "Firearm Experimentation",
  flora_harvester_efficiency: "Flora Harvester Efficiency",
  flora_harvester_maintenance: "Flora Harvester Maintenance",
  flora_harvester_speed: "Flora Harvester Speed",
  food_assembly: "Food Assembly",
  food_complexity: "Food Complexity",
  food_experimentation: "Food Experimentation",
  foraging: "Foraging",
  force_absorb: "Force Absorb",
  force_armor: "Force Armor",
  force_assembly: "Force Assembly",
  force_choke: "Force Choke",
  force_control_dark: "Force Control: Dark",
  force_control_light: "Force Control: Light",
  force_defense: "Force Defense",
  force_experimentation: "Force Experimentation",
  force_failure_reduction: "Crafting Technique",
  force_feedback: "Force Feedback",
  force_luck: "Luck",
  force_manipulation_dark: "Force Manipulation: Dark",
  force_manipulation_light: "Force Manipulation: Light",
  force_persuade: "Persuasion",
  force_power_dark: "Force Power: Dark",
  force_power_light: "Force Power: Light",
  force_repair_bonus: "Force Repair Bonus",
  force_run: "Force Run",
  force_shield: "Force Shield",
  force_vehicle_control: "Force Vehicular Control",
  force_vehicle_speed: "Force Vehicular Acceleration",
  forceintimidate_accuracy: "Force Intimidate Accuracy",
  forceknockdown_accuracy: "Force Knockdown Accuracy",
  forcelightning_accuracy: "Force Lightning Accuracy",
  forcethrow_accuracy: "Force Throw Accuracy",
  forceweaken_accuracy: "Force Weaken Accuracy",
  frs_dark_envy: "Dark Force: Envy",
  frs_dark_suffering: "Dark Force: Suffering",
  frs_dark_vengeance: "Dark Force: Vengeance",
  frs_light_serenity: "Light Force: Serenity",
  frs_light_vigilance: "Light Force: Vigilance",
  frs_light_wisdom: "Light Force: Wisdom",
  general_assembly: "Artisan Assembly",
  general_damage: "Damage Healing",
  general_experimentation: "Artisan Experimentation",
  general_wound: "Wound Healing",
  grenade_assembly: "Grenade Assembly",
  grenade_experimentation: "Grenade Experimentation",
  group_burst_run: "Group Burst Run Efficiency",
  group_defense: "Group Defense Bonus",
  group_melee_defense: "Group Melee Defense",
  group_offense: "Group Offense Bonus",
  group_ranged_defense: "Group Ranged Defense",
  group_slope_move: "Group Terrain Negotiation",
  hair: "Hair Styling",
  harvester_efficiency: "Harvester Efficiency",
  harvester_maintenance: "Harvester Maintenance",
  harvester_speed: "Harvester Speed",
  heal_creature_wound: "Creature Wound Healing",
  healer_accuracy: "Ranged Healing Accuracy",
  healer_speed: "Ranged Healing Speed",
  healing_ability: "Medicine Use",
  healing_dance_ability: "Dance Knowledge",
  healing_dance_mind: "Dancing Mind Enhancement",
  healing_dance_shock: "Battle Fatigue Healing (Dancing)",
  healing_dance_wound: "Wound Healing (Dancing)",
  healing_injury_speed: "Injury Treatment Speed",
  healing_injury_treatment: "Injury Treatment",
  healing_music_ability: "Music Knowledge",
  healing_music_mind: "Musical Mind Enhancement",
  healing_music_shock: "Battle Fatigue Healing (Music)",
  healing_music_wound: "Wound Healing (Music)",
  healing_range: "Healing Range",
  healing_range_speed: "Ranged Injury Treatment Speed",
  healing_wound_speed: "Wound Treatment Speed",
  healing_wound_treatment: "Wound Treatment",
  heavy_acid_beam_accuracy: "Heavy Acid Beam Accuracy",
  heavy_acid_beam_speed: "Heavy Acid Beam Speed",
  heavy_acid_rifle_accuracy: "Heavy Acid Rifle Accuracy",
  heavy_acid_rifle_speed: "Heavy Acid Rifle Speed",
  heavy_flame_thrower_accuracy: "Flamethrower Accuracy",
  heavy_flame_thrower_speed: "Flamethrower Speed",
  heavy_lighting_rifle_accuracy: "Light Lightning Cannon Accuracy",
  heavy_lightning_beam_accuracy: "Heavy Lightning Beam Accuracy",
  heavy_lightning_beam_speed: "Heavy Lightning Beam Speed",
  heavy_lightning_rifle_accuracy: "Light Lightning Cannon Accuracy",
  heavy_particle_beam_accuracy: "Heavy Particle Beam Accuracy",
  heavy_particle_beam_speed: "Heavy Particle Beam Speed",
  heavy_rifle_acid_accuracy: "Heavy Acid Rifle Accuracy",
  heavy_rifle_acid_speed: "Heavy Acid Rifle Speed",
  heavy_rifle_lighting_accuracy: "Light Lightning Cannon Accuracy",
  heavy_rifle_lightning_accuracy: "Light Lightning Cannon Accuracy",
  heavy_rifle_lightning_speed: "Light Lightning Cannon Speed",
  heavy_rocket_launcher_accuracy: "Heavy Rocket Launcher Accuracy",
  heavy_rocket_launcher_speed: "Heavy Rocket Launcher Speed",
  heavyweapon_accuracy: "Heavy Weapon Accuracy",
  heavyweapon_speed: "Heavy Weapon Speed",
  hiring: "Hiring",
  innate_equilibrium: "Equilibrium",
  innate_regeneration: "Regeneration",
  innate_roar: "Wookiee Roar",
  innate_vitalize: "Vitalize",
  instrument_assembly: "Instrument Assembly",
  intimidate: "Intimidation",
  intimidate_defense: "Defense Vs. Intimidate",
  jedi_force_power_max: "Force Power Max",
  jedi_force_power_regen: "Force Power Regeneration",
  jedi_saber_assembly: "Lightsaber Assembly",
  jedi_saber_experimentation: "Lightsaber Experimentation",
  jedi_state_defense: "Jedi State Defense",
  jedi_toughness: "Jedi Toughness",
  keep_creature: "Additional Pets",
  knockdown_defense: "Defense Vs. Knockdown",
  language_all_comprehend: "Language Comprehension",
  language_basic_comprehend: "Basic (Comprehension)",
  language_basic_speak: "Basic (Speech)",
  language_bothan: "Bothese",
  language_bothan_comprehend: "Bothese (Comprehension)",
  language_bothan_speak: "Bothese (Speech)",
  language_ithorian: "Ithorian",
  language_ithorian_comprehend: "Ithorian (Comprehension)",
  language_ithorian_speak: "Ithorian (Speech)",
  language_lekku: "Lekku",
  language_lekku_comprehend: "Lekku (Comprehension)",
  language_lekku_speak: "Lekku (Silent Speech)",
  language_moncalamari: "Mon Calamarian",
  language_moncalamari_comprehend: "Mon Calamarian (Comprehension)",
  language_moncalamari_speak: "Mon Calamarian (Speech)",
  language_rodian: "Rodese",
  language_rodian_comprehend: "Rodese (Comprehension)",
  language_rodian_speak: "Rodese (Speech)",
  language_sullustan: "Sullustan",
  language_sullustan_comprehend: "Sullustan (Comprehension)",
  language_sullustan_speak: "Sullustan (Speech)",
  language_trandoshan: "Dosh",
  language_trandoshan_comprehend: "Dosh (Comprehension)",
  language_trandoshan_speak: "Dosh (Speech)",
  language_twilek: "Ryl",
  language_twilek_comprehend: "Ryl (Comprehension)",
  language_twilek_speak: "Ryl (Speech)",
  language_wookiee: "Shyriiwook",
  language_wookiee_comprehend: "Shyriiwook (Comprehension)",
  language_wookiee_speak: "Shyriiwook (Speech)",
  language_zabrak: "Zabrak",
  language_zabrak_comprehend: "Zabrak (Comprehension)",
  language_zabrak_speak: "Zabrak (Speech)",
  leadership: "Leadership",
  light_lightning_cannon_accuracy: "Light Lightning Cannon Accuracy",
  lightning: "Force Lightning",
  lightsaber_toughness: "Lightsaber Toughness",
  manage_vendor: "Vendors",
  markings: "Marking Design",
  mask_scent: "Mask Scent",
  medical_foraging: "Medical Foraging",
  medicine_assembly: "Medicine Assembly",
  medicine_complexity: "Crafting Medicine Complexity",
  medicine_experimentation: "Medicine Experimentation",
  meditate: "Meditate",
  melee_accuracy: "Enhanced Melee Accuracy",
  melee_assembly: "Melee Weapon Assembly",
  melee_complexity: "Melee Weapon Complexity",
  melee_defense: "Melee Defense",
  melee_experimentation: "Melee Experimentation",
  melee_speed: "Enhanced Melee Speed",
  mental: "Force Psyche",
  mindblast_accuracy: "Mind Blast Accuracy",
  missile_launching: "Missile Launching Skill",
  morale_management: "Morale Management",
  mountedcreature: "Mounted Creature",
  munition_assembly: "Munition Assembly",
  munition_complexity: "Munition Complexity",
  munition_experimentation: "Munition Experimentation",
  music_heal_injury: "Healing with Music",
  offensive_strategy: "Offensive Strategy",
  onehandlightsaber_accuracy: "One-handed Lightsaber Accuracy",
  onehandlightsaber_speed: "One-handed Lightsaber Speed",
  onehandlightsaber_toughness: "One-handed Lightsaber Toughness",
  onehandmelee_accuracy: "One-handed Weapon Accuracy",
  onehandmelee_center_of_being_efficacy:
    "One-handed Melee Center Of Being Efficacy",
  onehandmelee_counter_attack: "One-handed Weapon Counter Attack",
  onehandmelee_damage: "One-handed Melee Damage",
  onehandmelee_evasion: "One-handed Weapon Evasion",
  onehandmelee_speed: "One-handed Weapon Speed",
  onehandmelee_toughness: "One-handed Melee Toughness",
  onehandmeleeaccuracy: "One-handed Weapon Accuracy",
  onehandpolearm: "One Handed Pole Arm",
  onehandtechnique: "One Handed Technique",
  persuade_bribe: "Bribery",
  persuade_lie: "Pursuasion",
  pilot_special_tactics: "Pilot Special Tactics",
  pistol_accuracy: "Pistol Accuracy",
  pistol_accuracy_while_standing: "Pistol Accuracy While Standing",
  pistol_aim: "Pistol Aiming",
  pistol_counterattack: "Pistol Counter Attack",
  pistol_damage: "Pistol Damage",
  pistol_hit_while_moving: "Pistol Accuracy While Moving",
  pistol_kneeling: "Pistol Accuracy While Kneeling",
  pistol_prone: "Pistol Accuracy While Prone",
  pistol_speed: "Pistol Speed",
  pistol_standing: "Pistol Accuracy While Standing",
  polearm_accuracy: "Polearm Accuracy",
  polearm_center_of_being_efficacy: "Polearm Center Of Being Efficacy",
  polearm_counter_attack: "Polearm Counter Attack",
  polearm_evasion: "Polearm Evasion",
  polearm_speed: "Polearm Speed",
  polearm_toughness: "Polearm Toughness",
  polearmlightsaber_accuracy: "Double-Bladed Lightsaber Accuracy",
  polearmlightsaber_speed: "Double-Bladed Lightsaber Speed",
  polearmlightsaber_toughness: "Double-Bladed Lightsaber Toughness",
  posture_change_down_defense: "Defense Vs. Posture Change (Down)",
  posture_change_up_defense: "Defense Vs. Posture Change (Up)",
  power_systems: "Power Systems",
  power_systems_experimentation: "Power Systems Experimentation",
  private_unarmed_combat_difficulty: "private_unarmed_combat_difficulty",
  private_jedi_difficulty: "private_jedi_difficulty",
  private_pistol_combat_difficulty: "private_pistol_combat_difficulty",
  private_carbine_combat_difficulty: "private_carbine_combat_difficulty",
  private_rifle_combat_difficulty: "private_rifle_combat_difficulty",
  private_polearm_combat_difficulty: "private_polearm_combat_difficulty",
  private_heavyweapon_combat_difficulty:
    "private_heavyweapon_combat_difficulty",
  private_onehandmelee_combat_difficulty:
    "private_onehandmelee_combat_difficulty",
  private_twohandmelee_combat_difficulty:
    "private_twohandmelee_combat_difficulty",
  private_onehandlightsaber_combat_difficulty:
    "private_onehandlightsaber_combat_difficulty",
  private_twohandlightsaber_combat_difficulty:
    "private_twohandlightsaber_combat_difficulty",
  private_polearmlightsaber_combat_difficulty:
    "private_polearmlightsaber_combat_difficulty",
  private_innage_regeneration: "Regeneration",
  private_innate_equilibrium: "Equilibrium",
  private_innate_regeneration: "Regeneration",
  private_innate_roar: "Wookiee Roar",
  private_innate_vitalize: "Vitalize",
  propulsion_reverse: "Propulsion Reverse Engineering",
  rally: "Rally Shot Bonus",
  ranged_accuracy: "Enhanced Ranged Accuracy",
  ranged_defense: "Ranged Defense",
  ranged_speed: "Enhanced Ranged Speed",
  rescue: "Rescue",
  resist_creature_attack: "Resist Creature Attacks",
  resistance_bleeding: "Bleeding Resistance",
  resistance_disease: "Disease Resistance",
  resistance_fire: "Fire Resistance",
  resistance_poison: "Poison Resistance",
  resistance_states: "States Resistance",
  resistcreatureattack: "Resist Creature Attacks",
  reverse_engineering: "Reverse Engineering",
  ridingmount: "Riding Mount",
  rifle_accuracy: "Rifle Accuracy",
  rifle_aim: "Rifle Aiming",
  rifle_concealment_chance: "Rifle Concealment Chance",
  rifle_counterattack: "Rifle Counterattacks",
  rifle_crawl: "Rifle Crawl Speed",
  rifle_damage: "Rifle Damage",
  rifle_hit_while_moving: "Rifle Accuracy While Moving",
  rifle_kneeling: "Rifle Accuracy While Kneeling",
  rifle_prone: "Rifle Accuracy While Prone",
  rifle_speed: "Rifle Speed",
  rifle_standing: "Rifle Accuracy While Standing",
  saber_block: "Lightsaber Block",
  sales: "Sales",
  shields_assembly: "Shields Assembly",
  shields_experimentation: "Shield Experimentation",
  shop_sign: "Shop Sign Options",
  slice_market: "Slicing",
  slope_move: "Terrain Negotiation",
  spice_assembly: "Spice Assembly",
  spice_experimentation: "Spice Experimentation",
  steadyaim: "Steady Aim Bonus",
  stored_pets: "Stored Pets",
  structure_assembly: "Structure Assembly",
  structure_complexity: "Structure Complexity",
  structure_experimentation: "Structure Experimentation",
  structure_maintenance_mod: "Structure Maintenance",
  stun_defense: "Defense Vs. Stun",
  survey_flora_structural: "Flora Surveying",
  survey_flora_structural_range: "Flora Surveying Range",
  survey_flora_structural_resolution: "Flora Surveying Resolution",
  survey_gas: "Gas Surveying",
  survey_gas_range: "Gas Surveying Range",
  survey_gas_resolution: "Gas Surveying Resolution",
  survey_liquid: "Liquid Surveying",
  survey_liquid_range: "Liquid Surveying Range",
  survey_liquid_resolution: "Liquid Surveying Resolution",
  survey_solid: "Mineral Surveying",
  survey_solid_range: "Mineral Surveying Range",
  survey_solid_resolution: "Mineral Surveying Resolution",
  surveying: "Surveying",
  systems_reverse: "Systems Reverse Engineering",
  take_cover: "Cover",
  takecover: "Cover",
  tame_aggro: "Taming Vicious Creatures",
  tame_bonus: "Creature Taming Bonus",
  tame_level: "Max level of pets",
  tame_non_aggro: "Taming Wild Creatures",
  taunt: "Taunt",
  thrown_accuracy: "Thrown Weapon Accuracy",
  thrown_speed: "Thrown Weapon Speed",
  bh_burst_run: "Bounty Hunter Burst Run",
  saber_break: "Bounty Hunter Saber Break",
  tissue_assembly: "Tissue Assembly",
  tissue_experimentation: "Tissue Experimentation",
  track_creature: "Creature Tracking",
  trackcreature: "Creature Tracking",
  trapping: "Trapping",
  twohandedmelee_accuracy: "Two-handed Weapon Accuracy",
  twohandedmelee_counter_attack: "Two-handed Weapon Counter Attack",
  twohandedmelee_evasion: "Two-handed Weapon Evasion",
  twohandedmelee_speed: "Two-handed Weapon Speed",
  twohandedmeleedamage: "Two-handed Melee Damage",
  twohandlightsaber_accuracy: "Two-handed Lightsaber Accuracy",
  twohandlightsaber_speed: "Two-handed Lightsaber Speed",
  twohandlightsaber_toughness: "Two-handed Lightsaber Toughness",
  twohandmelee_accuracy: "Two-handed Melee Accuracy",
  twohandmelee_center_of_being_efficacy:
    "Two-handed Melee Center Of Being Efficacy",
  twohandmelee_counter_attack: "Two-handed Melee Counter Attacks",
  twohandmelee_damage: "Two-handed Melee Damage",
  twohandmelee_evasion: "Two-handed Melee Evasion",
  twohandmelee_speed: "Two-handed Melee Speed",
  twohandmelee_toughness: "Two-handed Melee Toughness",
  twohandpolearm: "Two Handed Pole Arm",
  twohandtechnique: "Two Handed Technique",
  unarmed_accuracy: "Unarmed Accuracy",
  unarmed_center_of_being_efficacy: "Unarmed Center Of Being Efficacy",
  unarmed_damage: "Unarmed Damage",
  unarmed_passive_defense: "Defensive Acuity",
  unarmed_speed: "Unarmed Speed",
  unarmed_toughness: "Unarmed Toughness",
  vendor_item_limit: "Vendor Item Limit",
  volley: "Volley Fire Bonus",
  warcry: "Warcry",
  weapon_assembly: "Weapon Assembly",
  weapon_experimentation: "Weapon Experimentation",
  weapon_repair: "Weapon Repair",
  weapon_systems: "Weapon Systems",
  weapon_systems_experimentation: "Weapon Systems Experimentation",
  combat_thraex_hit: "Striking of the Thraex",
  combat_murmillo_defense: "Defense of the Murmillo",
  combat_dimachaerus_hit: "Striking of the Dimachaerus",
  combat_secutor_defense: "Defense of the Secutor"
};

export const COMMAND_NAME = {
  absentminded: "Absentminded",
  access_fee: "Access Fees",
  accuse: "Accuse",
  ache: "Ache",
  actionshot1: "Action Shot 1",
  actionshot2: "Action Shot 2",
  activateclone: "Activate Clone",
  ad_fees_1: "Reduced Advertisement Fees",
  adjust: "Adjust",
  adn: "About Dang Time!",
  adventurous: "Adventurous",
  afk: "Away From Keyboard",
  afk4drink: "Away From Keyboard (getting a drink).",
  afk4food: "Away From Keyboard (getting some food).",
  agree: "Agree",
  aim: "Aim",
  airguitar: "Air Guitar",
  alert: "Alert",
  amaze: "Amaze",
  amazed: "Amazed",
  amazing: "Amazing",
  ambivalent: "Ambivalent",
  amused: "Amused",
  angry: "Angry",
  animalattack: "Animal Attack",
  animalcalm: "Animal Calm",
  animalscare: "Animal Scare",
  annoyed: "Annoyed",
  anon: "Anonymous",
  anxious: "Anxious",
  apologize: "Apologize",
  applaud: "Applaud",
  applydisease: "Apply Disease",
  applypoison: "Apply Poison",
  approving: "Approving",
  arch: "Arch Back",
  areatrack: "Area Track",
  areatrack_animal: "Area Track: Animals",
  areatrack_direction: "Area Track: Direction",
  areatrack_distance: "Area Track: Distance",
  areatrack_npc: "Area Track: People",
  areatrack_player: "Area Track: Players",
  assist: "Assist",
  associatedroidcontroldevicewithship: "Associate Droid With Ship",
  astromech_droid_cert_1: "Level 1 Astromech Droid Certification",
  astromech_droid_cert_2: "Level 2 Astromech Droid Certification",
  astromech_droid_cert_3: "Level 3 Astromech Droid Certification",
  astromech_droid_cert_4: "Level 4 Astromech Droid Certification",
  astromech_droid_cert_5: "Level 5 Astromech Droid Certification",
  astromech_droid_cert_6: "Level 6 Astromech Droid Certification",
  attack: "Attack",
  attend: "Attend",
  autodefend: "Auto Defend",
  avoidincapacitation: "Avoid Incapacitation",
  ayt: "Are You There?",
  backhand: "Backhand",
  bad: "Bad",
  badfeeling: "Bad Feeling",
  bah: "Bah!",
  bak: "Back (from AFK)",
  bandfill: "Bandfill (Instrument)",
  bang: "Head Bang",
  bark: "Bark",
  bat: "Bat Eyelashes",
  batlashes: "Bat Eyelashes",
  battlefieldstatus: "Battle Field Status",
  bbl: "Be Back Later",
  beam: "Beam Smile",
  bearhug: "Bear Hug",
  beckon: "Beckon",
  belch: "Belch",
  belligerent: "Belligerent",
  berserk1: "Berserk 1",
  berserk2: "Berserk 2",
  bet: "Bet",
  bite: "Bite",
  bitter: "Bitter",
  blame: "Blame",
  bleed: "Bleed",
  bleedingshot: "Bleeding Shot",
  blindattack: "Blind Attack",
  blink: "Blink",
  bloodthirsty: "Bloodthirsty",
  blow: "Blow Bubbles",
  blowkiss: "Blow Kiss",
  blush: "Blush",
  bmoc: "Big Man On Campus",
  boardshuttle: "Board Shuttle",
  bob: "Bob",
  bodyshot: "Body Shot",
  bodyshot1: "Body Shot 1",
  bodyshot2: "Body Shot 2",
  bodyshot3: "Body Shot 3",
  bodyslam: "Body Slam!",
  boggle: "Boggle",
  bonk: "Bonk",
  boogie: "Boogie",
  boostmorale: "Boost Morale",
  bored: "Bored..",
  bounce: "Bounce",
  bouquet: "Bouquet",
  bow: "Bow (Basic)",
  bow2: "Bow (Honorable)",
  bow3: "Bow (Deep)",
  bow4: "Bow (Formal)",
  bowhead: "Bow Head",
  brandish: "Brandish Weapon",
  brave: "Brave",
  brb: "Be Right Back",
  brt: "Be Right There",
  bstrike1: "Bomber Strike 1",
  bstrike2: "Bomber Strike 2",
  bstrike3: "Bomber Strike 3",
  bubbly: "Bubbly",
  bump: "Bump",
  burp: "Burp",
  burstrun: "Burst Run",
  burstshot1: "Burst Shot 1",
  burstshot2: "Burst Shot 2",
  bye: "Bye!",
  cackle: "Cackle",
  callous: "Callous",
  callretreat: "Call Retreat",
  callstop: "Stop!",
  calm: "Calm Down",
  cancelcraftingsession: "Cancel Crafting Session",
  carbineaim: "Carbine Aim",
  carbinecharge: "Carbine Charge",
  carbinedisarmingshot: "Carbine Disarming Shot",
  carbineflurryshot: "Carbine Flurry Shot",
  carbinemeleedefense1: "Carbine Melee Defense 1",
  carbinemeleedefense2: "Carbine Melee Defense 2",
  carbinescattershot: "Carbine Scatter Shot",
  carbinesneak: "Carbine Sneak",
  carbinestartleshot: "Carbine Startle Shot",
  carbinestrafeshot: "Carbine Strafe Shot",
  carbinesuppressionfire: "Carbine Suppression Fire",
  carbinesurpriseshot: "Carbine Surprise Shot",
  careful: "Careful",
  careless: "Careless",
  casual: "Casual",
  catchbreath: "Catch Breath",
  censor: "Censor",
  centerofbeing: "Center Of Being",
  cert_axe_heavy_duty: "Heavy Axe Certification",
  cert_axe_vibro: "Vibro Axe Certification",
  cert_baton_gaderiffi: "Gaderiffi Baton Certification",
  cert_baton_stun: "Stun Baton Certification",
  cert_carbine_cdef: "CDEF Carbine Certification",
  cert_carbine_dh17: "DH17 Carbine Certification",
  cert_carbine_dh17_short: "DH17 Short Carbine Certification",
  cert_carbine_dh17_snubnose: "DH17 Snubnose Carbine Certification",
  cert_carbine_dxr6: "DXR6 Carbine Certification",
  cert_carbine_e11: "E11 Carbine Certification",
  cert_carbine_ee3: "EE3 Carbine Certification",
  cert_carbine_elite: "Elite Carbine Certification",
  cert_carbine_laser: "Laser Carbine Certification",
  cert_carbine_laster: "Laser Carbine Certification",
  cert_carbine_nym_slugthrower: "Slugthrower Certification",
  cert_droid_astromech_1: "Level One Astromech Certification",
  cert_droid_astromech_2: "Level Two Astromech Certification",
  cert_droid_astromech_3: "Level Three Astromech Certification",
  cert_droid_astromech_4: "Level Four Astromech Certification",
  cert_droid_astromech_5: "Level Five Astromech Certification",
  cert_droid_astromech_6: "Level Six Astromech Certification",
  cert_grenade_cryoban: "Cryoban Grenade Certification",
  cert_grenade_fragmentation: "Fragmentation Grenade Certification",
  cert_grenade_fragmentation_light: "Light Fragmentation Grenade Certification",
  cert_grenade_glop: "Glop Grenade Certification",
  cert_grenade_imperial_detonator: "Imperial Detonator Certification",
  cert_grenade_proton: "Proton Grenade Certification",
  cert_grenade_thermal_detonator: "Thermal Detonator Certification",
  cert_heavy_acid_beam: "Heavy Acid Beam Certification",
  cert_heavy_lightning_beam: "Lightning Beam Cannon Certification",
  cert_heavy_particle_beam: "Heavy Particle Beam Cannon Certification",
  cert_knife_dagger: "Dagger Certification",
  cert_knife_stone: "Stone Knife Certification",
  cert_knife_survival: "Survival Knife Certification",
  cert_knife_vibroblade: "Vibroblade Certification",
  cert_lance_controllerfp: "Basic Lance Certification",
  cert_lance_staff_metal: "Metal Staff Certification",
  cert_lance_staff_wood_s1: "Wood Staff Certification",
  cert_lance_staff_wood_s2: "Reinforced Combat Staff Certification",
  cert_lance_vibro_axe: "Long Vibro Axe Certification",
  cert_lance_vibrolance: "Vibro Lance Certification",
  cert_onehandlightsaber: "One-handed Lightsaber Certification",
  cert_onehandlightsaber_gen1:
    "One-handed Lightsaber Generation 1 Certification",
  cert_onehandlightsaber_gen2:
    "One-handed Lightsaber Generation 2 Certification",
  cert_onehandlightsaber_gen3:
    "One-handed Lightsaber Generation 3 Certification",
  cert_onehandlightsaber_gen4:
    "One-handed Lightsaber Generation 4 Certification",
  cert_onehandlightsaber_training:
    "One-handed Training Lightsaber Certification",
  cert_ordnance_level1: "Level 1 Ship Equipment Certification",
  cert_ordnance_level2: "Level 2 Ship Equipment Certification",
  cert_ordnance_level3: "Level 3 Ship Equipment Certification",
  cert_ordnance_level4: "Level 4 Ship Equipment Certification",
  cert_ordnance_level5: "Level 5 Ship Equipment Certification",
  cert_ordnance_level6: "Level 6 Ship Equipment Certification",
  cert_ordnance_level7: "Level 7 Ship Equipment Certification",
  cert_ordnance_level8: "Level 8 Ship Equipment Certification",
  cert_ordnance_level9: "Level 9 Ship Equipment Certification",
  cert_ordnance_levelten: "Level 10 Ship Equipment Certification",
  cert_pistol_cdef: "CDEF Pistol Certification",
  cert_pistol_d18: "D18 Pistol Certification",
  cert_pistol_dh17: "DH17 Pistol Certification",
  cert_pistol_dl18: "DL18 Pistol Certification",
  cert_pistol_dl44: "DL44 Pistol Certification",
  cert_pistol_dl44_metal: "DL44 Metal Pistol Certification",
  cert_pistol_dx2: "DX2 Pistol Certification",
  cert_pistol_fwg5: "FWG5 Pistol Certification",
  cert_pistol_launcher: "Launcher Pistol Certification",
  cert_pistol_power5: "Power5 Pistol Certification",
  cert_pistol_republic_blaster: "Republic Blaster Certification",
  cert_pistol_scatter: "Scatter Pistol Certification",
  cert_pistol_scout_blaster: "Scout Blaster Certification",
  cert_pistol_srcombat: "SR Combat Pistol Certification",
  cert_pistol_striker: "Striker Pistol Certification",
  cert_pistol_tangle: "Tangle Pistol Certification",
  cert_polearmlightsaber: "Polearm Lightsaber Certification",
  cert_polearmlightsaber_gen1:
    "Double-Bladed Lightsaber Generation 1 Certification",
  cert_polearmlightsaber_gen2:
    "Double-Bladed Lightsaber Generation 2 Certification",
  cert_polearmlightsaber_gen3:
    "Double-Bladed Lightsaber Generation 3 Certification",
  cert_polearmlightsaber_gen4:
    "Double-Bladed Lightsaber Generation 4 Certification",
  cert_rifle_acid: "Heavy Acid Rifle Certification",
  cert_rifle_acid_beam: "Heavy Acid Rifle Certification",
  cert_rifle_beam: "Beam Rifle Certification",
  cert_rifle_bowcaster: "Bowcaster Certification",
  cert_rifle_cdef: "CDEF Rifle Certification",
  cert_rifle_dlt20: "DLT20 Rifle Certification",
  cert_rifle_dlt20a: "DLT20a Rifle Certification",
  cert_rifle_e11: "E11 Rifle Certification",
  cert_rifle_flame_thrower: "Flame Thrower Certification",
  cert_rifle_flamethrower: "Flame Thrower Certification",
  cert_rifle_jawa_ion: "Jawa Ion Rifle Certification",
  cert_rifle_laser: "Laser Rifle Certification",
  cert_rifle_laster: "Laser Rifle Certification",
  cert_rifle_lightning: "Light Lightning Cannon Certification",
  cert_rifle_sg82: "SG82 Rifle Certification",
  cert_rifle_spraystick: "Spraystick Certification",
  cert_rifle_t21: "T21 Rifle Certification",
  cert_rifle_tusken: "Tusken Rifle Certification",
  cert_rocket_launcher: "Rocket Launcher Certification",
  cert_starships_awing: "A-Wing Piloting Certification",
  cert_starships_blacksunfighter: "Ixiyen Starfighter Piloting Certification",
  cert_starships_bwing: "B-Wing Piloting Certification",
  cert_starships_corsecfighter: "CORSEC Starfighter Piloting Certification",
  cert_starships_decimator: "VT-49 Decimator Piloting Certification",
  cert_starships_firespray: "KSE Firespray Piloting Certification",
  cert_starships_heavyblacksunfighter: "Rihkxyrk Starfighter Certification",
  cert_starships_heavyhuttfighter:
    "Kimogila Starfighter Piloting Certification",
  cert_starships_hutt_turret_ship: "M22-T Krayt Gunship Certification",
  cert_starships_huttfighter: "Dunelizard Starfighter Piloting Certification",
  cert_starships_imperialtransport: "Imperial Transport Piloting Certification",
  cert_starships_lightblacksunfighter:
    "Kihraxz Starfighter Piloting Certification",
  cert_starships_lighthuttfighter: "Scyk Starfighter Piloting Certification",
  cert_starships_mediumblacksunfighter:
    "Ixiyen Starfighter Piloting Certification",
  cert_starships_mediumhuttfighter:
    "Dunelizard Starfighter Piloting Certification",
  cert_starships_merchantcruiser: "Merchant Cruiser Piloting Certification",
  cert_starships_rebeltransport: "Rebel Transport Piloting Certification",
  cert_starships_republicfighter: "Republic Starfighter Piloting Certification",
  cert_starships_tieadvanced: "TIE Advanced Piloting Certification",
  cert_starships_tieaggressor: "TIE Aggressor Piloting Certification",
  cert_starships_tiebomber: "TIE Bomber Piloting Certification",
  cert_starships_tiefighter: "TIE Fighter Piloting Certification",
  cert_starships_tiefighterin: "TIE/In Fighter Piloting Certification",
  cert_starships_tiefighterlight:
    "TIE Fighter (Light Duty) Piloting Certification",
  cert_starships_tieinterceptor: "TIE Interceptor Piloting Certification",
  cert_starships_tieoppressor: "TIE Oppressor Piloting Certification",
  cert_starships_xwing: "X-Wing Piloting Certification",
  cert_starships_ykl37r: "YKL-37R Nova Courier Piloting Certification",
  cert_starships_yt1300: "YT-1300 Transport Piloting Certification",
  cert_starships_yt2400: "YT-2400 Freighter Piloting Certification",
  cert_starships_ywing: "Y-Wing Piloting Certification",
  cert_starships_ywinglongprobe: "Y-Wing 'LongProbe' Piloting Certification",
  cert_starships_z95headhunter: "Z-95 Headhunter Piloting Certification",
  cert_sword_01: "Sword Certification",
  cert_sword_02: "Curved Sword Certification",
  cert_sword_2h_axe: "Two-handed Axe Certification",
  cert_sword_2h_cleaver: "Two-handed Cleaver Certification",
  cert_sword_2h_katana: "Two-handed Curved Sword Certification",
  cert_sword_2h_maul: "Power Hammer Certification",
  cert_sword_2h_scythe: "Scythe Certification",
  cert_sword_blade_rantok: "Rantok Sword Certification",
  cert_sword_blade_ryyk: "Ryyk Blade Certification",
  cert_sword_rantok: "Rantok Sword Certification",
  cert_thrown_bolo: "Bolo Throwing Certification",
  cert_thrown_dagger: "Dagger Throwing Certification",
  cert_thrown_hatchet: "Throwing Axe Certification",
  cert_thrown_knife: "Knife Throwing Certification",
  cert_thrown_plasmasphere: "Plasma Sphere Throwing Certification",
  cert_thrown_shuriken: "Throwing Star Certification",
  cert_twohandlightsaber: "Two-handed Lightsaber Certification",
  cert_twohandlightsaber_gen1:
    "Two-handed Lightsaber Generation 1 Certification",
  cert_twohandlightsaber_gen2:
    "Two-handed Lightsaber Generation 2 Certification",
  cert_twohandlightsaber_gen3:
    "Two-handed Lightsaber Generation 3 Certification",
  cert_twohandlightsaber_gen4:
    "Two-handed Lightsaber Generation 4 Certification",
  cert_vibroknuckler: "Vibroknuckler certification",
  channelforce: "Channel Force",
  chargeshot1: "Charge Shot 1",
  chargeshot2: "Charge Shot 2",
  chase: "Chase",
  cheek: "Cheek Kiss",
  cheer: "Cheer",
  cheerful: "Cheerful",
  chestpound: "Pound Chest",
  chestpuff: "Puff Chest",
  choppedliver: "Chopped Liver",
  chortle: "Chortle",
  chuckle: "Chuckle",
  city_faction_declare: "Declare City Faction",
  city_map: "Register City",
  city_spec_cloning: "City Specialization: Clone Lab",
  city_spec_doctor: "City Specialization: Medical Center",
  city_spec_entertainer: "City Specialization: Entertainment District",
  city_spec_farming: "City Specialization: Farming Community",
  city_spec_industry: "City Specialization: Manufacturing Center",
  city_spec_master_healing: "City Specialization: Scientific Society",
  city_spec_master_manufacturing: "City Specialization: Industrial Society",
  city_spec_missions: "City Specialization: Improved Job Market",
  city_spec_research: "City Specialization: Research Center",
  city_spec_sample_rich: "City Specialization: Sample Rich",
  city_spec_stronghold: "City Specialization: Stronghold",
  city_watch: "Deploy City Watch",
  city_zoning: "Grant Zoning Rights",
  cityban: "City Ban",
  citypardon: "City Pardon",
  citywarn: "City Warn",
  clap: "Clap",
  claw: "Claw (Bare Claws)",
  clinical: "Clinical",
  close: "Close Eyes",
  closeeyes: "Close Eyes",
  cocky: "Cocky",
  cold: "Cold",
  colorlights: "Colored Lights",
  comb: "Comb",
  combarea: "Comb Area",
  combatattitudeaggressive: "Combat Attitude Aggressive",
  combatattitudeevasive: "Combat Attitude Evasive",
  combattarget: "Combat Target",
  combhair: "Comb Hair",
  comfort: "Comfort",
  compassionate: "Compassionate",
  con: "Consider",
  conceal: "Conceal",
  concealshot: "Conceal Shot",
  condescending: "Condescending",
  confident: "Confident",
  confused: "Confused",
  confusionshot: "Confusion Shot",
  congratulate: "Congratulate",
  consent: "Consent",
  consider: "Consider",
  contemplate: "Contemplate",
  contemptuous: "Contemptuous",
  content: "Content",
  corpse: "Corpse",
  cough: "Cough",
  counterattack: "Counter Attack",
  courtly: "Courtly",
  cover: "Cover Up",
  covereyes: "Cover Eyes",
  cower: "Cower",
  coy: "Coy",
  createmanfschematic: "Create Manufcture Schematic",
  createprototype: "Create Prototype",
  creatureareableeding: "Creature",
  creatureareacombo: "Creature",
  creatureareadisease: "Creatures are a Disease",
  creatureareaknockdown: "Creature",
  creatureareapoison: "Creature are a Poison",
  creatureareattack: "Creature",
  cringe: "Cringe",
  cripplingshot: "Crippling Shot",
  crotchety: "Crotchety",
  crude: "Crude",
  cruel: "Cruel",
  cry: "Cry",
  cu: "See Ya!",
  cuckoo: "Cuckoo",
  culater: "See Ya Later!",
  curedisease: "Cure Disease",
  curepoison: "Cure Poison",
  curious: "Curious",
  curse: "Curse",
  curtsey: "Curtsey",
  customizedroid: "Customize Droid",
  cynical: "Cynical",
  dainty: "Dainty",
  dance: "Dance",
  dancer: "Dancer",
  dazzle: "Dazzle",
  declareovert: "Declare Overt Faction Status",
  deepbow: "Deep Bow",
  defaultattack: "Attack",
  defend: "Defend",
  defensive: "Defensive",
  defuseminefield: "Defuse Mine Field",
  demure: "Demure",
  deploytrap: "deploy a trap",
  depressed: "Depressed",
  deride: "Deride",
  devious: "Devious",
  diagnose: "Diagnose",
  dies: "Dies",
  dignified: "Dignified",
  dimwitted: "Dimwitted",
  diplomatic: "Diplomatic",
  disagree: "Disagree",
  disappointed: "Dissappointed",
  disarmingshot: "Disarming Shot",
  disarmingshot1: "Disarming Shot 1",
  disarmingshot2: "Disarming Shot 2",
  discreet: "Discreet",
  disdainful: "Disdainful",
  disgruntled: "Disgruntled",
  disgusted: "Disgusted",
  dismayed: "Dismayed",
  dismiss: "Dismiss",
  dismount: "Dismount",
  disoriented: "Disoriented",
  distract: "Distract",
  distracted: "Distracted",
  diveshot: "Dive Shot",
  dizzyattack: "Dizzy Attack",
  dock: "Dock",
  doh: "Doh!",
  doubletap: "Double Tap",
  doubtful: "Doubtful",
  down: "Stay Down",
  dragincapacitatedplayer: "Drag Incapacitated Player",
  dragplayer: "Drag Player",
  drainforce: "Drain Force",
  dramatic: "Dramatic",
  dream: "Dream",
  dreamy: "Dreamy",
  drool: "Drool",
  drunk: "Drunk",
  duck: "Duck",
  duel: "Duel",
  dumppausedcommands: "Dump Paused Commands",
  earnest: "Earnest",
  echo: "Echo",
  echuta: "E chu ta!",
  ecstatic: "Ecstatic",
  eek: "Eek",
  eject: "Eject",
  elbow: "Elbow",
  embarrassed: "Embarrassed",
  emboldenpets: "Embolden Pets",
  embrace: "Embrace",
  emotional: "Emotional",
  emotionless: "Emotionless",
  emphatic: "Emphatic",
  encourage: "Encourage",
  encouraging: "Encouraging",
  endduel: "End Duel",
  enraged: "Enraged",
  enragepets: "Enrage Pets",
  enthusiastic: "Enthusiastic",
  envious: "Envious",
  epulse1: "Energy Pulse Level One",
  epulse2: "Energy Pulse Level Two",
  epulse3: "Energy Pulse Level Three",
  equilibrium: "Equilibrium",
  eshields: "Emergency Shields",
  ethrust: "Emergency Thrust",
  evil: "Evil",
  evilgrin: "Evil Grin",
  eweapons: "Emergency Weapons",
  exasperated: "Exasperated",
  exhausted: "Exhausted",
  extinguishfire: "Extinguish Fire",
  exuberant: "Exuberant",
  eyebrow: "Raise Eyebrow",
  eyeroll: "Roll Eyes",
  eyeshot: "Eye Shot",
  faint: "Faint",
  false: "False!",
  fanatical: "Fanatical",
  fanfar: "Fanfar (Instrument)",
  fanshot: "Fan Shot",
  faq: "Read The Frequently Asked Questions",
  fastblast: "Fast Blast",
  fastidious: "Fastidious",
  fear: "Fear",
  fearful: "Fearful",
  feel: "Feel",
  feh: "Feh!",
  feigndeath: "Feign Death",
  fiddle: "Fiddle",
  fidget: "Fidget",
  find: "Find",
  fireacidcone1: "Acid Cone 1",
  fireacidcone2: "Acid Cone 2",
  fireacidsingle1: "Acid Single 1",
  fireacidsingle2: "Acid Single 2",
  fireheavyweapon: "Fire Heavy Weapon",
  firejet: "Fire Jet",
  firelightningcone1: "Lightning Cone 1",
  firelightningcone2: "Lightning Cone 2",
  firelightningsingle1: "Lightning Single 1",
  firelightningsingle2: "Lightning Single 2",
  firm: "Firm",
  firstaid: "First Aid",
  fish: "Fish",
  fistpalm: "Palm Fist",
  fizz: "Fizz (Instrument)",
  flail: "Flail",
  flame: "Flame",
  flamecone1: "Flame Cone 1",
  flamecone2: "Flame Cone 2",
  flamesingle1: "Flame Single 1",
  flamesingle2: "Flame Single 2",
  flee: "Flee",
  flex: "Flex",
  flip: "Flip",
  flipcoin: "Flip Coin",
  flirt: "Flirt",
  flourish: "Flourish",
  flower: "Flower",
  flurryshot: "Flurry Shot",
  flurryshot1: "Flurry Shot 1",
  flurryshot2: "Flurry Shot 2",
  flushgraphicresources: "Flush Graphic Resources",
  flushingshot1: "Flushing Shot 1",
  flushingshot2: "Flushing Shot 2",
  flutedroopy: "Chidinkalu Horn (Instrument)",
  flutter: "Heart Flutter",
  follow: "Follow",
  fool: "Fool",
  forage: "Forage",
  forceabsorb1: "Force Absorb 1",
  forceabsorb2: "Force Absorb 2",
  forcearmor1: "Force Armor 1",
  forcearmor2: "Force Armor 2",
  forcechoke: "Force Choke",
  forcecuredisease: "Force Cure Disease",
  forcecurepoison: "Force Cure Poison",
  forcefeedback1: "Force Feedback 1",
  forcefeedback2: "Force Feedback 2",
  forceintimidate1: "Force Intimidate 1",
  forceintimidate2: "Force Intimidate 2",
  forceknockdown1: "Force Knockdown 1",
  forceknockdown2: "Force Knockdown 2",
  forceknockdown3: "Force Knockdown 3",
  forcelightningcone1: "Force Lightning Cone 1",
  forcelightningcone2: "Force Lightning Cone 2",
  forcelightningsingle1: "Force Lightning Single 1",
  forcelightningsingle2: "Force Lightning Single 2",
  forcemeditate: "Force Meditate",
  forceofwill: "Force of Will",
  forceresistbleeding: "Force Resist Bleeding",
  forceresistdisease: "Force Resist Disease",
  forceresistpoison: "Force Resist Poison",
  forceresiststates: "Force Resist States",
  forcerun1: "Force Run 1",
  forcerun2: "Force Run 2",
  forcerun3: "Force Run 3",
  forceshield1: "Force Shield 1",
  forceshield2: "Force Shield 2",
  forcespeed1: "Force Speed 1",
  forcespeed2: "Force Speed 2",
  forcethrow1: "Force Throw 1",
  forcethrow2: "Force Throw 2",
  forceweaken1: "Force Weaken 1",
  forceweaken2: "Force Weaken 2",
  forgive: "Forgive",
  formup: "Form Up",
  friendly: "Friendly",
  frown: "Frown",
  frustrated: "Frustrated",
  fullautoarea: "Full Auto Area",
  fullautoarea1: "Full Auto Area 1",
  fullautoarea2: "Full Auto Area 2",
  fullautosingle: "Full Auto Single",
  fullautosingle1: "Full Auto Single 1",
  fullautosingle2: "Full Auto Single 2",
  fume: "Fume",
  fuzzy: "Fuzzy",
  gag: "Gag",
  gallop: "Gallop",
  gallopstop: "Stop Galloping",
  gape: "Gape",
  gasp: "Gasp",
  gawk: "Gawk",
  gaze: "Gaze",
  getattributesbatch: "getAttributesBatch",
  giggle: "Giggle",
  giveitem: "Give item",
  giveup: "Give Up",
  glare: "Glare",
  gloat: "Gloat",
  gloomy: "Gloomy",
  glow: "Glow",
  going: "Going To Charge",
  goofy: "Goofy",
  grantzoningrights: "Grant Zoning Rights",
  greet: "Greet",
  grin: "Grin",
  groan: "Groan",
  group: "Group",
  grovel: "Grovel",
  growl: "Growl",
  grumble: "Grumble",
  grumpy: "Grumpy",
  grunt: "Grunt",
  guildremove: "Guild Remove",
  guildstatus: "Guild Status",
  guilty: "Guilty",
  gulp: "Gulp",
  hack: "Hack",
  hail: "Hail",
  halfnelson: "Half-nelson",
  halo: "Halo",
  hand: "Give/Kiss Hand",
  handshake: "Shake Hand",
  happy: "Happy",
  harvestcorpse: "Harvest Corpse",
  haughty: "Haughty",
  haveconsent: "Have Consent",
  headache: "Headache",
  headlock: "Headlock",
  headshot: "Head Shot",
  headshot1: "Head Shot 1",
  headshot2: "Head Shot 2",
  headshot3: "Head Shot 3",
  healactionself1: "Heal Action Self 1",
  healactionself2: "Heal Action Self 2",
  healactionwoundother1: "Heal Action Wound Other 1",
  healactionwoundother2: "Heal Action Wound Other 2",
  healactionwoundself1: "Heal Action Wound Self 1",
  healactionwoundself2: "Heal Action Wound Self 2",
  healallother1: "Heal All Other 1",
  healallother2: "Heal All Other 2",
  healallself1: "Heal All Self 1",
  healallself2: "Heal All Self 2",
  healbattlefatigueother1: "Heal Battle Fatigue Other 1",
  healbattlefatigueother2: "Heal Battle Fatigue Other 2",
  healbattlefatigueself1: "Heal Battle Fatigue Self 1",
  healbattlefatigueself2: "Heal Battle Fatigue Self 2",
  healdamage: "Heal Damage",
  healenhance: "Heal Enhance",
  healhealthself1: "Heal Health Self 1",
  healhealthself2: "Heal Health Self 2",
  healhealthwoundother1: "Heal Health Wound Other 1",
  healhealthwoundother2: "Heal Health Wound Other 2",
  healhealthwoundself1: "Heal Health Wound Self 1",
  healhealthwoundself2: "Heal Health Wound Self 2",
  healmind: "Heal Mind",
  healmindself1: "Heal Mind Self 1",
  healmindself2: "Heal Mind Self 2",
  healmindwoundother1: "Heal Mind Wound Other 1",
  healmindwoundother2: "Heal Mind Wound Other 2",
  healmindwoundself1: "Heal Mind Wound Self 1",
  healmindwoundself2: "Heal Mind Wound Self 2",
  healstate: "Heal State",
  healstatesother: "Heal States Other",
  healstatesself: "Heal States Self",
  healthshot1: "Health Shot 1",
  healthshot2: "Health Shot 2",
  healwound: "Heal Wound",
  hearnoevil: "Hear No Evil",
  help: "Help!",
  helpme: "Help Me!",
  hero: "Hero",
  heroic: "Heroic",
  hi5: "High Five",
  hiccup: "Hiccup",
  hiss: "Hiss",
  hobble: "Hobble",
  holdon: "Hold On",
  holoemote: "Holo-Emote",
  honest: "Honest",
  hop: "Hop",
  hopeful: "Hopeful",
  hopeless: "Hopeless",
  hose: "Hose Down",
  hot: "Hot",
  hug: "Hug",
  huge: "It Was Huge",
  hum: "Hum",
  humble: "Humble",
  hunger: "Hunger",
  hungry: "Hungry",
  hurried: "Hurried",
  hysterical: "Hysterical",
  iffscramble: "IFF Transponder Scramble",
  imagedesign: "Image Design",
  imagedesigner: "Image Designer",
  imfull: "Full Stomach",
  imitate: "Imitate",
  imploring: "Imploring",
  indifferent: "Indifferent",
  indignant: "Indignant",
  innate: "Innate Commands",
  innocent: "Innocent",
  insertitemintoshipcomponentslot: "Load Item into Ship",
  inspacereload: "Underway Replenishment",
  inspacerepair: "In Space Repair",
  inspacerr: "Repair and Replenishment",
  inspect: "Inspect",
  installmissionterminal: "Install Mission Terminal",
  installshipcomponent: "Install Ship Component",
  interested: "Interested",
  interplanetary_travel: "Interplanetary Travel",
  intimidate1: "Intimidate 1",
  intimidate2: "Intimidate 2",
  intimidationattack: "Intimidation Attack",
  introduce: "Introduce",
  invite: "invite to group",
  isafk: "Is Afk",
  jam: "Just A Moment!",
  jas: "Just A Second!",
  jealous: "Jealous",
  jedimindtrick: "Jedi Mind Trick",
  jk: "Just Kidding",
  joyful: "Joyful",
  jstart1: "Jump Start Level One",
  jstart2: "Jump Start Level Two",
  jstart3: "Jump Start Level Three",
  jump: "Jump Up",
  kipupshot: "Kip Up Shot",
  kiss: "Kiss",
  kisscheek: "Kiss Cheek",
  kloohorn: "Kloo Horn (Instrument)",
  kneel: "Kneel",
  knock: "Knock",
  knockdownattack: "Knock Down Attack",
  knockdownfire: "Fire Knockdown",
  knockwood: "Knock On Wood",
  kowtow: "Kowtow (Honorable Bow)",
  lag: "Lag",
  lagging: "Lagging",
  large: "It Was Large",
  lastditch: "Last Ditch",
  laugh: "Laugh",
  launchfirework: "Launch Firework",
  launchintospace: "Launch into Space",
  lazy: "Lazy",
  lean: "Lean",
  leavegame: "Leave Game",
  leer: "Leer",
  left: "Point Left",
  legshake: "Shake Leg",
  legshot: "Leg Shot",
  legshot1: "Leg Shot 1",
  legshot2: "Leg Shot 2",
  legshot3: "Leg Shot 3",
  lfg: "Looking for a Group",
  lick: "Lick",
  listen: "Listen",
  lives: "Lives",
  lofty: "Lofty",
  logical: "Logical",
  lol: "Laugh Out Loud!",
  loser: "Loser",
  lost: "Lost",
  loud: "Loud",
  love: "Love",
  loving: "Loving",
  lowblow: "Low Blow",
  luck: "Luck (Good Luck)",
  lustful: "Lustful",
  maintenance_fees_1: "Reduced Maintenance Fees",
  makeroom: "Make Room",
  malevolent: "Malevolent",
  manage_militia: "Manage Militia",
  manage_taxes: "Manage Taxes",
  mandoviol: "Mandoviol (Instrument)",
  manual: "Read The Manual",
  maskscent: "Mask Scent",
  mean: "Mean",
  medicalforage: "Medical Forage",
  medicalforaging: "Medical Forage",
  meditate: "Meditate",
  medium: "It Was Medium",
  melee1hblindhit1: "One-Hand Blind 1",
  melee1hblindhit2: "One-Hand Blind 2",
  melee1hbodyhit1: "One-Hand Body Hit 1",
  melee1hbodyhit2: "One-Hand Body Hit 2",
  melee1hbodyhit3: "One-Hand Body Hit 3",
  melee1hdizzyhit1: "One-Hand Dizzy 1",
  melee1hdizzyhit2: "One-Hand Dizzy 2",
  melee1hhealthhit1: "One-Hand Health Hit 1",
  melee1hhealthhit2: "One-Hand Health Hit 2",
  melee1hhit1: "One-Hand Hit 1",
  melee1hhit2: "One-Hand Hit 2",
  melee1hhit3: "One-Hand Hit 3",
  melee1hlunge1: "One-Hand Lunge 1",
  melee1hlunge2: "One-Hand Lunge 2",
  melee1hscatterhit1: "One-Hand Scatter Hit 1",
  melee1hscatterhit2: "One-Hand Scatter Hit 2",
  melee1hspinattack1: "One-Hand Spin Attack 1",
  melee1hspinattack2: "One-Hand Spin Attack 2",
  melee2harea1: "Two-Hand Area Attack 1",
  melee2harea2: "Two-Hand Area Attack 2",
  melee2harea3: "Two-Hand Area Attack 3",
  melee2hheadhit1: "Two-Hand Head Hit 1",
  melee2hheadhit2: "Two-Hand Head Hit 2",
  melee2hheadhit3: "Two-Hand Head Hit 3",
  melee2hhit1: "Two-Hand Hit 1",
  melee2hhit2: "Two-Hand Hit 2",
  melee2hhit3: "Two-Hand Hit 3",
  melee2hlunge1: "Two-Hand Lunge 1",
  melee2hlunge2: "Two-Hand Lunge 2",
  melee2hmindhit1: "Two-Hand Mind Hit 1",
  melee2hmindhit2: "Two-Hand Mind Hit 2",
  melee2hspinattack1: "Two-Hand Spin Attack 1",
  melee2hspinattack2: "Two-Hand Spin Attack 2",
  melee2hsweep1: "Two-Hand Sweep 1",
  melee2hsweep2: "Two-Hand Sweep 2",
  melee_damage_mitigation_1: "Melee Damage Mitigation 1",
  melee_damage_mitigation_2: "Melee Damage Mitigation 2",
  melee_damage_mitigation_3: "Melee Damage Mitigation 3",
  meleedefense1: "Melee Defense 1",
  meleedefense2: "Melee Defense 2",
  melt: "Melt",
  merchant_fees_1: "Reduced Bazaar Fees",
  mercy: "Mercy!",
  mimic: "Mimic",
  mindblast1: "Mind Blast 1",
  mindblast2: "Mind Blast 2",
  mindshot1: "Mind Shot 1",
  mindshot2: "Mind Shot 2",
  mirror: "Mirror",
  mischievous: "Mischievous",
  mock: "Mock",
  model: "Model",
  mope: "Mope",
  mosh: "Mosh!",
  mount: "Mount",
  mourn: "Mourn",
  multitargetpistolshot: "Multi Target Pistol Shot",
  multitargetshot: "Multi Target Shot",
  musician: "Musician",
  mutedroid: "Mute Flight Astromech/Computer",
  mutter: "Mutter",
  nails: "Fingernails",
  nalargon: "Nalargon (Instrument)",
  namestructure: "Name Structure",
  nap: "Nap",
  nausea: "Nausea",
  navigator: "Space Lane Navigation",
  nblast: "Nebula Blast",
  nelson: "Nelson",
  nervous: "Nervous",
  neutral: "Neutral",
  newbiehelper: "Newbie Helper",
  nextcraftingstage: "Next Crafting Stage",
  nice: "Nice",
  nod: "Nod",
  none: "None",
  nono: "That's A No-No",
  noogie: "Noogie",
  nose: "Nose",
  npcconversationselect: "Conversation Response",
  npcconversationstart: "Start Conversing",
  npcconversationstop: "Stop Conversing",
  nudge: "Nudge",
  nuzzle: "Nuzzle",
  obnoxious: "Obnoxious",
  obscure: "Obscure",
  offended: "Offended",
  omg: "Oh My Gosh!",
  omnibox: "Ommni Box (Instrument)",
  onehandmeleeblind1: "One-Hand Melee Blind 1",
  onehandmeleebodyhit: "One-Hand Melee Body Hit",
  onehandmeleedizzy1: "One-Hand Melee Dizzy 1",
  onehandmeleeheadhit: "One-Hand Melee Head Hit",
  onehandmeleehit1: "One-Hand Melee Hit 1",
  onehandmeleehit2: "One-Hand Melee Hit 2",
  onehandmeleeleghit: "One-Hand Melee Leg Hit",
  onehandmeleestun1: "One-Hand Melee Stun 1",
  onehandmeleesweep1: "One-Hand Melee Sweep 1",
  onehandmeleesweep2: "One-Hand Melee Sweep 2",
  oneknee: "Take A Knee",
  openclosewings: "WingsOpenClose",
  opossum: "Opossum (Play Dead)",
  optimistic: "Optimistic",
  overchargeshot1: "Overcharge Shot 1",
  overchargeshot2: "Overcharge Shot 2",
  painful: "Painful",
  panic: "Panic!",
  panicked: "Panicked",
  panicshot: "Panic Shot",
  pant: "Pant",
  pat: "Pat",
  patient: "Patient",
  pawithdraw: "Withdraw",
  paymaintenance: "Pay Maintenance",
  payup: "Pay Up",
  peace: "Peace",
  pedantic: "Pedantic",
  peer: "Peer",
  peptalk: "Pep Talk",
  perturbed: "Perturbed",
  pessimistic: "Pessimistic",
  pet: "Pet",
  pet_attack: "Pet Command: Attack",
  pet_follow: "Pet Command: Follow",
  pet_followother: "Pet Command: Follow Other",
  pet_formation: "Pet Command: Formations",
  pet_friend: "Pet Command: Friend",
  pet_group: "Pet Command: Group",
  pet_guard: "Pet Command: Guard",
  pet_patrol: "Pet Command: Patrol",
  pet_rangedattack: "Pet Command:  Ranged Attack",
  pet_release: "Pet Command: Store",
  pet_specialattack1: "Pet Command:  Special Attack One",
  pet_specialattack2: "Pet Command:  Special Attack Two",
  pet_stay: "Pet Command: Stay",
  pet_transfer: "Pet Command: Transfer",
  pethigh: "Pet High",
  petlow: "Pet Low",
  petulant: "Petulant",
  peyoo: "Peeyoo! (Something Stinks)",
  philosophical: "Philosophical",
  pillow: "Pillow Fight",
  pinch: "Pinch",
  pistolaim: "Pistol Aim",
  pistolcharge: "Pistol Charge",
  pistoldisarmingshot: "Pistol Disarming Shot",
  pistolflurryshot: "Pistol Flurry Shot",
  pistolmeleedefense1: "Pistol Melee Defense 1",
  pistolmeleedefense2: "Pistol Melee Defense 2",
  pistolscattershot: "Pistol Scatter Shot",
  pistolsneak: "Pistol Sneak Shot",
  pistolstartleshot: "Pistol Startle Shot",
  pistolstrafeshot: "Pistol Strafe Shot",
  pistolsuppressionfire: "Pistol Suppression Fire",
  pistolsurpriseshot: "Pistol Surprise Shot",
  pitying: "Pitying",
  place_bank: "Place Bank",
  place_cantina: "Place Cantina",
  place_cityhall: "Place City Hall",
  place_cloning: "Place Cloning",
  place_exotic_garden: "Place Exotic Garden",
  place_faction_terminal: "Place Faction Terminal",
  place_fountain: "Place Fountain",
  place_garage: "Place City Garage",
  place_hospital: "Place Hospital",
  place_large_garden: "Place Large Garden",
  place_medium_garden: "Place Medium Garden",
  place_merchant_tent: "Place Merchant Tent",
  place_mission_terminals: "Place Mission Terminals",
  place_shuttleport: "Place Shuttleport",
  place_small_garden: "Place Small Garden",
  place_statue: "Place Statue",
  place_streetlamp: "Place Streetlamp",
  place_theater: "Place Theater",
  place_trainers: "Place Trainers",
  placebattlefieldstructure: "Place Battlefield Structure",
  placestructuremode: "Place Structure",
  playful: "Playful",
  plugears: "Plug Ears",
  plugnose: "Plug Nose",
  point: "Point",
  pointat: "Point At",
  pointblankarea1: "Point Blank Area 1",
  pointblankarea2: "Point Blank Area 2",
  pointblanksingle1: "Point Blank Single 1",
  pointblanksingle2: "Point Blank Single 2",
  pointdown: "Point Down",
  pointleft: "Point Left",
  pointright: "Point Right",
  pointup: "Point Up",
  poke: "Poke Ribs",
  polearmactionhit1: "Polearm Action Hit 1",
  polearmactionhit2: "Polearm Action Hit 2",
  polearmarea1: "Polearm Area Attack 1",
  polearmarea2: "Polearm Area Attack 2",
  polearmblind1: "Polearm Blind 1",
  polearmbodyhit: "Polearm Body Hit",
  polearmdizzy1: "Polearm Dizzy",
  polearmheadhit: "Polearm Head Hit",
  polearmhit1: "Polearm Hit 1",
  polearmhit2: "Polearm Hit 2",
  polearmhit3: "Polearm Hit 3",
  polearmleghit1: "Polearm Leg Hit 1",
  polearmleghit2: "Polearm Leg Hit 2",
  polearmleghit3: "Polearm Leg Hit 3",
  polearmlunge1: "Polearm Lunge 1",
  polearmlunge2: "Polearm Lunge 2",
  polearmspinattack1: "Polearm Spin Attack 1",
  polearmspinattack2: "Polearm Spin Attack 2",
  polearmstun1: "Polearm Stun 1",
  polearmstun2: "Polearm Stun 2",
  polearmstunhit1: "Polearm Stun Hit 1",
  polearmsweep1: "Polearm Sweep 1",
  polearmsweep2: "Polearm Sweep 2",
  polite: "Polite",
  pompous: "Pompous",
  ponder: "Ponder",
  posturedownattack: "Posture Down Attack",
  postureupattack: "Posture Up Attack",
  pound: "Pound Chest",
  pout: "Pout",
  powerboost: "Power Boost",
  preen: "Preen",
  premium_auctions: "Premium Auctions",
  primp: "Primp",
  prod: "Prod",
  prone: "Prone",
  protect: "Protect",
  proud: "Proud",
  provocative: "Provocative",
  provoke: "Provoke",
  pshrug: "Shrug (Philosophical)",
  ptrap1: "Pirate Trap Level One",
  ptrap2: "Pirate Trap Level Two",
  pucker: "Pucker",
  puke: "Puke",
  pull: "Pull",
  pumpreactor: "Pump Reactor",
  punch: "Punch",
  purchasereinforcement: "Purchase Reinforcement",
  purchaseticket: "Purchase Ticket",
  push: "Push",
  puzzle: "Puzzle",
  puzzled: "Puzzled",
  question: "Question",
  quickheal: "Quick Heal",
  quiet: "Quiet!",
  r: "Reply",
  raise: "Raise Hand(s)",
  rally: "Rally",
  ranged_damage_mitigation_1: "Ranged Damage Mitigation 1",
  ranged_damage_mitigation_2: "Ranged Damage Mitigation 2",
  ranged_damage_mitigation_3: "Ranged Damage Mitigation 3",
  raspberry: "Raspberry",
  ready: "Ready",
  reassure: "Reassure",
  recruitskilltrainer: "Recruit Skill Trainer",
  regainconsciousness: "Regain Consciousness",
  regeneration: "Regeneration",
  registerwithlocation: "Register Location with Planetary Map",
  regretful: "Regretful",
  relaxed: "Relaxed",
  relieved: "Relieved",
  reload: "Reload",
  reluctant: "Reluctant",
  remorseful: "Remorseful",
  repairbattlefieldstructure: "Repair Battlefield Structure",
  reply: "Reply",
  requestcraftingsession: "Begin Crafting",
  requestcraftingstation: "Begin Crafting",
  rescue: "Rescue",
  resigned: "Resigned",
  respectful: "Respectful",
  restartcraftingsession: "Restart Crafting Session",
  retell: "Retell",
  retreat: "Retreat!",
  reviveplayer: "Revive Player",
  rifleaim: "Rifle Aim",
  riflecharge: "Rifle Charge",
  rifledisarmingshot: "Rifle Disarming Shot",
  rifleflurryshot: "Rifle Flurry Shot",
  riflemeleedefense1: "Rifle Melee Defense 1",
  riflemeleedefense2: "Rifle Melee Defense 2",
  riflescattershot: "Rifle Scatter Shot",
  riflesneak: "Rifle Sneak",
  riflestartleshot: "Rifle Startle Shot",
  riflestrafeshot: "Rifle Strafe Shot",
  riflesuppressionfire: "Rifle Suppression Fire",
  riflesurpriseshot: "Rifle Surprise Shot",
  riflewildshot: "Rifle Wild Shot",
  right: "Point Right",
  roar: "Roar",
  rofl: "Rolling On The Floor Laughing!",
  roll: "Roll Eyes",
  rolleyes: "Roll Eyes",
  rollshot: "Roll Shot",
  romantic: "Romantic",
  rose: "Give Rose",
  rtell: "Re-Tell",
  rubnose: "Rub Nose",
  rude: "Rude",
  ruffle: "Ruffle",
  saber1hcombohit1: "Saber One Hand Combo Hit 1",
  saber1hcombohit2: "Saber One Hand Combo Hit 2",
  saber1hcombohit3: "Saber One Hand Combo Hit 3",
  saber1hflurry: "Saber One Hand Flurry",
  saber1hflurry2: "Saber One Hand Flurry 2",
  saber1hheadhit1: "Saber One Hand Head Hit 1",
  saber1hheadhit2: "Saber One Hand Head Hit 2",
  saber1hheadhit3: "Saber One Hand Head Hit 3",
  saber1hhit1: "Saber One Hand Hit 1",
  saber1hhit2: "Saber One Hand Hit 2",
  saber1hhit3: "Saber One Hand Hit 3",
  saber2hbodyhit1: "Saber Two Hand Body Hit 1",
  saber2hbodyhit2: "Saber Two Hand Body Hit 2",
  saber2hbodyhit3: "Saber Two Hand Body Hit 3",
  saber2hfrenzy: "Saber Two Hand Frenzy",
  saber2hhit1: "Saber Two Hand Hit 1",
  saber2hhit2: "Saber Two Hand Hit 2",
  saber2hhit3: "Saber Two Hand Hit 3",
  saber2hphantom: "Saber Two Hand Phantom Attack",
  saber2hsweep1: "Saber Two Hand Sweep 1",
  saber2hsweep2: "Saber Two Hand Sweep 2",
  saber2hsweep3: "Saber Two Hand Sweep 3",
  saber_block: "Saber Block",
  saberpolearmdervish: "Saber Polearm Dervish",
  saberpolearmdervish2: "Saber Polearm Dervish 2",
  saberpolearmhit1: "Saber Polearm Hit 1",
  saberpolearmhit2: "Saber Polearm Hit 2",
  saberpolearmhit3: "Saber Polearm Hit 3",
  saberpolearmleghit1: "Saber Polearm Leg Hit 1",
  saberpolearmleghit2: "Saber Polearm Leg Hit 2",
  saberpolearmleghit3: "Saber Polearm Leg Hit 3",
  saberpolearmspinattack1: "Saber Polearm Spin Attack 1",
  saberpolearmspinattack2: "Saber Polearm Spin Attack 2",
  saberpolearmspinattack3: "Saber Polearm Spin Attack 3",
  saberslash1: "Saber Slash 1",
  saberslash2: "Saber Slash 2",
  saberthrow1: "Saber Throw 1",
  saberthrow2: "Saber Throw 2",
  saberthrow3: "Saber Throw 3",
  sad: "Sad",
  salute: "Salute",
  sample: "Sample Resource",
  sampledna: "Sample DNA",
  sarcastic: "Sarcastic",
  scare: "Scare",
  scared: "Scared",
  scattershot: "Scatter Shot",
  scattershot1: "Scatter Shot 1",
  scattershot2: "Scatter Shot 2",
  scold: "Scold",
  scolding: "Scolding",
  scornful: "Scornful",
  scowl: "Scowl",
  scratch: "Scratch",
  scream: "Scream",
  sedate: "Sedate",
  seenoevil: "See No Evil",
  selectdraftschematic: "Select Draft Schematic",
  send: "Send",
  serious: "Serious",
  serversysgroup: "Server System Group",
  setformation: "Set Formation",
  setformationslot: "Set Formation Slot",
  setwaypointactivestatus: "Set Waypoint Active Status",
  shake: "Shake Head",
  shameless: "Shameless",
  sharpen: "Sharpen",
  sheepish: "Sheepish",
  shifty: "Shifty",
  shiver: "Shiver",
  shocked: "Shocked",
  shoo: "Shoo",
  shower: "Take A Shower",
  shrug: "Shrug",
  shudder: "Shudder",
  shush: "Shush!",
  shy: "Shy",
  sigh: "Sigh",
  silly: "Silly",
  sincere: "Sincere",
  sit: "Sit",
  skip: "Skip",
  slap: "Slap",
  sleepy: "Sleepy",
  slice_armor: "Slicing: Armor",
  slice_containers: "Slicing: Containers",
  slice_sockets: "Slicing: Sockets",
  slice_terminals: "Slicing: Terminals",
  slice_weaponsadvanced: "Slicing: Weapons (Advanced)",
  slice_weaponsbasic: "Slicing: Weapons (Basic)",
  slit: "Slit Eyes",
  slitherhorn: "Slitherhorn (Instrument)",
  slobber: "Slobber",
  sly: "Sly",
  small: "It Was Small",
  smell: "Smell",
  smile: "Smile",
  smirk: "Smirk",
  smokebomb: "Smoke Bomb",
  smug: "Smug",
  snap: "Snap Fingers",
  snarl: "Snarl",
  sneak: "Sneak",
  sneer: "Sneer",
  sneeze: "Sneeze",
  snicker: "Snicker",
  sniff: "Sniff",
  sniffle: "Sniffle",
  snipershot: "Sniper Shot",
  snobby: "Snobby",
  snog: "Snog",
  snore: "Snore",
  snort: "Snort",
  soapbox: "Soapbox",
  softclap: "Soft Clap",
  sorry: "Sorry",
  spam: "Spam!",
  speaknoevil: "Speak No Evil",
  spin: "Spin",
  spit: "Spit",
  spiteful: "Spiteful",
  splitcreditswithgroup: "Split Cash Credits With Group",
  spotlight: "Spot Light",
  sprayshot: "Spray Shot",
  squeamish: "Squeamish",
  squeeze: "Squeeze",
  squirm: "Squirm",
  stand: "Stand",
  stare: "Stare",
  startdance: "Start Dancing",
  startleshot: "Startle Shot",
  startleshot1: "Startle Shot 1",
  startleshot2: "Startle Shot 2",
  startmusic: "Start Music",
  steadyaim: "Steady Aim",
  steam: "Steam",
  stink: "Stink",
  stomp: "Stomp",
  stop: "Stop!",
  stopbleeding: "Stop Bleeding",
  stopcraftingsession: "Stop Crafting Session",
  stopdance: "Stop Dancing",
  stopfollow: "Stop Following",
  stopmusic: "Stop Music",
  stoppingshot: "Stopping Shot",
  strafe: "Strafe",
  strafeshot1: "Strafe Shot 1",
  strafeshot2: "Strafe Shot 2",
  strangle: "Strangle",
  stretch: "Stretch",
  structurestatus: "Structure Status",
  strut: "Strut",
  stubborn: "Stubborn",
  stunattack: "Stun Attack",
  suffering: "Suffering",
  sulk: "Sulk",
  sullen: "Sullen",
  summon: "Summon",
  suppressionfire: "Suppression Fire",
  suppressionfire1: "Suppression Fire 1",
  suppressionfire2: "Suppression Fire 2",
  surly: "Surly",
  surprised: "Surprised",
  surpriseshot: "Surprise Shot",
  surrender: "Surrender",
  surrenderself: "Surrender Self",
  surrenderskill: "Surrender Skill",
  survey: "Survey Resources",
  suspicious: "Suspicious",
  swat: "Swat",
  sweat: "Sweat",
  sweep: "Sweep Floor",
  sysgroup: "System Message To Group",
  t: "Tell",
  tackle: "Tackle",
  tag: "Tag!  You're It!",
  take_cover: "Take Cover",
  takecover: "Take Cover",
  tame: "Tame",
  tantrum: "Tantrum",
  tap: "Tap Foot",
  taunt: "Taunt",
  taunting: "Taunting",
  teach: "Teach",
  tease: "Tease",
  tell: "Tell",
  tenddamage: "Tend Damage",
  tendwound: "Tend Wound",
  terrified: "Terrified",
  thank: "Thanks",
  thankful: "Thankful",
  thirst: "Thirsty",
  thirsty: "Thirsty",
  thoughtful: "Thoughtful",
  threatenshot: "Threaten Shot",
  throw: "Throw",
  throwat: "Throw At",
  throwdown: "Throw Down Gauntlet",
  throwgrenade: "Throw Grenade",
  throwtrap: "Trap Throw",
  thumbdown: "Thumb Down",
  thumbsdown: "Thumbs Down",
  thumbsup: "Thumbs Up",
  thumbup: "Thumb Up",
  thxinfo: "Thanks For The Info (Sarcastic)",
  tickle: "Tickle",
  timid: "Timid",
  tiny: "It Was Tiny",
  tip: "Tip Hat",
  tiphat: "Tip Hat",
  tiptoe: "Tiptoe",
  tired: "Tired",
  tmi: "Too Much Information!",
  tolerant: "Tolerant",
  tongue: "Tongue",
  torsoshot: "Torso Shot",
  toss: "Toss",
  totalhealother: "Total Heal Other",
  totalhealself: "Total Heal Self",
  train_mount: "Train Mount",
  transferforce: "Transfer Force",
  transferitem: "Transfer Item",
  transferitemarmor: "Transfer Armor",
  transferitemmisc: "Transfer Item",
  transferitemweapon: "Transfer Weapon",
  traz: "Traz (Instrument)",
  trick1: "Pet Command: Trick1",
  trick2: "Pet Command: Trick2",
  trick3: "Pet Command: Trick3",
  trick4: "Pet Command: Trick4",
  troubled: "Troubled",
  tsktsk: "Tsk Tsk.",
  ttell: "Target Tell",
  tug: "Tug",
  tumbletokneeling: "Tumble To Kneeling",
  tumbletoprone: "Tumble To Prone",
  tumbletostanding: "Tumble To Standing",
  tweak: "Tweak",
  twibble: "Twibble",
  twiddle: "Twiddle Thumbs",
  twirl: "Twirl",
  twistarm: "Twist Arm",
  twitch: "Twitch",
  twohandmeleeblind1: "Two-Hand Melee Blind 1",
  twohandmeleebodyhit: "Two-Hand Melee Body Hit",
  twohandmeleedizzy1: "Two-Hand Melee Dizzy 1",
  twohandmeleeheadhit: "Two-Hand Melee Head Hit",
  twohandmeleehit1: "Two-Hand Melee Hit 1",
  twohandmeleehit2: "Two-Hand Melee Hit 2",
  twohandmeleeleghit: "Two-Hand Melee Leg Hit",
  twohandmeleestun1: "Two-Hand Melee Stun 1",
  unarmedblind1: "Unarmed Blind 1",
  unarmedblind2: "Unarmed Blind 2",
  unarmedbodyhit1: "Unarmed Body Hit 1",
  unarmedcombo1: "Unarmed Combo 1",
  unarmedcombo2: "Unarmed Combo 2",
  unarmeddizzy1: "Unarmed Dizzy 1",
  unarmeddizzy2: "Unarmed Dizzy 2",
  unarmedheadhit1: "Unarmed Head Hit 1",
  unarmedhit1: "Unarmed Hit 1",
  unarmedhit2: "Unarmed Hit 2",
  unarmedhit3: "Unarmed Hit 3",
  unarmedknockdown1: "Unarmed Knockdown 1",
  unarmedknockdown2: "Unarmed Knockdown 2",
  unarmedleghit1: "Unarmed Leg Hit 1",
  unarmedlunge1: "Unarmed Lunge 1",
  unarmedlunge2: "Unarmed Lunge 2",
  unarmedspinattack1: "Unarmed Spin Attack 1",
  unarmedspinattack2: "Unarmed Spin Attack 2",
  unarmedstun1: "Unarmed Stun 1",
  unarmedstun2: "Unarmed Stun 2",
  unarmedsweep1: "Unarmed Sweep 1",
  unarmedsweep2: "Unarmed Sweep 2",
  uncertain: "Uncertain",
  uncle: "Uncle!",
  unconsent: "Unconsent",
  underhandshot: "Underhand Shot",
  undock: "Undock",
  unhappy: "Unhappy",
  uninstallshipcomponent: "Uninstall Ship Component",
  unwilling: "Unwilling",
  up: "Point Up",
  vendor_fees_1: "Reduced Vendor Fees",
  vengeful: "Vengeful",
  ventriloquism: "Ventriloquism",
  veto: "Veto",
  vitalize: "Vitalize",
  volley: "Volley",
  volleyfire: "Volley Fire",
  volleyfireattack: "Volley Fire Attack",
  vrepair: "Ship System Emergency Repair",
  vrepairother: "Other Ship System Emergency Repair",
  waft: "Waft",
  wait: "Wait",
  warcry: "Warcry",
  warcry1: "Warcry 1",
  warcry2: "Warcry 2",
  ward: "Ward",
  warm: "Warm",
  warningshot: "Warning Shot",
  wary: "Wary",
  wave: "Wave",
  waypoint: "Waypoint",
  welcome: "Welcome",
  whap: "Whap",
  whatthe: "What The?",
  whimper: "Whimper",
  whiny: "Whiny",
  whisper: "Whisper",
  whistle: "Whistle",
  wicked: "Wicked",
  wild_panic: "Wild Panic",
  wildpanic: "Wild Panic",
  wildshot: "Wild Shot",
  wildshot1: "Wild Shot 1",
  wildshot2: "Wild Shot 2",
  wince: "Wince",
  wink: "Wink",
  wise: "Wise",
  wistful: "Wistful",
  wookieehug: "Wookiee Hug",
  wookieeroar: "Wookiee Roar",
  worried: "Worried",
  worship: "Worship",
  wounded: "Wounded",
  wrinkle: "Wrinkle Nose",
  wtg: "Way To Go",
  yawn: "Yawn",
  yes: "Yes",
  youthful: "Youthful",
  zip: "Zip",
  zone: "Zone Out",
};

export const ALL_SPECIES = ['bothan', 'human', 'ithorian', 'mon_calamari', 'rodian', 'sullustan', 'trandoshan', 'twilek', 'wookiee', 'zabrak']

export const TITLES = [
    {
        "key": "social_entertainer_novice",
        "title": "Novice Entertainer"
    },
    {
        "key": "social_entertainer_master",
        "title": "Master Entertainer"
    },
    {
        "key": "social_entertainer_hairstyle_04",
        "title": "Hairstylist"
    },
    {
        "key": "social_entertainer_music_04",
        "title": "Apprentice Musician"
    },
    {
        "key": "social_entertainer_dance_04",
        "title": "Apprentice Dancer"
    },
    {
        "key": "social_entertainer_healing_04",
        "title": "Apprentice Performer"
    },
    {
        "key": "outdoors_scout_novice",
        "title": "Novice Scout"
    },
    {
        "key": "outdoors_scout_master",
        "title": "Master Scout"
    },
    {
        "key": "outdoors_scout_movement_04",
        "title": "Explorer"
    },
    {
        "key": "outdoors_scout_tools_04",
        "title": "Trapper"
    },
    {
        "key": "outdoors_scout_harvest_04",
        "title": "Hunter"
    },
    {
        "key": "outdoors_scout_camp_04",
        "title": "Survivalist"
    },
    {
        "key": "science_medic_novice",
        "title": "Novice Medic"
    },
    {
        "key": "science_medic_master",
        "title": "Master Medic"
    },
    {
        "key": "science_medic_injury_04",
        "title": "Field Stabilizer"
    },
    {
        "key": "science_medic_injury_speed_04",
        "title": "Emergency Technician"
    },
    {
        "key": "science_medic_ability_04",
        "title": "First Responder"
    },
    {
        "key": "science_medic_crafting_04",
        "title": "Stimpack Chemist"
    },
    {
        "key": "crafting_artisan_novice",
        "title": "Novice Artisan"
    },
    {
        "key": "crafting_artisan_master",
        "title": "Master Artisan"
    },
    {
        "key": "crafting_artisan_engineering_04",
        "title": "Engineer"
    },
    {
        "key": "crafting_artisan_domestic_04",
        "title": "Homemaker"
    },
    {
        "key": "crafting_artisan_business_04",
        "title": "Businessman"
    },
    {
        "key": "crafting_artisan_survey_04",
        "title": "Surveyor"
    },
    {
        "key": "combat_brawler_novice",
        "title": "Novice Brawler"
    },
    {
        "key": "combat_brawler_master",
        "title": "Master Brawler"
    },
    {
        "key": "combat_brawler_unarmed_04",
        "title": "Teras Kasi Student"
    },
    {
        "key": "combat_brawler_1handmelee_04",
        "title": "Apprentice Swordsman"
    },
    {
        "key": "combat_brawler_2handmelee_04",
        "title": "Apprentice Heavy Swordsman"
    },
    {
        "key": "combat_brawler_polearm_04",
        "title": "Apprentice Pikeman"
    },
    {
        "key": "combat_marksman_novice",
        "title": "Novice Marksman"
    },
    {
        "key": "combat_marksman_master",
        "title": "Master Marksman"
    },
    {
        "key": "combat_marksman_rifle_04",
        "title": "Apprentice Sharpshooter"
    },
    {
        "key": "combat_marksman_pistol_04",
        "title": "Apprentice Gunfighter"
    },
    {
        "key": "combat_marksman_carbine_04",
        "title": "Apprentice Carbine Specialist"
    },
    {
        "key": "combat_marksman_support_04",
        "title": "Guardsman"
    },
    {
        "key": "combat_rifleman_novice",
        "title": "Novice Rifleman"
    },
    {
        "key": "combat_rifleman_master",
        "title": "Master Rifleman"
    },
    {
        "key": "combat_rifleman_accuracy_04",
        "title": "Sniper"
    },
    {
        "key": "combat_rifleman_speed_04",
        "title": "Assassin"
    },
    {
        "key": "combat_rifleman_ability_04",
        "title": "Gunner"
    },
    {
        "key": "combat_rifleman_support_04",
        "title": "Soldier"
    },
    {
        "key": "combat_pistol_novice",
        "title": "Novice Pistoleer"
    },
    {
        "key": "combat_pistol_master",
        "title": "Master Pistoleer"
    },
    {
        "key": "combat_pistol_accuracy_04",
        "title": "Gunslinger"
    },
    {
        "key": "combat_pistol_speed_04",
        "title": "Dead-Eye"
    },
    {
        "key": "combat_pistol_ability_04",
        "title": "Trickshot"
    },
    {
        "key": "combat_pistol_support_04",
        "title": "Quickdraw"
    },
    {
        "key": "combat_carbine_novice",
        "title": "Novice Carbineer"
    },
    {
        "key": "combat_carbine_master",
        "title": "Master Carbineer"
    },
    {
        "key": "combat_carbine_accuracy_04",
        "title": "Mercenary"
    },
    {
        "key": "combat_carbine_speed_04",
        "title": "Marauder"
    },
    {
        "key": "combat_carbine_ability_04",
        "title": "Infiltrator"
    },
    {
        "key": "combat_carbine_support_04",
        "title": "Assaulter"
    },
    {
        "key": "combat_unarmed_novice",
        "title": "Teras Kasi Novice"
    },
    {
        "key": "combat_unarmed_master",
        "title": "Teras Kasi Master"
    },
    {
        "key": "combat_unarmed_accuracy_04",
        "title": "Teras Kasi Mystic"
    },
    {
        "key": "combat_unarmed_speed_04",
        "title": "Teras Kasi Monk"
    },
    {
        "key": "combat_unarmed_ability_04",
        "title": "Teras Kasi Expert"
    },
    {
        "key": "combat_unarmed_support_04",
        "title": "Teras Kasi Warrior"
    },
    {
        "key": "combat_1hsword_novice",
        "title": "Novice Fencer"
    },
    {
        "key": "combat_1hsword_master",
        "title": "Master Fencer"
    },
    {
        "key": "combat_1hsword_accuracy_04",
        "title": "Duelist"
    },
    {
        "key": "combat_1hsword_speed_04",
        "title": "Swashbuckler"
    },
    {
        "key": "combat_1hsword_ability_04",
        "title": "Bladesmaster"
    },
    {
        "key": "combat_1hsword_support_04",
        "title": "Blade Weaver"
    },
    {
        "key": "combat_2hsword_novice",
        "title": "Novice Swordsman"
    },
    {
        "key": "combat_2hsword_master",
        "title": "Master Swordsman"
    },
    {
        "key": "combat_2hsword_accuracy_04",
        "title": "Cleaver"
    },
    {
        "key": "combat_2hsword_speed_04",
        "title": "Battlemaster"
    },
    {
        "key": "combat_2hsword_ability_04",
        "title": "Expert Heavy Swordsman"
    },
    {
        "key": "combat_2hsword_support_04",
        "title": "Warrior"
    },
    {
        "key": "combat_polearm_novice",
        "title": "Novice Pikeman"
    },
    {
        "key": "combat_polearm_master",
        "title": "Master Pikeman"
    },
    {
        "key": "combat_polearm_accuracy_04",
        "title": "Heavy Cleaver"
    },
    {
        "key": "combat_polearm_speed_04",
        "title": "Pike Weaver"
    },
    {
        "key": "combat_polearm_ability_04",
        "title": "Foot Soldier"
    },
    {
        "key": "combat_polearm_support_04",
        "title": "Sentinel"
    },
    {
        "key": "social_dancer_novice",
        "title": "Novice Dancer"
    },
    {
        "key": "social_dancer_master",
        "title": "Master Dancer"
    },
    {
        "key": "social_dancer_ability_04",
        "title": "Dazzler"
    },
    {
        "key": "social_dancer_wound_04",
        "title": "Captivator"
    },
    {
        "key": "social_dancer_knowledge_04",
        "title": "Choreographer"
    },
    {
        "key": "social_dancer_shock_04",
        "title": "Enthraller"
    },
    {
        "key": "social_musician_novice",
        "title": "Novice Musician"
    },
    {
        "key": "social_musician_master",
        "title": "Master Musician"
    },
    {
        "key": "social_musician_ability_04",
        "title": "Virtuoso"
    },
    {
        "key": "social_musician_wound_04",
        "title": "Skilled Musician"
    },
    {
        "key": "social_musician_knowledge_04",
        "title": "Composer"
    },
    {
        "key": "social_musician_shock_04",
        "title": "Mesmerizer"
    },
    {
        "key": "science_doctor_novice",
        "title": "Novice Doctor"
    },
    {
        "key": "science_doctor_master",
        "title": "Master Doctor"
    },
    {
        "key": "science_doctor_wound_speed_04",
        "title": "Field Surgeon"
    },
    {
        "key": "science_doctor_wound_04",
        "title": "Master Surgeon"
    },
    {
        "key": "science_doctor_ability_04",
        "title": "Medical Professor"
    },
    {
        "key": "science_doctor_support_04",
        "title": "Master Chemist"
    },
    {
        "key": "outdoors_ranger_novice",
        "title": "Novice Ranger"
    },
    {
        "key": "outdoors_ranger_master",
        "title": "Master Ranger"
    },
    {
        "key": "outdoors_ranger_movement_04",
        "title": "Wayfarer"
    },
    {
        "key": "outdoors_ranger_tracking_04",
        "title": "Frontiersman"
    },
    {
        "key": "outdoors_ranger_harvest_04",
        "title": "Tracker"
    },
    {
        "key": "outdoors_ranger_support_04",
        "title": "Trap Master"
    },
    {
        "key": "outdoors_creaturehandler_novice",
        "title": "Novice Creature Handler"
    },
    {
        "key": "outdoors_creaturehandler_master",
        "title": "Master Creature Handler"
    },
    {
        "key": "outdoors_creaturehandler_taming_04",
        "title": "Creature Tamer"
    },
    {
        "key": "outdoors_creaturehandler_training_04",
        "title": "Creature Trainer"
    },
    {
        "key": "outdoors_creaturehandler_healing_04",
        "title": "Creature Empath"
    },
    {
        "key": "outdoors_creaturehandler_support_04",
        "title": "Pack Master"
    },
    {
        "key": "outdoors_bio_engineer_novice",
        "title": "Novice Bio-Engineer"
    },
    {
        "key": "outdoors_bio_engineer_master",
        "title": "Master Bio-Engineer"
    },
    {
        "key": "outdoors_bio_engineer_creature_04",
        "title": "Breeder"
    },
    {
        "key": "outdoors_bio_engineer_tissue_04",
        "title": "Expert Bio-Engineer"
    },
    {
        "key": "outdoors_bio_engineer_dna_harvesting_04",
        "title": "Field Scientist"
    },
    {
        "key": "outdoors_bio_engineer_production_04",
        "title": "Geneticist"
    },
    {
        "key": "crafting_armorsmith_novice",
        "title": "Novice Armorsmith"
    },
    {
        "key": "crafting_armorsmith_master",
        "title": "Master Armorsmith"
    },
    {
        "key": "crafting_armorsmith_personal_04",
        "title": "Master of Armor Design"
    },
    {
        "key": "crafting_armorsmith_heavy_04",
        "title": "Materials Specialist"
    },
    {
        "key": "crafting_armorsmith_deflectors_04",
        "title": "Deflector Technologist"
    },
    {
        "key": "crafting_armorsmith_complexity_04",
        "title": "Expert Armorsmith"
    },
    {
        "key": "crafting_weaponsmith_novice",
        "title": "Novice Weaponsmith"
    },
    {
        "key": "crafting_weaponsmith_master",
        "title": "Master Weaponsmith"
    },
    {
        "key": "crafting_weaponsmith_melee_04",
        "title": "Swordsmith"
    },
    {
        "key": "crafting_weaponsmith_firearms_04",
        "title": "Gunsmith"
    },
    {
        "key": "crafting_weaponsmith_munitions_04",
        "title": "Explosives Manufacturer"
    },
    {
        "key": "crafting_weaponsmith_techniques_04",
        "title": "Expert Weaponsmith"
    },
    {
        "key": "crafting_chef_novice",
        "title": "Novice Chef"
    },
    {
        "key": "crafting_chef_master",
        "title": "Master Chef"
    },
    {
        "key": "crafting_chef_dish_04",
        "title": "Iron Chef"
    },
    {
        "key": "crafting_chef_dessert_04",
        "title": "Accomplished Baker"
    },
    {
        "key": "crafting_chef_drink_04",
        "title": "Expert Bartender"
    },
    {
        "key": "crafting_chef_techniques_04",
        "title": "Culinary Master"
    },
    {
        "key": "crafting_tailor_novice",
        "title": "Novice Tailor"
    },
    {
        "key": "crafting_tailor_master",
        "title": "Master Tailor"
    },
    {
        "key": "crafting_tailor_casual_04",
        "title": "Clothier"
    },
    {
        "key": "crafting_tailor_field_04",
        "title": "Uniform Marshal"
    },
    {
        "key": "crafting_tailor_formal_04",
        "title": "Costumier"
    },
    {
        "key": "crafting_tailor_production_04",
        "title": "Expert Tailor"
    },
    {
        "key": "crafting_architect_novice",
        "title": "Novice Architect"
    },
    {
        "key": "crafting_architect_master",
        "title": "Master Architect"
    },
    {
        "key": "crafting_architect_production_04",
        "title": "Interior Designer"
    },
    {
        "key": "crafting_architect_techniques_04",
        "title": "Foreman"
    },
    {
        "key": "crafting_architect_harvesting_04",
        "title": "Installation Designer"
    },
    {
        "key": "crafting_architect_blueprints_04",
        "title": "Home Designer"
    },
    {
        "key": "crafting_droidengineer_novice",
        "title": "Novice Droid Engineer"
    },
    {
        "key": "crafting_droidengineer_master",
        "title": "Master Droid Engineer"
    },
    {
        "key": "crafting_droidengineer_production_04",
        "title": "Droid Builder"
    },
    {
        "key": "crafting_droidengineer_techniques_04",
        "title": "Expert Droid Engineer"
    },
    {
        "key": "crafting_droidengineer_refinement_04",
        "title": "Droid Refiner"
    },
    {
        "key": "crafting_droidengineer_blueprints_04",
        "title": "Droid Designer"
    },
    {
        "key": "crafting_merchant_novice",
        "title": "Novice Merchant"
    },
    {
        "key": "crafting_merchant_master",
        "title": "Master Merchant"
    },
    {
        "key": "crafting_merchant_advertising_04",
        "title": "Propagandist"
    },
    {
        "key": "crafting_merchant_sales_04",
        "title": "Entrepreneur"
    },
    {
        "key": "crafting_merchant_hiring_04",
        "title": "Recruiter"
    },
    {
        "key": "crafting_merchant_management_04",
        "title": "Manager"
    },
    {
        "key": "combat_smuggler_novice",
        "title": "Novice Smuggler"
    },
    {
        "key": "combat_smuggler_master",
        "title": "Master Smuggler"
    },
    {
        "key": "combat_smuggler_underworld_04",
        "title": "Fixer"
    },
    {
        "key": "combat_smuggler_slicing_04",
        "title": "Slicer"
    },
    {
        "key": "combat_smuggler_combat_04",
        "title": "Rogue"
    },
    {
        "key": "combat_smuggler_spice_04",
        "title": "Fence"
    },
    {
        "key": "combat_bountyhunter_novice",
        "title": "Novice Bounty Hunter"
    },
    {
        "key": "combat_bountyhunter_master",
        "title": "Master Bounty Hunter"
    },
    {
        "key": "combat_bountyhunter_investigation_04",
        "title": "Stalker"
    },
    {
        "key": "combat_bountyhunter_droidcontrol_04",
        "title": "Enforcer"
    },
    {
        "key": "combat_bountyhunter_droidresponse_04",
        "title": "Desperado"
    },
    {
        "key": "combat_bountyhunter_support_04",
        "title": "Avenger"
    },
    {
        "key": "combat_commando_novice",
        "title": "Novice Commando"
    },
    {
        "key": "combat_commando_master",
        "title": "Master Commando"
    },
    {
        "key": "combat_commando_heavyweapon_accuracy_04",
        "title": "Grenadier"
    },
    {
        "key": "combat_commando_heavyweapon_speed_04",
        "title": "Demolitionist"
    },
    {
        "key": "combat_commando_thrownweapon_04",
        "title": "Shock Trooper"
    },
    {
        "key": "combat_commando_support_04",
        "title": "Heavy Infantry"
    },
    {
        "key": "science_combatmedic_novice",
        "title": "Novice Combat Medic"
    },
    {
        "key": "science_combatmedic_master",
        "title": "Master Combat Medic"
    },
    {
        "key": "science_combatmedic_healing_range_04",
        "title": "Medical Tactician"
    },
    {
        "key": "science_combatmedic_healing_range_speed_04",
        "title": "Chemical Warfare Expert"
    },
    {
        "key": "science_combatmedic_medicine_04",
        "title": "Toxicologist"
    },
    {
        "key": "science_combatmedic_support_04",
        "title": "Expert Combat Medic"
    },
    {
        "key": "social_imagedesigner_novice",
        "title": "Novice Image Designer"
    },
    {
        "key": "social_imagedesigner_master",
        "title": "Master Image Designer"
    },
    {
        "key": "social_imagedesigner_hairstyle_04",
        "title": "Expert Hairstylist"
    },
    {
        "key": "social_imagedesigner_exotic_04",
        "title": "Plastic Surgeon"
    },
    {
        "key": "social_imagedesigner_bodyform_04",
        "title": "Personal Trainer"
    },
    {
        "key": "social_imagedesigner_markings_04",
        "title": "Tattoo Artist"
    },
    {
        "key": "outdoors_squadleader_novice",
        "title": "Novice Squad Leader"
    },
    {
        "key": "outdoors_squadleader_master",
        "title": "Master Squad Leader"
    },
    {
        "key": "outdoors_squadleader_movement_04",
        "title": "Field Commander"
    },
    {
        "key": "outdoors_squadleader_offense_04",
        "title": "Strategist"
    },
    {
        "key": "outdoors_squadleader_defense_04",
        "title": "Commissar"
    },
    {
        "key": "outdoors_squadleader_support_04",
        "title": "Tactician"
    },
    {
        "key": "social_politician_novice",
        "title": "Novice Politician"
    },
    {
        "key": "social_politician_master",
        "title": "Master Politician"
    },
    {
        "key": "social_politician_fiscal_04",
        "title": "Accountant"
    },
    {
        "key": "social_politician_martial_04",
        "title": "Warmaster"
    },
    {
        "key": "social_politician_civic_04",
        "title": "Statesman"
    },
    {
        "key": "social_politician_urban_04",
        "title": "Urban Planner"
    },
    {
        "key": "combat_gladiator_master",
        "title": "Titan"
    },
    {
        "key": "combat_gladiator_thraex_04",
        "title": "Thraex"
    },
    {
        "key": "combat_gladiator_murmillo_04",
        "title": "Murmillo"
    },
    {
        "key": "combat_gladiator_dimachaerus_04",
        "title": "Dimachaerus"
    },
    {
        "key": "combat_gladiator_secutor_04",
        "title": "Secutor"
    },

];